import { SAPIDate } from '@/types/sapi/scalars';
import { SAPIDateTime } from '@/types/sapi/scalars';
import { SAPIDuration } from '@/types/sapi/scalars';
import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: SAPIDate; output: SAPIDate; }
  DateTime: { input: SAPIDateTime; output: SAPIDateTime; }
  /** Duration in seconds */
  Duration: { input: SAPIDuration; output: SAPIDuration; }
  Long: { input: number; output: number; }
  /** A scalar type that accepts strings or arrays */
  SettingValue: { input: any; output: any; }
  Time: { input: any; output: any; }
  /** Translation key (aka phrase_id) */
  Translation: { input: string; output: string; }
};

export type ActivityGroupType = {
  __typename?: 'ActivityGroupType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ActivityLogsInput = {
  filters: UserLogFiltersInput;
  pager?: InputMaybe<PagerInput>;
};

export const ActivitySourceEnum = {
  /** Exchange */
  Exchange: 'EXCHANGE',
  /** Google Calendar */
  GoogleCalendar: 'GOOGLE_CALENDAR'
} as const;

export type ActivitySourceEnum = typeof ActivitySourceEnum[keyof typeof ActivitySourceEnum];
export type ActivityType = {
  __typename?: 'ActivityType';
  group?: Maybe<ActivityGroupType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: ActivityTypeStatus;
};

export const ActivityTypeStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE'
} as const;

export type ActivityTypeStatus = typeof ActivityTypeStatus[keyof typeof ActivityTypeStatus];
export type Adapter = {
  __typename?: 'Adapter';
  adapterCode?: Maybe<Scalars['String']['output']>;
  calendarId?: Maybe<Scalars['String']['output']>;
  calendarName?: Maybe<Scalars['String']['output']>;
  companyAccountId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Count all sync logs that finished with errors */
  errorCount?: Maybe<Scalars['Int']['output']>;
  externalSystemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialConnectionDate: Scalars['DateTime']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  nextSyncTime?: Maybe<Scalars['DateTime']['output']>;
  quickAddPermissionSets?: Maybe<Scalars['String']['output']>;
  setupStep?: Maybe<Scalars['String']['output']>;
  syncDates?: Maybe<Scalars['String']['output']>;
  syncDefaults?: Maybe<Scalars['String']['output']>;
  syncFrequency?: Maybe<Scalars['String']['output']>;
  syncSettings?: Maybe<Scalars['String']['output']>;
  syncType?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Availability = {
  __typename?: 'Availability';
  availability: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  userId: Scalars['ID']['output'];
};

export type AvailabilityListInput = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type AvailableDateParamsInput = {
  /** Date from where to start counting days from */
  date: Scalars['String']['input'];
  /** Number of days in the future you would like to get the new date */
  daysCount: Scalars['Int']['input'];
};

export type AvalaraDefaultFieldMapping = {
  __typename?: 'AvalaraDefaultFieldMapping';
  avalaraFieldId: Scalars['String']['output'];
  scoroFieldId: Scalars['String']['output'];
};

export type AvalaraInputDataFormat = {
  __typename?: 'AvalaraInputDataFormat';
  documentType: Scalars['String']['output'];
  documentVersion: Scalars['String']['output'];
};

export type AvalaraMandate = {
  __typename?: 'AvalaraMandate';
  id: Scalars['ID']['output'];
  inputDataFormats: Array<AvalaraInputDataFormat>;
  isActive: Scalars['Boolean']['output'];
  mandateId: Scalars['String']['output'];
  statusCode: Scalars['String']['output'];
  statusText: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AvalaraMappingField = {
  __typename?: 'AvalaraMappingField';
  dataType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxLength?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  optionality?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type AvalaraScoroField = {
  __typename?: 'AvalaraScoroField';
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  endDatetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isHidden: Scalars['Boolean']['output'];
  jobClass: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  output: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  percentDone: Scalars['Float']['output'];
  startDatetime: Scalars['DateTime']['output'];
  status: BackgroundJobStatus;
  timeout: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export const BackgroundJobStatus = {
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  Running: 'RUNNING',
  Stalled: 'STALLED'
} as const;

export type BackgroundJobStatus = typeof BackgroundJobStatus[keyof typeof BackgroundJobStatus];
export type Bill = {
  __typename?: 'Bill';
  author: User;
  currency: Scalars['String']['output'];
  deadline?: Maybe<Scalars['Date']['output']>;
  /** Currency multiplier for converting the sums from bill's currency to user's display currency */
  displayCurrencyRate: Scalars['Float']['output'];
  hasProjectOnEachLine: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  issueDate?: Maybe<Scalars['Date']['output']>;
  lines: Array<BillLine>;
  mainContact?: Maybe<Contact>;
  number: Scalars['String']['output'];
  project?: Maybe<Project>;
  status: Scalars['String']['output'];
  sum: Scalars['Float']['output'];
};

export type BillLine = {
  __typename?: 'BillLine';
  amount: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEmptyRow: Scalars['Boolean']['output'];
  isSubHeading: Scalars['Boolean']['output'];
  ordering: Scalars['Int']['output'];
  product?: Maybe<Product>;
  project?: Maybe<Project>;
  purchaseOrderLine?: Maybe<PurchaseOrderLineMaybeHiddenByPermissions>;
  quoteLine?: Maybe<QuoteLineMaybeHiddenByPermissions>;
  secondaryAmount: Scalars['Float']['output'];
  /** Line sum without tax, includes line-based and doc discounts. */
  sumAfterAllDiscounts: Scalars['Float']['output'];
  unit?: Maybe<Unit>;
};

export const BillableTimeTypeEnum = {
  Billable: 'BILLABLE',
  Custom: 'CUSTOM',
  NonBillable: 'NON_BILLABLE'
} as const;

export type BillableTimeTypeEnum = typeof BillableTimeTypeEnum[keyof typeof BillableTimeTypeEnum];
export type Booking = {
  __typename?: 'Booking';
  amount: Scalars['Int']['output'];
  amountType: BookingAmountType;
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isTentative: Scalars['Boolean']['output'];
  project: Project;
  roleProject?: Maybe<RoleProject>;
  startDate: Scalars['Date']['output'];
  user?: Maybe<User>;
};

export const BookingAmountType = {
  Hour: 'hour',
  Percent: 'percent',
  Total: 'total'
} as const;

export type BookingAmountType = typeof BookingAmountType[keyof typeof BookingAmountType];
export const BookingCreationSource = {
  BookingsModule: 'bookings_module',
  ProjectBookings: 'project_bookings'
} as const;

export type BookingCreationSource = typeof BookingCreationSource[keyof typeof BookingCreationSource];
export type BookingDeleteInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  roleProjectId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type BookingSaveInput = {
  amount: Scalars['Int']['input'];
  amountType: BookingAmountType;
  /** Analytics context for booking creation. Create only, ignored on update. */
  creationSource?: InputMaybe<BookingCreationSource>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isTentative?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  roleProjectId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type BookingsFiltersInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  projectIds: Array<Scalars['ID']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BookingsListInput = {
  filters: BookingsFiltersInput;
  pager?: InputMaybe<PagerInput>;
};

export type BookingsMoveInput = {
  fromRoleProjectId?: InputMaybe<Scalars['ID']['input']>;
  fromUserId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  toUserId: Scalars['ID']['input'];
};

export type Bookmark = {
  __typename?: 'Bookmark';
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  module: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner: User;
};

export type BookmarkFilterInput = {
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BoolCustomFieldValue = {
  __typename?: 'BoolCustomFieldValue';
  boolValue?: Maybe<Scalars['Boolean']['output']>;
};

export type Budget = {
  __typename?: 'Budget';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BudgetList = {
  __typename?: 'BudgetList';
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BudgetsFiltersInput = {
  budgetName?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inputTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BudgetsListInput = {
  filters?: InputMaybe<BudgetsFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  activityType: ActivityType;
  company?: Maybe<Contact>;
  contact?: Maybe<Contact>;
  createdDateTime: Scalars['DateTime']['output'];
  createdUser: User;
  description: Scalars['String']['output'];
  durationPlanned?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isPersonal: Scalars['Boolean']['output'];
  modifiedDateTime: Scalars['DateTime']['output'];
  modifiedUser: User;
  name: Scalars['String']['output'];
  phase?: Maybe<Phase>;
  project?: Maybe<Project>;
  startDatetime?: Maybe<Scalars['DateTime']['output']>;
  status: Status;
  strippedDescription?: Maybe<Scalars['String']['output']>;
};

export type CalendarEventsFiltersInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarEventsListInput = {
  filters?: InputMaybe<CalendarEventsFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export type ChecklistItems = {
  __typename?: 'ChecklistItems';
  id?: Maybe<Scalars['ID']['output']>;
  isDone: Scalars['Int']['output'];
  item: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ChecklistItemsInput = {
  type: Scalars['String']['input'];
};

export type ChecklistSaveInput = {
  item: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ClientProfile = {
  __typename?: 'ClientProfile';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priceList?: Maybe<PriceList>;
};

export type Comment = {
  __typename?: 'Comment';
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reactions: Array<Maybe<CommentReactionItem>>;
  strippedText: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CommentReactionItem = {
  __typename?: 'CommentReactionItem';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  reactionCode: Scalars['String']['output'];
  userIds: Array<Scalars['Int']['output']>;
};

export type CommentReactionMutationInput = {
  commentId: Scalars['Int']['input'];
  isAdd: Scalars['Boolean']['input'];
  reactionCode: Scalars['String']['input'];
};

export type CompanyAccount = {
  __typename?: 'CompanyAccount';
  id: Scalars['ID']['output'];
  isInUse?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  clientProfile?: Maybe<ClientProfile>;
  customFields?: Maybe<Array<Maybe<CustomFieldData>>>;
  emails: Array<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  mobiles: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phones: Array<Scalars['String']['output']>;
  type?: Maybe<ContactType>;
  /** Note: Use only in single-contact queries, not in lists. */
  unpaidInvoices?: Maybe<ContactUnpaidInvoices>;
};

export type ContactCategory = {
  __typename?: 'ContactCategory';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export const ContactType = {
  Company: 'COMPANY',
  Person: 'PERSON'
} as const;

export type ContactType = typeof ContactType[keyof typeof ContactType];
export type ContactUnpaidInvoices = {
  __typename?: 'ContactUnpaidInvoices';
  currencySymbol: Scalars['String']['output'];
  hasAccessToInvoices: Scalars['Boolean']['output'];
  hasUnpaidInvoices: Scalars['Boolean']['output'];
  /** Total prepayment balance (0 if user has no access to invoices) */
  prepaymentBalance: Scalars['Float']['output'];
  /** Total unpaid invoices amount (0 if user has no access to invoices) */
  unpaidInvoices: Scalars['Float']['output'];
};

export type ContactsFiltersInput = {
  contactType?: InputMaybe<ContactType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
};

export type ContactsListInput = {
  filters?: InputMaybe<ContactsFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export type CurrenciesFiltersInput = {
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
};

export type CurrenciesListInput = {
  filters?: InputMaybe<CurrenciesFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export type Currency = {
  __typename?: 'Currency';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CustomFieldData = {
  __typename?: 'CustomFieldData';
  id: Scalars['ID']['output'];
  type?: Maybe<CustomFieldType>;
  value?: Maybe<CustomFieldValue>;
};

export type CustomFieldInput = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export const CustomFieldType = {
  CheckText: 'CHECK_TEXT',
  ContextHelp: 'CONTEXT_HELP',
  Date: 'DATE',
  Datetime: 'DATETIME',
  Dropdown: 'DROPDOWN',
  Duration: 'DURATION',
  Formula: 'FORMULA',
  Hidden: 'HIDDEN',
  Image: 'IMAGE',
  Money: 'MONEY',
  Number: 'NUMBER',
  Numbering: 'NUMBERING',
  PhpCode: 'PHP_CODE',
  Readonly: 'READONLY',
  RelationWithExistingModel: 'RELATION_WITH_EXISTING_MODEL',
  Select: 'SELECT',
  SubHeading: 'SUB_HEADING',
  Text: 'TEXT',
  TriggerButton: 'TRIGGER_BUTTON'
} as const;

export type CustomFieldType = typeof CustomFieldType[keyof typeof CustomFieldType];
export type CustomFieldValue = BoolCustomFieldValue | DateCustomFieldValue | DateTimeCustomFieldValue | FloatCustomFieldValue | FloatRangeCustomFieldValue | ImageCustomFieldValue | IntCustomFieldValue | RelationCustomFieldValue | StringCustomFieldValue;

export type CustomModule = {
  __typename?: 'CustomModule';
  nameCode: Scalars['String']['output'];
  nameTranslated: Scalars['String']['output'];
};

export type CustomModuleEntry = {
  __typename?: 'CustomModuleEntry';
  customFields: Array<Maybe<CustomFieldData>>;
  id: Scalars['ID']['output'];
  module: CustomModule;
  primaryFieldName?: Maybe<Scalars['String']['output']>;
};

export type CustomScriptsExecutionInput = {
  activitySource?: InputMaybe<ActivitySourceEnum>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  idList?: InputMaybe<Scalars['String']['input']>;
  scriptAction: Scalars['String']['input'];
  scriptSource: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type DateCustomFieldValue = {
  __typename?: 'DateCustomFieldValue';
  dateValue?: Maybe<Scalars['Date']['output']>;
};

export type DateTimeCustomFieldValue = {
  __typename?: 'DateTimeCustomFieldValue';
  dateTimeValue?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentLineRelationsSaveInput = {
  relations: Array<DocumentLineToDocumentLineRelationInput>;
};

export type DocumentLineToDocumentLineRelationInput = {
  /** Indicates whether the target line is settled. Used only for relations to purchase order lines. */
  isSettled?: InputMaybe<Scalars['Boolean']['input']>;
  lineId?: InputMaybe<Scalars['ID']['input']>;
  targetLineId?: InputMaybe<Scalars['ID']['input']>;
};

export const DynamicOwnerEnum = {
  ProjectManager: 'PROJECT_MANAGER',
  TaskCreator: 'TASK_CREATOR'
} as const;

export type DynamicOwnerEnum = typeof DynamicOwnerEnum[keyof typeof DynamicOwnerEnum];
export type DynamicUserGroup = {
  __typename?: 'DynamicUserGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EliChatHistoryInput = {
  threadId: Scalars['String']['input'];
};

export type EliChatMessageInput = {
  eliContext?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  threadId?: InputMaybe<Scalars['String']['input']>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

export type EliChatMessageResponse = {
  __typename?: 'EliChatMessageResponse';
  feedback?: Maybe<Scalars['Boolean']['output']>;
  messageId: Scalars['String']['output'];
  messageType: Scalars['String']['output'];
  nextActions: Array<Scalars['String']['output']>;
  response: Scalars['String']['output'];
  threadId: Scalars['String']['output'];
};

export type EliChatThread = {
  __typename?: 'EliChatThread';
  id: Scalars['ID']['output'];
  messages?: Maybe<Array<EliChatMessageResponse>>;
  threadId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  user: User;
};

export type EliInsightsBookmarkInput = {
  module: Scalars['String']['input'];
  query: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};

export type EliInsightsBookmarkResponse = {
  __typename?: 'EliInsightsBookmarkResponse';
  module: Scalars['String']['output'];
  moduleTranslatedName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type EliInsightsHistoryResponse = {
  __typename?: 'EliInsightsHistoryResponse';
  bookmark: EliInsightsBookmarkResponse;
  question: Scalars['String']['output'];
};

export type EliInsightsMessageResponse = {
  __typename?: 'EliInsightsMessageResponse';
  message: Scalars['String']['output'];
};

export type EliInsightsModulesInput = {
  query: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};

export type EliInsightsModulesResponse = {
  __typename?: 'EliInsightsModulesResponse';
  module: Scalars['String']['output'];
  moduleTranslatedName: Scalars['String']['output'];
};

export type EliInsightsModulesResponseUnion = EliInsightsMessageResponse | EliInsightsModulesResponse;

export type EliInsightsRateInput = {
  id: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};

export type EliMessageRateInput = {
  messageId: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};

export type EliWelcomeMessageInput = {
  threadId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export const EmailDeliveryRegionEnum = {
  Eu: 'EU',
  Us: 'US'
} as const;

export type EmailDeliveryRegionEnum = typeof EmailDeliveryRegionEnum[keyof typeof EmailDeliveryRegionEnum];
export type EmailDomain = {
  __typename?: 'EmailDomain';
  dnsRecords: Array<EmailDomainDnsRecord>;
  domain: Scalars['String']['output'];
  isVerified: Scalars['Boolean']['output'];
  region: EmailDeliveryRegionEnum;
};

export type EmailDomainAddInput = {
  domain: Scalars['String']['input'];
  region: EmailDeliveryRegionEnum;
};

export type EmailDomainDeleteInput = {
  domain: Scalars['String']['input'];
};

export type EmailDomainDnsRecord = {
  __typename?: 'EmailDomainDnsRecord';
  host: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EmailDomainVerifyInput = {
  domain: Scalars['String']['input'];
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Expense = {
  __typename?: 'Expense';
  author: User;
  /** Currency multiplier for converting the sums from expense's currency to user's display currency */
  displayCurrencyRate: Scalars['Float']['output'];
  hasProjectOnEachLine: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  issueDate: Scalars['Date']['output'];
  lines: Array<ExpenseLine>;
  mainContact?: Maybe<Contact>;
  number?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

export type ExpenseLine = {
  __typename?: 'ExpenseLine';
  amount: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEmptyRow: Scalars['Boolean']['output'];
  isSubHeading: Scalars['Boolean']['output'];
  ordering: Scalars['Int']['output'];
  product?: Maybe<Product>;
  project?: Maybe<Project>;
  quoteLine?: Maybe<QuoteLineMaybeHiddenByPermissions>;
  secondaryAmount: Scalars['Float']['output'];
  /** Line sum without tax, includes line-based and doc discounts. */
  sumAfterAllDiscounts: Scalars['Float']['output'];
  unit?: Maybe<Unit>;
};

export const ExportCsvDelimiterEnum = {
  Comma: 'COMMA',
  Semicolon: 'SEMICOLON',
  Tab: 'TAB'
} as const;

export type ExportCsvDelimiterEnum = typeof ExportCsvDelimiterEnum[keyof typeof ExportCsvDelimiterEnum];
export const ExportCsvEncodingEnum = {
  EncodingIso8859_13: 'ENCODING_ISO8859_13',
  EncodingUtf8: 'ENCODING_UTF8',
  EncodingUtf16Le: 'ENCODING_UTF16LE',
  EncodingWindows1252: 'ENCODING_WINDOWS1252'
} as const;

export type ExportCsvEncodingEnum = typeof ExportCsvEncodingEnum[keyof typeof ExportCsvEncodingEnum];
export const ExportFileFormatEnum = {
  Csv: 'CSV',
  Xls: 'XLS'
} as const;

export type ExportFileFormatEnum = typeof ExportFileFormatEnum[keyof typeof ExportFileFormatEnum];
export type ExportInput = {
  csvDelimiter?: InputMaybe<ExportCsvDelimiterEnum>;
  csvEncoding?: InputMaybe<ExportCsvEncodingEnum>;
  fileFormat: ExportFileFormatEnum;
  xlsEncoding?: InputMaybe<ExportXlsEncodingEnum>;
};

export type ExportResponse = {
  __typename?: 'ExportResponse';
  fileUrl: Scalars['String']['output'];
};

export const ExportXlsEncodingEnum = {
  Xls: 'XLS',
  Xlsx: 'XLSX'
} as const;

export type ExportXlsEncodingEnum = typeof ExportXlsEncodingEnum[keyof typeof ExportXlsEncodingEnum];
export const ExternalSystemEnum = {
  BambooHr: 'BAMBOO_HR',
  GoogleCalendar: 'GOOGLE_CALENDAR'
} as const;

export type ExternalSystemEnum = typeof ExternalSystemEnum[keyof typeof ExternalSystemEnum];
export type Feature = {
  __typename?: 'Feature';
  id: Scalars['ID']['output'];
  max_volume_count?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FeatureInput = {
  /** Feature input type */
  name: Scalars['String']['input'];
};

export type File = {
  __typename?: 'File';
  /**
   * URL that can be used to display the full size image (when logged in).
   * Null if file is not an image or isn't embeddable.
   */
  embedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * URL that can be used to display the thumbnail of the image (when logged in).
   * Null if file is not an image or isn't embeddable.
   */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type Filter = {
  __typename?: 'Filter';
  extraClasses?: Maybe<Scalars['String']['output']>;
  filterLabel?: Maybe<Scalars['String']['output']>;
  filterSelector?: Maybe<Scalars['String']['output']>;
  isRendered?: Maybe<Scalars['String']['output']>;
  isUsed?: Maybe<Scalars['String']['output']>;
  labelPrefix?: Maybe<Scalars['String']['output']>;
  spriteIcon?: Maybe<Scalars['String']['output']>;
};

export type FilterHashExportInput = {
  exportInput: ExportInput;
  filterHashInput: FilterHashInput;
};

export type FilterHashInput = {
  filterHash: Scalars['String']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  pager?: InputMaybe<PagerInput>;
};

export type FinanceDocumentFilterInput = {
  number?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
};

export type FinanceDocumentsListInput = {
  filters?: InputMaybe<FinanceDocumentFilterInput>;
  pager?: InputMaybe<PagerInput>;
};

export type FloatCustomFieldValue = {
  __typename?: 'FloatCustomFieldValue';
  floatValue?: Maybe<Scalars['Float']['output']>;
};

export type FloatRangeCustomFieldValue = {
  __typename?: 'FloatRangeCustomFieldValue';
  floatValueFrom?: Maybe<Scalars['Float']['output']>;
  floatValueTo?: Maybe<Scalars['Float']['output']>;
};

export type FreeTimeSlot = {
  __typename?: 'FreeTimeSlot';
  busyUserIds: Array<Scalars['ID']['output']>;
  endDateTime: Scalars['DateTime']['output'];
  startDateTime: Scalars['DateTime']['output'];
};

export type FreeTimeSlotInput = {
  dayEndTime: Scalars['Time']['input'];
  dayStartTime: Scalars['Time']['input'];
  endDate: Scalars['Date']['input'];
  eventDuration: Scalars['Duration']['input'];
  requiredUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['Date']['input'];
  stepLength: Scalars['Duration']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type GanttChartShareInput = {
  chartData?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  ttlSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type HelpStationArticle = {
  __typename?: 'HelpStationArticle';
  body?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type HelpStationVideo = {
  __typename?: 'HelpStationVideo';
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  player_embed_url: Scalars['String']['output'];
};

export type HiddenByPermissions = {
  __typename?: 'HiddenByPermissions';
  id: Scalars['ID']['output'];
};

export type ImageCustomFieldValue = {
  __typename?: 'ImageCustomFieldValue';
  file?: Maybe<File>;
};

export type ImportType = {
  __typename?: 'ImportType';
  account: CompanyAccount;
  backgroundJob: BackgroundJob;
  columnsMapping?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<User>;
  deletedDateTime?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  hadErrors: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  importFinishedDateTime?: Maybe<Scalars['DateTime']['output']>;
  importedDateTime?: Maybe<Scalars['DateTime']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isPartiallyDeleted: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  user: User;
};

export type IntCustomFieldValue = {
  __typename?: 'IntCustomFieldValue';
  intValue?: Maybe<Scalars['Int']['output']>;
};

export type IntegrationAction = {
  __typename?: 'IntegrationAction';
  errorCount?: Maybe<Scalars['Int']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  syncStatus?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type IntegrationActionListInput = {
  adapterCode: Scalars['String']['input'];
  itemId: Scalars['ID']['input'];
  itemType: Scalars['String']['input'];
};

export type IntegrationActionRunInput = {
  action: Scalars['String']['input'];
  adapterCode: Scalars['String']['input'];
  itemId: Scalars['ID']['input'];
  itemType: Scalars['String']['input'];
};

export type IntegrationActionRunResponse = {
  __typename?: 'IntegrationActionRunResponse';
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type IntegrationAuthorizeInputType = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type IntegrationGetAdapterInputType = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type IntegrationGetJwtInputType = {
  code: Scalars['String']['input'];
};

export type IntegrationItem = {
  __typename?: 'IntegrationItem';
  description: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  iframeUrl?: Maybe<Scalars['String']['output']>;
  integrationPage: Scalars['String']['output'];
  isConnected: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type IntegrationItemEntity = {
  __typename?: 'IntegrationItemEntity';
  code: Scalars['String']['output'];
  domainRestriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enabledForUsers: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  iframeUrl?: Maybe<Scalars['String']['output']>;
  integrationGroup: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requiredModule?: Maybe<Scalars['String']['output']>;
  requiresSiteSettings: Scalars['Boolean']['output'];
};

export type IntegrationItemInputType = {
  code: Scalars['String']['input'];
};

export type IntegrationSetAdapterStatusInputType = {
  code: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type IntegrationValidateJwtInputType = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type InviteUsersSaveInput = {
  email: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
  permissionSetId: Scalars['Int']['input'];
};

export type Invoice = {
  __typename?: 'Invoice';
  currency: Scalars['String']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  deadline?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  mainContact?: Maybe<Contact>;
  margin?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  project?: Maybe<Project>;
  status: Scalars['String']['output'];
  sum: Scalars['String']['output'];
};

export type InvoiceAllocationsSaveInput = {
  billLineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  expenseLineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceId: Scalars['ID']['input'];
  timeEntryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IsUniqueFieldInput = {
  field: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['ID']['input']>;
  module: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LaborCostInput = {
  /** The currency for the cost. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The date for which the cost is set. */
  date?: InputMaybe<Scalars['String']['input']>;
};

export type LimitedTask = {
  __typename?: 'LimitedTask';
  id: Scalars['ID']['output'];
  isDone: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: TaskPermissions;
  subtasks: Array<TaskMaybeLimitedByPermissions>;
};

export type LocalPriceList = {
  __typename?: 'LocalPriceList';
  createdDate: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** List of local role prices */
  localRolePrices: Array<LocalRolePrice>;
  name: Scalars['String']['output'];
};

export type LocalPriceListSaveInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  localRolePrices: Array<LocalPriceListSaveLocalRolePriceInput>;
  priceListId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type LocalPriceListSaveLocalRolePriceInput = {
  buyingPrice?: InputMaybe<Scalars['Float']['input']>;
  roleId: Scalars['ID']['input'];
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type LocalRolePrice = {
  __typename?: 'LocalRolePrice';
  buyingPrice?: Maybe<Scalars['Float']['output']>;
  currencyConvertedSellingPrice?: Maybe<Scalars['Float']['output']>;
  localPriceListId: Scalars['ID']['output'];
  roleId: Scalars['ID']['output'];
  sellingPrice?: Maybe<Scalars['Float']['output']>;
};


export type LocalRolePriceCurrencyConvertedSellingPriceArgs = {
  input?: InputMaybe<LocalRoleSellingPriceInput>;
};

export type LocalRoleSellingPriceInput = {
  /** The target currency for the selling price. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The date for which the currency rate is applied. */
  date?: InputMaybe<Scalars['String']['input']>;
};

export type MarketingList = {
  __typename?: 'MarketingList';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MenuItem = {
  __typename?: 'MenuItem';
  link: Scalars['String']['output'];
  module: Scalars['String']['output'];
  moduleName: Scalars['String']['output'];
};

export type MetricConfig = {
  __typename?: 'MetricConfig';
  alertCondition?: Maybe<WatchdogAlertConditionEnum>;
  alertThreshold?: Maybe<Scalars['Float']['output']>;
  alertType?: Maybe<WatchdogAlertTypeEnum>;
  hasHistogram: Scalars['Boolean']['output'];
  histogramLogs?: Maybe<Array<MetricLog>>;
  id: Scalars['ID']['output'];
  isAlertTriggered?: Maybe<Scalars['Boolean']['output']>;
  isHistogramSupported: Scalars['Boolean']['output'];
  isPastPeriod: Scalars['Boolean']['output'];
  isWatchdogLimitReached?: Maybe<Scalars['Boolean']['output']>;
  metricId: Scalars['String']['output'];
  notificationTypes?: Maybe<Array<WatchdogNotificationTypeEnum>>;
  retainerPeriod?: Maybe<RetainerPeriod>;
  supportedAlertTypes?: Maybe<Array<WatchdogAlertTypeEnum>>;
};

export type MetricLog = {
  __typename?: 'MetricLog';
  id: Scalars['ID']['output'];
  loggedDateTime: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type MetricSettingOption = {
  __typename?: 'MetricSettingOption';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export const MetricsValueState = {
  Danger: 'DANGER',
  Default: 'DEFAULT',
  Success: 'SUCCESS'
} as const;

export type MetricsValueState = typeof MetricsValueState[keyof typeof MetricsValueState];
export type Milestone = {
  __typename?: 'Milestone';
  isReached: Scalars['Boolean']['output'];
  milestone: Scalars['String']['output'];
};

export type Module = {
  __typename?: 'Module';
  name: ModuleType;
};

export type ModuleInput = {
  customModule?: InputMaybe<Scalars['String']['input']>;
  module: ModuleType;
};

export const ModuleType = {
  Bills: 'bills',
  Calendar: 'calendar',
  Companies: 'companies',
  Contacts: 'contacts',
  CustomModule: 'customModule',
  Expenses: 'expenses',
  Invoices: 'invoices',
  Orders: 'orders',
  Persons: 'persons',
  Prepayments: 'prepayments',
  Products: 'products',
  Projects: 'projects',
  PurchaseOrders: 'purchaseOrders',
  Quotes: 'quotes',
  Tasks: 'tasks',
  Users: 'users'
} as const;

export type ModuleType = typeof ModuleType[keyof typeof ModuleType];
export type Mutation = {
  __typename?: 'Mutation';
  BookingDelete: Scalars['Boolean']['output'];
  BookingSave: Booking;
  BookingsMove: Scalars['Boolean']['output'];
  ChecklistItemSetAsDone?: Maybe<ChecklistItems>;
  CommentReactionMutation?: Maybe<CommentReactionItem>;
  CustomScriptExecution: Array<Maybe<Scalars['String']['output']>>;
  EliInsightsRate?: Maybe<Scalars['Boolean']['output']>;
  EliMessageRate?: Maybe<Scalars['Boolean']['output']>;
  EmailDomainAdd: EmailDomain;
  EmailDomainDelete: Scalars['Boolean']['output'];
  EmailDomainVerify: Scalars['Boolean']['output'];
  IntegrationActionRun?: Maybe<IntegrationActionRunResponse>;
  IntegrationAuthorize: Scalars['Boolean']['output'];
  IntegrationSetAdapterStatus: Scalars['Boolean']['output'];
  InviteUsersMutation: Scalars['Boolean']['output'];
  InvoiceAllocation: Scalars['Boolean']['output'];
  JoinReferralMutation: ReferralLinks;
  LocalPriceListSave: LocalPriceList;
  MarkAllNotificationsRead: Scalars['Boolean']['output'];
  NotificationsMarkAllAsRead: Array<Notification>;
  NotificationsMarkAsRead: Notification;
  NotificationsMarkAsUnread: Notification;
  ProjectDatesSave: Project;
  ProjectDelete: Scalars['Boolean']['output'];
  ProjectMembersAdd: Project;
  ProjectMembersRemove: Project;
  ProjectMembersSave: Project;
  ProjectMetricsConfigSave: MetricConfig;
  ProjectMetricsSettingsSave: Scalars['Boolean']['output'];
  ProjectPhasesAndTaskSetsSave: Project;
  ProjectRestore: Project;
  ProjectSave: Project;
  PublicGanttShare: ShareSnapshot;
  PublicGanttUnShare: Scalars['Boolean']['output'];
  QuoteShare: ShareSnapshot;
  QuoteUnShare: Scalars['Boolean']['output'];
  RateVirtualAssistantChat?: Maybe<Scalars['Boolean']['output']>;
  RateVirtualAssistantChatMessage?: Maybe<Scalars['Boolean']['output']>;
  RetainerSave: Retainer;
  RevenueForecastPeriodSave: Array<RevenueForecastPeriod>;
  RoleDelete: Scalars['Boolean']['output'];
  RoleSave: Role;
  SageDimensionsSave: Array<SageDimension>;
  SalesforceSyncQuoteSumAndPdf: Scalars['Boolean']['output'];
  SaveBillLinePurchaseOrderLineRelations: Scalars['Boolean']['output'];
  SaveBillLineQuoteLineRelations: Scalars['Boolean']['output'];
  SaveExpenseLineQuoteLineRelations: Scalars['Boolean']['output'];
  SearchSettingsUpdate: Array<SearchSetting>;
  SelfServiceCancelSubscriptionRequest: Scalars['Boolean']['output'];
  SelfServiceDataUpdate: Scalars['Boolean']['output'];
  SelfServiceDeleteSeatReductionRequest: Scalars['Boolean']['output'];
  SelfServiceSendSeatReductionRequest: SelfServiceSeatReductionRequest;
  SelfServiceVoucherApply: Scalars['Boolean']['output'];
  SettingSave: Setting;
  SingleSignOnRegularLoginExclusionAdd: Scalars['Boolean']['output'];
  SingleSignOnRegularLoginExclusionDelete: Scalars['Boolean']['output'];
  StatusChange: Scalars['Boolean']['output'];
  StripeTemplateSave: StripeTemplate;
  TabsSave: Scalars['Boolean']['output'];
  TaskAssigneesSave: Task;
  TaskMarkAsDone: Task;
  TaskMarkAsNotDone: Task;
  TaskResponsibleSave: Task;
  TaskSave: Task;
  TaskSetAsSubtasksSave: Task;
  TaskTemplateAssigneesSave: TaskTemplate;
  TimeEntrySave: TimeEntry;
  TimeOffDelete: Scalars['Boolean']['output'];
  TimeOffSave: TimeOffItem;
  TimeOffTypeDelete: Scalars['Boolean']['output'];
  TimeOffTypeSave: TimeOffTypeListItem;
  TimeOffTypesOrderSave: Scalars['Boolean']['output'];
  TimesheetScheduleReminders: Scalars['Int']['output'];
  TrialAutoExtension: Scalars['String']['output'];
  TriggerDataUpdate: Trigger;
  TriggerDelete: Scalars['Boolean']['output'];
  TriggerMutedUpdate: Trigger;
  TriggerStatusUpdate: Trigger;
  UpdateMcpPermissions: Scalars['Boolean']['output'];
};


export type MutationBookingDeleteArgs = {
  input: BookingDeleteInput;
};


export type MutationBookingSaveArgs = {
  input: BookingSaveInput;
};


export type MutationBookingsMoveArgs = {
  input: BookingsMoveInput;
};


export type MutationChecklistItemSetAsDoneArgs = {
  input: ChecklistSaveInput;
};


export type MutationCommentReactionMutationArgs = {
  input: CommentReactionMutationInput;
};


export type MutationCustomScriptExecutionArgs = {
  input: CustomScriptsExecutionInput;
};


export type MutationEliInsightsRateArgs = {
  input: EliInsightsRateInput;
};


export type MutationEliMessageRateArgs = {
  input: EliMessageRateInput;
};


export type MutationEmailDomainAddArgs = {
  input: EmailDomainAddInput;
};


export type MutationEmailDomainDeleteArgs = {
  input: EmailDomainDeleteInput;
};


export type MutationEmailDomainVerifyArgs = {
  input: EmailDomainVerifyInput;
};


export type MutationIntegrationActionRunArgs = {
  input: IntegrationActionRunInput;
};


export type MutationIntegrationAuthorizeArgs = {
  input: IntegrationAuthorizeInputType;
};


export type MutationIntegrationSetAdapterStatusArgs = {
  input: IntegrationSetAdapterStatusInputType;
};


export type MutationInviteUsersMutationArgs = {
  input: Array<InviteUsersSaveInput>;
};


export type MutationInvoiceAllocationArgs = {
  input: InvoiceAllocationsSaveInput;
};


export type MutationLocalPriceListSaveArgs = {
  input: LocalPriceListSaveInput;
};


export type MutationNotificationsMarkAsReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotificationsMarkAsUnreadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProjectDatesSaveArgs = {
  input: ProjectDatesSaveInput;
};


export type MutationProjectDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProjectMembersAddArgs = {
  input: ProjectMembersAddInput;
};


export type MutationProjectMembersRemoveArgs = {
  input: ProjectMembersRemoveInput;
};


export type MutationProjectMembersSaveArgs = {
  input: ProjectMembersSaveInput;
};


export type MutationProjectMetricsConfigSaveArgs = {
  input: ProjectMetricsConfigSaveInput;
};


export type MutationProjectMetricsSettingsSaveArgs = {
  input: ProjectMetricsSettingsSaveInput;
};


export type MutationProjectPhasesAndTaskSetsSaveArgs = {
  input: ProjectPhasesAndTaskSetsSaveInput;
};


export type MutationProjectRestoreArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProjectSaveArgs = {
  input: ProjectSaveInput;
};


export type MutationPublicGanttShareArgs = {
  input: GanttChartShareInput;
};


export type MutationPublicGanttUnShareArgs = {
  input: UnShareInput;
};


export type MutationQuoteShareArgs = {
  input: QuoteShareInput;
};


export type MutationQuoteUnShareArgs = {
  input: UnShareInput;
};


export type MutationRateVirtualAssistantChatArgs = {
  input: VirtualAssistantRatingInput;
};


export type MutationRateVirtualAssistantChatMessageArgs = {
  input: VirtualAssistantRatingInput;
};


export type MutationRetainerSaveArgs = {
  input: RetainerSaveInput;
};


export type MutationRevenueForecastPeriodSaveArgs = {
  input: RevenueForecastPeriodSaveInput;
};


export type MutationRoleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRoleSaveArgs = {
  input: RoleSaveInput;
};


export type MutationSageDimensionsSaveArgs = {
  input: SageDimensionsSaveInput;
};


export type MutationSalesforceSyncQuoteSumAndPdfArgs = {
  input: SalesforceSyncQuoteSumAndPdfInputType;
};


export type MutationSaveBillLinePurchaseOrderLineRelationsArgs = {
  input: DocumentLineRelationsSaveInput;
};


export type MutationSaveBillLineQuoteLineRelationsArgs = {
  input: DocumentLineRelationsSaveInput;
};


export type MutationSaveExpenseLineQuoteLineRelationsArgs = {
  input: DocumentLineRelationsSaveInput;
};


export type MutationSearchSettingsUpdateArgs = {
  modules: Array<Scalars['String']['input']>;
};


export type MutationSelfServiceCancelSubscriptionRequestArgs = {
  input: SelfServiceCancelSubscriptionRequestInput;
};


export type MutationSelfServiceDataUpdateArgs = {
  siteId?: InputMaybe<Scalars['ID']['input']>;
  userChanges: SelfServiceDataInput;
};


export type MutationSelfServiceDeleteSeatReductionRequestArgs = {
  reductionRequestId: Scalars['ID']['input'];
};


export type MutationSelfServiceSendSeatReductionRequestArgs = {
  input: SelfServiceSendSeatReductionRequestInput;
};


export type MutationSelfServiceVoucherApplyArgs = {
  siteId?: InputMaybe<Scalars['ID']['input']>;
  voucher: Scalars['String']['input'];
};


export type MutationSettingSaveArgs = {
  input: SettingSaveInput;
};


export type MutationSingleSignOnRegularLoginExclusionAddArgs = {
  input?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationSingleSignOnRegularLoginExclusionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStatusChangeArgs = {
  input: StatusChangeInput;
};


export type MutationStripeTemplateSaveArgs = {
  pdfTemplateId: Scalars['ID']['input'];
};


export type MutationTabsSaveArgs = {
  input: TabsSaveInput;
};


export type MutationTaskAssigneesSaveArgs = {
  input: TaskAssigneesSaveInput;
};


export type MutationTaskMarkAsDoneArgs = {
  input: TaskMarkAsDoneMutationInput;
};


export type MutationTaskMarkAsNotDoneArgs = {
  input: TaskMarkAsNotDoneMutationInput;
};


export type MutationTaskResponsibleSaveArgs = {
  input: TaskResponsibleSaveInput;
};


export type MutationTaskSaveArgs = {
  input: TaskSaveInput;
};


export type MutationTaskSetAsSubtasksSaveArgs = {
  input: TaskSetAsSubtasksSaveInput;
};


export type MutationTaskTemplateAssigneesSaveArgs = {
  input: TaskTemplateAssigneesSaveInput;
};


export type MutationTimeEntrySaveArgs = {
  input: TimeEntrySaveInput;
};


export type MutationTimeOffDeleteArgs = {
  input: TimeOffDeleteInput;
};


export type MutationTimeOffSaveArgs = {
  input: TimeOffSaveInput;
};


export type MutationTimeOffTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTimeOffTypeSaveArgs = {
  input: TimeOffTypeSaveInput;
};


export type MutationTimeOffTypesOrderSaveArgs = {
  input: TimeOffTypesOrderSaveInput;
};


export type MutationTimesheetScheduleRemindersArgs = {
  input: TimesheetScheduleRemindersInput;
};


export type MutationTrialAutoExtensionArgs = {
  input: TrialExtensionInput;
};


export type MutationTriggerDataUpdateArgs = {
  triggerChanges: TriggerDataInput;
  triggerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationTriggerDeleteArgs = {
  triggerId: Scalars['ID']['input'];
};


export type MutationTriggerMutedUpdateArgs = {
  triggerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationTriggerStatusUpdateArgs = {
  status: TriggerStatusType;
  triggerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateMcpPermissionsArgs = {
  input: UpdateMcpPermissionsInput;
};

export type NewsFeedItem = {
  __typename?: 'NewsFeedItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  action: NotificationActionType;
  changes?: Maybe<Array<NotificationChange>>;
  comment?: Maybe<Comment>;
  createdDateTime: Scalars['DateTime']['output'];
  customBody?: Maybe<Scalars['String']['output']>;
  customLink?: Maybe<Scalars['String']['output']>;
  customText?: Maybe<Scalars['String']['output']>;
  customTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  module?: Maybe<Scalars['String']['output']>;
  relatedObject?: Maybe<NotificationRelatedObject>;
  relatedObjectId: Scalars['Int']['output'];
  relatedUser?: Maybe<User>;
  task?: Maybe<Task>;
  trigger?: Maybe<Trigger>;
  type: Scalars['String']['output'];
};

export const NotificationActionType = {
  ApprovalApproved: 'APPROVAL_APPROVED',
  ApprovalChangeRequested: 'APPROVAL_CHANGE_REQUESTED',
  ApprovalRequested: 'APPROVAL_REQUESTED',
  Cancelled: 'CANCELLED',
  Complete: 'COMPLETE',
  Create: 'CREATE',
  Delete: 'DELETE',
  Modify: 'MODIFY',
  React: 'REACT'
} as const;

export type NotificationActionType = typeof NotificationActionType[keyof typeof NotificationActionType];
export type NotificationChange = UnionFieldChange | UnionManagerChange | UnionProjectChange | UnionStatusChange | UnionUsersChange;

export type NotificationRelatedObject = UnionBackgroundJob | UnionBill | UnionContact | UnionCustomModuleEntry | UnionEvent | UnionExpense | UnionImport | UnionInvoice | UnionNewsFeedItem | UnionOrder | UnionPrepayment | UnionProject | UnionPurchaseOrder | UnionQuote | UnionTask | UnionTimeEntry;

export type NotificationStatus = UnionStaticStatus | UnionStatus;

export type Order = {
  __typename?: 'Order';
  id: Scalars['ID']['output'];
  mainContact?: Maybe<Contact>;
  number: Scalars['String']['output'];
  project?: Maybe<Project>;
};

export type OrderBy = {
  __typename?: 'OrderBy';
  direction?: Maybe<OrderDirectionEnum>;
  fieldName: Scalars['String']['output'];
};

export type OrderByInput = {
  direction?: InputMaybe<OrderDirectionEnum>;
  fieldName: Scalars['String']['input'];
};

export const OrderDirectionEnum = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type OrderDirectionEnum = typeof OrderDirectionEnum[keyof typeof OrderDirectionEnum];
export type PagerInput = {
  limit: Scalars['Int']['input'];
  startFrom: Scalars['Int']['input'];
};

export type PdfTemplate = {
  __typename?: 'PdfTemplate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  name: Scalars['String']['output'];
};

export type PermissionSet = {
  __typename?: 'PermissionSet';
  defaultDashboardId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PermissionSetPermissionUpdateInput = {
  /** Array of permission names that should be enabled for this permission set */
  enabledPermissions: Array<Scalars['String']['input']>;
  /** The ID of the permission set to update */
  permissionSetId: Scalars['Int']['input'];
};

export type PermissionSetWithPermissions = {
  __typename?: 'PermissionSetWithPermissions';
  /** The permission set ID */
  id: Scalars['ID']['output'];
  /** The permission set name */
  name: Scalars['String']['output'];
  /** List of permission key-value pairs for this permission set */
  permissionValues: Array<PermissionValue>;
};

export type PermissionSetsListInput = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PermissionSetsPermissionsInput = {
  /** Optional feature identifier. If omitted, returns all permissions. */
  feature?: InputMaybe<Scalars['String']['input']>;
};

export type PermissionSetsPermissionsResult = {
  __typename?: 'PermissionSetsPermissionsResult';
  /** List of permission sets with their permission values */
  permissionSets: Array<PermissionSetWithPermissions>;
};

export type PermissionValue = {
  __typename?: 'PermissionValue';
  /** The permission identifier (e.g., "see_other_projects", "change_other_invoices") */
  permissionKey: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type Permissions = {
  __typename?: 'Permissions';
  projects?: Maybe<ProjectPermissions>;
  roles?: Maybe<RolePermissions>;
};


export type PermissionsProjectsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Phase = {
  __typename?: 'Phase';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PhasesTaskSets = ProjectPhase | TaskSet;

export type Prepayment = {
  __typename?: 'Prepayment';
  date?: Maybe<Scalars['Date']['output']>;
  deadline?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  mainContact?: Maybe<Contact>;
  number: Scalars['String']['output'];
  project?: Maybe<Project>;
};

export type PriceList = {
  __typename?: 'PriceList';
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PriceListsFiltersInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PriceListsListInput = {
  filters?: InputMaybe<PriceListsFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export const Priority = {
  High: 'HIGH',
  Low: 'LOW',
  Normal: 'NORMAL'
} as const;

export type Priority = typeof Priority[keyof typeof Priority];
export type Product = {
  __typename?: 'Product';
  id: Scalars['ID']['output'];
  /** Product name in the active language */
  name: Scalars['String']['output'];
  /** List of product names in all languages enabled for the site */
  names: Array<TranslatedValue>;
  /** Indicates if the general document discounts are applied to the product. If true, then only line based discounts are applied. */
  noDiscountsApplied: Scalars['Boolean']['output'];
  /** Related product group */
  productGroup?: Maybe<ProductGroup>;
};

export type ProductGroup = {
  __typename?: 'ProductGroup';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Project = {
  __typename?: 'Project';
  accountId: Scalars['String']['output'];
  accounts: Array<CompanyAccount>;
  actualBillsCost?: Maybe<Scalars['Float']['output']>;
  actualDueDate?: Maybe<Scalars['Date']['output']>;
  actualExpensesCost?: Maybe<Scalars['Float']['output']>;
  actualIncome?: Maybe<Scalars['Float']['output']>;
  actualLaborCost?: Maybe<Scalars['Float']['output']>;
  actualStartDate?: Maybe<Scalars['Date']['output']>;
  /** Get project actual used budget sum in display currency */
  actualUsedBudgetSum?: Maybe<Scalars['Float']['output']>;
  /** Billable time from done time entries */
  billableDoneDuration?: Maybe<Scalars['Duration']['output']>;
  /**
   * Billable Time from scheduled time entries + task's planned billable time
   * minus billable time scheduled/done by time entries
   */
  billableToDoDuration?: Maybe<Scalars['Duration']['output']>;
  bookingsMaxDate?: Maybe<Scalars['Date']['output']>;
  bookingsMinDate?: Maybe<Scalars['Date']['output']>;
  budgetBillsCost?: Maybe<Scalars['Float']['output']>;
  budgetExpensesCost?: Maybe<Scalars['Float']['output']>;
  budgetIncome?: Maybe<Scalars['Float']['output']>;
  budgetLaborCost?: Maybe<Scalars['Float']['output']>;
  budgetSums?: Maybe<Array<ProjectBudgetSums>>;
  budgetType?: Maybe<ProjectBudget>;
  color?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Contact>;
  completedDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** Billable time from done and confirmed time entries */
  confirmedBillableDoneDuration?: Maybe<Scalars['Duration']['output']>;
  /** Time from done and confirmed time entries */
  confirmedDoneDuration?: Maybe<Scalars['Duration']['output']>;
  costBudget?: Maybe<Budget>;
  createTasksFromQuoteId?: Maybe<Scalars['ID']['output']>;
  createdBy?: Maybe<User>;
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  cupoUsers: Array<User>;
  customFields?: Maybe<Array<Maybe<CustomFieldData>>>;
  date?: Maybe<Scalars['Date']['output']>;
  deadline?: Maybe<Scalars['Date']['output']>;
  defaultContact?: Maybe<Contact>;
  description?: Maybe<Scalars['String']['output']>;
  /** Time from done time entries */
  doneDuration?: Maybe<Scalars['Duration']['output']>;
  /** Project's estimated duration */
  duration?: Maybe<Scalars['Duration']['output']>;
  hasBackToBackPhases?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isPersonal?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  localPriceList?: Maybe<LocalPriceList>;
  manager?: Maybe<User>;
  members: Array<User>;
  modifiedBy?: Maybe<User>;
  modifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  numberOfTasks?: Maybe<Scalars['Int']['output']>;
  permissions?: Maybe<ProjectPermissions>;
  priceList?: Maybe<PriceList>;
  profitData?: Maybe<ProjectProfitData>;
  progressData: Array<ProjectProgressGroup>;
  projectPhases?: Maybe<Array<ProjectPhase>>;
  projectTags: Array<Tag>;
  projectType: ProjectType;
  quotedBudgetSums?: Maybe<Array<ProjectBudgetSums>>;
  retainer?: Maybe<Retainer>;
  revenueBudget?: Maybe<Budget>;
  roleProjects?: Maybe<Array<RoleProject>>;
  /** Billable time from scheduled time entries */
  scheduledBillableToDoDuration?: Maybe<Scalars['Duration']['output']>;
  /** Time from scheduled time entries */
  scheduledToDoDuration?: Maybe<Scalars['Duration']['output']>;
  shouldDisableCalculationType?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Status>;
  strippedDescription?: Maybe<Scalars['String']['output']>;
  taskSets?: Maybe<Array<TaskSet>>;
  /** Time from scheduled time entries + task's planned time minus time scheduled/done by time entries */
  toDoDuration?: Maybe<Scalars['Duration']['output']>;
  /** Planned billable time from unassigned tasks minus billable time scheduled/done by time entries */
  unassignedBillableToDoDuration?: Maybe<Scalars['Duration']['output']>;
  /** Planned time from unassigned tasks minus time scheduled/done by time entries */
  unassignedToDoDuration?: Maybe<Scalars['Duration']['output']>;
  /** Task's planned billable time minus billable time scheduled/done by time entries */
  unscheduledBillableToDoDuration?: Maybe<Scalars['Duration']['output']>;
  /** Task's planned time minus time scheduled/done by time entries */
  unscheduledToDoDuration?: Maybe<Scalars['Duration']['output']>;
  useBillsExpensesInCalculations?: Maybe<Scalars['Boolean']['output']>;
  useRoles?: Maybe<Scalars['Boolean']['output']>;
};


export type ProjectProfitDataArgs = {
  input?: InputMaybe<ProjectProfitDataInput>;
};


export type ProjectProgressDataArgs = {
  input: ProjectProgressInput;
};

export const ProjectBudget = {
  Advanced: 'ADVANCED',
  Manual: 'MANUAL',
  NoBudget: 'NO_BUDGET',
  Quote: 'QUOTE'
} as const;

export type ProjectBudget = typeof ProjectBudget[keyof typeof ProjectBudget];
export type ProjectBudgetSums = {
  __typename?: 'ProjectBudgetSums';
  bills?: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  expenses?: Maybe<Scalars['Float']['output']>;
  invoices?: Maybe<Scalars['Float']['output']>;
  laborCost?: Maybe<Scalars['Float']['output']>;
};

export type ProjectDatesSaveInput = {
  changedObjects?: InputMaybe<Array<ProjectRelatedObjectEnum>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  projectId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};

export type ProjectHealth = {
  __typename?: 'ProjectHealth';
  createdDatetime: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  project: Project;
  projectHealthScore: Scalars['Float']['output'];
  projectHealthScoreDescription: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
};

export type ProjectHealthInput = {
  projectId: Scalars['ID']['input'];
};

export const ProjectListOrderByEnum = {
  OrderByProjectName: 'orderByProjectName'
} as const;

export type ProjectListOrderByEnum = typeof ProjectListOrderByEnum[keyof typeof ProjectListOrderByEnum];
export type ProjectMembersAddInput = {
  projectId: Scalars['ID']['input'];
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectMembersRemoveInput = {
  projectId: Scalars['ID']['input'];
  roleProjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectMembersSaveInput = {
  cupoUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectMetricConfigInput = {
  metricId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  retainerPeriodId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectMetricsConfigSaveInput = {
  alertThreshold?: InputMaybe<Scalars['Float']['input']>;
  alertType?: InputMaybe<WatchdogAlertTypeEnum>;
  hasHistogram?: InputMaybe<Scalars['Boolean']['input']>;
  metricId: Scalars['String']['input'];
  notificationTypes?: InputMaybe<Array<WatchdogNotificationTypeEnum>>;
  projectId: Scalars['ID']['input'];
};

export type ProjectMetricsInput = {
  projectId: Scalars['ID']['input'];
  retainerPeriodId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectMetricsSettingsSaveInput = {
  projectId: Scalars['ID']['input'];
  selectedMetrics?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectParamsInput = {
  /** Client id to get project data from to create a new project */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  /** Project id to fetch data for an existing project */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Quote id to get project data from to create a new project */
  quoteId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Retainer period id to fetch period specific data for an existing project,
   * has to be provided together with projectId
   */
  retainerPeriodId?: InputMaybe<Scalars['ID']['input']>;
  /** Project template id to fetch data to create a new project */
  templateId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectPermissions = {
  __typename?: 'ProjectPermissions';
  canDelete: Scalars['Boolean']['output'];
  canModify: Scalars['Boolean']['output'];
  canSeeMonetaryBudgetValuesForProject: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
  canViewList: Scalars['Boolean']['output'];
  hasProjectTabs: Scalars['Boolean']['output'];
};

export type ProjectPhase = {
  __typename?: 'ProjectPhase';
  endDate?: Maybe<Scalars['Date']['output']>;
  endDays?: Maybe<Scalars['Int']['output']>;
  hasDependencies: Scalars['Boolean']['output'];
  hasTasks: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isChangingDatesDisabled: Scalars['Boolean']['output'];
  ordering: Scalars['Int']['output'];
  quoteLine?: Maybe<QuoteLine>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startDays?: Maybe<Scalars['Int']['output']>;
  taskSets?: Maybe<Array<TaskSet>>;
  title: Scalars['String']['output'];
  type: ProjectPhaseTypeEnum;
};

export type ProjectPhaseInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDays?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  quoteLineId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDays?: InputMaybe<Scalars['String']['input']>;
  taskSets?: InputMaybe<Array<TaskSetsInput>>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export const ProjectPhaseTypeEnum = {
  Milestone: 'MILESTONE',
  Phase: 'PHASE'
} as const;

export type ProjectPhaseTypeEnum = typeof ProjectPhaseTypeEnum[keyof typeof ProjectPhaseTypeEnum];
export type ProjectPhasesAndTaskSetsSaveInput = {
  hasBackToBackPhases?: InputMaybe<Scalars['Boolean']['input']>;
  /** This will only generate tasks from provided task sets without modifying phases. */
  isSaveOnlyTaskSets?: InputMaybe<Scalars['Boolean']['input']>;
  phases?: InputMaybe<Array<ProjectPhaseInput>>;
  projectId: Scalars['ID']['input'];
  taskSets?: InputMaybe<Array<TaskSetsInput>>;
};

export type ProjectProfitData = {
  __typename?: 'ProjectProfitData';
  costBudget?: Maybe<Scalars['Float']['output']>;
  costForecasted?: Maybe<Scalars['Float']['output']>;
  costInvoiced?: Maybe<Scalars['Float']['output']>;
  costRecognized?: Maybe<Scalars['Float']['output']>;
  externalCostBudget?: Maybe<Scalars['Float']['output']>;
  externalCostForecasted?: Maybe<Scalars['Float']['output']>;
  externalCostInvoiced?: Maybe<Scalars['Float']['output']>;
  externalCostRecognized?: Maybe<Scalars['Float']['output']>;
  internalCostBudget?: Maybe<Scalars['Float']['output']>;
  internalCostForecasted?: Maybe<Scalars['Float']['output']>;
  internalCostInvoiced?: Maybe<Scalars['Float']['output']>;
  internalCostRecognized?: Maybe<Scalars['Float']['output']>;
  revenueBudget?: Maybe<Scalars['Float']['output']>;
  revenueForecasted?: Maybe<Scalars['Float']['output']>;
  revenueInvoiced?: Maybe<Scalars['Float']['output']>;
  revenueRecognized?: Maybe<Scalars['Float']['output']>;
};

export type ProjectProfitDataInput = {
  retainerPeriodId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectProgressGroup = {
  __typename?: 'ProjectProgressGroup';
  actualCost: Scalars['Float']['output'];
  actualRevenue: Scalars['Float']['output'];
  actualTime: Scalars['Float']['output'];
  bookingsCost: Scalars['Float']['output'];
  costBudget: Scalars['Float']['output'];
  forecastedCost: Scalars['Float']['output'];
  forecastedRevenue: Scalars['Float']['output'];
  forecastedTime: Scalars['Float']['output'];
  groupName: Scalars['String']['output'];
  monetaryBudget: Scalars['Float']['output'];
  plannedTime: Scalars['Float']['output'];
  tasksCost: Scalars['Float']['output'];
  timeBudget: Scalars['Float']['output'];
};

export const ProjectProgressGroupBy = {
  Days: 'DAYS',
  Roles: 'ROLES',
  Services: 'SERVICES'
} as const;

export type ProjectProgressGroupBy = typeof ProjectProgressGroupBy[keyof typeof ProjectProgressGroupBy];
export type ProjectProgressInput = {
  groupBy: ProjectProgressGroupBy;
  retainerPeriodId?: InputMaybe<Scalars['ID']['input']>;
};

export const ProjectRelatedObjectEnum = {
  Bookings: 'BOOKINGS',
  PhasesTasks: 'PHASES_TASKS'
} as const;

export type ProjectRelatedObjectEnum = typeof ProjectRelatedObjectEnum[keyof typeof ProjectRelatedObjectEnum];
export type ProjectRetainerBudgetInput = {
  budgetType: RetainerBudget;
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Billing period duration */
  frequency: Scalars['Int']['input'];
  /** Billing period duration type */
  frequencyType: RetainerFrequency;
  /** No. of periods */
  noOfPeriods: Scalars['Int']['input'];
  /** Estimated costs - bills */
  periodBillsSum?: InputMaybe<Scalars['Float']['input']>;
  /** Hours per period */
  periodDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated costs - expenses */
  periodExpensesSum?: InputMaybe<Scalars['Float']['input']>;
  /** Estimated costs - labor cost */
  periodLaborCostSum?: InputMaybe<Scalars['Float']['input']>;
  /** Budget per period */
  periodSum?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['String']['input'];
};

export type ProjectRevenueForecast = {
  __typename?: 'ProjectRevenueForecast';
  periods: Array<RevenueForecastPeriod>;
  project: Project;
  quotedTotal?: Maybe<Scalars['Float']['output']>;
};

export type ProjectRevenueForecastInput = {
  projectId: Scalars['ID']['input'];
};

export type ProjectSaveInput = {
  accounts?: InputMaybe<Array<Scalars['String']['input']>>;
  budgetType?: InputMaybe<ProjectBudget>;
  color?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  cupoMembers?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  date?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** Quote to project flow, project created from quote ID */
  fromQuoteId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  localPriceListId?: InputMaybe<Scalars['ID']['input']>;
  managerId?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  priceListId?: InputMaybe<Scalars['ID']['input']>;
  projectType?: InputMaybe<ProjectType>;
  retainerBudget?: InputMaybe<ProjectRetainerBudgetInput>;
  /** Quote to project flow, if set then updates quote to confirmed status */
  setQuoteAsConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  simpleBudget?: InputMaybe<ProjectSimpleBudgetInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * In case of a retainer project this field affects how bills and expenses deducted.
   * In case of a regular project this field will count pass-through cost as revenue.
   */
  useBillsExpensesInCalc?: InputMaybe<Scalars['Boolean']['input']>;
  useRoles?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectSimpleBudgetInput = {
  /** Bills */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Expenses */
  expenseCost?: InputMaybe<Scalars['Float']['input']>;
  /** Labor cost */
  laborCost?: InputMaybe<Scalars['Float']['input']>;
  /** Total budget */
  revenue?: InputMaybe<Scalars['Float']['input']>;
};

export type ProjectTabsListInput = {
  projectId: Scalars['ID']['input'];
  retainerPeriodId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectTemplate = {
  __typename?: 'ProjectTemplate';
  accountId: Scalars['String']['output'];
  accounts: Array<CompanyAccount>;
  actualBillsCost?: Maybe<Scalars['Float']['output']>;
  actualDueDate?: Maybe<Scalars['Date']['output']>;
  actualExpensesCost?: Maybe<Scalars['Float']['output']>;
  actualIncome?: Maybe<Scalars['Float']['output']>;
  actualLaborCost?: Maybe<Scalars['Float']['output']>;
  actualStartDate?: Maybe<Scalars['Date']['output']>;
  /** Get project actual used budget sum in display currency */
  actualUsedBudgetSum?: Maybe<Scalars['Float']['output']>;
  /** Billable time from done time entries */
  billableDoneDuration?: Maybe<Scalars['Duration']['output']>;
  /**
   * Billable Time from scheduled time entries + task's planned billable time
   * minus billable time scheduled/done by time entries
   */
  billableToDoDuration?: Maybe<Scalars['Duration']['output']>;
  bookingsMaxDate?: Maybe<Scalars['Date']['output']>;
  bookingsMinDate?: Maybe<Scalars['Date']['output']>;
  budgetBillsCost?: Maybe<Scalars['Float']['output']>;
  budgetExpensesCost?: Maybe<Scalars['Float']['output']>;
  budgetIncome?: Maybe<Scalars['Float']['output']>;
  budgetLaborCost?: Maybe<Scalars['Float']['output']>;
  budgetSums?: Maybe<Array<ProjectBudgetSums>>;
  budgetType?: Maybe<ProjectBudget>;
  color?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Contact>;
  completedDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** Billable time from done and confirmed time entries */
  confirmedBillableDoneDuration?: Maybe<Scalars['Duration']['output']>;
  /** Time from done and confirmed time entries */
  confirmedDoneDuration?: Maybe<Scalars['Duration']['output']>;
  costBudget?: Maybe<Budget>;
  createTasksFromQuoteId?: Maybe<Scalars['ID']['output']>;
  createdBy?: Maybe<User>;
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  cupoUsers: Array<User>;
  customFields?: Maybe<Array<Maybe<CustomFieldData>>>;
  date?: Maybe<Scalars['Date']['output']>;
  deadline?: Maybe<Scalars['Date']['output']>;
  defaultContact?: Maybe<Contact>;
  description?: Maybe<Scalars['String']['output']>;
  /** Time from done time entries */
  doneDuration?: Maybe<Scalars['Duration']['output']>;
  /** Project's estimated duration */
  duration?: Maybe<Scalars['Duration']['output']>;
  hasBackToBackPhases?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isPersonal?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  localPriceList?: Maybe<LocalPriceList>;
  manager?: Maybe<User>;
  members: Array<User>;
  modifiedBy?: Maybe<User>;
  modifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<ProjectPermissions>;
  priceList?: Maybe<PriceList>;
  profitData?: Maybe<ProjectProfitData>;
  progressData: Array<ProjectProgressGroup>;
  projectPhases?: Maybe<Array<ProjectPhase>>;
  projectTags: Array<Tag>;
  projectType: ProjectType;
  quotedBudgetSums?: Maybe<Array<ProjectBudgetSums>>;
  retainer?: Maybe<Retainer>;
  revenueBudget?: Maybe<Budget>;
  roleProjects?: Maybe<Array<RoleProject>>;
  /** Billable time from scheduled time entries */
  scheduledBillableToDoDuration?: Maybe<Scalars['Duration']['output']>;
  /** Time from scheduled time entries */
  scheduledToDoDuration?: Maybe<Scalars['Duration']['output']>;
  shouldDisableCalculationType?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Status>;
  strippedDescription?: Maybe<Scalars['String']['output']>;
  taskSets?: Maybe<Array<TaskSet>>;
  templateName?: Maybe<Scalars['String']['output']>;
  /** Time from scheduled time entries + task's planned time minus time scheduled/done by time entries */
  toDoDuration?: Maybe<Scalars['Duration']['output']>;
  /** Planned billable time from unassigned tasks minus billable time scheduled/done by time entries */
  unassignedBillableToDoDuration?: Maybe<Scalars['Duration']['output']>;
  /** Planned time from unassigned tasks minus time scheduled/done by time entries */
  unassignedToDoDuration?: Maybe<Scalars['Duration']['output']>;
  /** Task's planned billable time minus billable time scheduled/done by time entries */
  unscheduledBillableToDoDuration?: Maybe<Scalars['Duration']['output']>;
  /** Task's planned time minus time scheduled/done by time entries */
  unscheduledToDoDuration?: Maybe<Scalars['Duration']['output']>;
  useBillsExpensesInCalculations?: Maybe<Scalars['Boolean']['output']>;
  useRoles?: Maybe<Scalars['Boolean']['output']>;
};


export type ProjectTemplateProfitDataArgs = {
  input?: InputMaybe<ProjectProfitDataInput>;
};


export type ProjectTemplateProgressDataArgs = {
  input: ProjectProgressInput;
};

export const ProjectType = {
  Internal: 'INTERNAL',
  Regular: 'REGULAR',
  Retainer: 'RETAINER'
} as const;

export type ProjectType = typeof ProjectType[keyof typeof ProjectType];
export type ProjectsFiltersInput = {
  canModify?: InputMaybe<Scalars['Boolean']['input']>;
  excludedUsers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filterHash?: InputMaybe<Scalars['String']['input']>;
  ignoreBookmarkUsers?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ProjectListOrderByEnum>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectsListInput = {
  filters?: InputMaybe<ProjectsFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  author?: Maybe<User>;
  currency: Scalars['String']['output'];
  /** Currency multiplier for converting the sums from purchase order's currency to user's display currency */
  displayCurrencyRate: Scalars['Float']['output'];
  hasProjectOnEachLine: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  issueDate: Scalars['Date']['output'];
  lines: Array<PurchaseOrderLine>;
  mainContact?: Maybe<Contact>;
  number: Scalars['String']['output'];
  project?: Maybe<Project>;
  status?: Maybe<Status>;
  sum: Scalars['Float']['output'];
};

export type PurchaseOrderLine = {
  __typename?: 'PurchaseOrderLine';
  amount?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  discount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isEmptyRow: Scalars['Boolean']['output'];
  isSettled: Scalars['Boolean']['output'];
  isSubHeading: Scalars['Boolean']['output'];
  ordering: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  product?: Maybe<Product>;
  project?: Maybe<Project>;
  purchaseOrder: PurchaseOrder;
  quoteLine?: Maybe<QuoteLineMaybeHiddenByPermissions>;
  secondaryAmount?: Maybe<Scalars['Float']['output']>;
  settledSum: Scalars['Float']['output'];
  /** Line sum without tax, includes line-based and document discounts. */
  sumAfterAllDiscounts: Scalars['Float']['output'];
  unit?: Maybe<Unit>;
};

export type PurchaseOrderLineMaybeHiddenByPermissions = HiddenByPermissions | PurchaseOrderLine;

export type Query = {
  __typename?: 'Query';
  ActiveTimer?: Maybe<TimeEntry>;
  ActiveTrialThread?: Maybe<EliChatThread>;
  ActiveTriggersLimitReached: Scalars['Boolean']['output'];
  ActivityLogs: Array<UserLog>;
  ActivityTypesList: Array<ActivityType>;
  AvailabilityList: Array<Availability>;
  /** Get new available date based on date and count of days. */
  AvailableDate: Scalars['String']['output'];
  AvalaraDefaultFieldMappingsList: Array<AvalaraDefaultFieldMapping>;
  AvalaraMandatesList: Array<AvalaraMandate>;
  AvalaraMappingFieldsList: Array<AvalaraMappingField>;
  AvalaraScoroFieldsList: Array<AvalaraScoroField>;
  Bill?: Maybe<Bill>;
  BillsList: Array<Bill>;
  BookingsList: Array<Booking>;
  BookmarksList: Array<Bookmark>;
  BudgetsList: Array<Budget>;
  CalendarEventsList: Array<CalendarEvent>;
  ChecklistItems: Array<ChecklistItems>;
  ClientProfilesList: Array<ClientProfile>;
  CommentReactions: Array<CommentReactionItem>;
  Contact?: Maybe<Contact>;
  ContactCategoriesList: Array<ContactCategory>;
  ContactsList: Array<Contact>;
  CurrenciesList: Array<Currency>;
  CurrentSite?: Maybe<Site>;
  CurrentUser: User;
  CurrentUserHasDemoData: Scalars['Boolean']['output'];
  CurrentUserSettings: Array<Setting>;
  CurrentUserTriggersList: Array<Trigger>;
  DynamicUserGroupsList: Array<DynamicUserGroup>;
  EliChatHistory?: Maybe<Array<EliChatMessageResponse>>;
  EliChatMessage: EliChatMessageResponse;
  EliChatThreadHistory: Array<EliChatThread>;
  EliInsightsBookmark: EliInsightsBookmarkResponse;
  EliInsightsHistory: Array<EliInsightsHistoryResponse>;
  EliInsightsMetrics: Array<SummaryBlockItem>;
  EliInsightsModules: Array<Maybe<EliInsightsModulesResponseUnion>>;
  EliUsageMetrics: Array<SummaryBlockItem>;
  EliWelcomeMessage: Scalars['String']['output'];
  EmailDomains: Array<EmailDomain>;
  EnabledFeatures: Array<Feature>;
  EnabledModules: Array<Feature>;
  EnabledPermissions: Array<Permission>;
  Expense?: Maybe<Expense>;
  ExpensesList: Array<Expense>;
  FavoriteBookmarks: Array<Bookmark>;
  FeatureFlags: Array<FeatureFlag>;
  Filters?: Maybe<Array<Maybe<Filter>>>;
  FreeTimeSlotList: Array<FreeTimeSlot>;
  GetStartedMilestones: Array<Milestone>;
  HelpStationArticles: Array<HelpStationArticle>;
  HelpStationArticlesSearch: Array<HelpStationArticle>;
  HelpStationVideos: Array<HelpStationVideo>;
  IntegrationActionList: Array<IntegrationAction>;
  IntegrationGetAdapter: Adapter;
  IntegrationGetAppJwt: Scalars['String']['output'];
  IntegrationItem: IntegrationItemEntity;
  IntegrationList: Array<IntegrationItem>;
  IntegrationValidateAppJwt: Scalars['Boolean']['output'];
  InvoicesList: Array<Invoice>;
  IsUniqueField?: Maybe<Scalars['Boolean']['output']>;
  LocalPriceList: LocalPriceList;
  LocalPriceListFromPriceList?: Maybe<LocalPriceList>;
  Menu: Array<MenuItem>;
  NotificationsList: Array<Notification>;
  OrdersList: Array<Order>;
  PermissionSetsList: Array<PermissionSet>;
  PermissionSetsPermissions: PermissionSetsPermissionsResult;
  Permissions: Permissions;
  /** Get phases and task sets list in correct order for the phases task sets list component. */
  PhasesTaskSets: Array<PhasesTaskSets>;
  PrepaymentsList: Array<Prepayment>;
  PriceListsList: Array<PriceList>;
  /** Get project or project template data */
  Project?: Maybe<Project>;
  ProjectHealth?: Maybe<ProjectHealth>;
  ProjectMetricConfig: MetricConfig;
  ProjectMetrics: Array<SummaryBlockItem>;
  ProjectMetricsSettings: Array<MetricSettingOption>;
  ProjectNextNumber: Scalars['Int']['output'];
  ProjectRelations: Array<Maybe<Scalars['String']['output']>>;
  ProjectRevenueForecast: ProjectRevenueForecast;
  ProjectTabsList: Array<Tab>;
  ProjectTemplates: Array<ProjectTemplate>;
  ProjectsList: Array<Project>;
  ProjectsListMetricsProjectIds: Array<Scalars['ID']['output']>;
  PurchaseOrder: PurchaseOrder;
  PurchaseOrdersList: Array<PurchaseOrder>;
  Quote?: Maybe<Quote>;
  QuoteMatrix: QuoteMatrix;
  QuoteRevenueForecast: QuoteRevenueForecast;
  QuotesList: Array<Quote>;
  ReferralLinks: ReferralLinks;
  ReportsLibrary: ReportsLibrary;
  RequiredUniqueFields: ValidationFields;
  ResourcePlanningPortfolioProjects?: Maybe<ResourcePlanningPortfolioProjects>;
  ResourcePlanningPortfolioUsersList?: Maybe<ResourcePlanningPortfolio>;
  ResourcesList: Array<Resource>;
  Retainer?: Maybe<Retainer>;
  RevenueReportForecast: RevenueReportForecast;
  RevenueReportForecastExport: ExportResponse;
  Role?: Maybe<Role>;
  RolesExport: ExportResponse;
  RolesList: Array<Role>;
  SageDimensionsList: Array<SageDimension>;
  SalesforceIsQuoteLinked: Scalars['Boolean']['output'];
  SearchResults: Array<SearchResult>;
  SearchSettings: Array<SearchSetting>;
  SearchTotals: SearchTotal;
  SelfServiceAddOnPrice?: Maybe<SumWithCurrency>;
  /** Contains all site's currently active self-service package details. With ´userChanges´ argument can see a forecast of new state. */
  SelfServiceData: SelfServiceData;
  SelfServiceFeaturesOverLimit: Array<SelfServiceFeatureOverLimit>;
  SettingsLookup: Array<SettingLookup>;
  ShareSnapshot?: Maybe<ShareSnapshot>;
  SocketConnection: SocketConnection;
  StatusesList?: Maybe<Array<Status>>;
  StripeTemplatesList: Array<StripeTemplate>;
  SummaryBlock: Array<SummaryBlockItem>;
  TagsList: Array<Tag>;
  Task?: Maybe<Task>;
  TaskBudgetList: Array<TaskBudgetRow>;
  TaskSetsList?: Maybe<Array<TaskSet>>;
  TaskTemplate?: Maybe<TaskTemplate>;
  TaskUsersAvailability: Array<TaskUsersAvailability>;
  TasksList: Array<TaskMaybeLimitedByPermissions>;
  TasksSearch: Array<Task>;
  TeamReport: TeamReport;
  TeamReportExport: ExportResponse;
  TeamReportMetrics: Array<SummaryBlockItem>;
  TimeOffItem: TimeOffItem;
  TimeOffReport: TimeOffReport;
  TimeOffReportExport: ExportResponse;
  TimeOffTypesList: Array<TimeOffTypeListItem>;
  Trigger: Trigger;
  TriggerFieldsList: Array<TriggerFieldList>;
  TriggerModulesList: Array<TriggerModuleUnion>;
  TriggerNotifyOptions: Array<Scalars['String']['output']>;
  UnreadNotificationsCount: Scalars['Int']['output'];
  User?: Maybe<Array<User>>;
  UserEmailDraftsCount: Scalars['Int']['output'];
  UserGroupsList: Array<UserGroup>;
  UserTimeOffList: Array<UserTimeOff>;
  UserUtilization: Array<UserUtilizationResponse>;
  UsersList: Array<User>;
  VirtualAssistantChat: VirtualAssistantChatResponse;
  WorkReportList: Array<WorkReportPrimaryGroup>;
  /**
   * This field is required to not have an empty schema extension. Do not query,
   * please!
   */
  _: Scalars['Boolean']['output'];
};


export type QueryActiveTrialThreadArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActivityLogsArgs = {
  input: ActivityLogsInput;
};


export type QueryActivityTypesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  startFrom?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ActivityTypeStatus>;
};


export type QueryAvailabilityListArgs = {
  input: AvailabilityListInput;
};


export type QueryAvailableDateArgs = {
  availableDateParams: AvailableDateParamsInput;
};


export type QueryAvalaraDefaultFieldMappingsListArgs = {
  module: Scalars['String']['input'];
};


export type QueryAvalaraMandatesListArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvalaraMappingFieldsListArgs = {
  documentType?: InputMaybe<Scalars['String']['input']>;
  documentVersion?: InputMaybe<Scalars['String']['input']>;
  mandateId: Scalars['String']['input'];
};


export type QueryAvalaraScoroFieldsListArgs = {
  module: Scalars['String']['input'];
};


export type QueryBillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillsListArgs = {
  input?: InputMaybe<FinanceDocumentsListInput>;
};


export type QueryBookingsListArgs = {
  input: BookingsListInput;
};


export type QueryBookmarksListArgs = {
  input?: InputMaybe<BookmarkFilterInput>;
};


export type QueryBudgetsListArgs = {
  input: BudgetsListInput;
};


export type QueryCalendarEventsListArgs = {
  input?: InputMaybe<CalendarEventsListInput>;
};


export type QueryChecklistItemsArgs = {
  input?: InputMaybe<ChecklistItemsInput>;
};


export type QueryClientProfilesListArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommentReactionsArgs = {
  commentId: Scalars['Int']['input'];
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactCategoriesListArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactsListArgs = {
  input?: InputMaybe<ContactsListInput>;
};


export type QueryCurrenciesListArgs = {
  input?: InputMaybe<CurrenciesListInput>;
};


export type QueryCurrentUserTriggersListArgs = {
  input?: InputMaybe<TriggersListInput>;
};


export type QueryDynamicUserGroupsListArgs = {
  input: ModuleInput;
};


export type QueryEliChatHistoryArgs = {
  input: EliChatHistoryInput;
};


export type QueryEliChatMessageArgs = {
  input: EliChatMessageInput;
};


export type QueryEliInsightsBookmarkArgs = {
  input: EliInsightsBookmarkInput;
};


export type QueryEliInsightsHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEliInsightsModulesArgs = {
  input: EliInsightsModulesInput;
};


export type QueryEliWelcomeMessageArgs = {
  input: EliWelcomeMessageInput;
};


export type QueryExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpensesListArgs = {
  input?: InputMaybe<FinanceDocumentsListInput>;
};


export type QueryFiltersArgs = {
  module: Scalars['String']['input'];
};


export type QueryFreeTimeSlotListArgs = {
  input: FreeTimeSlotInput;
};


export type QueryHelpStationArticlesArgs = {
  tag: Scalars['String']['input'];
};


export type QueryHelpStationArticlesSearchArgs = {
  keyword: Scalars['String']['input'];
};


export type QueryHelpStationVideosArgs = {
  tag: Scalars['String']['input'];
};


export type QueryIntegrationActionListArgs = {
  input: IntegrationActionListInput;
};


export type QueryIntegrationGetAdapterArgs = {
  input: IntegrationGetAdapterInputType;
};


export type QueryIntegrationGetAppJwtArgs = {
  input: IntegrationGetJwtInputType;
};


export type QueryIntegrationItemArgs = {
  input: IntegrationItemInputType;
};


export type QueryIntegrationValidateAppJwtArgs = {
  input: IntegrationValidateJwtInputType;
};


export type QueryInvoicesListArgs = {
  input?: InputMaybe<FinanceDocumentsListInput>;
};


export type QueryIsUniqueFieldArgs = {
  input: IsUniqueFieldInput;
};


export type QueryLocalPriceListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocalPriceListFromPriceListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationsListArgs = {
  bookmarkHash?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startFrom?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrdersListArgs = {
  input?: InputMaybe<FinanceDocumentsListInput>;
};


export type QueryPermissionSetsListArgs = {
  input?: InputMaybe<PermissionSetsListInput>;
};


export type QueryPermissionSetsPermissionsArgs = {
  input?: InputMaybe<PermissionSetsPermissionsInput>;
};


export type QueryPhasesTaskSetsArgs = {
  projectParams: ProjectParamsInput;
};


export type QueryPrepaymentsListArgs = {
  input?: InputMaybe<FinanceDocumentsListInput>;
};


export type QueryPriceListsListArgs = {
  input?: InputMaybe<PriceListsListInput>;
};


export type QueryProjectArgs = {
  projectParams: ProjectParamsInput;
};


export type QueryProjectHealthArgs = {
  input?: InputMaybe<ProjectHealthInput>;
};


export type QueryProjectMetricConfigArgs = {
  input?: InputMaybe<ProjectMetricConfigInput>;
};


export type QueryProjectMetricsArgs = {
  input?: InputMaybe<ProjectMetricsInput>;
};


export type QueryProjectMetricsSettingsArgs = {
  input?: InputMaybe<ProjectMetricsInput>;
};


export type QueryProjectRelationsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectRevenueForecastArgs = {
  input: ProjectRevenueForecastInput;
};


export type QueryProjectTabsListArgs = {
  input: ProjectTabsListInput;
};


export type QueryProjectsListArgs = {
  input?: InputMaybe<ProjectsListInput>;
};


export type QueryProjectsListMetricsProjectIdsArgs = {
  input?: InputMaybe<SummaryBlockInput>;
};


export type QueryPurchaseOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPurchaseOrdersListArgs = {
  input?: InputMaybe<FinanceDocumentsListInput>;
};


export type QueryQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuoteMatrixArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuoteRevenueForecastArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuotesListArgs = {
  filters?: InputMaybe<QuoteFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<QuoteOrderingInput>>;
  startFrom?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRequiredUniqueFieldsArgs = {
  input: RequiredUniqueFieldsInput;
};


export type QueryResourcePlanningPortfolioProjectsArgs = {
  input?: InputMaybe<ResourcePlanningPortfolioProjectsFiltersInput>;
};


export type QueryResourcePlanningPortfolioUsersListArgs = {
  input?: InputMaybe<FilterHashInput>;
};


export type QueryResourcesListArgs = {
  input?: InputMaybe<ResourcesListInput>;
};


export type QueryRetainerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRevenueReportForecastArgs = {
  input: FilterHashInput;
};


export type QueryRevenueReportForecastExportArgs = {
  input: RevenueReportForecastExportInput;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesExportArgs = {
  input: ExportInput;
};


export type QueryRolesListArgs = {
  input?: InputMaybe<RolesListInput>;
};


export type QuerySageDimensionsListArgs = {
  input: Scalars['String']['input'];
};


export type QuerySalesforceIsQuoteLinkedArgs = {
  input: SalesforceIsQuoteLinkedInputType;
};


export type QuerySearchResultsArgs = {
  input: SearchInput;
};


export type QuerySearchTotalsArgs = {
  input: SearchInput;
};


export type QuerySelfServiceAddOnPriceArgs = {
  featureId: Scalars['Int']['input'];
};


export type QuerySelfServiceDataArgs = {
  siteId?: InputMaybe<Scalars['ID']['input']>;
  userChanges?: InputMaybe<SelfServiceDataInput>;
};


export type QuerySelfServiceFeaturesOverLimitArgs = {
  input: SelfServiceDataInput;
};


export type QuerySettingsLookupArgs = {
  input?: InputMaybe<SettingLookupRequest>;
};


export type QueryShareSnapshotArgs = {
  input: ShareSnapshotInput;
};


export type QuerySocketConnectionArgs = {
  moduleName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStatusesListArgs = {
  input?: InputMaybe<StatusesListInput>;
};


export type QuerySummaryBlockArgs = {
  input?: InputMaybe<SummaryBlockInput>;
};


export type QueryTagsListArgs = {
  input?: InputMaybe<TagsListInput>;
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaskBudgetListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaskSetsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  startFrom?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaskUsersAvailabilityArgs = {
  input: TaskUsersAvailabilityInput;
};


export type QueryTasksListArgs = {
  input?: InputMaybe<TasksListInput>;
};


export type QueryTasksSearchArgs = {
  input: TasksSearchInput;
};


export type QueryTeamReportArgs = {
  input: FilterHashInput;
};


export type QueryTeamReportExportArgs = {
  input: FilterHashExportInput;
};


export type QueryTeamReportMetricsArgs = {
  input: FilterHashInput;
};


export type QueryTimeOffItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTimeOffReportArgs = {
  input: FilterHashInput;
};


export type QueryTimeOffReportExportArgs = {
  input: FilterHashExportInput;
};


export type QueryTimeOffTypesListArgs = {
  input?: InputMaybe<TimeOffTypesListFiltersInput>;
};


export type QueryTriggerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTriggerFieldsListArgs = {
  customModule?: InputMaybe<Scalars['String']['input']>;
  module?: InputMaybe<ModuleType>;
};


export type QueryUserTimeOffListArgs = {
  input: UserTimeOffListInput;
};


export type QueryUserUtilizationArgs = {
  input: UserUtilizationInput;
};


export type QueryUsersListArgs = {
  input?: InputMaybe<UsersListInput>;
};


export type QueryVirtualAssistantChatArgs = {
  input: Array<InputMaybe<VirtualAssistantMessageInput>>;
};


export type QueryWorkReportListArgs = {
  bookmarkHash?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startFrom?: InputMaybe<Scalars['Int']['input']>;
};

export type Quote = {
  __typename?: 'Quote';
  author: User;
  confirmedDate?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  discount2?: Maybe<Scalars['Float']['output']>;
  discount3?: Maybe<Scalars['Float']['output']>;
  /** Currency multiplier for converting the sums from quote's currency to user's display currency */
  displayCurrencyRate: Scalars['Float']['output'];
  estimatedDuration?: Maybe<Scalars['Int']['output']>;
  hasProjectOnEachLine: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isRoleBased: Scalars['Boolean']['output'];
  issueDate: Scalars['Date']['output'];
  lines: Array<QuoteLine>;
  localPriceList?: Maybe<LocalPriceList>;
  mainContact?: Maybe<Contact>;
  margin?: Maybe<Scalars['Float']['output']>;
  number: Scalars['String']['output'];
  project?: Maybe<Project>;
  quoteName?: Maybe<Scalars['String']['output']>;
  revenueIncludeCosts: Scalars['Boolean']['output'];
  revenueStartDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Status>;
  /** Quote sum after all discounts and without tax */
  sum: Scalars['Float']['output'];
};

export type QuoteFiltersInput = {
  isStatusSuccessful?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteLine = {
  __typename?: 'QuoteLine';
  amount: Scalars['Float']['output'];
  /** Total budgeted duration in seconds. */
  budgetedDuration: Scalars['Duration']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  /** Total cost of the quote line. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Discount percentage applied to this quote line. */
  discount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isEmptyRow: Scalars['Boolean']['output'];
  /** Whether this quote line is internal or outsourced. */
  isInternal: Scalars['Boolean']['output'];
  isSubHeading: Scalars['Boolean']['output'];
  ordering: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  product?: Maybe<Product>;
  project?: Maybe<Project>;
  /** List of providers for this quote line. */
  providers?: Maybe<Array<QuoteLineProvider>>;
  quote: Quote;
  secondaryAmount: Scalars['Float']['output'];
  /** Line sum without tax, includes line-based and quote discounts. */
  sumAfterAllDiscounts: Scalars['Float']['output'];
  unit?: Maybe<Unit>;
  /** Sum of the quote line minus sum of every linked bill AND expense line. */
  unlinkedSum: Scalars['Float']['output'];
};

export type QuoteLineMaybeHiddenByPermissions = HiddenByPermissions | QuoteLine;

export type QuoteLineProvider = {
  __typename?: 'QuoteLineProvider';
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  role?: Maybe<Role>;
  unitCost?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
};

export type QuoteMatrix = {
  __typename?: 'QuoteMatrix';
  extraProviders: Array<QuoteMatrixProvider>;
  quote: Quote;
  settings: QuoteMatrixSettings;
};

export type QuoteMatrixProvider = {
  __typename?: 'QuoteMatrixProvider';
  role?: Maybe<Role>;
  user?: Maybe<User>;
};

export type QuoteMatrixSettings = {
  __typename?: 'QuoteMatrixSettings';
  canSeeLaborCost: Scalars['Boolean']['output'];
  hoursPerDay: Scalars['Float']['output'];
  isSecondaryQuantityEnabled: Scalars['Boolean']['output'];
  secondaryQuantityLabel: Scalars['String']['output'];
};

export type QuoteOrderingInput = {
  direction?: InputMaybe<SortDirection>;
  orderBy: QuotesListOrderBy;
};

export type QuoteRevenueForecast = {
  __typename?: 'QuoteRevenueForecast';
  periods: Array<RevenueForecastPeriod>;
  quote: Quote;
};

export type QuoteShareInput = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  pdfTemplateId?: InputMaybe<Scalars['Int']['input']>;
};

export const QuotesListOrderBy = {
  IssueDate: 'ISSUE_DATE',
  Number: 'NUMBER',
  ProjectName: 'PROJECT_NAME'
} as const;

export type QuotesListOrderBy = typeof QuotesListOrderBy[keyof typeof QuotesListOrderBy];
export type RealEstateObject = {
  __typename?: 'RealEstateObject';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ReferralLinks = {
  __typename?: 'ReferralLinks';
  linkedIn: Scalars['String']['output'];
  portal?: Maybe<Scalars['String']['output']>;
  share: Scalars['String']['output'];
};

export type RelationCustomFieldValue = {
  __typename?: 'RelationCustomFieldValue';
  relation?: Maybe<RelationValue>;
};

export type RelationValue = CalendarEvent | Contact | CustomModuleEntry | Project | Task | User;

export type RentalOrder = {
  __typename?: 'RentalOrder';
  id: Scalars['ID']['output'];
  mainContact?: Maybe<Contact>;
  number: Scalars['String']['output'];
};

export type ReportDataGroupInterface = {
  /** Unique grouping ID in this report level */
  id?: Maybe<Scalars['ID']['output']>;
  /** The title to be displayed at the beginning of this reporting group */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of grouping used in this reporting level (aka "grouped by" type) */
  type: Scalars['String']['output'];
};

export type ReportsLibrary = {
  __typename?: 'ReportsLibrary';
  categories?: Maybe<Array<Scalars['String']['output']>>;
  reports?: Maybe<Array<ReportsLibraryReport>>;
};

export type ReportsLibraryReport = {
  __typename?: 'ReportsLibraryReport';
  categories: Array<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RequiredUniqueFieldsInput = {
  module: Scalars['String']['input'];
};

export type Resource = {
  __typename?: 'Resource';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ResourcePlanningPortfolio = {
  __typename?: 'ResourcePlanningPortfolio';
  roles: Array<Role>;
  users: Array<User>;
};

export type ResourcePlanningPortfolioProjects = {
  __typename?: 'ResourcePlanningPortfolioProjects';
  projects: Array<Project>;
  role?: Maybe<Role>;
  user?: Maybe<User>;
};

export type ResourcePlanningPortfolioProjectsFiltersInput = {
  endDate: Scalars['DateTime']['input'];
  filterHash: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['DateTime']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ResourcesFiltersInput = {
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
};

export type ResourcesListInput = {
  filters?: InputMaybe<ResourcesFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export type Retainer = {
  __typename?: 'Retainer';
  budgetType: RetainerBudget;
  endDate?: Maybe<Scalars['Date']['output']>;
  frequency: Scalars['Int']['output'];
  frequencyType: RetainerFrequency;
  id: Scalars['ID']['output'];
  isPeriodDurationEnabled?: Maybe<Scalars['Boolean']['output']>;
  noOfPeriods: Scalars['Int']['output'];
  periodBillsSum?: Maybe<Scalars['Float']['output']>;
  periodDuration?: Maybe<Scalars['Int']['output']>;
  periodExpensesSum?: Maybe<Scalars['Float']['output']>;
  periodLaborCostSum?: Maybe<Scalars['Float']['output']>;
  periodSum?: Maybe<Scalars['Float']['output']>;
  periods: Array<RetainerPeriod>;
  startDate?: Maybe<Scalars['Date']['output']>;
  totalDuration?: Maybe<Scalars['Int']['output']>;
  totalSum?: Maybe<Scalars['Float']['output']>;
};


export type RetainerTotalSumArgs = {
  input?: InputMaybe<RetainerValuesInput>;
};

export const RetainerBudget = {
  Manual: 'MANUAL',
  Quote: 'QUOTE'
} as const;

export type RetainerBudget = typeof RetainerBudget[keyof typeof RetainerBudget];
export const RetainerFrequency = {
  Day: 'DAY',
  Month: 'MONTH',
  Week: 'WEEK'
} as const;

export type RetainerFrequency = typeof RetainerFrequency[keyof typeof RetainerFrequency];
export type RetainerPeriod = {
  __typename?: 'RetainerPeriod';
  actualDuration?: Maybe<Scalars['Int']['output']>;
  actualSum?: Maybe<Scalars['Float']['output']>;
  defaultName?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
  sum?: Maybe<Scalars['Float']['output']>;
};


export type RetainerPeriodActualDurationArgs = {
  input: RetainerValuesInput;
};


export type RetainerPeriodActualSumArgs = {
  input: RetainerValuesInput;
};


export type RetainerPeriodSumArgs = {
  input?: InputMaybe<RetainerValuesInput>;
};

export type RetainerSaveInput = {
  id: Scalars['ID']['input'];
  periods: Array<RetainerSavePeriodInput>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type RetainerSavePeriodInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  sum?: InputMaybe<Scalars['Float']['input']>;
};

export type RetainerValuesInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
};

export type RevenueForecastPeriod = {
  __typename?: 'RevenueForecastPeriod';
  earnedRevenue?: Maybe<Scalars['Float']['output']>;
  forecastedRevenue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isRevenueSetByUser: Scalars['Boolean']['output'];
  period: Scalars['String']['output'];
  project?: Maybe<Project>;
  quote?: Maybe<Quote>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

export type RevenueForecastPeriodSaveInput = {
  forecastedRevenue?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  recognizedRevenue?: InputMaybe<Scalars['Float']['input']>;
};

export type RevenueReportForecast = {
  __typename?: 'RevenueReportForecast';
  revenueReportForecastList: Array<RevenueReportForecastListItem>;
  revenueReportForecastSummary?: Maybe<RevenueReportForecastSummary>;
};

export type RevenueReportForecastExportInput = {
  exportInput: ExportInput;
  filterHashInput: FilterHashInput;
};

export const RevenueReportForecastGroupByEnum = {
  Clients: 'CLIENTS',
  ProjectsQuotes: 'PROJECTS_QUOTES'
} as const;

export type RevenueReportForecastGroupByEnum = typeof RevenueReportForecastGroupByEnum[keyof typeof RevenueReportForecastGroupByEnum];
export type RevenueReportForecastListItem = {
  __typename?: 'RevenueReportForecastListItem';
  client?: Maybe<Contact>;
  periods: Array<RevenueReportForecastPeriod>;
  project?: Maybe<Project>;
  quote?: Maybe<Quote>;
};

export type RevenueReportForecastPeriod = {
  __typename?: 'RevenueReportForecastPeriod';
  displayRevenue?: Maybe<Scalars['Float']['output']>;
  period: Scalars['Date']['output'];
};

export type RevenueReportForecastSummary = {
  __typename?: 'RevenueReportForecastSummary';
  fromDate: Scalars['Date']['output'];
  groupBy: RevenueReportForecastGroupByEnum;
  isProjectsSelected: Scalars['Boolean']['output'];
  isQuotesSelected: Scalars['Boolean']['output'];
  numberOfPeriods: Scalars['Int']['output'];
  periods: Array<RevenueReportForecastSummaryPeriod>;
};

export type RevenueReportForecastSummaryPeriod = {
  __typename?: 'RevenueReportForecastSummaryPeriod';
  period: Scalars['Date']['output'];
  pipelineRevenue: Scalars['Float']['output'];
  recognizedRevenue: Scalars['Float']['output'];
};

export type Role = {
  __typename?: 'Role';
  /** Hsl color from role name */
  hslColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Role initials (unique) */
  initials?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  laborCost?: Maybe<Scalars['Float']['output']>;
  /** Default role name */
  name: Scalars['String']['output'];
  /** All role price lists */
  priceLists: Array<RolePriceList>;
  /** By default uses the global role price of the default price list in the currency of the price list. */
  sellingPrice?: Maybe<Scalars['Float']['output']>;
  /** All role translations in different languages */
  translations: Array<RoleTranslation>;
  users: Array<User>;
  usersCount: Scalars['Int']['output'];
};


export type RoleLaborCostArgs = {
  input?: InputMaybe<LaborCostInput>;
};


export type RoleSellingPriceArgs = {
  input?: InputMaybe<RoleSellingPriceInput>;
};


export type RoleUsersArgs = {
  input?: InputMaybe<UsersListInput>;
};

export type RolePermissions = {
  __typename?: 'RolePermissions';
  canToggleRolesOff: Scalars['Boolean']['output'];
};

export type RolePriceList = {
  __typename?: 'RolePriceList';
  buyingPrice?: Maybe<Scalars['Float']['output']>;
  priceList: PriceList;
  sellingPrice?: Maybe<Scalars['Float']['output']>;
};

export type RoleProject = {
  __typename?: 'RoleProject';
  id: Scalars['ID']['output'];
  project: Project;
  role: Role;
};

export type RoleSaveInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  priceLists: Array<RoleSavePriceListInput>;
  translations: Array<RoleSaveTranslationInput>;
  userIds: Array<Scalars['ID']['input']>;
};

export type RoleSavePriceListInput = {
  buyingPrice?: InputMaybe<Scalars['Float']['input']>;
  priceListId: Scalars['ID']['input'];
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type RoleSaveTranslationInput = {
  description: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type RoleSellingPriceInput = {
  /** If set, use the selling price from the given local price list. */
  localPriceListId?: InputMaybe<Scalars['ID']['input']>;
  /** If set, use the role's global selling price of the given price list. */
  priceListId?: InputMaybe<Scalars['ID']['input']>;
};

export type RoleTranslation = {
  __typename?: 'RoleTranslation';
  description: Scalars['String']['output'];
  languageId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RolesFiltersInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RolesListInput = {
  filters?: InputMaybe<RolesFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export type SageDimension = {
  __typename?: 'SageDimension';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Array<Maybe<SageDimensionOptionType>>;
  value: Scalars['String']['output'];
};

export type SageDimensionOptionType = {
  __typename?: 'SageDimensionOptionType';
  value: Scalars['ID']['output'];
};

export type SageDimensionsSaveInput = {
  dimensions?: InputMaybe<Array<InputMaybe<SageDimensionsSaveListInput>>>;
  module: Scalars['String']['input'];
};

export type SageDimensionsSaveListInput = {
  dimension: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SalesforceIsQuoteLinkedInputType = {
  quoteId: Scalars['Int']['input'];
};

export type SalesforceSyncQuoteSumAndPdfInputType = {
  quoteId: Scalars['Int']['input'];
};

export type SearchInput = {
  feature: FeatureInput;
  keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  startFrom?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchResult = UnionBill | UnionContact | UnionExpense | UnionFile | UnionInvoice | UnionMarketingList | UnionNewsFeedItem | UnionOrder | UnionProject | UnionPurchaseOrder | UnionQuote | UnionRealEstateObject | UnionRentalOrder | UnionUser;

export type SearchSetting = {
  __typename?: 'SearchSetting';
  feature: Feature;
  isEnabled: Scalars['Boolean']['output'];
};

export type SearchTotal = {
  __typename?: 'SearchTotal';
  count: Scalars['Int']['output'];
  feature: Feature;
};

export type SelfServiceAddon = {
  __typename?: 'SelfServiceAddon';
  amountInUse: Scalars['Int']['output'];
  annualPrice: Scalars['Float']['output'];
  availableInPackage: Scalars['Boolean']['output'];
  cannotRemove: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['Translation']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isBundle: Scalars['Boolean']['output'];
  isFree: Scalars['Boolean']['output'];
  isGlobal: Scalars['Boolean']['output'];
  isInUse: Scalars['Boolean']['output'];
  isIncludedInPackage: Scalars['Boolean']['output'];
  isPerUser: Scalars['Boolean']['output'];
  isTool: Scalars['Boolean']['output'];
  monthlyPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  setupPrice: Scalars['Float']['output'];
};

export type SelfServiceAddonInput = {
  amountInUse?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export const SelfServiceBillingCycleType = {
  Annual: 'ANNUAL',
  Monthly: 'MONTHLY'
} as const;

export type SelfServiceBillingCycleType = typeof SelfServiceBillingCycleType[keyof typeof SelfServiceBillingCycleType];
export const SelfServiceCancelSubscriptionReason = {
  CompanyBudgetCuts: 'COMPANY_BUDGET_CUTS',
  CompanyNoLongerTrading: 'COMPANY_NO_LONGER_TRADING',
  CompanyRestructuring: 'COMPANY_RESTRUCTURING',
  Price: 'PRICE',
  ProductComplexityUx: 'PRODUCT_COMPLEXITY_UX',
  ProductFunctionalityLimitation: 'PRODUCT_FUNCTIONALITY_LIMITATION',
  ProductPerformance: 'PRODUCT_PERFORMANCE',
  UnsatisfactoryProfessionalServices: 'UNSATISFACTORY_PROFESSIONAL_SERVICES'
} as const;

export type SelfServiceCancelSubscriptionReason = typeof SelfServiceCancelSubscriptionReason[keyof typeof SelfServiceCancelSubscriptionReason];
export type SelfServiceCancelSubscriptionRequestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: SelfServiceCancelSubscriptionReason;
};

export type SelfServiceCompanyAccount = {
  __typename?: 'SelfServiceCompanyAccount';
  /** Determines, if this account is related to any non-cupo user */
  hasRelatedUsers: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInUse?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type SelfServiceCompanyAccountInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export const SelfServiceCurrency = {
  Aud: 'AUD',
  Cad: 'CAD',
  Eur: 'EUR',
  Gbp: 'GBP',
  Usd: 'USD'
} as const;

export type SelfServiceCurrency = typeof SelfServiceCurrency[keyof typeof SelfServiceCurrency];
export type SelfServiceData = {
  __typename?: 'SelfServiceData';
  addons: Array<SelfServiceAddon>;
  billingCycle: SelfServiceBillingCycleType;
  companyAccounts: Array<SelfServiceCompanyAccount>;
  currency: SelfServiceCurrency;
  currentOnboardingPackage?: Maybe<SelfServiceOnboardingPackage>;
  currentPackage: SelfServicePackage;
  customAddons?: Maybe<Array<SelfServiceAddon>>;
  isVoucherApplied: Scalars['Boolean']['output'];
  /** Minimum amount of seats the client can have - depending on package or site configuration. */
  minSeatCount?: Maybe<Scalars['Int']['output']>;
  /** Date for onboarding payment or end-of-the-billing-cycle changes payment. */
  nextPaymentDate?: Maybe<Scalars['Date']['output']>;
  /** Sum that is used for onboarding payment. Value represented in currency returned in CURRENCY field. */
  nextPaymentSum?: Maybe<Scalars['Float']['output']>;
  onboardingCustomPrice?: Maybe<Scalars['Float']['output']>;
  onboardingPackages?: Maybe<Array<SelfServiceOnboardingPackage>>;
  packages: Array<SelfServicePackage>;
  /** Amount of user seats included in the current package, that the client is actually paying for. */
  paidSeatCount?: Maybe<Scalars['Int']['output']>;
  /** Sites currently active payment method info */
  paymentInfo: SelfServicePaymentMethodInfo;
  seatReductionRequests?: Maybe<Array<SelfServiceSeatReductionRequest>>;
  /** The site for which self-service is used for */
  site: Site;
  /** Date of the next standard payment (depending on active BILLING_CYCLE). For date of next regular monthly payment. */
  standardPaymentDate?: Maybe<Scalars['Date']['output']>;
  /**
   * Sum that is used for standard payments (depending on active BILLING_CYCLE). For example regular monthly payment sum.
   * 					Value represented in currency returned in CURRENCY field.
   */
  standardPaymentSum?: Maybe<Scalars['Float']['output']>;
  /** Amount of user seats that the client is actually using - active users count. */
  usedSeatCount?: Maybe<Scalars['Int']['output']>;
};

export type SelfServiceDataInput = {
  addons?: InputMaybe<Array<SelfServiceAddonInput>>;
  billingCycle: SelfServiceBillingCycleType;
  companyAccounts: Array<SelfServiceCompanyAccountInput>;
  customAddons?: InputMaybe<Array<SelfServiceAddonInput>>;
  onboardingPackageId?: InputMaybe<Scalars['ID']['input']>;
  packageId: Scalars['ID']['input'];
  paidSeatCount: Scalars['Int']['input'];
};

export type SelfServiceFeatureOverLimit = {
  __typename?: 'SelfServiceFeatureOverLimit';
  actionUrl?: Maybe<Scalars['String']['output']>;
  currentUsage: Scalars['Int']['output'];
  feature: Feature;
  isBlockingDowngrade: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  willDeleteData: Scalars['Boolean']['output'];
};

export type SelfServiceOnboardingPackage = {
  __typename?: 'SelfServiceOnboardingPackage';
  description?: Maybe<Scalars['Translation']['output']>;
  id: Scalars['ID']['output'];
  maxUserCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['Translation']['output'];
  price: Scalars['Float']['output'];
};

export type SelfServicePackage = {
  __typename?: 'SelfServicePackage';
  annualPrice: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isTrialPackage: Scalars['Boolean']['output'];
  minSeatCount: Scalars['Int']['output'];
  monthlyPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  sortingOrder: Scalars['Int']['output'];
};

export type SelfServicePaymentMethodInfo = {
  __typename?: 'SelfServicePaymentMethodInfo';
  creditCardLastNumbers?: Maybe<Scalars['String']['output']>;
  hasPaymentHistory: Scalars['Boolean']['output'];
  type: SelfServicePaymentMethodType;
};

export const SelfServicePaymentMethodType = {
  Invoice: 'INVOICE',
  NotSet: 'NOT_SET',
  Stripe: 'STRIPE'
} as const;

export type SelfServicePaymentMethodType = typeof SelfServicePaymentMethodType[keyof typeof SelfServicePaymentMethodType];
export type SelfServiceSeatReductionRequest = {
  __typename?: 'SelfServiceSeatReductionRequest';
  createdDate: Scalars['DateTime']['output'];
  createdUser: User;
  effectiveDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  modifiedDate?: Maybe<Scalars['DateTime']['output']>;
  modifiedUser?: Maybe<User>;
  reductionAmount: Scalars['Int']['output'];
};

export type SelfServiceSendSeatReductionRequestInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  reductionAmount: Scalars['Int']['input'];
};

export type Setting = {
  __typename?: 'Setting';
  name: Scalars['String']['output'];
  value: Scalars['SettingValue']['output'];
};

export type SettingLookup = {
  __typename?: 'SettingLookup';
  path: Scalars['String']['output'];
  siteHasAccess: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  userHasAccess: Scalars['Boolean']['output'];
};

export type SettingLookupRequest = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SettingSaveInput = {
  name: Scalars['String']['input'];
  value: Scalars['SettingValue']['input'];
};

export type ShareSnapshot = {
  __typename?: 'ShareSnapshot';
  id: Scalars['ID']['output'];
  isUrlExpired: Scalars['Boolean']['output'];
  snapshotDate: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type ShareSnapshotInput = {
  id: Scalars['ID']['input'];
  shareType: ShareTypeEnum;
};

export const ShareTypeEnum = {
  GanttChart: 'GANTT_CHART',
  Quotes: 'QUOTES'
} as const;

export type ShareTypeEnum = typeof ShareTypeEnum[keyof typeof ShareTypeEnum];
export type Site = {
  __typename?: 'Site';
  abTag?: Maybe<Scalars['String']['output']>;
  canScheduleDemo: Scalars['Boolean']['output'];
  hasPaymentMethod: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isFree: Scalars['Boolean']['output'];
  isSiteExpired: Scalars['Boolean']['output'];
  isTrialActive: Scalars['Boolean']['output'];
  isTrialExpired: Scalars['Boolean']['output'];
  marketingCompanySize?: Maybe<Scalars['String']['output']>;
  paidUntilDate?: Maybe<Scalars['Date']['output']>;
  server: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  siteUrl: Scalars['String']['output'];
  trialExpireDateTime?: Maybe<Scalars['DateTime']['output']>;
  version: Version;
};

export type SocketConnection = {
  __typename?: 'SocketConnection';
  serverUrl: Scalars['String']['output'];
  userToken: Scalars['String']['output'];
};

export const SortDirection = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];
export type StaticStatus = {
  __typename?: 'StaticStatus';
  /** color of the status, RGB values as hex string, e.g. #00AA77 */
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
  statusId: Scalars['String']['output'];
};

export type Status = {
  __typename?: 'Status';
  /** color of the status, RGB values as hex string, e.g. #00AA77 */
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  statusId: Scalars['String']['output'];
};

export type StatusChangeInput = {
  module: StatusModulesEnum;
  objectId: Scalars['ID']['input'];
  statusId: Scalars['String']['input'];
};

/** Default Modules For Status */
export const StatusModulesEnum = {
  /** Calendar */
  Calendar: 'CALENDAR',
  /** Orders */
  Orders: 'ORDERS',
  /** Projects */
  Projects: 'PROJECTS',
  /** Purchase Orders */
  PurchaseOrders: 'PURCHASE_ORDERS',
  /** Quotes */
  Quotes: 'QUOTES',
  /** Rental Orders */
  RentalOrders: 'RENTAL_ORDERS',
  /** Tasks */
  Tasks: 'TASKS'
} as const;

export type StatusModulesEnum = typeof StatusModulesEnum[keyof typeof StatusModulesEnum];
export type StatusesFiltersInput = {
  customModuleName?: InputMaybe<Scalars['String']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  module?: InputMaybe<ModuleType>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
};

export type StatusesListInput = {
  filters?: InputMaybe<StatusesFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export type StringCustomFieldValue = {
  __typename?: 'StringCustomFieldValue';
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type StripeTemplate = {
  __typename?: 'StripeTemplate';
  id: Scalars['ID']['output'];
  isPaymentLinkActive: Scalars['Boolean']['output'];
  relatedObject: StripeTemplateObject;
};

export type StripeTemplateObject = EmailTemplate | PdfTemplate;

export type SumWithCurrency = {
  __typename?: 'SumWithCurrency';
  currency: Scalars['String']['output'];
  sum: Scalars['Float']['output'];
};

export type SummaryBlockInput = {
  filterHash?: InputMaybe<Scalars['String']['input']>;
  module: Scalars['String']['input'];
};

export type SummaryBlockItem = {
  __typename?: 'SummaryBlockItem';
  config?: Maybe<MetricConfig>;
  id: Scalars['ID']['output'];
  isSecondaryValueFirst?: Maybe<Scalars['Boolean']['output']>;
  secondaryDescription?: Maybe<Scalars['String']['output']>;
  secondaryUnit?: Maybe<Scalars['String']['output']>;
  secondaryValue?: Maybe<Scalars['Float']['output']>;
  secondaryValueState?: Maybe<MetricsValueState>;
  title: Scalars['String']['output'];
  type: SummaryBlockItemType;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueState?: Maybe<MetricsValueState>;
};

export const SummaryBlockItemType = {
  Decimal: 'DECIMAL',
  Duration: 'DURATION',
  Integer: 'INTEGER',
  Money: 'MONEY'
} as const;

export type SummaryBlockItemType = typeof SummaryBlockItemType[keyof typeof SummaryBlockItemType];
export type Tab = {
  __typename?: 'Tab';
  isActive: Scalars['Boolean']['output'];
  key: TabKey;
  shortcuts: Array<TabShortcut>;
  subTabs: Array<Tab>;
};

export const TabKey = {
  Budget: 'Budget',
  BudgetBreakdown: 'BudgetBreakdown',
  BudgetBurnUp: 'BudgetBurnUp',
  BudgetHealth: 'BudgetHealth',
  BudgetProfit: 'BudgetProfit',
  BudgetQuotedVsActual: 'BudgetQuotedVsActual',
  Calendar: 'Calendar',
  Comments: 'Comments',
  Details: 'Details',
  EventList: 'EventList',
  Finances: 'Finances',
  ResourcePlanning: 'ResourcePlanning',
  RevenueForecast: 'RevenueForecast',
  TaskBoard: 'TaskBoard',
  Tasks: 'Tasks',
  TasksGantt: 'TasksGantt',
  TasksList: 'TasksList',
  Time: 'Time'
} as const;

export type TabKey = typeof TabKey[keyof typeof TabKey];
export type TabSaveInput = {
  isActive: Scalars['Boolean']['input'];
  subTabs?: InputMaybe<Array<TabSaveInput>>;
  tabKey: TabKey;
};

export type TabShortcut = {
  __typename?: 'TabShortcut';
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type TabsSaveInput = {
  module: ModuleType;
  tabs: Array<TabSaveInput>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  isGroup: Scalars['Boolean']['output'];
  parent?: Maybe<Tag>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TagsFiltersInput = {
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
};

export type TagsListInput = {
  filters?: InputMaybe<TagsFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export type Task = {
  __typename?: 'Task';
  activityType?: Maybe<ActivityType>;
  assignees: Array<TaskAssignee>;
  billableTimeType: BillableTimeTypeEnum;
  /** Budgeted duration from the linked quote line. Returns null if user lacks permission or task has no quote line. */
  budgetedDuration?: Maybe<Scalars['Duration']['output']>;
  comments: Array<Comment>;
  commentsCount: Scalars['Int']['output'];
  company?: Maybe<Contact>;
  completedDateTime?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  dueDateTime?: Maybe<Scalars['DateTime']['output']>;
  durationBillableDone: Scalars['Int']['output'];
  durationBillablePlanned: Scalars['Int']['output'];
  durationBillableRemaining: Scalars['Int']['output'];
  durationBillableScheduled: Scalars['Int']['output'];
  /** Sum of done actual duration and past scheduled time entries (those need to be considered as done). */
  durationDone: Scalars['Int']['output'];
  durationPlanned: Scalars['Int']['output'];
  durationRemaining: Scalars['Int']['output'];
  /**
   * Duration of time entries scheduled today or in the future.
   * 					Time entries scheduled in the past are considered as done and are not added to this duration.
   */
  durationScheduled: Scalars['Int']['output'];
  hasCustomAllocation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDone: Scalars['Boolean']['output'];
  /** Whether the linked quote line is attached to more than one parent task. Returns false if task has no quote line. */
  isQuoteLineShared: Scalars['Boolean']['output'];
  isRequiredFieldsMissing: Scalars['Boolean']['output'];
  isTimeEntriesRequiredFieldsMissing: Scalars['Boolean']['output'];
  modifiedBy?: Maybe<User>;
  modifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  permissions: TaskPermissions;
  person?: Maybe<Contact>;
  priority?: Maybe<Priority>;
  /** Calculated taking into account that past scheduled time entries need to be considered as done. */
  progressPercentage: Scalars['Int']['output'];
  project?: Maybe<Project>;
  projectPhase?: Maybe<ProjectPhase>;
  quote?: Maybe<Quote>;
  quoteLine?: Maybe<QuoteLine>;
  /** Calculated using billable time. Returns null if no permission or task has no quote line. */
  remainingBudgetedDuration?: Maybe<Scalars['Duration']['output']>;
  responsibleUser?: Maybe<User>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Status>;
  strippedDescription?: Maybe<Scalars['String']['output']>;
  subtasks: Array<TaskMaybeLimitedByPermissions>;
  subtasksCount: Scalars['Int']['output'];
  /** Sum of billable done durations of the task and all its subtasks. */
  totalDurationBillableDone: Scalars['Duration']['output'];
  /** Sum of billable planned durations of the task and all its subtasks. */
  totalDurationBillablePlanned: Scalars['Duration']['output'];
  /** Sum of billable remaining durations of the task and all its subtasks. */
  totalDurationBillableRemaining: Scalars['Duration']['output'];
  /**
   * Sum of done durations of the task and all its subtasks.
   * 					Done duration includes actual done duration and past scheduled time entries (those need to be considered as done).
   */
  totalDurationDone: Scalars['Duration']['output'];
  /** Sum of planned durations of the task and all its subtasks. */
  totalDurationPlanned: Scalars['Duration']['output'];
  /** Sum of remaining durations of the task and all its subtasks. */
  totalDurationRemaining: Scalars['Duration']['output'];
  /**
   * Sum of scheduled durations of the task and all its subtasks.
   * 					Scheduled duration includes time entries scheduled today or in the future.
   * 					Time entries scheduled in the past are considered as done and are not added to this duration.
   */
  totalDurationScheduled: Scalars['Duration']['output'];
  /**
   * Calculated taking into account that past scheduled time entries need to be considered as done.
   * 					Calculated for the task and all its subtasks together.
   */
  totalProgressPercentage: Scalars['Int']['output'];
};

export type TaskAssignee = {
  __typename?: 'TaskAssignee';
  allocatedDuration: Scalars['Duration']['output'];
  role?: Maybe<Role>;
  user?: Maybe<User>;
};

export type TaskAssigneesInput = {
  allocatedDuration?: InputMaybe<Scalars['Duration']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type TaskAssigneesSaveInput = {
  assignees: Array<TaskAssigneesInput>;
  /** Individual allocation toggle - on or off. If it is false, allocatedDuration value is not saved. */
  hasCustomAllocation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notify checkbox */
  shouldNotify?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['ID']['input'];
};

export type TaskBudgetRow = {
  __typename?: 'TaskBudgetRow';
  budgetedDuration: Scalars['Duration']['output'];
  doneDuration: Array<TaskDoneDuration>;
  /** Combination of task_id and role_id */
  id: Scalars['ID']['output'];
  isBudgeted: Scalars['Boolean']['output'];
  /** Indicates if role is part of the task assignees */
  isRoleAssigned: Scalars['Boolean']['output'];
  plannedDuration: Scalars['Duration']['output'];
  role: Role;
  users: Array<User>;
};

export type TaskDoneDuration = {
  __typename?: 'TaskDoneDuration';
  duration: Scalars['Duration']['output'];
  taskId: Scalars['ID']['output'];
};

export type TaskMarkAsDoneInput = {
  doneDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Duration']['input']>;
  isDone: Scalars['Boolean']['input'];
};

export type TaskMarkAsDoneMutationInput = {
  completedDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Duration']['input']>;
  taskId: Scalars['ID']['input'];
};

export type TaskMarkAsNotDoneMutationInput = {
  taskId: Scalars['ID']['input'];
};

export type TaskMaybeLimitedByPermissions = LimitedTask | Task;

export type TaskOrderingInput = {
  direction?: InputMaybe<SortDirection>;
  orderBy: TasksListOrderByEnum;
};

export type TaskPermissions = {
  __typename?: 'TaskPermissions';
  canModify: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
};

export type TaskResponsibleSaveInput = {
  responsibleUserId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export type TaskSaveInput = {
  activityTypeId?: InputMaybe<Scalars['ID']['input']>;
  assignees?: InputMaybe<Array<TaskAssigneesInput>>;
  dueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  durationPlanned?: InputMaybe<Scalars['Duration']['input']>;
  markAsDone?: InputMaybe<TaskMarkAsDoneInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projectPhaseId?: InputMaybe<Scalars['ID']['input']>;
  responsibleUserId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type TaskSet = {
  __typename?: 'TaskSet';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isShared: Scalars['Boolean']['output'];
  /** Maximum days from all the related task templates, if NULL then no maximum days */
  maxDays?: Maybe<Scalars['Int']['output']>;
  /** Minimum days from all the related task templates, if NULL then no minimum days */
  minDays?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Ordering for phases and task sets block */
  ordering: Scalars['Int']['output'];
  /** Count for all the related task templates */
  taskTemplatesCount: Scalars['Int']['output'];
  user: User;
};

export type TaskSetAsSubtasksSaveInput = {
  /** ID of the parent task under which the subtasks will be created */
  parentId: Scalars['ID']['input'];
  taskSetId: Scalars['ID']['input'];
};

export type TaskSetsInput = {
  id: Scalars['ID']['input'];
  ordering?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskTemplate = {
  __typename?: 'TaskTemplate';
  activity?: Maybe<ActivityType>;
  assignees: Array<TaskTemplateAssignee>;
  dueInDays: Scalars['Int']['output'];
  durationBillable: Scalars['Int']['output'];
  durationPlanned: Scalars['Int']['output'];
  dynamicOwner?: Maybe<DynamicOwnerEnum>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<User>;
  priority?: Maybe<Priority>;
  sortOrder: Scalars['Int']['output'];
  startInDays: Scalars['Int']['output'];
  status?: Maybe<Status>;
};

export type TaskTemplateAssignee = {
  __typename?: 'TaskTemplateAssignee';
  allocatedDuration: Scalars['Duration']['output'];
  id: Scalars['ID']['output'];
  role?: Maybe<Role>;
  user?: Maybe<User>;
};

export type TaskTemplateAssigneesInput = {
  allocatedDuration?: InputMaybe<Scalars['Duration']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type TaskTemplateAssigneesSaveInput = {
  assignees: Array<TaskTemplateAssigneesInput>;
  /** Individual allocation toggle - on or off. If it is false, allocatedDuration value is not saved. */
  hasCustomAllocation?: InputMaybe<Scalars['Boolean']['input']>;
  taskTemplateId: Scalars['ID']['input'];
};

export type TaskUsersAvailability = {
  __typename?: 'TaskUsersAvailability';
  totalAvailability: Scalars['Duration']['output'];
  usedAvailability: Scalars['Duration']['output'];
  user: User;
};

export type TaskUsersAvailabilityInput = {
  /** Specified task custom due date if it has not yet been saved */
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  /** Specified task custom start date if it has not yet been saved */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  /** List of user IDs. If not provided, all users that can be assigned to a task will be returned */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TasksFiltersInput = {
  /** If true, includes subtasks in the results. By default only returns parent tasks. */
  includeSubtasks?: InputMaybe<Scalars['Boolean']['input']>;
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  retainerPeriodId?: InputMaybe<Scalars['ID']['input']>;
  searchByTitle?: InputMaybe<Scalars['String']['input']>;
};

export type TasksListInput = {
  filters?: InputMaybe<TasksFiltersInput>;
  module?: InputMaybe<ModuleType>;
  ordering?: InputMaybe<TaskOrderingInput>;
  pager?: InputMaybe<PagerInput>;
};

export const TasksListOrderByEnum = {
  ActivityType: 'activityType',
  CommentsCount: 'commentsCount',
  DueDate: 'dueDate',
  DurationDone: 'durationDone',
  DurationPlanned: 'durationPlanned',
  DurationRemaining: 'durationRemaining',
  Name: 'name',
  StartDate: 'startDate',
  Status: 'status',
  SubtasksCount: 'subtasksCount'
} as const;

export type TasksListOrderByEnum = typeof TasksListOrderByEnum[keyof typeof TasksListOrderByEnum];
export type TasksSearchFilter = {
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  isModifiable?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  isRelatedToCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
  relatedCompanyId?: InputMaybe<Scalars['ID']['input']>;
  relatedProjectId?: InputMaybe<Scalars['ID']['input']>;
  relatedProjectPhaseId?: InputMaybe<Scalars['ID']['input']>;
  relatedQuoteLineId?: InputMaybe<Scalars['ID']['input']>;
};

export type TasksSearchInput = {
  filters?: InputMaybe<TasksSearchFilter>;
  keyword: Scalars['String']['input'];
  pager?: InputMaybe<PagerInput>;
};

export type TeamReport = {
  __typename?: 'TeamReport';
  columns: Array<TeamReportColumnEnum>;
  groupBy?: Maybe<TeamReportGroupByEnum>;
  orderBy?: Maybe<OrderBy>;
  rows: Array<TeamReportRow>;
};

export const TeamReportColumnEnum = {
  Availability: 'availability',
  Bookings: 'bookings',
  BookingsFixed: 'bookingsFixed',
  BookingsTentative: 'bookingsTentative',
  BookingsVsAvailability: 'bookingsVsAvailability',
  Capacity: 'capacity',
  ExtraAvailability: 'extraAvailability',
  TasksPlanned: 'tasksPlanned',
  TimeEntries: 'timeEntries',
  TimeEntriesBillable: 'timeEntriesBillable',
  TimeEntriesBillableVsAvailability: 'timeEntriesBillableVsAvailability',
  TimeEntriesDone: 'timeEntriesDone',
  TimeEntriesNonBillable: 'timeEntriesNonBillable',
  TimeEntriesNonBillableVsAvailability: 'timeEntriesNonBillableVsAvailability',
  TimeEntriesScheduled: 'timeEntriesScheduled',
  TimeEntriesVsAvailability: 'timeEntriesVsAvailability',
  TimeOff: 'timeOff',
  User: 'user'
} as const;

export type TeamReportColumnEnum = typeof TeamReportColumnEnum[keyof typeof TeamReportColumnEnum];
export const TeamReportGroupByEnum = {
  Roles: 'roles',
  Users: 'users'
} as const;

export type TeamReportGroupByEnum = typeof TeamReportGroupByEnum[keyof typeof TeamReportGroupByEnum];
export type TeamReportRow = {
  __typename?: 'TeamReportRow';
  availability?: Maybe<TeamReportRowItem>;
  bookings?: Maybe<TeamReportRowItem>;
  bookingsFixed?: Maybe<TeamReportRowItem>;
  bookingsTentative?: Maybe<TeamReportRowItem>;
  bookingsVsAvailability?: Maybe<TeamReportRowItem>;
  capacity?: Maybe<TeamReportRowItem>;
  extraAvailability?: Maybe<TeamReportRowItem>;
  groupName?: Maybe<Scalars['String']['output']>;
  tasksPlanned?: Maybe<TeamReportRowItem>;
  timeEntries?: Maybe<TeamReportRowItem>;
  timeEntriesBillable?: Maybe<TeamReportRowItem>;
  timeEntriesBillableVsAvailability?: Maybe<TeamReportRowItem>;
  timeEntriesDone?: Maybe<TeamReportRowItem>;
  timeEntriesNonBillable?: Maybe<TeamReportRowItem>;
  timeEntriesNonBillableVsAvailability?: Maybe<TeamReportRowItem>;
  timeEntriesScheduled?: Maybe<TeamReportRowItem>;
  timeEntriesVsAvailability?: Maybe<TeamReportRowItem>;
  timeOff?: Maybe<TeamReportRowItem>;
  user: User;
};

export type TeamReportRowItem = {
  __typename?: 'TeamReportRowItem';
  unit: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type TimeEntry = {
  __typename?: 'TimeEntry';
  activityType?: Maybe<ActivityType>;
  description: Scalars['String']['output'];
  entryDuration: Scalars['Duration']['output'];
  id: Scalars['ID']['output'];
  startDateTime: Scalars['DateTime']['output'];
  startedDateTime?: Maybe<Scalars['DateTime']['output']>;
  task?: Maybe<Task>;
  timerDuration?: Maybe<Scalars['Duration']['output']>;
};

export type TimeEntrySaveInput = {
  duration: Scalars['Duration']['input'];
  taskId: Scalars['ID']['input'];
};

export type TimeOff = {
  __typename?: 'TimeOff';
  endDate: Scalars['Date']['output'];
  externalSystem?: Maybe<ExternalSystemEnum>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  type: TimeOffTypeRelation;
  value: Scalars['Int']['output'];
};

export type TimeOffDeleteInput = {
  id: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TimeOffFiltersInput = {
  endDate: Scalars['String']['input'];
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['String']['input'];
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TimeOffItem = {
  __typename?: 'TimeOffItem';
  timeOff: TimeOff;
  users: Array<User>;
};

export type TimeOffOverlappingProjectsListItem = {
  __typename?: 'TimeOffOverlappingProjectsListItem';
  endDate: Scalars['Date']['output'];
  overlapDaysCount: Scalars['Int']['output'];
  project: Project;
  startDate: Scalars['Date']['output'];
};

export type TimeOffReport = {
  __typename?: 'TimeOffReport';
  timeOffReportList: Array<TimeOffReportListItem>;
  timeOffReportSummary?: Maybe<TimeOffReportSummary>;
};

export type TimeOffReportItem = {
  __typename?: 'TimeOffReportItem';
  extraSeconds?: Maybe<Scalars['Int']['output']>;
  hasMultipleUsers: Scalars['Boolean']['output'];
  offDays?: Maybe<Scalars['Int']['output']>;
  offSeconds?: Maybe<Scalars['Int']['output']>;
  overlappingProjects: Array<TimeOffOverlappingProjectsListItem>;
  timeOff: TimeOff;
};

export type TimeOffReportListItem = {
  __typename?: 'TimeOffReportListItem';
  overlappingProjects: Array<TimeOffOverlappingProjectsListItem>;
  timeOffs: Array<TimeOffReportItem>;
  total: TimeOffReportTotal;
  user: User;
};

export type TimeOffReportSummary = {
  __typename?: 'TimeOffReportSummary';
  total: TimeOffReportTotal;
  usersCount: Scalars['Int']['output'];
};

export type TimeOffReportTotal = {
  __typename?: 'TimeOffReportTotal';
  extraSeconds?: Maybe<Scalars['Int']['output']>;
  offDays?: Maybe<Scalars['Int']['output']>;
  offSeconds?: Maybe<Scalars['Int']['output']>;
};

export type TimeOffSaveInput = {
  endDate: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  type: Scalars['String']['input'];
  userIds: Array<Scalars['ID']['input']>;
  value: Scalars['Int']['input'];
};

export type TimeOffTypeListItem = {
  __typename?: 'TimeOffTypeListItem';
  displayName: Scalars['String']['output'];
  externalSystems?: Maybe<Array<ExternalSystemEnum>>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  isInUse: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  ordering: Scalars['Int']['output'];
  systemName: Scalars['String']['output'];
};

export type TimeOffTypeRelation = {
  __typename?: 'TimeOffTypeRelation';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  systemName: Scalars['String']['output'];
};

export type TimeOffTypeSaveInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isInUse: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeOffTypesListFiltersInput = {
  isInUse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeOffTypesOrderSaveInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type TimesheetScheduleRemindersInput = {
  sendNow: Scalars['Boolean']['input'];
};

export type TranslatedValue = {
  __typename?: 'TranslatedValue';
  language: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TrialExtensionInput = {
  milestone: Scalars['String']['input'];
};

export type Trigger = {
  __typename?: 'Trigger';
  actions: Array<TriggerAction>;
  activities: Array<TriggerActivity>;
  bookmark?: Maybe<Bookmark>;
  customModule?: Maybe<CustomModule>;
  filterData: TriggerFilterData;
  id: Scalars['ID']['output'];
  isMuted?: Maybe<Scalars['Boolean']['output']>;
  isShared: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  isSystemNotification?: Maybe<Scalars['Boolean']['output']>;
  isTemplate: Scalars['Boolean']['output'];
  module: ModuleType;
  name: Scalars['String']['output'];
  runCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<TriggerStatusType>;
  user: User;
};

export type TriggerAction = {
  __typename?: 'TriggerAction';
  actionData: Array<TriggerActionData>;
  actionName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  triggerId: Scalars['ID']['output'];
  type: TriggerActionType;
};

export type TriggerActionData = DynamicUserGroup | User | UserGroup | WebhookData;

export type TriggerActionInput = {
  actionName?: InputMaybe<Scalars['String']['input']>;
  triggerId: Scalars['ID']['input'];
  type: TriggerActionType;
  userGroupId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export const TriggerActionType = {
  NotifyViaEmail: 'NOTIFY_VIA_EMAIL',
  NotifyViaSlack: 'NOTIFY_VIA_SLACK',
  NotifyViaSystem: 'NOTIFY_VIA_SYSTEM',
  Webhook: 'WEBHOOK'
} as const;

export type TriggerActionType = typeof TriggerActionType[keyof typeof TriggerActionType];
export type TriggerActivity = {
  __typename?: 'TriggerActivity';
  activity: TriggerActivityType;
  triggerId: Scalars['String']['output'];
};

export type TriggerActivityInput = {
  activity: TriggerActivityType;
  triggerId: Scalars['ID']['input'];
};

export const TriggerActivityType = {
  Create: 'CREATE',
  Delete: 'DELETE',
  Modify: 'MODIFY'
} as const;

export type TriggerActivityType = typeof TriggerActivityType[keyof typeof TriggerActivityType];
export type TriggerDataInput = {
  bookmarkId?: InputMaybe<Scalars['ID']['input']>;
  customModuleName?: InputMaybe<Scalars['String']['input']>;
  filterData: TriggerFilterDataInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem: Scalars['Boolean']['input'];
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  module: ModuleType;
  name: Scalars['String']['input'];
  status: TriggerStatusType;
  triggerActions: Array<TriggerActionInput>;
  triggerActivities: Array<TriggerActivityInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type TriggerDoerGroupData = DynamicUserGroup | UserGroup;

export type TriggerFieldList = {
  __typename?: 'TriggerFieldList';
  activities?: Maybe<Array<TriggerFieldListActivitiesType>>;
  conditions?: Maybe<Array<TriggerFieldListConditionsType>>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: TriggerFieldType;
  values?: Maybe<Array<TriggerFieldValue>>;
};

export const TriggerFieldListActivitiesType = {
  IsAdded: 'IS_ADDED',
  IsDeleted: 'IS_DELETED',
  IsModified: 'IS_MODIFIED',
  IsModifiedFrom: 'IS_MODIFIED_FROM'
} as const;

export type TriggerFieldListActivitiesType = typeof TriggerFieldListActivitiesType[keyof typeof TriggerFieldListActivitiesType];
export const TriggerFieldListConditionsType = {
  Contains: 'CONTAINS',
  GreaterThan: 'GREATER_THAN',
  Is: 'IS',
  IsNot: 'IS_NOT',
  SmallerThan: 'SMALLER_THAN'
} as const;

export type TriggerFieldListConditionsType = typeof TriggerFieldListConditionsType[keyof typeof TriggerFieldListConditionsType];
export const TriggerFieldType = {
  Autosuggestactivity: 'AUTOSUGGESTACTIVITY',
  Autosuggestbills: 'AUTOSUGGESTBILLS',
  Autosuggestclientprofiles: 'AUTOSUGGESTCLIENTPROFILES',
  Autosuggestcompanies: 'AUTOSUGGESTCOMPANIES',
  Autosuggestcontactcategories: 'AUTOSUGGESTCONTACTCATEGORIES',
  Autosuggestcontacts: 'AUTOSUGGESTCONTACTS',
  Autosuggestcurrency: 'AUTOSUGGESTCURRENCY',
  Autosuggestevents: 'AUTOSUGGESTEVENTS',
  Autosuggestexpenses: 'AUTOSUGGESTEXPENSES',
  Autosuggestinvoices: 'AUTOSUGGESTINVOICES',
  Autosuggestorders: 'AUTOSUGGESTORDERS',
  Autosuggestpersons: 'AUTOSUGGESTPERSONS',
  Autosuggestprepayments: 'AUTOSUGGESTPREPAYMENTS',
  Autosuggestprojects: 'AUTOSUGGESTPROJECTS',
  Autosuggestpurchaseorders: 'AUTOSUGGESTPURCHASEORDERS',
  Autosuggestquotes: 'AUTOSUGGESTQUOTES',
  Autosuggestresources: 'AUTOSUGGESTRESOURCES',
  Autosuggeststatus: 'AUTOSUGGESTSTATUS',
  Autosuggesttags: 'AUTOSUGGESTTAGS',
  Autosuggesttasks: 'AUTOSUGGESTTASKS',
  Autosuggestusers: 'AUTOSUGGESTUSERS',
  Date: 'DATE',
  Dropdown: 'DROPDOWN',
  Duration: 'DURATION',
  Number: 'NUMBER',
  Text: 'TEXT'
} as const;

export type TriggerFieldType = typeof TriggerFieldType[keyof typeof TriggerFieldType];
export type TriggerFieldValue = {
  __typename?: 'TriggerFieldValue';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TriggerFilterData = {
  __typename?: 'TriggerFilterData';
  activities: TriggerFilterDataFilter;
  activityDoers: TriggerFilterDataUserList;
  filters: TriggerFilterDataFilter;
};

export type TriggerFilterDataBlock = {
  __typename?: 'TriggerFilterDataBlock';
  logicalOperator: TriggerFilterDataLogicalOperator;
  rules: Array<TriggerFilterDataRule>;
};

export type TriggerFilterDataBlockInput = {
  logicalOperator: TriggerFilterDataLogicalOperator;
  rules?: InputMaybe<Array<InputMaybe<TriggerFilterDataRuleInput>>>;
};

export type TriggerFilterDataFilter = {
  __typename?: 'TriggerFilterDataFilter';
  blocks: Array<TriggerFilterDataBlock>;
  logicalOperator: TriggerFilterDataLogicalOperator;
};

export type TriggerFilterDataFilterInput = {
  blocks?: InputMaybe<Array<TriggerFilterDataBlockInput>>;
  logicalOperator: TriggerFilterDataLogicalOperator;
};

export type TriggerFilterDataInput = {
  activities: TriggerFilterDataFilterInput;
  activityDoers: TriggerFilterDataUserInput;
  filters: TriggerFilterDataFilterInput;
};

export const TriggerFilterDataLogicalOperator = {
  And: 'AND',
  Or: 'OR'
} as const;

export type TriggerFilterDataLogicalOperator = typeof TriggerFilterDataLogicalOperator[keyof typeof TriggerFilterDataLogicalOperator];
export type TriggerFilterDataRule = {
  __typename?: 'TriggerFilterDataRule';
  fieldCondition: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  fieldTypeLabel: Scalars['String']['output'];
  groupValues?: Maybe<Array<UserGroup>>;
  values?: Maybe<Array<TriggerFilterDataValue>>;
};

export type TriggerFilterDataRuleInput = {
  fieldCondition: Scalars['String']['input'];
  fieldType: Scalars['String']['input'];
  groupValues?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TriggerFilterDataUserInput = {
  groupValues?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  values?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type TriggerFilterDataUserList = {
  __typename?: 'TriggerFilterDataUserList';
  groupValues?: Maybe<Array<TriggerDoerGroupData>>;
  values?: Maybe<Array<User>>;
};

export type TriggerFilterDataValue = UnionActivity | UnionBill | UnionClientProfile | UnionContact | UnionContactCategory | UnionCurrency | UnionCustomModuleEntry | UnionEvent | UnionExpense | UnionInvoice | UnionOrder | UnionPrepayment | UnionProject | UnionPurchaseOrder | UnionQuote | UnionResource | UnionStatus | UnionStringFieldValue | UnionTag | UnionTask | UnionUser;

export type TriggerModuleUnion = CustomModule | Module;

export const TriggerStatusType = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Suspended: 'SUSPENDED'
} as const;

export type TriggerStatusType = typeof TriggerStatusType[keyof typeof TriggerStatusType];
export type TriggersFiltersInput = {
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TriggersListInput = {
  filters?: InputMaybe<TriggersFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export type UnShareInput = {
  id: Scalars['ID']['input'];
  shareType: ShareTypeEnum;
};

export type UnionActivity = {
  __typename?: 'UnionActivity';
  activity: ActivityType;
};

export type UnionBackgroundJob = {
  __typename?: 'UnionBackgroundJob';
  backgroundJob: BackgroundJob;
};

export type UnionBill = {
  __typename?: 'UnionBill';
  bill: Bill;
};

export type UnionClientProfile = {
  __typename?: 'UnionClientProfile';
  clientProfile: ClientProfile;
};

export type UnionContact = {
  __typename?: 'UnionContact';
  contact: Contact;
};

export type UnionContactCategory = {
  __typename?: 'UnionContactCategory';
  contactCategory: ContactCategory;
};

export type UnionCurrency = {
  __typename?: 'UnionCurrency';
  currency: Currency;
};

export type UnionCustomModuleEntry = {
  __typename?: 'UnionCustomModuleEntry';
  customEntry: CustomModuleEntry;
};

export type UnionEvent = {
  __typename?: 'UnionEvent';
  event: CalendarEvent;
};

export type UnionExpense = {
  __typename?: 'UnionExpense';
  expense: Expense;
};

export type UnionFieldChange = {
  __typename?: 'UnionFieldChange';
  currentValue?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  previousValue?: Maybe<Scalars['String']['output']>;
};

export type UnionFile = {
  __typename?: 'UnionFile';
  file: File;
};

export type UnionImport = {
  __typename?: 'UnionImport';
  import: ImportType;
};

export type UnionInvoice = {
  __typename?: 'UnionInvoice';
  invoice: Invoice;
};

export type UnionManagerChange = {
  __typename?: 'UnionManagerChange';
  currentUser?: Maybe<User>;
  fieldName: Scalars['String']['output'];
  previousUser?: Maybe<User>;
};

export type UnionMarketingList = {
  __typename?: 'UnionMarketingList';
  marketingList: MarketingList;
};

export type UnionNewsFeedItem = {
  __typename?: 'UnionNewsFeedItem';
  newsFeedItem: NewsFeedItem;
};

export type UnionOrder = {
  __typename?: 'UnionOrder';
  order: Order;
};

export type UnionPrepayment = {
  __typename?: 'UnionPrepayment';
  prepayment: Prepayment;
};

export type UnionProject = {
  __typename?: 'UnionProject';
  project: Project;
};

export type UnionProjectChange = {
  __typename?: 'UnionProjectChange';
  currentProject?: Maybe<Project>;
  fieldName: Scalars['String']['output'];
  previousProject?: Maybe<Project>;
};

export type UnionPurchaseOrder = {
  __typename?: 'UnionPurchaseOrder';
  purchaseOrder: PurchaseOrder;
};

export type UnionQuote = {
  __typename?: 'UnionQuote';
  quote: Quote;
};

export type UnionRealEstateObject = {
  __typename?: 'UnionRealEstateObject';
  realEstateObject: RealEstateObject;
};

export type UnionRentalOrder = {
  __typename?: 'UnionRentalOrder';
  rentalOrder: RentalOrder;
};

export type UnionResource = {
  __typename?: 'UnionResource';
  resource: Resource;
};

export type UnionStaticStatus = {
  __typename?: 'UnionStaticStatus';
  staticStatus: StaticStatus;
};

export type UnionStatus = {
  __typename?: 'UnionStatus';
  status: Status;
};

export type UnionStatusChange = {
  __typename?: 'UnionStatusChange';
  currentStatus?: Maybe<NotificationStatus>;
  fieldName: Scalars['String']['output'];
  previousStatus?: Maybe<NotificationStatus>;
};

export type UnionStringFieldValue = {
  __typename?: 'UnionStringFieldValue';
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type UnionTag = {
  __typename?: 'UnionTag';
  tag: Tag;
};

export type UnionTask = {
  __typename?: 'UnionTask';
  task: Task;
};

export type UnionTimeEntry = {
  __typename?: 'UnionTimeEntry';
  timeEntry: TimeEntry;
};

export type UnionUser = {
  __typename?: 'UnionUser';
  user: User;
};

export type UnionUsersChange = {
  __typename?: 'UnionUsersChange';
  addedUsers?: Maybe<Array<User>>;
  deletedUsers?: Maybe<Array<User>>;
  fieldName: Scalars['String']['output'];
};

export type Unit = {
  __typename?: 'Unit';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  names: Array<TranslatedValue>;
  symbol: Scalars['String']['output'];
};

export type UpdateMcpPermissionsInput = {
  /** Feature identifier (e.g., "mcp_server") */
  feature: Scalars['String']['input'];
  /** Array of permission set updates containing permission set ID and enabled permissions */
  permissionSetUpdates: Array<PermissionSetPermissionUpdateInput>;
};

export type User = {
  __typename?: 'User';
  adapters?: Maybe<Array<Adapter>>;
  companyAccounts: Array<CompanyAccount>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gsm?: Maybe<Scalars['String']['output']>;
  hslColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  laborCost?: Maybe<Scalars['Float']['output']>;
  languageId: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastNoticeVersion?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissionSet?: Maybe<PermissionSet>;
  profilePicture?: Maybe<UserPicture>;
  role?: Maybe<Role>;
  status: UserStatus;
  type: UserType;
  uuid: Scalars['String']['output'];
};


export type UserLaborCostArgs = {
  input?: InputMaybe<LaborCostInput>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  comment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isHidden: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  users: Array<User>;
};

export type UserLog = {
  __typename?: 'UserLog';
  action: Scalars['String']['output'];
  activityType: Scalars['String']['output'];
  changeLog?: Maybe<Scalars['String']['output']>;
  datetime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ip: Scalars['String']['output'];
  itemId: Scalars['Int']['output'];
  itemName: Scalars['String']['output'];
  itemType: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type UserLogFiltersInput = {
  activitySource?: InputMaybe<Scalars['String']['input']>;
};

export type UserPicture = {
  __typename?: 'UserPicture';
  large: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  mini: Scalars['String']['output'];
};

export const UserStatus = {
  Active: 'ACTIVE',
  Awaiting: 'AWAITING',
  Inactive: 'INACTIVE',
  Pending: 'PENDING'
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];
export type UserTimeOff = {
  __typename?: 'UserTimeOff';
  availability: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  hasMultipleUsers: Scalars['Boolean']['output'];
  timeOff: TimeOff;
  user: User;
  value: Scalars['Int']['output'];
};

export type UserTimeOffListInput = {
  filters: TimeOffFiltersInput;
  pager?: InputMaybe<PagerInput>;
};

export const UserType = {
  Admin: 'ADMIN',
  Cupo: 'CUPO',
  User: 'USER'
} as const;

export type UserType = typeof UserType[keyof typeof UserType];
export type UserUtilization = {
  __typename?: 'UserUtilization';
  availability: Scalars['Int']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  fixedBookedDuration: Scalars['Int']['output'];
  project?: Maybe<Project>;
  tentativeBookedDuration: Scalars['Int']['output'];
};

export type UserUtilizationInput = {
  endDate: Scalars['Date']['input'];
  filterHash?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<UtilizationGroupBy>;
  module?: InputMaybe<Scalars['String']['input']>;
  pager?: InputMaybe<PagerInput>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['Date']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserUtilizationResponse = {
  __typename?: 'UserUtilizationResponse';
  roleId?: Maybe<Scalars['ID']['output']>;
  totalAvailability: Scalars['Int']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
  utilizations: Array<UserUtilization>;
};

export type UsersFiltersInput = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  filtersIgnored?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
  searchLevel?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<UserStatus>>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  userNames?: InputMaybe<Array<Scalars['String']['input']>>;
  userTypes?: InputMaybe<Array<UserType>>;
};

export type UsersListInput = {
  filters?: InputMaybe<UsersFiltersInput>;
  pager?: InputMaybe<PagerInput>;
};

export const UtilizationGroupBy = {
  Period: 'PERIOD',
  Project: 'PROJECT'
} as const;

export type UtilizationGroupBy = typeof UtilizationGroupBy[keyof typeof UtilizationGroupBy];
export type ValidationFields = {
  __typename?: 'ValidationFields';
  requiredFields: Array<Scalars['String']['output']>;
  uniqueFields: Array<Scalars['String']['output']>;
};

export type Version = {
  __typename?: 'Version';
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type VirtualAssistantChatResponse = {
  __typename?: 'VirtualAssistantChatResponse';
  kind: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type VirtualAssistantMessageInput = {
  chatId: Scalars['String']['input'];
  messageId?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type VirtualAssistantRatingInput = {
  chatId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};

export const WatchdogAlertConditionEnum = {
  LessThan: 'LESS_THAN',
  MoreThan: 'MORE_THAN'
} as const;

export type WatchdogAlertConditionEnum = typeof WatchdogAlertConditionEnum[keyof typeof WatchdogAlertConditionEnum];
export const WatchdogAlertTypeEnum = {
  PercentValue: 'PERCENT_VALUE',
  TotalValue: 'TOTAL_VALUE'
} as const;

export type WatchdogAlertTypeEnum = typeof WatchdogAlertTypeEnum[keyof typeof WatchdogAlertTypeEnum];
export const WatchdogNotificationTypeEnum = {
  Email: 'EMAIL'
} as const;

export type WatchdogNotificationTypeEnum = typeof WatchdogNotificationTypeEnum[keyof typeof WatchdogNotificationTypeEnum];
export type WebhookData = {
  __typename?: 'WebhookData';
  urlToPost: Scalars['String']['output'];
};

export type WorkReportPrimaryGroup = ReportDataGroupInterface & {
  __typename?: 'WorkReportPrimaryGroup';
  /** Unique grouping ID in this report level */
  id?: Maybe<Scalars['ID']['output']>;
  /** The title to be displayed at the beginning of this reporting group */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of grouping used in this reporting level (aka "grouped by" type) */
  type: Scalars['String']['output'];
  /** The list of values under this reporting group */
  value: Array<WorkReportSecondaryGroup>;
};

export type WorkReportSecondaryGroup = ReportDataGroupInterface & {
  __typename?: 'WorkReportSecondaryGroup';
  /** Duration of work already done */
  actualDuration?: Maybe<Scalars['Duration']['output']>;
  /** Billable duration of work */
  billableDuration?: Maybe<Scalars['Duration']['output']>;
  /** Unique grouping ID in this report level */
  id?: Maybe<Scalars['ID']['output']>;
  /** Labor cost */
  laborCost?: Maybe<Scalars['Float']['output']>;
  /** Non billable duration */
  nonBillableDuration?: Maybe<Scalars['Duration']['output']>;
  /** Planned billable duration */
  plannedBillableDuration?: Maybe<Scalars['Duration']['output']>;
  /** Total planned duration of work */
  plannedDuration?: Maybe<Scalars['Duration']['output']>;
  /** Quantity */
  quantity: Scalars['Int']['output'];
  /** Selling price */
  sellingPrice?: Maybe<Scalars['Float']['output']>;
  /** The title to be displayed at the beginning of this reporting group */
  title?: Maybe<Scalars['String']['output']>;
  /** Duration of work still to be done */
  todoDuration?: Maybe<Scalars['Duration']['output']>;
  /** The type of grouping used in this reporting level (aka "grouped by" type) */
  type: Scalars['String']['output'];
  /** User selling price */
  userSellingPrice?: Maybe<Scalars['Float']['output']>;
};

export type AuthorizeIntegrationMutationVariables = Exact<{
  input: IntegrationAuthorizeInputType;
}>;


export type AuthorizeIntegrationMutation = { __typename?: 'Mutation', IntegrationAuthorize: boolean };

export type GetIntegrationAdapterStatusQueryVariables = Exact<{
  input: IntegrationGetAdapterInputType;
}>;


export type GetIntegrationAdapterStatusQuery = { __typename?: 'Query', IntegrationGetAdapter: { __typename?: 'Adapter', id: string, isActive?: boolean | null } };

export type SetIntegrationAdapterStatusMutationVariables = Exact<{
  input: IntegrationSetAdapterStatusInputType;
}>;


export type SetIntegrationAdapterStatusMutation = { __typename?: 'Mutation', IntegrationSetAdapterStatus: boolean };

export type ValidateTokenQueryVariables = Exact<{
  input: IntegrationValidateJwtInputType;
}>;


export type ValidateTokenQuery = { __typename?: 'Query', IntegrationValidateAppJwt: boolean };

export type SetUpPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SetUpPermissionsQuery = { __typename?: 'Query', EnabledFeatures: Array<{ __typename?: 'Feature', name: string }>, EnabledModules: Array<{ __typename?: 'Feature', name: string }>, EnabledPermissions: Array<{ __typename?: 'Permission', name: string }>, CurrentUser: { __typename?: 'User', id: string, type: UserType }, FeatureFlags: Array<{ __typename?: 'FeatureFlag', name: string, value: string }> };

export type SettingSaveMutationVariables = Exact<{
  input: SettingSaveInput;
}>;


export type SettingSaveMutation = { __typename?: 'Mutation', SettingSave: { __typename: 'Setting', name: string, value: any } };

export type SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsQuery = { __typename?: 'Query', CurrentUserSettings: Array<{ __typename?: 'Setting', name: string, value: any }> };

export type SocketQueryVariables = Exact<{
  moduleName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SocketQuery = { __typename?: 'Query', SocketConnection: { __typename?: 'SocketConnection', serverUrl: string, userToken: string } };

export type RequiredFieldsQueryVariables = Exact<{
  input: RequiredUniqueFieldsInput;
}>;


export type RequiredFieldsQuery = { __typename?: 'Query', RequiredUniqueFields: { __typename?: 'ValidationFields', requiredFields: Array<string> } };

export type UseSiteQueryVariables = Exact<{ [key: string]: never; }>;


export type UseSiteQuery = { __typename?: 'Query', CurrentSite?: { __typename?: 'Site', id: string, siteName: string, siteUrl: string, isTrialActive: boolean, isTrialExpired: boolean, isSiteExpired: boolean, trialExpireDateTime?: SAPIDateTime | null, canScheduleDemo: boolean, marketingCompanySize?: string | null, hasPaymentMethod: boolean, abTag?: string | null, server: string, version: { __typename?: 'Version', name: string, state: string } } | null };

export type ActivityTypeAutoSuggestQueryVariables = Exact<{
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
}>;


export type ActivityTypeAutoSuggestQuery = { __typename?: 'Query', ActivityTypesList: Array<{ __typename?: 'ActivityType', id: string, name: string }> };

export type ActivityTypeInlineSelectFragment = { __typename?: 'ActivityType', id: string, name: string };

export type ActivityTypeInlineSelectQueryVariables = Exact<{
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActivityTypeStatus>;
}>;


export type ActivityTypeInlineSelectQuery = { __typename?: 'Query', ActivityTypesList: Array<{ __typename?: 'ActivityType', id: string, name: string }> };

export type CurrencyAutoSuggestQueryVariables = Exact<{
  currenciesListInput?: InputMaybe<CurrenciesListInput>;
}>;


export type CurrencyAutoSuggestQuery = { __typename?: 'Query', CurrenciesList: Array<{ __typename?: 'Currency', id: string, name: string }> };

export type AppHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type AppHeaderQuery = { __typename?: 'Query', Menu: Array<{ __typename?: 'MenuItem', moduleName: string, link: string, module: string }> };

export type AppMetricsListQueryVariables = Exact<{
  input?: InputMaybe<SummaryBlockInput>;
}>;


export type AppMetricsListQuery = { __typename?: 'Query', SummaryBlock: Array<{ __typename?: 'SummaryBlockItem', id: string, title: string, value?: number | null, unit?: string | null, valueState?: MetricsValueState | null, type: SummaryBlockItemType, secondaryValue?: number | null, secondaryUnit?: string | null, secondaryDescription?: string | null, secondaryValueState?: MetricsValueState | null }> };

export type MentionListQueryVariables = Exact<{
  usersListInput?: InputMaybe<UsersListInput>;
}>;


export type MentionListQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', CurrentUser: { __typename?: 'User', id: string, uuid: string, type: UserType, firstName?: string | null, lastName?: string | null, name: string, initials?: string | null, gsm?: string | null, email?: string | null, lastNoticeVersion?: string | null, hslColor?: string | null, status: UserStatus, languageId: string, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, companyAccounts: Array<{ __typename?: 'CompanyAccount', id: string, logo?: string | null, name: string, isInUse?: boolean | null }>, permissionSet?: { __typename?: 'PermissionSet', name: string } | null } };

export type AvailabilityListQueryVariables = Exact<{
  input: AvailabilityListInput;
}>;


export type AvailabilityListQuery = { __typename?: 'Query', AvailabilityList: Array<{ __typename?: 'Availability', userId: string, date: SAPIDate, availability: number }> };

export type BillAutoSuggestQueryVariables = Exact<{
  billsListInput?: InputMaybe<FinanceDocumentsListInput>;
}>;


export type BillAutoSuggestQuery = { __typename?: 'Query', BillsList: Array<{ __typename?: 'Bill', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null }> };

export type BookmarksDropdownQueryVariables = Exact<{
  filters?: InputMaybe<BookmarkFilterInput>;
}>;


export type BookmarksDropdownQuery = { __typename?: 'Query', BookmarksList: Array<{ __typename?: 'Bookmark', id: string, name: string, module: string, owner: { __typename?: 'User', id: string, name: string, initials?: string | null } }> };

export type BookmarksShortcutQueryVariables = Exact<{ [key: string]: never; }>;


export type BookmarksShortcutQuery = { __typename?: 'Query', FavoriteBookmarks: Array<{ __typename?: 'Bookmark', id: string, name: string, module: string }> };

export type TimeOffDeleteMutationVariables = Exact<{
  input: TimeOffDeleteInput;
}>;


export type TimeOffDeleteMutation = { __typename?: 'Mutation', TimeOffDelete: boolean };

export type TimeOffListPopoverQueryVariables = Exact<{
  input: UserTimeOffListInput;
}>;


export type TimeOffListPopoverQuery = { __typename?: 'Query', UserTimeOffList: Array<{ __typename?: 'UserTimeOff', value: number, availability: number, hasMultipleUsers: boolean, timeOff: { __typename?: 'TimeOff', endDate: SAPIDate, id: string, reason?: string | null, startDate: SAPIDate, value: number, externalSystem?: ExternalSystemEnum | null, type: { __typename?: 'TimeOffTypeRelation', id: string, displayName: string, systemName: string } }, user: { __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null } }> };

export type TimeOffModifyFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TimeOffModifyFormQuery = { __typename?: 'Query', TimeOffItem: { __typename?: 'TimeOffItem', timeOff: { __typename?: 'TimeOff', id: string, reason?: string | null, value: number, startDate: SAPIDate, endDate: SAPIDate, type: { __typename?: 'TimeOffTypeRelation', id: string, systemName: string } }, users: Array<{ __typename?: 'User', id: string, name: string }> } };

export type TimeOffModifyFormSaveMutationVariables = Exact<{
  input: TimeOffSaveInput;
}>;


export type TimeOffModifyFormSaveMutation = { __typename?: 'Mutation', TimeOffSave: { __typename?: 'TimeOffItem', timeOff: { __typename?: 'TimeOff', endDate: SAPIDate, id: string, reason?: string | null, startDate: SAPIDate, value: number, type: { __typename?: 'TimeOffTypeRelation', id: string, systemName: string } }, users: Array<{ __typename?: 'User', id: string, name: string }> } };

export type TimeOffTypeQueryVariables = Exact<{
  timeOffTypeInput: TimeOffTypesListFiltersInput;
}>;


export type TimeOffTypeQuery = { __typename?: 'Query', TimeOffTypesList: Array<{ __typename?: 'TimeOffTypeListItem', id: string, displayName: string, systemName: string }> };

export type TimeSpotterQueryVariables = Exact<{
  input: FreeTimeSlotInput;
}>;


export type TimeSpotterQuery = { __typename?: 'Query', FreeTimeSlotList: Array<{ __typename?: 'FreeTimeSlot', startDateTime: SAPIDateTime, endDateTime: SAPIDateTime, busyUserIds: Array<string> }> };

export type TimeSpotterUsersQueryVariables = Exact<{
  input: UsersListInput;
}>;


export type TimeSpotterUsersQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null }> };

export type ClientProfileAutoSuggestQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClientProfileAutoSuggestQuery = { __typename?: 'Query', ClientProfilesList: Array<{ __typename?: 'ClientProfile', id: string, name: string }> };

export type CommentReactionChangeMutationVariables = Exact<{
  input: CommentReactionMutationInput;
}>;


export type CommentReactionChangeMutation = { __typename?: 'Mutation', CommentReactionMutation?: { __typename?: 'CommentReactionItem', id: string, reactionCode: string, isActive: boolean, userIds: Array<number> } | null };

export type CommentReactionUsersQueryVariables = Exact<{
  usersListInput?: InputMaybe<UsersListInput>;
}>;


export type CommentReactionUsersQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string }> };

export type CommentReactionsQueryVariables = Exact<{
  commentId: Scalars['Int']['input'];
}>;


export type CommentReactionsQuery = { __typename?: 'Query', CommentReactions: Array<{ __typename?: 'CommentReactionItem', id: string, reactionCode: string, isActive: boolean, userIds: Array<number> }> };

export type ContactAutoSuggestQueryVariables = Exact<{
  contactsListInput?: InputMaybe<ContactsListInput>;
  includeType: Scalars['Boolean']['input'];
}>;


export type ContactAutoSuggestQuery = { __typename?: 'Query', ContactsList: Array<{ __typename?: 'Contact', id: string, name: string, type?: ContactType | null }> };

export type ContactCategoryAutoSuggestQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactCategoryAutoSuggestQuery = { __typename?: 'Query', ContactCategoriesList: Array<{ __typename?: 'ContactCategory', id: string, name: string, description: string }> };

export type EliChatHistoryQueryVariables = Exact<{
  input: EliChatHistoryInput;
}>;


export type EliChatHistoryQuery = { __typename?: 'Query', EliChatHistory?: Array<{ __typename?: 'EliChatMessageResponse', messageId: string, threadId: string, response: string, messageType: string }> | null };

export type EliMessageRateMutationVariables = Exact<{
  input: EliMessageRateInput;
}>;


export type EliMessageRateMutation = { __typename?: 'Mutation', EliMessageRate?: boolean | null };

export type EliWelcomeMessageQueryVariables = Exact<{
  input: EliWelcomeMessageInput;
}>;


export type EliWelcomeMessageQuery = { __typename?: 'Query', EliWelcomeMessage: string };

export type EliChatThreadHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type EliChatThreadHistoryQuery = { __typename?: 'Query', EliChatThreadHistory: Array<{ __typename?: 'EliChatThread', threadId: string, title: string }> };

export type EliChatMessageQueryVariables = Exact<{
  input: EliChatMessageInput;
}>;


export type EliChatMessageQuery = { __typename?: 'Query', EliChatMessage: { __typename?: 'EliChatMessageResponse', response: string, messageId: string, threadId: string, nextActions: Array<string>, feedback?: boolean | null } };

export type EliInsightsBookmarkQueryVariables = Exact<{
  input: EliInsightsBookmarkInput;
}>;


export type EliInsightsBookmarkQuery = { __typename?: 'Query', EliInsightsBookmark: { __typename?: 'EliInsightsBookmarkResponse', module: string, moduleTranslatedName: string, name: string, url: string } };

export type EliInsightsDropdownQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type EliInsightsDropdownQuery = { __typename?: 'Query', EliInsightsHistory: Array<{ __typename?: 'EliInsightsHistoryResponse', question: string, bookmark: { __typename?: 'EliInsightsBookmarkResponse', module: string, moduleTranslatedName: string, name: string, url: string } }> };

export type EliInsightsModulesQueryVariables = Exact<{
  input: EliInsightsModulesInput;
}>;


export type EliInsightsModulesQuery = { __typename?: 'Query', EliInsightsModules: Array<
    | { __typename?: 'EliInsightsMessageResponse', message: string }
    | { __typename?: 'EliInsightsModulesResponse', module: string, moduleTranslatedName: string }
   | null> };

export type EliInsightsRateMutationVariables = Exact<{
  input: EliInsightsRateInput;
}>;


export type EliInsightsRateMutation = { __typename?: 'Mutation', EliInsightsRate?: boolean | null };

export type EliInsightsMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type EliInsightsMetricsQuery = { __typename?: 'Query', EliInsightsMetrics: Array<{ __typename?: 'SummaryBlockItem', id: string, value?: number | null, title: string, secondaryValue?: number | null, secondaryDescription?: string | null, type: SummaryBlockItemType }> };

export type EliUsageMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type EliUsageMetricsQuery = { __typename?: 'Query', EliUsageMetrics: Array<{ __typename?: 'SummaryBlockItem', id: string, value?: number | null, title: string, secondaryValue?: number | null, secondaryDescription?: string | null, type: SummaryBlockItemType }> };

export type DomainAddOnPriceQueryVariables = Exact<{
  featureId: Scalars['Int']['input'];
}>;


export type DomainAddOnPriceQuery = { __typename?: 'Query', SelfServiceAddOnPrice?: { __typename?: 'SumWithCurrency', sum: number, currency: string } | null };

export type EmailServiceSettingsEmailDomainAddMutationVariables = Exact<{
  input: EmailDomainAddInput;
}>;


export type EmailServiceSettingsEmailDomainAddMutation = { __typename?: 'Mutation', EmailDomainAdd: { __typename?: 'EmailDomain', domain: string, isVerified: boolean, region: EmailDeliveryRegionEnum, dnsRecords: Array<{ __typename?: 'EmailDomainDnsRecord', host: string, type: string, value: string }> } };

export type EmailServiceSettingsEmailDomainDeleteMutationVariables = Exact<{
  input: EmailDomainDeleteInput;
}>;


export type EmailServiceSettingsEmailDomainDeleteMutation = { __typename?: 'Mutation', EmailDomainDelete: boolean };

export type EmailServiceSettingsEmailDomainFragment = { __typename?: 'EmailDomain', domain: string, isVerified: boolean, region: EmailDeliveryRegionEnum, dnsRecords: Array<{ __typename?: 'EmailDomainDnsRecord', host: string, type: string, value: string }> };

export type EmailServiceSettingsEmailDomainVerifyMutationVariables = Exact<{
  input: EmailDomainVerifyInput;
}>;


export type EmailServiceSettingsEmailDomainVerifyMutation = { __typename?: 'Mutation', EmailDomainVerify: boolean };

export type EmailServiceSettingsEmailDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailServiceSettingsEmailDomainsQuery = { __typename?: 'Query', EmailDomains: Array<{ __typename?: 'EmailDomain', domain: string, isVerified: boolean, region: EmailDeliveryRegionEnum, dnsRecords: Array<{ __typename?: 'EmailDomainDnsRecord', host: string, type: string, value: string }> }> };

export type AutoSuggestCalendarEventsQueryVariables = Exact<{
  calendarEventsListInput?: InputMaybe<CalendarEventsListInput>;
}>;


export type AutoSuggestCalendarEventsQuery = { __typename?: 'Query', CalendarEventsList: Array<{ __typename?: 'CalendarEvent', id: string, name: string }> };

export type ExpenseAutoSuggestQueryVariables = Exact<{
  expensesListInput?: InputMaybe<FinanceDocumentsListInput>;
}>;


export type ExpenseAutoSuggestQuery = { __typename?: 'Query', ExpensesList: Array<{ __typename?: 'Expense', id: string, number?: string | null, mainContact?: { __typename?: 'Contact', name: string } | null }> };

export type ChecklistItemSetAsDoneMutationVariables = Exact<{
  input: ChecklistSaveInput;
}>;


export type ChecklistItemSetAsDoneMutation = { __typename?: 'Mutation', ChecklistItemSetAsDone?: { __typename?: 'ChecklistItems', id?: string | null, type: string, item: string, isDone: number } | null };

export type ChecklistItemsQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type ChecklistItemsQuery = { __typename?: 'Query', ChecklistItems: Array<{ __typename?: 'ChecklistItems', id?: string | null, type: string, item: string, isDone: number }> };

export type GetStartedMilestonesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStartedMilestonesQuery = { __typename?: 'Query', GetStartedMilestones: Array<{ __typename?: 'Milestone', milestone: string, isReached: boolean }> };

export type HelpStationArticlesQueryVariables = Exact<{
  tag: Scalars['String']['input'];
}>;


export type HelpStationArticlesQuery = { __typename?: 'Query', HelpStationArticles: Array<{ __typename?: 'HelpStationArticle', id: number, url: string, title: string }> };

export type HelpStationSearchQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
}>;


export type HelpStationSearchQuery = { __typename?: 'Query', HelpStationArticlesSearch: Array<{ __typename?: 'HelpStationArticle', id: number, url: string, title: string }> };

export type HelpStationVideosQueryVariables = Exact<{
  tag: Scalars['String']['input'];
}>;


export type HelpStationVideosQuery = { __typename?: 'Query', HelpStationVideos: Array<{ __typename?: 'HelpStationVideo', duration: number, name: string, link: string, player_embed_url: string }> };

export type RateVirtualAssistantChatMessageMutationVariables = Exact<{
  input: VirtualAssistantRatingInput;
}>;


export type RateVirtualAssistantChatMessageMutation = { __typename?: 'Mutation', RateVirtualAssistantChatMessage?: boolean | null };

export type RateVirtualAssistantChatMutationVariables = Exact<{
  input: VirtualAssistantRatingInput;
}>;


export type RateVirtualAssistantChatMutation = { __typename?: 'Mutation', RateVirtualAssistantChat?: boolean | null };

export type TrialAutoExtensionMutationVariables = Exact<{
  input: TrialExtensionInput;
}>;


export type TrialAutoExtensionMutation = { __typename?: 'Mutation', TrialAutoExtension: string };

export type VirtualAssistantQueryVariables = Exact<{
  messages: Array<InputMaybe<VirtualAssistantMessageInput>> | InputMaybe<VirtualAssistantMessageInput>;
}>;


export type VirtualAssistantQuery = { __typename?: 'Query', VirtualAssistantChat: { __typename?: 'VirtualAssistantChatResponse', text: string, kind: string, messageId: string } };

export type IntegrationContainerQueryVariables = Exact<{
  appInput: IntegrationGetJwtInputType;
  itemInput: IntegrationItemInputType;
}>;


export type IntegrationContainerQuery = { __typename?: 'Query', IntegrationGetAppJwt: string, IntegrationItem: { __typename?: 'IntegrationItemEntity', iframeUrl?: string | null } };

export type IntegrationsListQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsListQuery = { __typename?: 'Query', IntegrationList: Array<{ __typename?: 'IntegrationItem', id: string, name: string, description: string, iconUrl?: string | null, isEnabled: boolean, isLocked: boolean, isConnected: boolean, integrationPage: string, iframeUrl?: string | null, groupName: string }> };

export type IntegrationActionRunMutationVariables = Exact<{
  input: IntegrationActionRunInput;
}>;


export type IntegrationActionRunMutation = { __typename?: 'Mutation', IntegrationActionRun?: { __typename?: 'IntegrationActionRunResponse', type?: string | null, message?: string | null } | null };

export type AvalaraMandatesQueryVariables = Exact<{
  countryCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AvalaraMandatesQuery = { __typename?: 'Query', AvalaraMandatesList: Array<{ __typename?: 'AvalaraMandate', id: string, title: string, mandateId: string, isActive: boolean, statusCode: string, statusText: string, inputDataFormats: Array<{ __typename?: 'AvalaraInputDataFormat', documentType: string, documentVersion: string }> }> };

export type AvalaraDefaultFieldMappingsQueryVariables = Exact<{
  module: Scalars['String']['input'];
}>;


export type AvalaraDefaultFieldMappingsQuery = { __typename?: 'Query', AvalaraDefaultFieldMappingsList: Array<{ __typename?: 'AvalaraDefaultFieldMapping', avalaraFieldId: string, scoroFieldId: string }> };

export type AvalaraMappingFieldsQueryVariables = Exact<{
  mandateId: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  documentVersion?: InputMaybe<Scalars['String']['input']>;
}>;


export type AvalaraMappingFieldsQuery = { __typename?: 'Query', AvalaraMappingFieldsList: Array<{ __typename?: 'AvalaraMappingField', id: string, name: string, description?: string | null, path?: string | null, dataType?: string | null, optionality?: string | null, fieldType?: string | null, minLength?: number | null, maxLength?: number | null, example?: string | null }> };

export type AvalaraScoroFieldsQueryVariables = Exact<{
  module: Scalars['String']['input'];
}>;


export type AvalaraScoroFieldsQuery = { __typename?: 'Query', AvalaraScoroFieldsList: Array<{ __typename?: 'AvalaraScoroField', id: string, title: string, group?: string | null }> };

export type IntegrationsCustomScriptsExecutionMutationVariables = Exact<{
  input: CustomScriptsExecutionInput;
}>;


export type IntegrationsCustomScriptsExecutionMutation = { __typename?: 'Mutation', CustomScriptExecution: Array<string | null> };

export type SageDimensionsSaveMutationVariables = Exact<{
  input: SageDimensionsSaveInput;
}>;


export type SageDimensionsSaveMutation = { __typename?: 'Mutation', SageDimensionsSave: Array<{ __typename: 'SageDimension', id: string, isActive: boolean, value: string, label: string, options: Array<{ __typename?: 'SageDimensionOptionType', value: string } | null> }> };

export type IntegrationsDimensionBlockQueryVariables = Exact<{
  module: Scalars['String']['input'];
}>;


export type IntegrationsDimensionBlockQuery = { __typename?: 'Query', SageDimensionsList: Array<{ __typename?: 'SageDimension', id: string, isActive: boolean, value: string, label: string, options: Array<{ __typename?: 'SageDimensionOptionType', value: string } | null> }> };

export type IntegrationsSettingsCalendarUserListQueryVariables = Exact<{
  input: UsersListInput;
}>;


export type IntegrationsSettingsCalendarUserListQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string, status: UserStatus, adapters?: Array<{ __typename?: 'Adapter', adapterCode?: string | null, externalSystemId?: string | null, calendarId?: string | null, calendarName?: string | null, syncSettings?: string | null, isActive?: boolean | null, setupStep?: string | null, errorCount?: number | null }> | null }> };

export type IntegrationsStripeSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsStripeSettingsQuery = { __typename?: 'Query', StripeTemplatesList: Array<{ __typename?: 'StripeTemplate', id: string, isPaymentLinkActive: boolean, relatedObject:
      | { __typename: 'EmailTemplate', id: string, name: string }
      | { __typename: 'PdfTemplate', id: string, name: string }
     }> };

export type StripeTemplateSaveMutationVariables = Exact<{
  pdfTemplateId: Scalars['ID']['input'];
}>;


export type StripeTemplateSaveMutation = { __typename?: 'Mutation', StripeTemplateSave: { __typename?: 'StripeTemplate', id: string, isPaymentLinkActive: boolean, relatedObject:
      | { __typename?: 'EmailTemplate' }
      | { __typename?: 'PdfTemplate', id: string, name: string }
     } };

export type InvoiceAutoSuggestQueryVariables = Exact<{
  invoicesListInput?: InputMaybe<FinanceDocumentsListInput>;
}>;


export type InvoiceAutoSuggestQuery = { __typename?: 'Query', InvoicesList: Array<{ __typename?: 'Invoice', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null }> };

export type ActivityLogsQueryVariables = Exact<{
  input: ActivityLogsInput;
}>;


export type ActivityLogsQuery = { __typename?: 'Query', ActivityLogs: Array<{ __typename?: 'UserLog', id: string, datetime: string, userId: number, userName: string, action: string, itemType: string, itemId: number, itemName: string, changeLog?: string | null, ip: string, activityType: string }> };

export type McpPermissionSetsQueryVariables = Exact<{
  input?: InputMaybe<PermissionSetsPermissionsInput>;
}>;


export type McpPermissionSetsQuery = { __typename?: 'Query', PermissionSetsPermissions: { __typename?: 'PermissionSetsPermissionsResult', permissionSets: Array<{ __typename?: 'PermissionSetWithPermissions', id: string, name: string, permissionValues: Array<{ __typename?: 'PermissionValue', permissionKey: string, value: boolean }> }> } };

export type UpdateMcpPermissionsMutationVariables = Exact<{
  input: UpdateMcpPermissionsInput;
}>;


export type UpdateMcpPermissionsMutation = { __typename?: 'Mutation', UpdateMcpPermissions: boolean };

export type NotificationsDropdownContentQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  startFrom?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NotificationsDropdownContentQuery = { __typename?: 'Query', UnreadNotificationsCount: number, NotificationsList: Array<{ __typename: 'Notification', id: string, action: NotificationActionType, isRead: boolean, customText?: string | null, customLink?: string | null, customTitle?: string | null, customBody?: string | null, createdDateTime: SAPIDateTime, module?: string | null, relatedObjectId: number, changes?: Array<
      | { __typename?: 'UnionFieldChange', fieldName: string, previousValue?: string | null, currentValue?: string | null }
      | { __typename?: 'UnionManagerChange', fieldName: string, previousUser?: { __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null } | null, currentUser?: { __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null } | null }
      | { __typename?: 'UnionProjectChange', fieldName: string, previousProject?: { __typename?: 'Project', name: string } | null, currentProject?: { __typename?: 'Project', name: string } | null }
      | { __typename?: 'UnionStatusChange', fieldName: string, previousStatus?:
          | { __typename?: 'UnionStaticStatus', staticStatus: { __typename?: 'StaticStatus', name: string, color: string } }
          | { __typename?: 'UnionStatus', status: { __typename?: 'Status', id: string, name: string, color: string } }
         | null, currentStatus?:
          | { __typename?: 'UnionStaticStatus', staticStatus: { __typename?: 'StaticStatus', name: string, color: string } }
          | { __typename?: 'UnionStatus', status: { __typename?: 'Status', id: string, name: string, color: string } }
         | null }
      | { __typename?: 'UnionUsersChange', fieldName: string, deletedUsers?: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null }> | null, addedUsers?: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null }> | null }
    > | null, comment?: { __typename?: 'Comment', id: string, text: string, strippedText: string, createdDate: SAPIDateTime, reactions: Array<{ __typename?: 'CommentReactionItem', id: string, reactionCode: string, isActive: boolean, userIds: Array<number> } | null> } | null, task?: { __typename?: 'Task', id: string, name: string, project?: { __typename?: 'Project', name: string } | null } | null, trigger?: { __typename?: 'Trigger', id: string, name: string } | null, relatedUser?: { __typename?: 'User', id: string, initials?: string | null, name: string, profilePicture?: { __typename?: 'UserPicture', medium: string } | null } | null, relatedObject?:
      | { __typename: 'UnionBackgroundJob', backgroundJob: { __typename?: 'BackgroundJob', id: string, jobTitle?: string | null, status: BackgroundJobStatus } }
      | { __typename: 'UnionBill', bill: { __typename?: 'Bill', id: string, number: string, deadline?: SAPIDate | null, sum: number, currency: string, status: string, mainContact?: { __typename?: 'Contact', name: string } | null, project?: { __typename?: 'Project', name: string } | null } }
      | { __typename: 'UnionContact', contact: { __typename?: 'Contact', id: string, name: string } }
      | { __typename: 'UnionCustomModuleEntry', customEntry: { __typename?: 'CustomModuleEntry', id: string, primaryFieldName?: string | null, module: { __typename?: 'CustomModule', nameCode: string, nameTranslated: string } } }
      | { __typename: 'UnionEvent', event: { __typename?: 'CalendarEvent', id: string, name: string, startDatetime?: SAPIDateTime | null, strippedDescription?: string | null, project?: { __typename?: 'Project', name: string } | null } }
      | { __typename: 'UnionExpense', expense: { __typename?: 'Expense', id: string, number?: string | null, mainContact?: { __typename?: 'Contact', name: string } | null, project?: { __typename?: 'Project', name: string } | null } }
      | { __typename: 'UnionImport', import: { __typename?: 'ImportType', id: string, fileName: string, type: string, hadErrors: boolean, isPartiallyDeleted: boolean, importedDateTime?: SAPIDateTime | null } }
      | { __typename: 'UnionInvoice', invoice: { __typename?: 'Invoice', id: string, number: string, deadline?: SAPIDate | null, margin?: string | null, sum: string, currency: string, mainContact?: { __typename?: 'Contact', name: string } | null, project?: { __typename?: 'Project', name: string } | null } }
      | { __typename: 'UnionNewsFeedItem', newsFeedItem: { __typename?: 'NewsFeedItem', id: string, name: string } }
      | { __typename: 'UnionOrder', order: { __typename?: 'Order', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null, project?: { __typename?: 'Project', name: string } | null } }
      | { __typename: 'UnionPrepayment', prepayment: { __typename?: 'Prepayment', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null, project?: { __typename?: 'Project', name: string } | null } }
      | { __typename: 'UnionProject', project: { __typename?: 'Project', id: string, name: string, strippedDescription?: string | null, defaultContact?: { __typename?: 'Contact', name: string } | null, company?: { __typename?: 'Contact', name: string } | null } }
      | { __typename: 'UnionPurchaseOrder', purchaseOrder: { __typename?: 'PurchaseOrder', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null, project?: { __typename?: 'Project', name: string } | null } }
      | { __typename: 'UnionQuote', quote: { __typename?: 'Quote', quoteName?: string | null, id: string, number: string, sum: number, currency: string, margin?: number | null, mainContact?: { __typename?: 'Contact', name: string } | null, project?: { __typename?: 'Project', name: string } | null, status?: { __typename?: 'Status', name: string, color: string } | null } }
      | { __typename: 'UnionTask', task: { __typename?: 'Task', id: string, name: string, strippedDescription?: string | null, project?: { __typename?: 'Project', name: string } | null } }
      | { __typename: 'UnionTimeEntry', timeEntry: { __typename?: 'TimeEntry', id: string, description: string, task?: { __typename?: 'Task', id: string, name: string, description?: string | null, project?: { __typename?: 'Project', id: string, name: string } | null, activityType?: { __typename?: 'ActivityType', id: string, name: string, status: ActivityTypeStatus } | null } | null } }
     | null }> };

export type NotificationsDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsDropdownQuery = { __typename?: 'Query', UnreadNotificationsCount: number };

export type NotificationsMarkAllAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationsMarkAllAsReadMutation = { __typename?: 'Mutation', MarkAllNotificationsRead: boolean };

export type NotificationsMarkAsReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NotificationsMarkAsReadMutation = { __typename?: 'Mutation', NotificationsMarkAsRead: { __typename?: 'Notification', id: string, isRead: boolean } };

export type NotificationsMarkAsUnreadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NotificationsMarkAsUnreadMutation = { __typename?: 'Mutation', NotificationsMarkAsUnread: { __typename?: 'Notification', id: string, isRead: boolean } };

export type OrderAutoSuggestQueryVariables = Exact<{
  ordersListInput?: InputMaybe<FinanceDocumentsListInput>;
}>;


export type OrderAutoSuggestQuery = { __typename?: 'Query', OrdersList: Array<{ __typename?: 'Order', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null }> };

export type PrepaymentAutoSuggestQueryVariables = Exact<{
  prepaymentsListInput?: InputMaybe<FinanceDocumentsListInput>;
}>;


export type PrepaymentAutoSuggestQuery = { __typename?: 'Query', PrepaymentsList: Array<{ __typename?: 'Prepayment', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null }> };

export type PriceListExistingPriceListQueryVariables = Exact<{
  rolesListInput: RolesListInput;
  localPriceListId: Scalars['ID']['input'];
}>;


export type PriceListExistingPriceListQuery = { __typename?: 'Query', LocalPriceList: { __typename?: 'LocalPriceList', id: string, currency: string, name: string, createdDate: SAPIDateTime, localRolePrices: Array<{ __typename?: 'LocalRolePrice', roleId: string, sellingPrice?: number | null }> }, RolesList: Array<{ __typename?: 'Role', id: string, name: string }> };

export type PriceListModalQueryVariables = Exact<{
  rolesListInput: RolesListInput;
  globalPriceListId: Scalars['ID']['input'];
}>;


export type PriceListModalQuery = { __typename?: 'Query', LocalPriceListFromPriceList?: { __typename?: 'LocalPriceList', id: string, name: string, currency: string, localRolePrices: Array<{ __typename?: 'LocalRolePrice', roleId: string, sellingPrice?: number | null }> } | null, RolesList: Array<{ __typename?: 'Role', id: string, name: string }> };

export type PriceListSaveMutationVariables = Exact<{
  input: LocalPriceListSaveInput;
}>;


export type PriceListSaveMutation = { __typename?: 'Mutation', LocalPriceListSave: { __typename: 'LocalPriceList', id: string, name: string, localRolePrices: Array<{ __typename?: 'LocalRolePrice', roleId: string, sellingPrice?: number | null }> } };

export type ProjectAutoSuggestQueryVariables = Exact<{
  projectsListInput?: InputMaybe<ProjectsListInput>;
}>;


export type ProjectAutoSuggestQuery = { __typename?: 'Query', ProjectsList: Array<{ __typename?: 'Project', id: string, name: string }> };

export type ProjectBudgetAndPricingExistingProjectQueryVariables = Exact<{
  projectParams: ProjectParamsInput;
}>;


export type ProjectBudgetAndPricingExistingProjectQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', projectType: ProjectType, budgetType?: ProjectBudget | null, duration?: SAPIDuration | null, useBillsExpensesInCalculations?: boolean | null, useRoles?: boolean | null, shouldDisableCalculationType?: boolean | null, revenueBudget?: { __typename?: 'Budget', id: string } | null, costBudget?: { __typename?: 'Budget', id: string } | null, budgetSums?: Array<{ __typename?: 'ProjectBudgetSums', bills?: number | null, expenses?: number | null, laborCost?: number | null, invoices?: number | null, currency: string }> | null, quotedBudgetSums?: Array<{ __typename?: 'ProjectBudgetSums', duration?: number | null, bills?: number | null, expenses?: number | null, laborCost?: number | null, invoices?: number | null, currency: string }> | null, priceList?: { __typename?: 'PriceList', id: string, currency: string } | null, localPriceList?: { __typename?: 'LocalPriceList', id: string } | null, retainer?: { __typename?: 'Retainer', id: string, frequency: number, frequencyType: RetainerFrequency, noOfPeriods: number, budgetType: RetainerBudget, periodBillsSum?: number | null, periodDuration?: number | null, periodExpensesSum?: number | null, periodLaborCostSum?: number | null, periodSum?: number | null, totalSum?: number | null, totalDuration?: number | null, startDate?: SAPIDate | null, isPeriodDurationEnabled?: boolean | null } | null } | null };

export type ProjectBudgetAndPricingPriceListsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectBudgetAndPricingPriceListsListQuery = { __typename?: 'Query', PriceListsList: Array<{ __typename?: 'PriceList', id: string, name: string, currency: string, isDefault: boolean }> };

export type ProjectSecondaryDataQueryQueryVariables = Exact<{
  budgetParams: BudgetsListInput;
}>;


export type ProjectSecondaryDataQueryQuery = { __typename?: 'Query', BudgetsList: Array<{ __typename?: 'Budget', id: string, name: string }> };

export type ProjectDetailsHeaderMembersSaveMutationMutationVariables = Exact<{
  input: ProjectMembersSaveInput;
}>;


export type ProjectDetailsHeaderMembersSaveMutationMutation = { __typename?: 'Mutation', ProjectMembersSave: { __typename: 'Project', id: string, manager?: { __typename?: 'User', id: string, name: string, profilePicture?: { __typename?: 'UserPicture', mini: string } | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null }>, cupoUsers: Array<{ __typename?: 'User', name: string, id: string, profilePicture?: { __typename?: 'UserPicture', mini: string } | null }> } };

export type ProjectDetailsHeaderQueryVariables = Exact<{
  projectInput: ProjectParamsInput;
}>;


export type ProjectDetailsHeaderQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, number?: string | null, name: string, date?: SAPIDate | null, deadline?: SAPIDate | null, completedDateTime?: SAPIDateTime | null, color?: string | null, duration?: SAPIDuration | null, doneDuration?: SAPIDuration | null, toDoDuration?: SAPIDuration | null, isDeleted?: boolean | null, isPersonal?: boolean | null, isPrivate?: boolean | null, projectType: ProjectType, manager?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, permissions?: { __typename?: 'ProjectPermissions', canModify: boolean } | null, members: Array<{ __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, cupoUsers: Array<{ __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, priceList?: { __typename?: 'PriceList', id: string, currency: string } | null, projectPhases?: Array<{ __typename?: 'ProjectPhase', id: string, title: string, ordering: number, startDate?: SAPIDate | null, endDate?: SAPIDate | null, type: ProjectPhaseTypeEnum }> | null } | null };

export type ProjectDetailsHeaderIntegrationActionListQueryVariables = Exact<{
  input: IntegrationActionListInput;
}>;


export type ProjectDetailsHeaderIntegrationActionListQuery = { __typename?: 'Query', IntegrationActionList: Array<{ __typename?: 'IntegrationAction', type: string, href?: string | null, title: string, icon: string, syncStatus?: string | null, errorCount?: number | null }> };

export type ProjectDetailsHeaderProjectRestoreMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectDetailsHeaderProjectRestoreMutation = { __typename?: 'Mutation', ProjectRestore: { __typename: 'Project', id: string, isDeleted?: boolean | null } };

export type ProjectHealthQueryVariables = Exact<{
  input?: InputMaybe<ProjectHealthInput>;
}>;


export type ProjectHealthQuery = { __typename?: 'Query', ProjectHealth?: { __typename?: 'ProjectHealth', projectHealthScore: number, createdDatetime: SAPIDate, project: { __typename?: 'Project', id: string, name: string } } | null };

export type ProjectsListMetricsProjectIdsQueryVariables = Exact<{
  input?: InputMaybe<SummaryBlockInput>;
}>;


export type ProjectsListMetricsProjectIdsQuery = { __typename?: 'Query', ProjectsListMetricsProjectIds: Array<string> };

export type ProjectMetricsConfigSaveMutationVariables = Exact<{
  input: ProjectMetricsConfigSaveInput;
}>;


export type ProjectMetricsConfigSaveMutation = { __typename?: 'Mutation', ProjectMetricsConfigSave: { __typename?: 'MetricConfig', id: string, hasHistogram: boolean, isHistogramSupported: boolean, metricId: string, alertCondition?: WatchdogAlertConditionEnum | null, alertThreshold?: number | null, alertType?: WatchdogAlertTypeEnum | null, notificationTypes?: Array<WatchdogNotificationTypeEnum> | null } };

export type ProjectMetricsConfigQueryVariables = Exact<{
  input?: InputMaybe<ProjectMetricConfigInput>;
}>;


export type ProjectMetricsConfigQuery = { __typename?: 'Query', ProjectMetricConfig: { __typename?: 'MetricConfig', id: string, hasHistogram: boolean, isHistogramSupported: boolean, metricId: string, alertCondition?: WatchdogAlertConditionEnum | null, alertThreshold?: number | null, alertType?: WatchdogAlertTypeEnum | null, notificationTypes?: Array<WatchdogNotificationTypeEnum> | null, supportedAlertTypes?: Array<WatchdogAlertTypeEnum> | null, isWatchdogLimitReached?: boolean | null, isPastPeriod: boolean, retainerPeriod?: { __typename?: 'RetainerPeriod', id: string, name: string, startDate: SAPIDate, endDate: SAPIDate } | null } };

export type ProjectMetricsQueryVariables = Exact<{
  input?: InputMaybe<ProjectMetricsInput>;
}>;


export type ProjectMetricsQuery = { __typename?: 'Query', ProjectMetrics: Array<{ __typename?: 'SummaryBlockItem', id: string, title: string, value?: number | null, unit?: string | null, valueState?: MetricsValueState | null, type: SummaryBlockItemType, secondaryValue?: number | null, secondaryUnit?: string | null, secondaryDescription?: string | null, secondaryValueState?: MetricsValueState | null, isSecondaryValueFirst?: boolean | null, config?: { __typename?: 'MetricConfig', id: string, hasHistogram: boolean, isHistogramSupported: boolean, notificationTypes?: Array<WatchdogNotificationTypeEnum> | null, metricId: string, isAlertTriggered?: boolean | null, isPastPeriod: boolean, histogramLogs?: Array<{ __typename?: 'MetricLog', id: string, loggedDateTime: SAPIDateTime, value: number }> | null } | null }> };

export type ProjectMetricsSettingsSaveMutationVariables = Exact<{
  input: ProjectMetricsSettingsSaveInput;
}>;


export type ProjectMetricsSettingsSaveMutation = { __typename?: 'Mutation', ProjectMetricsSettingsSave: boolean };

export type ProjectMetricsSettingListQueryVariables = Exact<{
  input?: InputMaybe<ProjectMetricsInput>;
}>;


export type ProjectMetricsSettingListQuery = { __typename?: 'Query', ProjectMetricsSettings: Array<{ __typename?: 'MetricSettingOption', id: string, isActive: boolean, title: string }> };

export type ContactUnpaidInvoicesFieldsFragment = { __typename?: 'ContactUnpaidInvoices', currencySymbol: string, hasAccessToInvoices: boolean, hasUnpaidInvoices: boolean, prepaymentBalance: number, unpaidInvoices: number };

export type ProjectModifyModalQueryVariables = Exact<{
  projectParams: ProjectParamsInput;
}>;


export type ProjectModifyModalQuery = { __typename?: 'Query', PhasesTaskSets: Array<
    | { __typename: 'ProjectPhase', id: string, title: string, startDate?: SAPIDate | null, startDays?: number | null, endDate?: SAPIDate | null, endDays?: number | null, type: ProjectPhaseTypeEnum, ordering: number, isChangingDatesDisabled: boolean, hasDependencies: boolean, quoteLine?: { __typename?: 'QuoteLine', id: string } | null, taskSets?: Array<{ __typename?: 'TaskSet', name: string, id: string, ordering: number, maxDays?: number | null, minDays?: number | null, taskTemplatesCount: number }> | null }
    | { __typename: 'TaskSet', name: string, id: string, ordering: number, maxDays?: number | null, minDays?: number | null, taskTemplatesCount: number }
  >, Project?: { __typename?: 'Project', id: string, accountId: string, projectType: ProjectType, name: string, number?: string | null, isPersonal?: boolean | null, date?: SAPIDate | null, deadline?: SAPIDate | null, color?: string | null, isPrivate?: boolean | null, budgetType?: ProjectBudget | null, useBillsExpensesInCalculations?: boolean | null, duration?: SAPIDuration | null, useRoles?: boolean | null, hasBackToBackPhases?: boolean | null, shouldDisableCalculationType?: boolean | null, numberOfTasks?: number | null, company?: { __typename?: 'Contact', id: string, name: string, unpaidInvoices?: { __typename?: 'ContactUnpaidInvoices', currencySymbol: string, hasAccessToInvoices: boolean, hasUnpaidInvoices: boolean, prepaymentBalance: number, unpaidInvoices: number } | null } | null, manager?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, cupoUsers: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }>, retainer?: { __typename?: 'Retainer', frequency: number, frequencyType: RetainerFrequency, noOfPeriods: number, isPeriodDurationEnabled?: boolean | null, budgetType: RetainerBudget, periodDuration?: number | null, periodSum?: number | null, periodBillsSum?: number | null, periodExpensesSum?: number | null, periodLaborCostSum?: number | null } | null, quotedBudgetSums?: Array<{ __typename?: 'ProjectBudgetSums', duration?: number | null, invoices?: number | null, bills?: number | null, expenses?: number | null, laborCost?: number | null, currency: string }> | null, budgetSums?: Array<{ __typename?: 'ProjectBudgetSums', duration?: number | null, bills?: number | null, invoices?: number | null, expenses?: number | null, laborCost?: number | null, currency: string }> | null, priceList?: { __typename?: 'PriceList', id: string, name: string, currency: string, isDefault: boolean } | null, projectTags: Array<{ __typename?: 'Tag', id: string, title: string, isGroup: boolean, parent?: { __typename?: 'Tag', id: string, title: string } | null }>, accounts: Array<{ __typename?: 'CompanyAccount', id: string, name: string, isInUse?: boolean | null }>, projectPhases?: Array<{ __typename?: 'ProjectPhase', id: string, type: ProjectPhaseTypeEnum, title: string, startDate?: SAPIDate | null, endDate?: SAPIDate | null }> | null, revenueBudget?: { __typename?: 'Budget', id: string, name: string } | null, localPriceList?: { __typename?: 'LocalPriceList', id: string, name: string } | null, permissions?: { __typename?: 'ProjectPermissions', canModify: boolean, canDelete: boolean } | null, costBudget?: { __typename?: 'Budget', id: string, name: string } | null } | null };

export type ProjectPhasesAndTaskSetsSaveMutationVariables = Exact<{
  input: ProjectPhasesAndTaskSetsSaveInput;
}>;


export type ProjectPhasesAndTaskSetsSaveMutation = { __typename?: 'Mutation', ProjectPhasesAndTaskSetsSave: { __typename?: 'Project', id: string } };

export type ContactDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactDetailsQuery = { __typename?: 'Query', Contact?: { __typename?: 'Contact', id: string, unpaidInvoices?: { __typename?: 'ContactUnpaidInvoices', currencySymbol: string, hasAccessToInvoices: boolean, hasUnpaidInvoices: boolean, prepaymentBalance: number, unpaidInvoices: number } | null, clientProfile?: { __typename?: 'ClientProfile', id: string, priceList?: { __typename?: 'PriceList', id: string } | null } | null, customFields?: Array<{ __typename?: 'CustomFieldData', id: string, type?: CustomFieldType | null, value?:
        | { __typename?: 'BoolCustomFieldValue', boolValue?: boolean | null }
        | { __typename?: 'DateCustomFieldValue', dateValue?: SAPIDate | null }
        | { __typename?: 'DateTimeCustomFieldValue', dateTimeValue?: SAPIDateTime | null }
        | { __typename?: 'FloatCustomFieldValue', floatValue?: number | null }
        | { __typename?: 'FloatRangeCustomFieldValue', floatValueFrom?: number | null, floatValueTo?: number | null }
        | { __typename?: 'ImageCustomFieldValue', file?: { __typename?: 'File', id: string } | null }
        | { __typename?: 'IntCustomFieldValue', intValue?: number | null }
        | { __typename?: 'RelationCustomFieldValue', relation?:
            | { __typename?: 'CalendarEvent', id: string, name: string }
            | { __typename?: 'Contact', id: string, name: string }
            | { __typename?: 'CustomModuleEntry' }
            | { __typename?: 'Project', id: string, name: string }
            | { __typename?: 'Task', id: string, name: string }
            | { __typename?: 'User', id: string, name: string }
           | null }
        | { __typename?: 'StringCustomFieldValue', stringValue?: string | null }
       | null } | null> | null } | null };

export type ProjectDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectDeleteMutation = { __typename?: 'Mutation', ProjectDelete: boolean };

export type ProjectNextHighestNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectNextHighestNumberQuery = { __typename?: 'Query', ProjectNextNumber: number };

export type ProjectRelationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectRelationsQuery = { __typename?: 'Query', ProjectRelations: Array<string | null> };

export type ProjectSaveMutationVariables = Exact<{
  input: ProjectSaveInput;
}>;


export type ProjectSaveMutation = { __typename?: 'Mutation', ProjectSave: { __typename: 'Project', id: string, name: string, manager?: { __typename?: 'User', id: string } | null, members: Array<{ __typename?: 'User', id: string }>, cupoUsers: Array<{ __typename?: 'User', id: string }>, projectPhases?: Array<{ __typename?: 'ProjectPhase', id: string, title: string, ordering: number, startDate?: SAPIDate | null, endDate?: SAPIDate | null, type: ProjectPhaseTypeEnum }> | null } };

export type ProjectTabsSettingsQueryVariables = Exact<{
  tabsListInput: ProjectTabsListInput;
}>;


export type ProjectTabsSettingsQuery = { __typename?: 'Query', ProjectTabsList: Array<{ __typename?: 'Tab', key: TabKey, isActive: boolean, shortcuts: Array<{ __typename?: 'TabShortcut', id: string, icon: string, label: string, link: string }>, subTabs: Array<{ __typename?: 'Tab', key: TabKey, isActive: boolean }> }> };

export type QuoteDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuoteDetailsQuery = { __typename?: 'Query', Quote?: { __typename?: 'Quote', id: string, status?: { __typename?: 'Status', id: string, statusId: string } | null, lines: Array<{ __typename?: 'QuoteLine', id: string }> } | null };

export type QuoteStatusesListQueryVariables = Exact<{ [key: string]: never; }>;


export type QuoteStatusesListQuery = { __typename?: 'Query', StatusesList?: Array<{ __typename?: 'Status', id: string, statusId: string, name: string }> | null };

export type ProjectProfitTableQueryVariables = Exact<{
  projectInput: ProjectParamsInput;
  projectProfitDataInput: ProjectProfitDataInput;
}>;


export type ProjectProfitTableQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, profitData?: { __typename?: 'ProjectProfitData', revenueBudget?: number | null, revenueRecognized?: number | null, revenueInvoiced?: number | null, revenueForecasted?: number | null, costBudget?: number | null, costRecognized?: number | null, costInvoiced?: number | null, costForecasted?: number | null, internalCostBudget?: number | null, internalCostRecognized?: number | null, internalCostInvoiced?: number | null, internalCostForecasted?: number | null, externalCostBudget?: number | null, externalCostRecognized?: number | null, externalCostInvoiced?: number | null, externalCostForecasted?: number | null } | null } | null };

export type ProjectProgressQueryVariables = Exact<{
  projectInput: ProjectParamsInput;
}>;


export type ProjectProgressQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, duration?: SAPIDuration | null, doneDuration?: SAPIDuration | null, toDoDuration?: SAPIDuration | null, projectPhases?: Array<{ __typename?: 'ProjectPhase', id: string, title: string, ordering: number, startDate?: SAPIDate | null, endDate?: SAPIDate | null, type: ProjectPhaseTypeEnum }> | null } | null };

export type BudgetChartQueryVariables = Exact<{
  projectInput: ProjectParamsInput;
  projectProgressInput: ProjectProgressInput;
}>;


export type BudgetChartQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, company?: { __typename?: 'Contact', id: string, type?: ContactType | null } | null, progressData: Array<{ __typename?: 'ProjectProgressGroup', timeBudget: number, groupName: string, plannedTime: number, actualTime: number, forecastedTime: number, monetaryBudget: number, actualRevenue: number, forecastedRevenue: number, actualCost: number, bookingsCost: number, costBudget: number, forecastedCost: number, tasksCost: number }> } | null };

export type BurnUpChartQueryVariables = Exact<{
  projectInput: ProjectParamsInput;
  projectProgressInput: ProjectProgressInput;
}>;


export type BurnUpChartQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, date?: SAPIDate | null, deadline?: SAPIDate | null, company?: { __typename?: 'Contact', id: string, type?: ContactType | null } | null, progressData: Array<{ __typename?: 'ProjectProgressGroup', timeBudget: number, groupName: string, actualTime: number, plannedTime: number, forecastedTime: number, monetaryBudget: number, actualRevenue: number, forecastedRevenue: number, actualCost: number, bookingsCost: number, costBudget: number, forecastedCost: number, tasksCost: number }> } | null };

export type ProjectRevenueForecastPeriodSaveMutationVariables = Exact<{
  input: RevenueForecastPeriodSaveInput;
}>;


export type ProjectRevenueForecastPeriodSaveMutation = { __typename?: 'Mutation', RevenueForecastPeriodSave: Array<{ __typename?: 'RevenueForecastPeriod', id: string, period: string, earnedRevenue?: number | null, forecastedRevenue?: number | null, revenue?: number | null, isRevenueSetByUser: boolean }> };

export type ProjectRevenueForecastQueryVariables = Exact<{
  revenueForecastInput: ProjectRevenueForecastInput;
}>;


export type ProjectRevenueForecastQuery = { __typename?: 'Query', ProjectRevenueForecast: { __typename?: 'ProjectRevenueForecast', quotedTotal?: number | null, project: { __typename?: 'Project', id: string, budgetType?: ProjectBudget | null, useBillsExpensesInCalculations?: boolean | null, priceList?: { __typename?: 'PriceList', id: string, currency: string } | null, retainer?: { __typename?: 'Retainer', id: string, budgetType: RetainerBudget } | null }, periods: Array<{ __typename?: 'RevenueForecastPeriod', id: string, period: string, earnedRevenue?: number | null, forecastedRevenue?: number | null, revenue?: number | null, isRevenueSetByUser: boolean }> }, CurrenciesList: Array<{ __typename?: 'Currency', id: string, name: string }> };

export type TabsSaveMutationVariables = Exact<{
  input: TabsSaveInput;
}>;


export type TabsSaveMutation = { __typename?: 'Mutation', TabsSave: boolean };

export type ProjectTabsPageQueryVariables = Exact<{
  tabsListInput: ProjectTabsListInput;
  projectInput: ProjectParamsInput;
}>;


export type ProjectTabsPageQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, createdBy?: { __typename?: 'User', id: string, initials?: string | null } | null, modifiedBy?: { __typename?: 'User', id: string, initials?: string | null } | null } | null, ProjectTabsList: Array<{ __typename?: 'Tab', key: TabKey, isActive: boolean, shortcuts: Array<{ __typename?: 'TabShortcut', id: string, icon: string, label: string, link: string }>, subTabs: Array<{ __typename?: 'Tab', key: TabKey, isActive: boolean }> }> };

export type ProjectTaskListEnrichmentsQueryVariables = Exact<{
  taskListParams: TasksListInput;
}>;


export type ProjectTaskListEnrichmentsQuery = { __typename?: 'Query', TasksList: Array<
    | { __typename?: 'LimitedTask', id: string, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
    | { __typename?: 'Task', id: string, hasCustomAllocation: boolean, durationPlanned: number, parentId?: string | null, subtasks: Array<
        | { __typename?: 'LimitedTask', id: string, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
        | { __typename?: 'Task', id: string, hasCustomAllocation: boolean, durationPlanned: number, parentId?: string | null, project?: { __typename?: 'Project', id: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }>, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
      >, project?: { __typename?: 'Project', id: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }>, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
  > };

export type ProjectTaskListQueryVariables = Exact<{
  taskListParams: TasksListInput;
  projectParams: ProjectParamsInput;
}>;


export type ProjectTaskListQuery = { __typename?: 'Query', TasksList: Array<
    | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, subtasks: Array<
        | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
        | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
      >, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
    | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, subtasks: Array<
        | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
        | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
      >, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
  >, Project?: { __typename?: 'Project', id: string, createTasksFromQuoteId?: string | null, company?: { __typename?: 'Contact', id: string } | null, projectPhases?: Array<{ __typename?: 'ProjectPhase', id: string, title: string, ordering: number, startDate?: SAPIDate | null, endDate?: SAPIDate | null, type: ProjectPhaseTypeEnum, hasTasks: boolean }> | null, permissions?: { __typename?: 'ProjectPermissions', canView: boolean, canModify: boolean } | null } | null };

export type ProjectTaskListTaskSaveMutationVariables = Exact<{
  input: TaskSaveInput;
}>;


export type ProjectTaskListTaskSaveMutation = { __typename?: 'Mutation', TaskSave: { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, subtasks: Array<
      | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
      | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
    >, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null } };

export type ProjectTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectTemplatesQuery = { __typename?: 'Query', ProjectTemplates: Array<{ __typename?: 'ProjectTemplate', id: string, templateName?: string | null, projectType: ProjectType }> };

export type ProjectTimeFrameSaveMutationVariables = Exact<{
  input: ProjectDatesSaveInput;
}>;


export type ProjectTimeFrameSaveMutation = { __typename?: 'Mutation', ProjectDatesSave: { __typename?: 'Project', id: string, date?: SAPIDate | null, deadline?: SAPIDate | null } };

export type ProjectPhasesProjectPhaseFragment = { __typename: 'ProjectPhase', id: string, title: string, startDate?: SAPIDate | null, startDays?: number | null, endDate?: SAPIDate | null, endDays?: number | null, type: ProjectPhaseTypeEnum, ordering: number, isChangingDatesDisabled: boolean, hasDependencies: boolean, quoteLine?: { __typename?: 'QuoteLine', id: string } | null, taskSets?: Array<{ __typename?: 'TaskSet', name: string, id: string, ordering: number, maxDays?: number | null, minDays?: number | null, taskTemplatesCount: number }> | null };

export type ProjectPhasesTaskSetFragment = { __typename: 'TaskSet', name: string, id: string, ordering: number, maxDays?: number | null, minDays?: number | null, taskTemplatesCount: number };

export type PhasesTaskSetsQueryVariables = Exact<{
  projectParams: ProjectParamsInput;
}>;


export type PhasesTaskSetsQuery = { __typename?: 'Query', PhasesTaskSets: Array<
    | { __typename: 'ProjectPhase', id: string, title: string, startDate?: SAPIDate | null, startDays?: number | null, endDate?: SAPIDate | null, endDays?: number | null, type: ProjectPhaseTypeEnum, ordering: number, isChangingDatesDisabled: boolean, hasDependencies: boolean, quoteLine?: { __typename?: 'QuoteLine', id: string } | null, taskSets?: Array<{ __typename?: 'TaskSet', name: string, id: string, ordering: number, maxDays?: number | null, minDays?: number | null, taskTemplatesCount: number }> | null }
    | { __typename: 'TaskSet', name: string, id: string, ordering: number, maxDays?: number | null, minDays?: number | null, taskTemplatesCount: number }
  >, Project?: { __typename?: 'Project', id: string, hasBackToBackPhases?: boolean | null, numberOfTasks?: number | null } | null };

export type AvailableDateQueryVariables = Exact<{
  availableDateParams: AvailableDateParamsInput;
}>;


export type AvailableDateQuery = { __typename?: 'Query', AvailableDate: string };

export type PurchaseOrderAutoSuggestQueryVariables = Exact<{
  purchaseOrdersListInput?: InputMaybe<FinanceDocumentsListInput>;
}>;


export type PurchaseOrderAutoSuggestQuery = { __typename?: 'Query', PurchaseOrdersList: Array<{ __typename?: 'PurchaseOrder', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null }> };

export type QuoteAutoSuggestQueryVariables = Exact<{
  quoteFiltersInput?: InputMaybe<QuoteFiltersInput>;
  startFrom?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<QuoteOrderingInput> | QuoteOrderingInput>;
}>;


export type QuoteAutoSuggestQuery = { __typename?: 'Query', QuotesList: Array<{ __typename?: 'Quote', id: string, number: string, quoteName?: string | null, mainContact?: { __typename?: 'Contact', name: string } | null }> };

export type QuoteMatrixRoleFragment = { __typename?: 'Role', id: string, name: string, laborCost?: number | null };

export type QuoteMatrixUserFragment = { __typename?: 'User', id: string, name: string, laborCost?: number | null, role?: { __typename?: 'Role', id: string, name: string } | null };

export type QuoteMatrixModalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  laborCostInput?: InputMaybe<LaborCostInput>;
  sellingPriceInput?: InputMaybe<LocalRoleSellingPriceInput>;
}>;


export type QuoteMatrixModalQuery = { __typename?: 'Query', QuoteMatrix: { __typename?: 'QuoteMatrix', quote: { __typename?: 'Quote', id: string, isRoleBased: boolean, discount?: number | null, discount2?: number | null, discount3?: number | null, localPriceList?: { __typename?: 'LocalPriceList', id: string, localRolePrices: Array<{ __typename?: 'LocalRolePrice', currencyConvertedSellingPrice?: number | null, roleId: string }> } | null, lines: Array<{ __typename?: 'QuoteLine', id: string, isSubHeading: boolean, isInternal: boolean, isEmptyRow: boolean, comment?: string | null, price: number, amount: number, secondaryAmount: number, cost?: number | null, ordering: number, discount: number, unit?: { __typename?: 'Unit', id: string, name: string } | null, product?: { __typename?: 'Product', id: string, name: string, noDiscountsApplied: boolean } | null, providers?: Array<{ __typename?: 'QuoteLineProvider', id: string, price: number, quantity: number, unitCost?: number | null, role?: { __typename?: 'Role', id: string, name: string, laborCost?: number | null } | null, user?: { __typename?: 'User', id: string, name: string, laborCost?: number | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null }> | null }> }, settings: { __typename?: 'QuoteMatrixSettings', hoursPerDay: number, isSecondaryQuantityEnabled: boolean, secondaryQuantityLabel: string, canSeeLaborCost: boolean }, extraProviders: Array<{ __typename?: 'QuoteMatrixProvider', role?: { __typename?: 'Role', id: string, name: string, laborCost?: number | null } | null, user?: { __typename?: 'User', id: string, name: string, laborCost?: number | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null }> } };

export type QuoteRevenueModalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuoteRevenueModalQuery = { __typename?: 'Query', QuoteRevenueForecast: { __typename?: 'QuoteRevenueForecast', quote: { __typename?: 'Quote', id: string, revenueStartDate?: SAPIDate | null, revenueIncludeCosts: boolean }, periods: Array<{ __typename?: 'RevenueForecastPeriod', id: string, revenue?: number | null, isRevenueSetByUser: boolean }> } };

export type QuoteToTaskAssigneesOwnerQueryVariables = Exact<{
  input: UsersListInput;
}>;


export type QuoteToTaskAssigneesOwnerQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null }> };

export type QuoteToTaskAssigneesRolesQueryVariables = Exact<{
  input: RolesListInput;
}>;


export type QuoteToTaskAssigneesRolesQuery = { __typename?: 'Query', RolesList: Array<{ __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null }> };

export type JoinReferralMutationVariables = Exact<{ [key: string]: never; }>;


export type JoinReferralMutation = { __typename?: 'Mutation', JoinReferralMutation: { __typename?: 'ReferralLinks', share: string, linkedIn: string } };

export type ReferralLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralLinksQuery = { __typename?: 'Query', ReferralLinks: { __typename?: 'ReferralLinks', share: string, linkedIn: string, portal?: string | null } };

export type ReferralShareLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralShareLinksQuery = { __typename?: 'Query', ReferralLinks: { __typename?: 'ReferralLinks', share: string, linkedIn: string } };

export type ReportsLibraryQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportsLibraryQuery = { __typename?: 'Query', ReportsLibrary: { __typename?: 'ReportsLibrary', categories?: Array<string> | null, reports?: Array<{ __typename?: 'ReportsLibraryReport', key: string, url: string, categories: Array<string> }> | null } };

export type ResourceAutoSuggestQueryVariables = Exact<{
  resourcesListInput?: InputMaybe<ResourcesListInput>;
}>;


export type ResourceAutoSuggestQuery = { __typename?: 'Query', ResourcesList: Array<{ __typename?: 'Resource', id: string, name: string }> };

export type ResourceBookingsMoveMutationVariables = Exact<{
  input: BookingsMoveInput;
}>;


export type ResourceBookingsMoveMutation = { __typename?: 'Mutation', BookingsMove: boolean };

export type ResourcePlanningRoleProjectFragment = { __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string, name: string } };

export type ResourcePlanningProjectAddMemberMutationVariables = Exact<{
  input: ProjectMembersAddInput;
}>;


export type ResourcePlanningProjectAddMemberMutation = { __typename?: 'Mutation', ProjectMembersAdd: { __typename: 'Project', id: string, members: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null }>, roleProjects?: Array<{ __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string, name: string } }> | null } };

export type ResourcePlanningProjectRemoveMemberMutationVariables = Exact<{
  input: ProjectMembersRemoveInput;
}>;


export type ResourcePlanningProjectRemoveMemberMutation = { __typename?: 'Mutation', ProjectMembersRemove: { __typename: 'Project', id: string, members: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null }>, roleProjects?: Array<{ __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string, name: string } }> | null } };

export type ResourcePlanningQueryVariables = Exact<{
  projectInput: ProjectParamsInput;
  bookingsListInput: BookingsListInput;
}>;


export type ResourcePlanningQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, name: string, color?: string | null, date?: SAPIDate | null, actualStartDate?: SAPIDate | null, deadline?: SAPIDate | null, actualDueDate?: SAPIDate | null, isPrivate?: boolean | null, projectType: ProjectType, manager?: { __typename?: 'User', id: string } | null, members: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, permissions?: { __typename?: 'ProjectPermissions', canModify: boolean } | null, roleProjects?: Array<{ __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string, name: string } }> | null, retainer?: { __typename?: 'Retainer', periods: Array<{ __typename?: 'RetainerPeriod', id: string, startDate: SAPIDate, endDate: SAPIDate }> } | null } | null, BookingsList: Array<{ __typename?: 'Booking', id: string, startDate: SAPIDate, endDate: SAPIDate, amount: number, amountType: BookingAmountType, isTentative: boolean, description?: string | null, user?: { __typename?: 'User', id: string } | null, roleProject?: { __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string, name: string } } | null }> };

export type ResourcePlanningUtilizationQueryVariables = Exact<{
  input: UserUtilizationInput;
}>;


export type ResourcePlanningUtilizationQuery = { __typename?: 'Query', UserUtilization: Array<{ __typename?: 'UserUtilizationResponse', userId?: string | null, roleId?: string | null, utilizations: Array<{ __typename?: 'UserUtilization', date?: SAPIDate | null, fixedBookedDuration: number, tentativeBookedDuration: number, availability: number }> }> };

export type ResourceBookingDeleteMutationVariables = Exact<{
  input: BookingDeleteInput;
}>;


export type ResourceBookingDeleteMutation = { __typename?: 'Mutation', BookingDelete: boolean };

export type ResourceBookingSaveMutationVariables = Exact<{
  input: BookingSaveInput;
}>;


export type ResourceBookingSaveMutation = { __typename?: 'Mutation', BookingSave: { __typename?: 'Booking', id: string, startDate: SAPIDate, endDate: SAPIDate, amount: number, amountType: BookingAmountType, isTentative: boolean, description?: string | null, user?: { __typename?: 'User', id: string } | null, roleProject?: { __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string, name: string } } | null } };

export type ResourcePlanningPortfolioAddToProjectMutationVariables = Exact<{
  input: ProjectMembersAddInput;
}>;


export type ResourcePlanningPortfolioAddToProjectMutation = { __typename?: 'Mutation', ProjectMembersAdd: { __typename: 'Project', id: string, name: string, members: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null, role?: { __typename?: 'Role', id: string } | null }>, roleProjects?: Array<{ __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string, name: string } }> | null } };

export type ResourcePlanningPortfolioBookingsQueryVariables = Exact<{
  input: BookingsListInput;
}>;


export type ResourcePlanningPortfolioBookingsQuery = { __typename?: 'Query', BookingsList: Array<{ __typename?: 'Booking', id: string, startDate: SAPIDate, endDate: SAPIDate, amount: number, amountType: BookingAmountType, isTentative: boolean, description?: string | null, user?: { __typename?: 'User', id: string } | null, project: { __typename?: 'Project', id: string }, roleProject?: { __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string, name: string } } | null }> };

export type ResourcePlanningPortfolioProjectQueryVariables = Exact<{
  input: ProjectParamsInput;
}>;


export type ResourcePlanningPortfolioProjectQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, manager?: { __typename?: 'User', id: string } | null, members: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null, role?: { __typename?: 'Role', id: string } | null }> } | null };

export type ResourcePlanningPortfolioProjectsQueryVariables = Exact<{
  input: ResourcePlanningPortfolioProjectsFiltersInput;
}>;


export type ResourcePlanningPortfolioProjectsQuery = { __typename?: 'Query', ResourcePlanningPortfolioProjects?: { __typename?: 'ResourcePlanningPortfolioProjects', projects: Array<{ __typename?: 'Project', id: string, name: string, color?: string | null, date?: SAPIDate | null, actualStartDate?: SAPIDate | null, deadline?: SAPIDate | null, actualDueDate?: SAPIDate | null, bookingsMinDate?: SAPIDate | null, bookingsMaxDate?: SAPIDate | null, isPrivate?: boolean | null, projectType: ProjectType, permissions?: { __typename?: 'ProjectPermissions', canModify: boolean } | null, manager?: { __typename?: 'User', id: string } | null, members: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null, role?: { __typename?: 'Role', id: string } | null }>, roleProjects?: Array<{ __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string, name: string } }> | null }>, user?: { __typename?: 'User', id: string } | null, role?: { __typename?: 'Role', id: string } | null } | null };

export type ResourcePlanningPortfolioUsersQueryVariables = Exact<{
  input?: InputMaybe<FilterHashInput>;
}>;


export type ResourcePlanningPortfolioUsersQuery = { __typename?: 'Query', ResourcePlanningPortfolioUsersList?: { __typename?: 'ResourcePlanningPortfolio', users: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string }> } | null };

export type ResourcePlanningPortfolioResourceUtilizationQueryVariables = Exact<{
  input: UserUtilizationInput;
}>;


export type ResourcePlanningPortfolioResourceUtilizationQuery = { __typename?: 'Query', UserUtilization: Array<{ __typename?: 'UserUtilizationResponse', userId?: string | null, roleId?: string | null, utilizations: Array<{ __typename?: 'UserUtilization', date?: SAPIDate | null, fixedBookedDuration: number, tentativeBookedDuration: number, availability: number }> }> };

export type ResourcePlanningPortfolioSingleProjectQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type ResourcePlanningPortfolioSingleProjectQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, name: string, color?: string | null, date?: SAPIDate | null, actualStartDate?: SAPIDate | null, deadline?: SAPIDate | null, actualDueDate?: SAPIDate | null, bookingsMinDate?: SAPIDate | null, bookingsMaxDate?: SAPIDate | null, isPrivate?: boolean | null, projectType: ProjectType, permissions?: { __typename?: 'ProjectPermissions', canModify: boolean } | null, manager?: { __typename?: 'User', id: string } | null, members: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null, role?: { __typename?: 'Role', id: string } | null }>, roleProjects?: Array<{ __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string, name: string } }> | null } | null };

export type ResourcePlanningProjectsPopoverQueryVariables = Exact<{
  input: UserUtilizationInput;
}>;


export type ResourcePlanningProjectsPopoverQuery = { __typename?: 'Query', UserUtilization: Array<{ __typename?: 'UserUtilizationResponse', totalAvailability: number, userId?: string | null, roleId?: string | null, utilizations: Array<{ __typename?: 'UserUtilization', fixedBookedDuration: number, tentativeBookedDuration: number, project?: { __typename?: 'Project', id: string, name: string, color?: string | null, isPrivate?: boolean | null, projectType: ProjectType, company?: { __typename?: 'Contact', id: string, name: string } | null, permissions?: { __typename?: 'ProjectPermissions', canView: boolean } | null } | null }> }> };

export type ResourcePlanningUserSelectProjectRolesQueryVariables = Exact<{
  projectInput: ProjectParamsInput;
}>;


export type ResourcePlanningUserSelectProjectRolesQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', roleProjects?: Array<{ __typename?: 'RoleProject', id: string, role: { __typename?: 'Role', id: string } }> | null } | null };

export type ResourcePlanningUserSelectQueryVariables = Exact<{
  usersListInput: UsersListInput;
}>;


export type ResourcePlanningUserSelectQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string, hslColor?: string | null, initials?: string | null, status: UserStatus, profilePicture?: { __typename?: 'UserPicture', mini: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }> };

export type ResourcePlanningUserSelectRolesQueryVariables = Exact<{
  rolesListInput: RolesListInput;
}>;


export type ResourcePlanningUserSelectRolesQuery = { __typename?: 'Query', RolesList: Array<{ __typename?: 'Role', id: string, name: string, usersCount: number, sellingPrice?: number | null, users: Array<{ __typename?: 'User', id: string }> }> };

export type ResourcePlanningTimeOffQueryVariables = Exact<{
  input: UserTimeOffListInput;
}>;


export type ResourcePlanningTimeOffQuery = { __typename?: 'Query', UserTimeOffList: Array<{ __typename?: 'UserTimeOff', date: SAPIDate, timeOff: { __typename?: 'TimeOff', endDate: SAPIDate, id: string, startDate: SAPIDate, value: number, type: { __typename?: 'TimeOffTypeRelation', id: string, systemName: string, displayName: string } }, user: { __typename?: 'User', id: string } }> };

export type RetainerPeriodModalQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
}>;


export type RetainerPeriodModalQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, color?: string | null, confirmedBillableDoneDuration?: SAPIDuration | null, actualUsedBudgetSum?: number | null, useBillsExpensesInCalculations?: boolean | null, permissions?: { __typename?: 'ProjectPermissions', canModify: boolean } | null, priceList?: { __typename?: 'PriceList', id: string, currency: string } | null, retainer?: { __typename?: 'Retainer', id: string, periodDuration?: number | null, periodSum?: number | null, periods: Array<{ __typename?: 'RetainerPeriod', id: string, name: string, startDate: SAPIDate, endDate: SAPIDate, duration?: number | null, actualDuration?: number | null, sum?: number | null, actualSum?: number | null, defaultName?: string | null }> } | null } | null };

export type RetainerPeriodModalSaveMutationVariables = Exact<{
  input: RetainerSaveInput;
  projectId: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
}>;


export type RetainerPeriodModalSaveMutation = { __typename?: 'Mutation', RetainerSave: { __typename?: 'Retainer', id: string, periodDuration?: number | null, periodSum?: number | null, periods: Array<{ __typename?: 'RetainerPeriod', id: string, name: string, startDate: SAPIDate, endDate: SAPIDate, duration?: number | null, actualDuration?: number | null, sum?: number | null, actualSum?: number | null, defaultName?: string | null }> } };

export type QuoteDetailsViewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuoteDetailsViewQuery = { __typename?: 'Query', Quote?: { __typename?: 'Quote', id: string, number: string, quoteName?: string | null, hasProjectOnEachLine: boolean, issueDate: SAPIDate, confirmedDate?: SAPIDateTime | null, displayCurrencyRate: number, author: { __typename?: 'User', id: string, name: string }, mainContact?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, color: string, name: string } | null, project?: { __typename?: 'Project', id: string } | null, lines: Array<{ __typename?: 'QuoteLine', id: string, isSubHeading: boolean, isEmptyRow: boolean, comment?: string | null, amount: number, secondaryAmount: number, ordering: number, sumAfterAllDiscounts: number, unlinkedSum: number, unit?: { __typename?: 'Unit', id: string, symbol: string, name: string } | null, product?: { __typename?: 'Product', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null }> } | null };

export type PurchaseOrderDetailsViewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PurchaseOrderDetailsViewQuery = { __typename?: 'Query', PurchaseOrder: { __typename?: 'PurchaseOrder', id: string, number: string, hasProjectOnEachLine: boolean, issueDate: SAPIDate, displayCurrencyRate: number, author?: { __typename?: 'User', id: string, name: string } | null, mainContact?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, color: string, name: string } | null, project?: { __typename?: 'Project', id: string } | null, lines: Array<{ __typename?: 'PurchaseOrderLine', id: string, isSubHeading: boolean, isEmptyRow: boolean, comment?: string | null, amount?: number | null, secondaryAmount?: number | null, ordering: number, sumAfterAllDiscounts: number, settledSum: number, isSettled: boolean, unit?: { __typename?: 'Unit', id: string, symbol: string, name: string } | null, product?: { __typename?: 'Product', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null }> } };

export type QuotesListViewQueryVariables = Exact<{
  filters?: InputMaybe<QuoteFiltersInput>;
  startFrom?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<QuoteOrderingInput> | QuoteOrderingInput>;
}>;


export type QuotesListViewQuery = { __typename?: 'Query', QuotesList: Array<{ __typename?: 'Quote', id: string, number: string, issueDate: SAPIDate, sum: number, hasProjectOnEachLine: boolean, displayCurrencyRate: number, quoteName?: string | null, confirmedDate?: SAPIDateTime | null, author: { __typename?: 'User', id: string, initials?: string | null, name: string }, mainContact?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, name: string, color: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, lines: Array<{ __typename?: 'QuoteLine', id: string, project?: { __typename?: 'Project', id: string, name: string } | null }> }> };

export type PurchaseOrdersListViewQueryVariables = Exact<{
  input: FinanceDocumentsListInput;
}>;


export type PurchaseOrdersListViewQuery = { __typename?: 'Query', PurchaseOrdersList: Array<{ __typename?: 'PurchaseOrder', id: string, number: string, issueDate: SAPIDate, sum: number, hasProjectOnEachLine: boolean, displayCurrencyRate: number, author?: { __typename?: 'User', id: string, initials?: string | null, name: string } | null, mainContact?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, name: string, color: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, lines: Array<{ __typename?: 'PurchaseOrderLine', id: string, project?: { __typename?: 'Project', id: string, name: string } | null }> }> };

export type RetrospectiveLinkingModalExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetrospectiveLinkingModalExpenseQuery = { __typename?: 'Query', Expense?: { __typename: 'Expense', id: string, number?: string | null, issueDate: SAPIDate, hasProjectOnEachLine: boolean, displayCurrencyRate: number, mainContact?: { __typename?: 'Contact', id: string, name: string } | null, author: { __typename?: 'User', id: string, name: string }, project?: { __typename?: 'Project', id: string, name: string } | null, lines: Array<{ __typename?: 'ExpenseLine', id: string, ordering: number, comment?: string | null, isSubHeading: boolean, isEmptyRow: boolean, amount: number, secondaryAmount: number, sumAfterAllDiscounts: number, quoteLine?:
        | { __typename: 'HiddenByPermissions', id: string }
        | { __typename: 'QuoteLine', id: string, product?: { __typename?: 'Product', id: string, name: string } | null, quote: { __typename?: 'Quote', id: string, number: string } }
       | null, project?: { __typename?: 'Project', id: string, name: string } | null, product?: { __typename?: 'Product', id: string, name: string } | null, unit?: { __typename?: 'Unit', id: string, symbol: string, name: string } | null }> } | null };

export type RetrospectiveLinkingModalBillQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetrospectiveLinkingModalBillQuery = { __typename?: 'Query', Bill?: { __typename: 'Bill', id: string, number: string, issueDate?: SAPIDate | null, hasProjectOnEachLine: boolean, displayCurrencyRate: number, mainContact?: { __typename?: 'Contact', id: string, name: string } | null, author: { __typename?: 'User', id: string, name: string }, project?: { __typename?: 'Project', id: string, name: string } | null, lines: Array<{ __typename?: 'BillLine', id: string, ordering: number, comment?: string | null, isSubHeading: boolean, isEmptyRow: boolean, amount: number, secondaryAmount: number, sumAfterAllDiscounts: number, quoteLine?:
        | { __typename: 'HiddenByPermissions', id: string }
        | { __typename: 'QuoteLine', id: string, comment?: string | null, product?: { __typename?: 'Product', id: string, name: string } | null, quote: { __typename?: 'Quote', id: string, number: string } }
       | null, purchaseOrderLine?:
        | { __typename: 'HiddenByPermissions', id: string }
        | { __typename: 'PurchaseOrderLine', id: string, comment?: string | null, product?: { __typename?: 'Product', id: string, name: string } | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: string, number: string } }
       | null, project?: { __typename?: 'Project', id: string, name: string } | null, product?: { __typename?: 'Product', id: string, name: string } | null, unit?: { __typename?: 'Unit', id: string, symbol: string, name: string } | null }> } | null };

export type SaveExpenseLineQuoteLineRelationsMutationVariables = Exact<{
  input: DocumentLineRelationsSaveInput;
}>;


export type SaveExpenseLineQuoteLineRelationsMutation = { __typename?: 'Mutation', SaveExpenseLineQuoteLineRelations: boolean };

export type SaveBillLineQuoteLineRelationsMutationVariables = Exact<{
  input: DocumentLineRelationsSaveInput;
}>;


export type SaveBillLineQuoteLineRelationsMutation = { __typename?: 'Mutation', SaveBillLineQuoteLineRelations: boolean };

export type SaveBillLinePurchaseOrderLineRelationsMutationVariables = Exact<{
  input: DocumentLineRelationsSaveInput;
}>;


export type SaveBillLinePurchaseOrderLineRelationsMutation = { __typename?: 'Mutation', SaveBillLinePurchaseOrderLineRelations: boolean };

export type RevenueReportForecastQueryVariables = Exact<{
  input: FilterHashInput;
}>;


export type RevenueReportForecastQuery = { __typename?: 'Query', RevenueReportForecast: { __typename?: 'RevenueReportForecast', revenueReportForecastList: Array<{ __typename?: 'RevenueReportForecastListItem', project?: { __typename?: 'Project', id: string, name: string, projectType: ProjectType, permissions?: { __typename?: 'ProjectPermissions', hasProjectTabs: boolean } | null } | null, quote?: { __typename?: 'Quote', id: string, number: string, quoteName?: string | null } | null, client?: { __typename?: 'Contact', id: string, name: string } | null, periods: Array<{ __typename?: 'RevenueReportForecastPeriod', period: SAPIDate, displayRevenue?: number | null }> }>, revenueReportForecastSummary?: { __typename?: 'RevenueReportForecastSummary', numberOfPeriods: number, fromDate: SAPIDate, isQuotesSelected: boolean, isProjectsSelected: boolean, groupBy: RevenueReportForecastGroupByEnum, periods: Array<{ __typename?: 'RevenueReportForecastSummaryPeriod', period: SAPIDate, recognizedRevenue: number, pipelineRevenue: number }> } | null } };

export type RevenueReportForecastExportQueryVariables = Exact<{
  input: RevenueReportForecastExportInput;
}>;


export type RevenueReportForecastExportQuery = { __typename?: 'Query', RevenueReportForecastExport: { __typename?: 'ExportResponse', fileUrl: string } };

export type RoleModifyDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RoleModifyDeleteMutation = { __typename?: 'Mutation', RoleDelete: boolean };

export type RoleModifyPageExistingRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RoleModifyPageExistingRoleQuery = { __typename?: 'Query', Role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, isActive: boolean, laborCost?: number | null, priceLists: Array<{ __typename?: 'RolePriceList', sellingPrice?: number | null, priceList: { __typename?: 'PriceList', id: string, name: string, currency: string, isDefault: boolean } }>, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, profilePicture?: { __typename?: 'UserPicture', medium: string } | null }> } | null };

export type RoleModifyPageQueryVariables = Exact<{
  usersListInput: UsersListInput;
}>;


export type RoleModifyPageQuery = { __typename?: 'Query', PriceListsList: Array<{ __typename?: 'PriceList', id: string, name: string, currency: string, isDefault: boolean }>, UsersList: Array<{ __typename?: 'User', id: string, name: string, role?: { __typename?: 'Role', id: string } | null, profilePicture?: { __typename?: 'UserPicture', medium: string } | null }> };

export type RoleSaveMutationVariables = Exact<{
  input: RoleSaveInput;
}>;


export type RoleSaveMutation = { __typename?: 'Mutation', RoleSave: { __typename: 'Role', id: string, name: string, isActive: boolean, initials?: string | null, usersCount: number, sellingPrice?: number | null, priceLists: Array<{ __typename?: 'RolePriceList', sellingPrice?: number | null, priceList: { __typename?: 'PriceList', id: string, name: string, currency: string, isDefault: boolean } }>, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, profilePicture?: { __typename?: 'UserPicture', medium: string } | null }> } };

export type RoleListQueryVariables = Exact<{
  rolesListInput: RolesListInput;
  usersFilterInput: UsersListInput;
}>;


export type RoleListQuery = { __typename?: 'Query', RolesList: Array<{ __typename?: 'Role', id: string, name: string, initials?: string | null, usersCount: number, sellingPrice?: number | null, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }> }> };

export type RolePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RolePermissionsQuery = { __typename?: 'Query', Permissions: { __typename?: 'Permissions', roles?: { __typename?: 'RolePermissions', canToggleRolesOff: boolean } | null } };

export type RolesExportQueryVariables = Exact<{
  input: ExportInput;
}>;


export type RolesExportQuery = { __typename?: 'Query', RolesExport: { __typename?: 'ExportResponse', fileUrl: string } };

export type SalesforceIsQuoteLinkedQueryVariables = Exact<{
  input: SalesforceIsQuoteLinkedInputType;
}>;


export type SalesforceIsQuoteLinkedQuery = { __typename?: 'Query', SalesforceIsQuoteLinked: boolean };

export type SalesforceSyncQuoteSumAndPdfMutationVariables = Exact<{
  input: SalesforceSyncQuoteSumAndPdfInputType;
}>;


export type SalesforceSyncQuoteSumAndPdfMutation = { __typename?: 'Mutation', SalesforceSyncQuoteSumAndPdf: boolean };

export type SearchSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchSettingsQuery = { __typename?: 'Query', SearchSettings: Array<{ __typename?: 'SearchSetting', isEnabled: boolean, feature: { __typename?: 'Feature', name: string } }> };

export type SearchDropdownSettingsUpdateMutationVariables = Exact<{
  featureNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SearchDropdownSettingsUpdateMutation = { __typename?: 'Mutation', SearchSettingsUpdate: Array<{ __typename?: 'SearchSetting', isEnabled: boolean, feature: { __typename?: 'Feature', name: string } }> };

export type SearchResultsQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  feature: Scalars['String']['input'];
  startFrom?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchResultsQuery = { __typename?: 'Query', SearchResults: Array<
    | { __typename?: 'UnionBill', bill: { __typename?: 'Bill', id: string, number: string, mainContact?: { __typename?: 'Contact', id: string, name: string, type?: ContactType | null } | null } }
    | { __typename?: 'UnionContact', contact: { __typename?: 'Contact', id: string, name: string, phones: Array<string>, mobiles: Array<string>, emails: Array<string>, type?: ContactType | null } }
    | { __typename?: 'UnionExpense', expense: { __typename?: 'Expense', id: string, number?: string | null, mainContact?: { __typename?: 'Contact', id: string, name: string, type?: ContactType | null } | null } }
    | { __typename?: 'UnionFile', file: { __typename?: 'File', id: string, name: string } }
    | { __typename?: 'UnionInvoice', invoice: { __typename?: 'Invoice', id: string, number: string, mainContact?: { __typename?: 'Contact', id: string, name: string, type?: ContactType | null } | null } }
    | { __typename?: 'UnionMarketingList', marketingList: { __typename?: 'MarketingList', id: string, name: string } }
    | { __typename?: 'UnionNewsFeedItem', newsFeedItem: { __typename?: 'NewsFeedItem', id: string, name: string } }
    | { __typename?: 'UnionOrder', order: { __typename?: 'Order', id: string, number: string, mainContact?: { __typename?: 'Contact', id: string, name: string, type?: ContactType | null } | null } }
    | { __typename?: 'UnionProject', project: { __typename?: 'Project', id: string, name: string } }
    | { __typename?: 'UnionPurchaseOrder', purchaseOrder: { __typename?: 'PurchaseOrder', id: string, number: string, mainContact?: { __typename?: 'Contact', id: string, name: string, type?: ContactType | null } | null } }
    | { __typename?: 'UnionQuote', quote: { __typename?: 'Quote', id: string, number: string, mainContact?: { __typename?: 'Contact', id: string, name: string, type?: ContactType | null } | null } }
    | { __typename?: 'UnionRealEstateObject', realEstateObject: { __typename?: 'RealEstateObject', id: string, name?: string | null } }
    | { __typename?: 'UnionRentalOrder', rentalOrder: { __typename?: 'RentalOrder', id: string, number: string, mainContact?: { __typename?: 'Contact', id: string, name: string, type?: ContactType | null } | null } }
    | { __typename?: 'UnionUser', user: { __typename?: 'User', id: string, name: string, profilePicture?: { __typename?: 'UserPicture', medium: string } | null } }
  > };

export type SearchTotalsQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
  feature: Scalars['String']['input'];
}>;


export type SearchTotalsQuery = { __typename?: 'Query', SearchTotals: { __typename?: 'SearchTotal', count: number, feature: { __typename?: 'Feature', name: string } } };

export type SelfServiceModalCancelMutationVariables = Exact<{
  input: SelfServiceCancelSubscriptionRequestInput;
}>;


export type SelfServiceModalCancelMutation = { __typename?: 'Mutation', SelfServiceCancelSubscriptionRequest: boolean };

export type SelfServiceSeatReductionRequestFragment = { __typename?: 'SelfServiceSeatReductionRequest', id: string, reductionAmount: number, effectiveDate: SAPIDate, createdDate: SAPIDateTime, modifiedDate?: SAPIDateTime | null, createdUser: { __typename?: 'User', id: string, name: string, initials?: string | null }, modifiedUser?: { __typename?: 'User', id: string, name: string, initials?: string | null } | null };

export type SelfServiceScheduleSeatReductionDeleteMutationVariables = Exact<{
  reductionRequestId: Scalars['ID']['input'];
}>;


export type SelfServiceScheduleSeatReductionDeleteMutation = { __typename?: 'Mutation', SelfServiceDeleteSeatReductionRequest: boolean };

export type SelfServiceScheduleSeatReductionModalMutationVariables = Exact<{
  input: SelfServiceSendSeatReductionRequestInput;
}>;


export type SelfServiceScheduleSeatReductionModalMutation = { __typename?: 'Mutation', SelfServiceSendSeatReductionRequest: { __typename?: 'SelfServiceSeatReductionRequest', id: string, reductionAmount: number, effectiveDate: SAPIDate, createdDate: SAPIDateTime, modifiedDate?: SAPIDateTime | null, createdUser: { __typename?: 'User', id: string, name: string, initials?: string | null }, modifiedUser?: { __typename?: 'User', id: string, name: string, initials?: string | null } | null } };

export type SelfServiceFeaturesOverLimitQueryVariables = Exact<{
  input: SelfServiceDataInput;
}>;


export type SelfServiceFeaturesOverLimitQuery = { __typename?: 'Query', SelfServiceFeaturesOverLimit: Array<{ __typename?: 'SelfServiceFeatureOverLimit', currentUsage: number, limit: number, isBlockingDowngrade: boolean, willDeleteData: boolean, actionUrl?: string | null, feature: { __typename?: 'Feature', id: string, title: string } }> };

export type SelfServiceAddonsQueryVariables = Exact<{
  siteId?: InputMaybe<Scalars['ID']['input']>;
  selfServiceData: SelfServiceDataInput;
}>;


export type SelfServiceAddonsQuery = { __typename?: 'Query', SelfServiceData: { __typename?: 'SelfServiceData', addons: Array<{ __typename?: 'SelfServiceAddon', id: string, name: string, description?: string | null, amountInUse: number, annualPrice: number, monthlyPrice: number, setupPrice: number, cannotRemove: boolean, code: string, group: string, isFree: boolean, isGlobal: boolean, isInUse: boolean, isIncludedInPackage: boolean, isPerUser: boolean, isBundle: boolean, availableInPackage: boolean, isTool: boolean }> } };

export type SelfServiceCostQueryVariables = Exact<{
  siteId?: InputMaybe<Scalars['ID']['input']>;
  selfServiceData: SelfServiceDataInput;
}>;


export type SelfServiceCostQuery = { __typename?: 'Query', SelfServiceData: { __typename?: 'SelfServiceData', standardPaymentSum?: number | null, standardPaymentDate?: SAPIDate | null, isVoucherApplied: boolean } };

export type SelfServiceDataQueryVariables = Exact<{
  siteId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SelfServiceDataQuery = { __typename?: 'Query', SelfServiceData: { __typename?: 'SelfServiceData', billingCycle: SelfServiceBillingCycleType, paidSeatCount?: number | null, usedSeatCount?: number | null, minSeatCount?: number | null, currency: SelfServiceCurrency, standardPaymentDate?: SAPIDate | null, standardPaymentSum?: number | null, nextPaymentSum?: number | null, nextPaymentDate?: SAPIDate | null, isVoucherApplied: boolean, onboardingCustomPrice?: number | null, site: { __typename?: 'Site', isTrialActive: boolean, trialExpireDateTime?: SAPIDateTime | null, hasPaymentMethod: boolean, paidUntilDate?: SAPIDate | null, isFree: boolean, isTrialExpired: boolean, isSiteExpired: boolean }, addons: Array<{ __typename?: 'SelfServiceAddon', id: string, name: string, description?: string | null, amountInUse: number, annualPrice: number, monthlyPrice: number, setupPrice: number, cannotRemove: boolean, code: string, group: string, isFree: boolean, isGlobal: boolean, isInUse: boolean, isIncludedInPackage: boolean, isPerUser: boolean, isBundle: boolean, availableInPackage: boolean, isTool: boolean }>, customAddons?: Array<{ __typename?: 'SelfServiceAddon', id: string, name: string, description?: string | null, amountInUse: number, annualPrice: number, monthlyPrice: number, setupPrice: number, cannotRemove: boolean, code: string, group: string, isFree: boolean, isGlobal: boolean, isInUse: boolean, isIncludedInPackage: boolean, isPerUser: boolean, isBundle: boolean, availableInPackage: boolean, isTool: boolean }> | null, companyAccounts: Array<{ __typename?: 'SelfServiceCompanyAccount', id: string, name: string, hasRelatedUsers: boolean, price: number, isInUse?: boolean | null }>, packages: Array<{ __typename?: 'SelfServicePackage', id: string, name: string, monthlyPrice: number, annualPrice: number, isTrialPackage: boolean, sortingOrder: number }>, currentPackage: { __typename?: 'SelfServicePackage', id: string, name: string }, onboardingPackages?: Array<{ __typename?: 'SelfServiceOnboardingPackage', id: string, name: string, price: number, maxUserCount?: number | null, description?: string | null }> | null, currentOnboardingPackage?: { __typename?: 'SelfServiceOnboardingPackage', id: string } | null, paymentInfo: { __typename?: 'SelfServicePaymentMethodInfo', type: SelfServicePaymentMethodType, creditCardLastNumbers?: string | null, hasPaymentHistory: boolean }, seatReductionRequests?: Array<{ __typename?: 'SelfServiceSeatReductionRequest', id: string, reductionAmount: number, effectiveDate: SAPIDate, createdDate: SAPIDateTime, modifiedDate?: SAPIDateTime | null, createdUser: { __typename?: 'User', id: string, name: string, initials?: string | null }, modifiedUser?: { __typename?: 'User', id: string, name: string, initials?: string | null } | null }> | null } };

export type SelfServiceUpdateMutationVariables = Exact<{
  siteId?: InputMaybe<Scalars['ID']['input']>;
  userChanges: SelfServiceDataInput;
}>;


export type SelfServiceUpdateMutation = { __typename?: 'Mutation', SelfServiceDataUpdate: boolean };

export type SelfServiceVoucherApplyMutationVariables = Exact<{
  voucherCode: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SelfServiceVoucherApplyMutation = { __typename?: 'Mutation', SelfServiceVoucherApply: boolean };

export type SettingsDropdownQueryVariables = Exact<{
  input: SettingLookupRequest;
}>;


export type SettingsDropdownQuery = { __typename?: 'Query', SettingsLookup: Array<{ __typename?: 'SettingLookup', path: string, title: string, userHasAccess: boolean, siteHasAccess: boolean }> };

export type SingleSignOnUsersQueryVariables = Exact<{
  input: UsersListInput;
}>;


export type SingleSignOnUsersQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null }> };

export type SingleSignOnRegularLoginExclusionAddMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SingleSignOnRegularLoginExclusionAddMutation = { __typename?: 'Mutation', SingleSignOnRegularLoginExclusionAdd: boolean };

export type SingleSignOnRegularLoginExclusionDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SingleSignOnRegularLoginExclusionDeleteMutation = { __typename?: 'Mutation', SingleSignOnRegularLoginExclusionDelete: boolean };

export type ShareSnapshotGanttStartMutationVariables = Exact<{
  input: GanttChartShareInput;
}>;


export type ShareSnapshotGanttStartMutation = { __typename?: 'Mutation', PublicGanttShare: { __typename?: 'ShareSnapshot', id: string, url: string, snapshotDate: SAPIDateTime, isUrlExpired: boolean } };

export type ShareSnapshotGanttStopMutationVariables = Exact<{
  input: UnShareInput;
}>;


export type ShareSnapshotGanttStopMutation = { __typename?: 'Mutation', PublicGanttUnShare: boolean };

export type ShareSnapshotModalQueryVariables = Exact<{
  input: ShareSnapshotInput;
}>;


export type ShareSnapshotModalQuery = { __typename?: 'Query', ShareSnapshot?: { __typename?: 'ShareSnapshot', id: string, url: string, snapshotDate: SAPIDateTime, isUrlExpired: boolean } | null };

export type ShareSnapshotQuoteStartMutationVariables = Exact<{
  input: QuoteShareInput;
}>;


export type ShareSnapshotQuoteStartMutation = { __typename?: 'Mutation', QuoteShare: { __typename?: 'ShareSnapshot', id: string, url: string, snapshotDate: SAPIDateTime, isUrlExpired: boolean } };

export type ShareSnapshotQuoteStopMutationVariables = Exact<{
  input: UnShareInput;
}>;


export type ShareSnapshotQuoteStopMutation = { __typename?: 'Mutation', QuoteUnShare: boolean };

export type StatusAutoSuggestQueryVariables = Exact<{
  statusesListInput?: InputMaybe<StatusesListInput>;
}>;


export type StatusAutoSuggestQuery = { __typename?: 'Query', StatusesList?: Array<{ __typename?: 'Status', statusId: string, name: string }> | null };

export type StatusChangeMutationVariables = Exact<{
  input: StatusChangeInput;
}>;


export type StatusChangeMutation = { __typename?: 'Mutation', StatusChange: boolean };

export type StatusesListQueryVariables = Exact<{
  statusesListInput?: InputMaybe<StatusesListInput>;
}>;


export type StatusesListQuery = { __typename?: 'Query', StatusesList?: Array<{ __typename?: 'Status', id: string, statusId: string, name: string, color: string }> | null };

export type StatusPickerStatusFragment = { __typename?: 'Status', id: string, statusId: string, name: string, color: string };

export type SubtaskListQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
  taskListParams: TasksListInput;
}>;


export type SubtaskListQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', id: string, isDone: boolean, project?: { __typename?: 'Project', id: string } | null, company?: { __typename?: 'Contact', id: string } | null, person?: { __typename?: 'Contact', id: string } | null, activityType?: { __typename?: 'ActivityType', id: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string } | null, quote?: { __typename?: 'Quote', id: string } | null } | null, TasksList: Array<
    | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, subtasks: Array<
        | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
        | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
      >, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
    | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, subtasks: Array<
        | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
        | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
      >, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
  > };

export type TagAutoSuggestQueryVariables = Exact<{
  tagsListInput?: InputMaybe<TagsListInput>;
}>;


export type TagAutoSuggestQuery = { __typename?: 'Query', TagsList: Array<{ __typename?: 'Tag', id: string, title: string, isGroup: boolean }> };

export type TaskAutoSuggestQueryVariables = Exact<{
  tasksSearchInput: TasksSearchInput;
}>;


export type TaskAutoSuggestQuery = { __typename?: 'Query', TasksSearch: Array<{ __typename?: 'Task', id: string, name: string, priority?: Priority | null, project?: { __typename?: 'Project', name: string } | null, company?: { __typename?: 'Contact', name: string } | null, person?: { __typename?: 'Contact', name: string } | null }> };

export type TaskAutoSuggestTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskAutoSuggestTaskQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', id: string, name: string } | null };

export type TaskBudgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskBudgetQuery = { __typename?: 'Query', TaskBudgetList: Array<{ __typename?: 'TaskBudgetRow', id: string, budgetedDuration: SAPIDuration, isBudgeted: boolean, isRoleAssigned: boolean, plannedDuration: SAPIDuration, doneDuration: Array<{ __typename?: 'TaskDoneDuration', taskId: string, duration: SAPIDuration }>, role: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null }, users: Array<{ __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null }> }> };

export type TaskHeaderQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type TaskHeaderQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', id: string, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, billableTimeType: BillableTimeTypeEnum, subtasksCount: number } | null };

export type TaskListRowTaskBundleSaveMutationVariables = Exact<{
  input: TaskSetAsSubtasksSaveInput;
}>;


export type TaskListRowTaskBundleSaveMutation = { __typename?: 'Mutation', TaskSetAsSubtasksSave: { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, subtasks: Array<
      | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
      | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
    >, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null } };

export type TaskListTaskMarkAsDoneMutationVariables = Exact<{
  input: TaskMarkAsDoneMutationInput;
}>;


export type TaskListTaskMarkAsDoneMutation = { __typename?: 'Mutation', TaskMarkAsDone: { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, subtasks: Array<
      | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
      | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
    >, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null } };

export type TaskListTaskMarkAsNotDoneMutationVariables = Exact<{
  input: TaskMarkAsNotDoneMutationInput;
}>;


export type TaskListTaskMarkAsNotDoneMutation = { __typename?: 'Mutation', TaskMarkAsNotDone: { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, subtasks: Array<
      | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
      | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
    >, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null } };

export type TaskListTaskFieldsFragment = { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null };

export type LimitedTaskFieldsFragment = { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } };

export type TaskListTaskFragment = { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, subtasks: Array<
    | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
    | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
  >, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null };

export type TaskListLimitedTaskFragment = { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, subtasks: Array<
    | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
    | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
  >, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } };

export type TaskListPhaseFragment = { __typename?: 'ProjectPhase', id: string, title: string, ordering: number, startDate?: SAPIDate | null, endDate?: SAPIDate | null, type: ProjectPhaseTypeEnum, hasTasks: boolean };

export type TaskListProjectFragment = { __typename?: 'Project', id: string, createTasksFromQuoteId?: string | null, company?: { __typename?: 'Contact', id: string } | null, projectPhases?: Array<{ __typename?: 'ProjectPhase', id: string, title: string, ordering: number, startDate?: SAPIDate | null, endDate?: SAPIDate | null, type: ProjectPhaseTypeEnum, hasTasks: boolean }> | null, permissions?: { __typename?: 'ProjectPermissions', canView: boolean, canModify: boolean } | null };

export type TaskListEnrichmentFieldsFragment = { __typename?: 'Task', id: string, hasCustomAllocation: boolean, durationPlanned: number, parentId?: string | null, project?: { __typename?: 'Project', id: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }>, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } };

export type TaskListTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskListTaskQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, subtasks: Array<
      | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
      | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
    >, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null } | null };

export type TaskListTaskSaveMutationVariables = Exact<{
  input: TaskSaveInput;
}>;


export type TaskListTaskSaveMutation = { __typename?: 'Mutation', TaskSave: { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, subtasks: Array<
      | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
      | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
    >, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null } };

export type TaskListTaskAssigneesSaveMutationVariables = Exact<{
  input: TaskAssigneesSaveInput;
}>;


export type TaskListTaskAssigneesSaveMutation = { __typename?: 'Mutation', TaskAssigneesSave: { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, subtasks: Array<
      | { __typename?: 'LimitedTask', id: string, name: string, isDone: boolean, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } }
      | { __typename?: 'Task', id: string, parentId?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, durationDone: number, durationPlanned: number, durationRemaining: number, durationScheduled: number, progressPercentage: number, durationBillablePlanned: number, durationBillableDone: number, durationBillableRemaining: number, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, description?: string | null, budgetedDuration?: SAPIDuration | null, remainingBudgetedDuration?: SAPIDuration | null, priority?: Priority | null, isRequiredFieldsMissing: boolean, isQuoteLineShared: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null }
    >, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null } };

export type TaskMissingRequiredFieldsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskMissingRequiredFieldsQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', isTimeEntriesRequiredFieldsMissing: boolean } | null };

export type TaskTemplateAssigneeFieldsFragment = { __typename?: 'TaskTemplateAssignee', id: string, allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null };

export type TaskTemplateAssigneesTaskTemplateFragment = { __typename?: 'TaskTemplate', id: string, dynamicOwner?: DynamicOwnerEnum | null, owner?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, assignees: Array<{ __typename?: 'TaskTemplateAssignee', id: string, allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }> };

export type TaskTemplateAssigneesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskTemplateAssigneesQuery = { __typename?: 'Query', TaskTemplate?: { __typename?: 'TaskTemplate', id: string, dynamicOwner?: DynamicOwnerEnum | null, owner?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, assignees: Array<{ __typename?: 'TaskTemplateAssignee', id: string, allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }> } | null };

export type TaskTemplateUsersAssigneesSaveMutationVariables = Exact<{
  input: TaskTemplateAssigneesSaveInput;
}>;


export type TaskTemplateUsersAssigneesSaveMutation = { __typename?: 'Mutation', TaskTemplateAssigneesSave: { __typename?: 'TaskTemplate', id: string, dynamicOwner?: DynamicOwnerEnum | null, owner?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, assignees: Array<{ __typename?: 'TaskTemplateAssignee', id: string, allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }> } };

export type TaskTooltipQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type TaskTooltipQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', id: string, description?: string | null, commentsCount: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, dueDateTime?: SAPIDateTime | null, totalDurationDone: SAPIDuration, totalDurationPlanned: SAPIDuration, totalDurationRemaining: SAPIDuration, totalDurationScheduled: SAPIDuration, totalProgressPercentage: number, totalDurationBillablePlanned: SAPIDuration, totalDurationBillableDone: SAPIDuration, totalDurationBillableRemaining: SAPIDuration, isDone: boolean, name: string, priority?: Priority | null, isRequiredFieldsMissing: boolean, createdDateTime?: SAPIDateTime | null, modifiedDateTime?: SAPIDateTime | null, activityType?: { __typename?: 'ActivityType', id: string, name: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', user?: { __typename?: 'User', id: string } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null } | null }>, project?: { __typename?: 'Project', id: string, name: string } | null, projectPhase?: { __typename?: 'ProjectPhase', id: string, title: string } | null, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, person?: { __typename?: 'Contact', id: string, name: string } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, permissions: { __typename?: 'TaskPermissions', canModify: boolean }, createdBy?: { __typename?: 'User', id: string, name: string } | null, modifiedBy?: { __typename?: 'User', id: string, name: string } | null } | null };

export type TaskUsersTaskFragment = { __typename?: 'Task', id: string, hasCustomAllocation: boolean, durationPlanned: number, parentId?: string | null, project?: { __typename?: 'Project', id: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }>, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } };

export type TaskUsersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskUsersQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', id: string, hasCustomAllocation: boolean, durationPlanned: number, parentId?: string | null, project?: { __typename?: 'Project', id: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }>, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } } | null };

export type TaskUsersResponsibleSaveMutationVariables = Exact<{
  input: TaskResponsibleSaveInput;
}>;


export type TaskUsersResponsibleSaveMutation = { __typename?: 'Mutation', TaskResponsibleSave: { __typename?: 'Task', id: string, hasCustomAllocation: boolean, durationPlanned: number, parentId?: string | null, project?: { __typename?: 'Project', id: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }>, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } } };

export type TaskUsersAssigneesSaveMutationVariables = Exact<{
  input: TaskAssigneesSaveInput;
}>;


export type TaskUsersAssigneesSaveMutation = { __typename?: 'Mutation', TaskAssigneesSave: { __typename?: 'Task', id: string, hasCustomAllocation: boolean, durationPlanned: number, parentId?: string | null, project?: { __typename?: 'Project', id: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }>, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } } };

export type TaskUsersGanttAssigneesSaveMutationVariables = Exact<{
  input: TaskAssigneesSaveInput;
}>;


export type TaskUsersGanttAssigneesSaveMutation = { __typename?: 'Mutation', TaskAssigneesSave: { __typename?: 'Task', id: string, hasCustomAllocation: boolean, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }> } };

export type TaskUsersGanttQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskUsersGanttQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', id: string, hasCustomAllocation: boolean, durationPlanned: number, startDate?: SAPIDateTime | null, dueDate?: SAPIDate | null, parentId?: string | null, project?: { __typename?: 'Project', id: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }>, responsibleUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } } | null };

export type TaskBundleAutoSuggestQueryVariables = Exact<{
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
}>;


export type TaskBundleAutoSuggestQuery = { __typename?: 'Query', TaskSetsList?: Array<{ __typename?: 'TaskSet', id: string, name: string, maxDays?: number | null, minDays?: number | null, taskTemplatesCount: number }> | null };

export type TeamReportExportQueryVariables = Exact<{
  input: FilterHashExportInput;
}>;


export type TeamReportExportQuery = { __typename?: 'Query', TeamReportExport: { __typename?: 'ExportResponse', fileUrl: string } };

export type TeamReportMetricsQueryVariables = Exact<{
  input: FilterHashInput;
}>;


export type TeamReportMetricsQuery = { __typename?: 'Query', TeamReportMetrics: Array<{ __typename?: 'SummaryBlockItem', id: string, title: string, value?: number | null, unit?: string | null, valueState?: MetricsValueState | null, type: SummaryBlockItemType, secondaryValue?: number | null, secondaryUnit?: string | null, secondaryDescription?: string | null, secondaryValueState?: MetricsValueState | null }> };

export type TeamReportQueryVariables = Exact<{
  input: FilterHashInput;
}>;


export type TeamReportQuery = { __typename?: 'Query', TeamReport: { __typename?: 'TeamReport', columns: Array<TeamReportColumnEnum>, groupBy?: TeamReportGroupByEnum | null, orderBy?: { __typename?: 'OrderBy', fieldName: string, direction?: OrderDirectionEnum | null } | null, rows: Array<{ __typename?: 'TeamReportRow', groupName?: string | null, user: { __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }, capacity?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, timeOff?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, extraAvailability?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, availability?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, bookings?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, bookingsFixed?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, bookingsTentative?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, bookingsVsAvailability?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, tasksPlanned?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, timeEntries?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, timeEntriesScheduled?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, timeEntriesDone?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, timeEntriesVsAvailability?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, timeEntriesBillable?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, timeEntriesBillableVsAvailability?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, timeEntriesNonBillable?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null, timeEntriesNonBillableVsAvailability?: { __typename?: 'TeamReportRowItem', value?: number | null, unit: string } | null }> } };

export type InvoiceAllocationMutationVariables = Exact<{
  input: InvoiceAllocationsSaveInput;
}>;


export type InvoiceAllocationMutation = { __typename?: 'Mutation', InvoiceAllocation: boolean };

export type TimeEntryActionsMutationVariables = Exact<{
  input: TimeEntrySaveInput;
}>;


export type TimeEntryActionsMutation = { __typename?: 'Mutation', TimeEntrySave: { __typename?: 'TimeEntry', id: string } };

export type TimeOffReportQueryVariables = Exact<{
  input: FilterHashInput;
  includeSummary: Scalars['Boolean']['input'];
}>;


export type TimeOffReportQuery = { __typename?: 'Query', TimeOffReport: { __typename?: 'TimeOffReport', timeOffReportList: Array<{ __typename?: 'TimeOffReportListItem', user: { __typename?: 'User', id: string, name: string, initials?: string | null, hslColor?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }, timeOffs: Array<{ __typename?: 'TimeOffReportItem', offDays?: number | null, offSeconds?: number | null, extraSeconds?: number | null, hasMultipleUsers: boolean, timeOff: { __typename?: 'TimeOff', id: string, reason?: string | null, startDate: SAPIDate, endDate: SAPIDate, externalSystem?: ExternalSystemEnum | null, type: { __typename?: 'TimeOffTypeRelation', id: string, systemName: string, displayName: string } }, overlappingProjects: Array<{ __typename?: 'TimeOffOverlappingProjectsListItem', overlapDaysCount: number, startDate: SAPIDate, endDate: SAPIDate, project: { __typename?: 'Project', id: string, name: string, color?: string | null, isPrivate?: boolean | null, projectType: ProjectType, company?: { __typename?: 'Contact', id: string, name: string } | null, permissions?: { __typename?: 'ProjectPermissions', canView: boolean } | null } }> }>, total: { __typename?: 'TimeOffReportTotal', offDays?: number | null, offSeconds?: number | null, extraSeconds?: number | null }, overlappingProjects: Array<{ __typename?: 'TimeOffOverlappingProjectsListItem', overlapDaysCount: number, startDate: SAPIDate, endDate: SAPIDate, project: { __typename?: 'Project', id: string, name: string, color?: string | null, isPrivate?: boolean | null, projectType: ProjectType, company?: { __typename?: 'Contact', id: string, name: string } | null, permissions?: { __typename?: 'ProjectPermissions', canView: boolean } | null } }> }>, timeOffReportSummary?: { __typename?: 'TimeOffReportSummary', usersCount: number, total: { __typename?: 'TimeOffReportTotal', offDays?: number | null, offSeconds?: number | null, extraSeconds?: number | null } } | null } };

export type TimeOffReportExportQueryVariables = Exact<{
  input: FilterHashExportInput;
}>;


export type TimeOffReportExportQuery = { __typename?: 'Query', TimeOffReportExport: { __typename?: 'ExportResponse', fileUrl: string } };

export type TimeOffTypeDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TimeOffTypeDeleteMutation = { __typename?: 'Mutation', TimeOffTypeDelete: boolean };

export type TimeOffTypeModifyMutationVariables = Exact<{
  input: TimeOffTypeSaveInput;
}>;


export type TimeOffTypeModifyMutation = { __typename?: 'Mutation', TimeOffTypeSave: { __typename?: 'TimeOffTypeListItem', displayName: string, id: string, isInUse: boolean, isSystem: boolean, isDefault: boolean, ordering: number } };

export type TimeOffTypeModifyPageQueryVariables = Exact<{
  input?: InputMaybe<TimeOffTypesListFiltersInput>;
}>;


export type TimeOffTypeModifyPageQuery = { __typename?: 'Query', TimeOffTypesList: Array<{ __typename?: 'TimeOffTypeListItem', displayName: string, id: string, isInUse: boolean, ordering: number, isSystem: boolean, isDefault: boolean, externalSystems?: Array<ExternalSystemEnum> | null }> };

export type TimeOffTypeOrderingMutationVariables = Exact<{
  input: TimeOffTypesOrderSaveInput;
}>;


export type TimeOffTypeOrderingMutation = { __typename?: 'Mutation', TimeOffTypesOrderSave: boolean };

export type TimeTrackerDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeTrackerDropdownQuery = { __typename?: 'Query', ActiveTimer?: { __typename?: 'TimeEntry', id: string, startedDateTime?: SAPIDateTime | null, timerDuration?: SAPIDuration | null } | null };

export type TimesheetScheduleRemindersMutationVariables = Exact<{
  input: TimesheetScheduleRemindersInput;
}>;


export type TimesheetScheduleRemindersMutation = { __typename?: 'Mutation', TimesheetScheduleReminders: number };

export type TriggersActionsListQueryVariables = Exact<{ [key: string]: never; }>;


export type TriggersActionsListQuery = { __typename?: 'Query', ActiveTriggersLimitReached: boolean, CurrentUserTriggersList: Array<{ __typename?: 'Trigger', id: string, name: string, module: ModuleType, status?: TriggerStatusType | null, runCount?: number | null, isTemplate: boolean, isSystemNotification?: boolean | null, isMuted?: boolean | null, customModule?: { __typename?: 'CustomModule', nameCode: string, nameTranslated: string } | null, user: { __typename?: 'User', id: string, initials?: string | null, name: string } }> };

export type TriggersActionsModifyTabsActionQueryVariables = Exact<{
  input: ModuleInput;
}>;


export type TriggersActionsModifyTabsActionQuery = { __typename?: 'Query', DynamicUserGroupsList: Array<{ __typename?: 'DynamicUserGroup', id: string, name: string }> };

export type TriggersActionsModifyTabsTriggerQueryVariables = Exact<{ [key: string]: never; }>;


export type TriggersActionsModifyTabsTriggerQuery = { __typename?: 'Query', TriggerModulesList: Array<
    | { __typename?: 'CustomModule', nameCode: string, nameTranslated: string }
    | { __typename?: 'Module', name: ModuleType }
  > };

export type TriggersActionsFieldsListQueryVariables = Exact<{
  module?: InputMaybe<ModuleType>;
  customModule?: InputMaybe<Scalars['String']['input']>;
}>;


export type TriggersActionsFieldsListQuery = { __typename?: 'Query', TriggerFieldsList: Array<{ __typename?: 'TriggerFieldList', label: string, name: string, type: TriggerFieldType, activities?: Array<TriggerFieldListActivitiesType> | null, conditions?: Array<TriggerFieldListConditionsType> | null, values?: Array<{ __typename?: 'TriggerFieldValue', id: string, label: string, name: string }> | null }> };

export type TriggersActionsModifyActionFragment = { __typename?: 'TriggerAction', id: string, triggerId: string, type: TriggerActionType, actionName?: string | null, actionData: Array<
    | { __typename?: 'DynamicUserGroup', id: string, name: string }
    | { __typename?: 'User', id: string, name: string }
    | { __typename?: 'UserGroup', id: string, name: string }
    | { __typename?: 'WebhookData', urlToPost: string }
  > };

export type TriggersActionsModifyDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggersActionsModifyDeleteMutation = { __typename?: 'Mutation', TriggerDelete: boolean };

export type TriggersActionsModifyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggersActionsModifyQuery = { __typename?: 'Query', TriggerModulesList: Array<
    | { __typename?: 'CustomModule', nameCode: string, nameTranslated: string }
    | { __typename?: 'Module', name: ModuleType }
  >, Trigger: { __typename?: 'Trigger', id: string, name: string, module: ModuleType, status?: TriggerStatusType | null, runCount?: number | null, isShared: boolean, isSystem: boolean, isTemplate: boolean, customModule?: { __typename?: 'CustomModule', nameCode: string, nameTranslated: string } | null, bookmark?: { __typename?: 'Bookmark', id: string, name: string, module: string, owner: { __typename?: 'User', id: string, name: string, initials?: string | null } } | null, user: { __typename?: 'User', id: string, name: string, initials?: string | null }, filterData: { __typename?: 'TriggerFilterData', filters: { __typename?: 'TriggerFilterDataFilter', logicalOperator: TriggerFilterDataLogicalOperator, blocks: Array<{ __typename?: 'TriggerFilterDataBlock', logicalOperator: TriggerFilterDataLogicalOperator, rules: Array<{ __typename?: 'TriggerFilterDataRule', fieldType: string, fieldCondition: string, fieldTypeLabel: string, groupValues?: Array<{ __typename?: 'UserGroup', id: string }> | null, values?: Array<
              | { __typename?: 'UnionActivity', activity: { __typename?: 'ActivityType', id: string, name: string } }
              | { __typename?: 'UnionBill', bill: { __typename?: 'Bill', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionClientProfile', clientProfile: { __typename?: 'ClientProfile', id: string, name: string } }
              | { __typename?: 'UnionContact', contact: { __typename?: 'Contact', id: string, name: string } }
              | { __typename?: 'UnionContactCategory', contactCategory: { __typename?: 'ContactCategory', id: string, name: string } }
              | { __typename?: 'UnionCurrency', currency: { __typename?: 'Currency', id: string, name: string } }
              | { __typename?: 'UnionCustomModuleEntry' }
              | { __typename?: 'UnionEvent', event: { __typename?: 'CalendarEvent', id: string, name: string } }
              | { __typename?: 'UnionExpense', expense: { __typename?: 'Expense', id: string, number?: string | null, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionInvoice', invoice: { __typename?: 'Invoice', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionOrder', order: { __typename?: 'Order', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionPrepayment', prepayment: { __typename?: 'Prepayment', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionProject', project: { __typename?: 'Project', id: string, name: string } }
              | { __typename?: 'UnionPurchaseOrder', purchaseOrder: { __typename?: 'PurchaseOrder', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionQuote', quote: { __typename?: 'Quote', id: string, number: string, quoteName?: string | null, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionResource', resource: { __typename?: 'Resource', id: string, name: string } }
              | { __typename?: 'UnionStatus', status: { __typename?: 'Status', statusId: string, name: string } }
              | { __typename?: 'UnionStringFieldValue', stringValue?: string | null }
              | { __typename?: 'UnionTag', tag: { __typename?: 'Tag', id: string, title: string } }
              | { __typename?: 'UnionTask', task: { __typename?: 'Task', id: string, name: string } }
              | { __typename?: 'UnionUser', user: { __typename?: 'User', id: string, name: string } }
            > | null }> }> }, activities: { __typename?: 'TriggerFilterDataFilter', logicalOperator: TriggerFilterDataLogicalOperator, blocks: Array<{ __typename?: 'TriggerFilterDataBlock', logicalOperator: TriggerFilterDataLogicalOperator, rules: Array<{ __typename?: 'TriggerFilterDataRule', fieldType: string, fieldCondition: string, fieldTypeLabel: string, groupValues?: Array<{ __typename?: 'UserGroup', id: string }> | null, values?: Array<
              | { __typename?: 'UnionActivity', activity: { __typename?: 'ActivityType', id: string, name: string } }
              | { __typename?: 'UnionBill', bill: { __typename?: 'Bill', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionClientProfile', clientProfile: { __typename?: 'ClientProfile', id: string, name: string } }
              | { __typename?: 'UnionContact', contact: { __typename?: 'Contact', id: string, name: string } }
              | { __typename?: 'UnionContactCategory', contactCategory: { __typename?: 'ContactCategory', id: string, name: string } }
              | { __typename?: 'UnionCurrency', currency: { __typename?: 'Currency', id: string, name: string } }
              | { __typename?: 'UnionCustomModuleEntry' }
              | { __typename?: 'UnionEvent', event: { __typename?: 'CalendarEvent', id: string, name: string } }
              | { __typename?: 'UnionExpense', expense: { __typename?: 'Expense', id: string, number?: string | null, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionInvoice', invoice: { __typename?: 'Invoice', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionOrder', order: { __typename?: 'Order', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionPrepayment', prepayment: { __typename?: 'Prepayment', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionProject', project: { __typename?: 'Project', id: string, name: string } }
              | { __typename?: 'UnionPurchaseOrder', purchaseOrder: { __typename?: 'PurchaseOrder', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionQuote', quote: { __typename?: 'Quote', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionResource', resource: { __typename?: 'Resource', id: string, name: string } }
              | { __typename?: 'UnionStatus', status: { __typename?: 'Status', statusId: string, name: string } }
              | { __typename?: 'UnionStringFieldValue', stringValue?: string | null }
              | { __typename?: 'UnionTag', tag: { __typename?: 'Tag', id: string, title: string } }
              | { __typename?: 'UnionTask', task: { __typename?: 'Task', id: string, name: string } }
              | { __typename?: 'UnionUser', user: { __typename?: 'User', id: string, name: string } }
            > | null }> }> }, activityDoers: { __typename?: 'TriggerFilterDataUserList', values?: Array<{ __typename?: 'User', id: string, name: string }> | null, groupValues?: Array<
          | { __typename?: 'DynamicUserGroup', id: string }
          | { __typename?: 'UserGroup', id: string }
        > | null } }, actions: Array<{ __typename?: 'TriggerAction', id: string, triggerId: string, type: TriggerActionType, actionName?: string | null, actionData: Array<
        | { __typename?: 'DynamicUserGroup', id: string, name: string }
        | { __typename?: 'User', id: string, name: string }
        | { __typename?: 'UserGroup', id: string, name: string }
        | { __typename?: 'WebhookData', urlToPost: string }
      > }>, activities: Array<{ __typename?: 'TriggerActivity', activity: TriggerActivityType }> } };

export type TriggersActionsModifyUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: TriggerDataInput;
}>;


export type TriggersActionsModifyUpdateMutation = { __typename?: 'Mutation', TriggerDataUpdate: { __typename?: 'Trigger', id: string, name: string, module: ModuleType, status?: TriggerStatusType | null, runCount?: number | null, isShared: boolean, isSystem: boolean, isTemplate: boolean, customModule?: { __typename?: 'CustomModule', nameCode: string, nameTranslated: string } | null, bookmark?: { __typename?: 'Bookmark', id: string, name: string, module: string, owner: { __typename?: 'User', id: string, name: string, initials?: string | null } } | null, user: { __typename?: 'User', id: string, name: string, initials?: string | null }, filterData: { __typename?: 'TriggerFilterData', filters: { __typename?: 'TriggerFilterDataFilter', logicalOperator: TriggerFilterDataLogicalOperator, blocks: Array<{ __typename?: 'TriggerFilterDataBlock', logicalOperator: TriggerFilterDataLogicalOperator, rules: Array<{ __typename?: 'TriggerFilterDataRule', fieldType: string, fieldCondition: string, fieldTypeLabel: string, groupValues?: Array<{ __typename?: 'UserGroup', id: string }> | null, values?: Array<
              | { __typename?: 'UnionActivity', activity: { __typename?: 'ActivityType', id: string, name: string } }
              | { __typename?: 'UnionBill', bill: { __typename?: 'Bill', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionClientProfile', clientProfile: { __typename?: 'ClientProfile', id: string, name: string } }
              | { __typename?: 'UnionContact', contact: { __typename?: 'Contact', id: string, name: string } }
              | { __typename?: 'UnionContactCategory', contactCategory: { __typename?: 'ContactCategory', id: string, name: string } }
              | { __typename?: 'UnionCurrency', currency: { __typename?: 'Currency', id: string, name: string } }
              | { __typename?: 'UnionCustomModuleEntry' }
              | { __typename?: 'UnionEvent', event: { __typename?: 'CalendarEvent', id: string, name: string } }
              | { __typename?: 'UnionExpense', expense: { __typename?: 'Expense', id: string, number?: string | null, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionInvoice', invoice: { __typename?: 'Invoice', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionOrder', order: { __typename?: 'Order', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionPrepayment', prepayment: { __typename?: 'Prepayment', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionProject', project: { __typename?: 'Project', id: string, name: string } }
              | { __typename?: 'UnionPurchaseOrder', purchaseOrder: { __typename?: 'PurchaseOrder', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionQuote', quote: { __typename?: 'Quote', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionResource', resource: { __typename?: 'Resource', id: string, name: string } }
              | { __typename?: 'UnionStatus', status: { __typename?: 'Status', statusId: string, name: string } }
              | { __typename?: 'UnionStringFieldValue', stringValue?: string | null }
              | { __typename?: 'UnionTag', tag: { __typename?: 'Tag', id: string, title: string } }
              | { __typename?: 'UnionTask', task: { __typename?: 'Task', id: string, name: string } }
              | { __typename?: 'UnionUser', user: { __typename?: 'User', id: string, name: string } }
            > | null }> }> }, activities: { __typename?: 'TriggerFilterDataFilter', logicalOperator: TriggerFilterDataLogicalOperator, blocks: Array<{ __typename?: 'TriggerFilterDataBlock', logicalOperator: TriggerFilterDataLogicalOperator, rules: Array<{ __typename?: 'TriggerFilterDataRule', fieldType: string, fieldCondition: string, fieldTypeLabel: string, groupValues?: Array<{ __typename?: 'UserGroup', id: string }> | null, values?: Array<
              | { __typename?: 'UnionActivity', activity: { __typename?: 'ActivityType', id: string, name: string } }
              | { __typename?: 'UnionBill', bill: { __typename?: 'Bill', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionClientProfile', clientProfile: { __typename?: 'ClientProfile', id: string, name: string } }
              | { __typename?: 'UnionContact', contact: { __typename?: 'Contact', id: string, name: string } }
              | { __typename?: 'UnionContactCategory', contactCategory: { __typename?: 'ContactCategory', id: string, name: string } }
              | { __typename?: 'UnionCurrency', currency: { __typename?: 'Currency', id: string, name: string } }
              | { __typename?: 'UnionCustomModuleEntry' }
              | { __typename?: 'UnionEvent', event: { __typename?: 'CalendarEvent', id: string, name: string } }
              | { __typename?: 'UnionExpense', expense: { __typename?: 'Expense', id: string, number?: string | null, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionInvoice', invoice: { __typename?: 'Invoice', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionOrder', order: { __typename?: 'Order', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionPrepayment', prepayment: { __typename?: 'Prepayment', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionProject', project: { __typename?: 'Project', id: string, name: string } }
              | { __typename?: 'UnionPurchaseOrder', purchaseOrder: { __typename?: 'PurchaseOrder', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionQuote', quote: { __typename?: 'Quote', id: string, number: string, mainContact?: { __typename?: 'Contact', name: string } | null } }
              | { __typename?: 'UnionResource', resource: { __typename?: 'Resource', id: string, name: string } }
              | { __typename?: 'UnionStatus', status: { __typename?: 'Status', statusId: string, name: string } }
              | { __typename?: 'UnionStringFieldValue', stringValue?: string | null }
              | { __typename?: 'UnionTag', tag: { __typename?: 'Tag', id: string, title: string } }
              | { __typename?: 'UnionTask', task: { __typename?: 'Task', id: string, name: string } }
              | { __typename?: 'UnionUser', user: { __typename?: 'User', id: string, name: string } }
            > | null }> }> }, activityDoers: { __typename?: 'TriggerFilterDataUserList', values?: Array<{ __typename?: 'User', id: string, name: string }> | null, groupValues?: Array<
          | { __typename?: 'DynamicUserGroup', id: string }
          | { __typename?: 'UserGroup', id: string }
        > | null } }, actions: Array<{ __typename?: 'TriggerAction', id: string, triggerId: string, type: TriggerActionType, actionName?: string | null, actionData: Array<
        | { __typename?: 'DynamicUserGroup', id: string, name: string }
        | { __typename?: 'User', id: string, name: string }
        | { __typename?: 'UserGroup', id: string, name: string }
        | { __typename?: 'WebhookData', urlToPost: string }
      > }>, activities: Array<{ __typename?: 'TriggerActivity', activity: TriggerActivityType }> } };

export type TriggersActionsMutedUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggersActionsMutedUpdateMutation = { __typename?: 'Mutation', TriggerMutedUpdate: { __typename?: 'Trigger', id: string, isMuted?: boolean | null } };

export type TriggersNotifyOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TriggersNotifyOptionsQuery = { __typename?: 'Query', TriggerNotifyOptions: Array<string> };

export type TriggersActionsStatusUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: TriggerStatusType;
}>;


export type TriggersActionsStatusUpdateMutation = { __typename?: 'Mutation', TriggerStatusUpdate: { __typename?: 'Trigger', id: string, name: string, status?: TriggerStatusType | null } };

export type UserActionsListQueryVariables = Exact<{ [key: string]: never; }>;


export type UserActionsListQuery = { __typename?: 'Query', CurrentUserHasDemoData: boolean, UserEmailDraftsCount: number, CurrentUser: { __typename?: 'User', id: string, type: UserType, companyAccounts: Array<{ __typename?: 'CompanyAccount', id: string, name: string, logo?: string | null }> } };

export type UserAssignSelectProjectMembersQueryVariables = Exact<{
  projectParams: ProjectParamsInput;
}>;


export type UserAssignSelectProjectMembersQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, members: Array<{ __typename?: 'User', id: string }> } | null };

export type UserAssignSelectUsersAndGroupsQueryVariables = Exact<{
  usersListInput: UsersListInput;
  projectParams: ProjectParamsInput;
  loadProject: Scalars['Boolean']['input'];
  rolesListInput: RolesListInput;
  loadRoles: Scalars['Boolean']['input'];
}>;


export type UserAssignSelectUsersAndGroupsQuery = { __typename?: 'Query', UserGroupsList: Array<{ __typename?: 'UserGroup', id: string, name: string, users: Array<{ __typename?: 'User', id: string, status: UserStatus }> }>, UsersList: Array<{ __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, Project?: { __typename?: 'Project', id: string, cupoUsers: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }> } | null, RolesList?: Array<{ __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null }> };

export type UserAssignSelectUsersQueryVariables = Exact<{
  input: UsersListInput;
  projectParams: ProjectParamsInput;
  loadProject: Scalars['Boolean']['input'];
}>;


export type UserAssignSelectUsersQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, Project?: { __typename?: 'Project', id: string, cupoUsers: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }> } | null };

export type TaskUserAvailabilityFragmentFragment = { __typename?: 'TaskUsersAvailability', totalAvailability: SAPIDuration, usedAvailability: SAPIDuration, user: { __typename?: 'User', id: string } };

export type UserAssignSelectAvailabilityQueryVariables = Exact<{
  input: TaskUsersAvailabilityInput;
}>;


export type UserAssignSelectAvailabilityQuery = { __typename?: 'Query', TaskUsersAvailability: Array<{ __typename?: 'TaskUsersAvailability', totalAvailability: SAPIDuration, usedAvailability: SAPIDuration, user: { __typename?: 'User', id: string } }> };

export type UserAssignSelectUserFragment = { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null };

export type UserAssignSelectInlineProjectMembersQueryVariables = Exact<{
  projectParams: ProjectParamsInput;
}>;


export type UserAssignSelectInlineProjectMembersQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, members: Array<{ __typename?: 'User', id: string }> } | null };

export type UserAssignSelectInlineUsersAndGroupsQueryVariables = Exact<{
  usersListInput: UsersListInput;
  projectParams: ProjectParamsInput;
  loadProject: Scalars['Boolean']['input'];
  rolesListInput: RolesListInput;
  loadRoles: Scalars['Boolean']['input'];
}>;


export type UserAssignSelectInlineUsersAndGroupsQuery = { __typename?: 'Query', UserGroupsList: Array<{ __typename?: 'UserGroup', id: string, name: string, users: Array<{ __typename?: 'User', id: string, status: UserStatus }> }>, UsersList: Array<{ __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, Project?: { __typename?: 'Project', id: string, cupoUsers: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }> } | null, RolesList?: Array<{ __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null }> };

export type UserAssignSelectInlineUsersQueryVariables = Exact<{
  input: UsersListInput;
  projectParams: ProjectParamsInput;
  loadProject: Scalars['Boolean']['input'];
}>;


export type UserAssignSelectInlineUsersQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, Project?: { __typename?: 'Project', id: string, cupoUsers: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }> } | null };

export type UserAssignSelectInlineTaskUserAvailabilityFragmentFragment = { __typename?: 'TaskUsersAvailability', totalAvailability: SAPIDuration, usedAvailability: SAPIDuration, user: { __typename?: 'User', id: string } };

export type UserAssignSelectInlineAvailabilityQueryVariables = Exact<{
  input: TaskUsersAvailabilityInput;
}>;


export type UserAssignSelectInlineAvailabilityQuery = { __typename?: 'Query', TaskUsersAvailability: Array<{ __typename?: 'TaskUsersAvailability', totalAvailability: SAPIDuration, usedAvailability: SAPIDuration, user: { __typename?: 'User', id: string } }> };

export type UserAutoSuggestQueryVariables = Exact<{
  usersListInput: UsersListInput;
}>;


export type UserAutoSuggestQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string }> };

export type TaskTemplateEventAssignTaskTemplateFragment = { __typename?: 'TaskTemplate', id: string, assignees: Array<{ __typename?: 'TaskTemplateAssignee', id: string, allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }> };

export type TaskTemplateEventAssignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskTemplateEventAssignQuery = { __typename?: 'Query', TaskTemplate?: { __typename?: 'TaskTemplate', id: string, assignees: Array<{ __typename?: 'TaskTemplateAssignee', id: string, allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }> } | null };

export type EventUsersTaskFragment = { __typename?: 'Task', id: string, parentId?: string | null, hasCustomAllocation: boolean, durationPlanned: number, project?: { __typename?: 'Project', id: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }>, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } };

export type UserEventAssignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserEventAssignQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', id: string, parentId?: string | null, hasCustomAllocation: boolean, durationPlanned: number, project?: { __typename?: 'Project', id: string } | null, assignees: Array<{ __typename?: 'TaskAssignee', allocatedDuration: SAPIDuration, user?: { __typename?: 'User', id: string } | null, role?: { __typename?: 'Role', id: string, name: string, initials?: string | null, hslColor?: string | null } | null }>, permissions: { __typename?: 'TaskPermissions', canView: boolean, canModify: boolean } } | null };

export type UserRoleSelectQueryVariables = Exact<{
  usersListInput: UsersListInput;
  rolesListInput: RolesListInput;
  laborCostInput?: InputMaybe<LaborCostInput>;
  includeRoles: Scalars['Boolean']['input'];
}>;


export type UserRoleSelectQuery = { __typename?: 'Query', UsersList: Array<{ __typename?: 'User', id: string, name: string, hslColor?: string | null, initials?: string | null, status: UserStatus, laborCost?: number | null, profilePicture?: { __typename?: 'UserPicture', mini: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, RolesList?: Array<{ __typename?: 'Role', id: string, name: string, laborCost?: number | null, users: Array<{ __typename?: 'User', id: string }> }> };

export type UserSelectListQueryVariables = Exact<{
  usersListInput?: InputMaybe<UsersListInput>;
  includeGroups: Scalars['Boolean']['input'];
}>;


export type UserSelectListQuery = { __typename?: 'Query', UserGroupsList?: Array<{ __typename?: 'UserGroup', id: string, name: string, users: Array<{ __typename?: 'User', id: string, status: UserStatus }> }>, UsersList: Array<{ __typename?: 'User', id: string, name: string }> };

export type InviteUsersMutationVariables = Exact<{
  input: Array<InviteUsersSaveInput> | InviteUsersSaveInput;
}>;


export type InviteUsersMutation = { __typename?: 'Mutation', InviteUsersMutation: boolean };

export type PermissionSetsListQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionSetsListQuery = { __typename?: 'Query', PermissionSetsList: Array<{ __typename?: 'PermissionSet', id: string, name: string }> };

export type WorkReportChartQueryVariables = Exact<{
  bookmarkHash: Scalars['String']['input'];
  startFrom: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type WorkReportChartQuery = { __typename?: 'Query', WorkReportList: Array<{ __typename?: 'WorkReportPrimaryGroup', id?: string | null, title?: string | null, type: string, value: Array<{ __typename?: 'WorkReportSecondaryGroup', actualDuration?: SAPIDuration | null, billableDuration?: SAPIDuration | null, id?: string | null, plannedDuration?: SAPIDuration | null, quantity: number, title?: string | null, todoDuration?: SAPIDuration | null, type: string }> }> };

export type ProjectsViewPageQueryVariables = Exact<{
  projectInput: ProjectParamsInput;
  projectId: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
}>;


export type ProjectsViewPageQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', id: string, number?: string | null, name: string, date?: SAPIDate | null, deadline?: SAPIDate | null, completedDateTime?: SAPIDateTime | null, color?: string | null, duration?: SAPIDuration | null, doneDuration?: SAPIDuration | null, toDoDuration?: SAPIDuration | null, isDeleted?: boolean | null, isPersonal?: boolean | null, isPrivate?: boolean | null, projectType: ProjectType, confirmedDoneDuration?: SAPIDuration | null, actualUsedBudgetSum?: number | null, useBillsExpensesInCalculations?: boolean | null, manager?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null, status?: { __typename?: 'Status', id: string, statusId: string, name: string, color: string } | null, company?: { __typename?: 'Contact', id: string, name: string } | null, permissions?: { __typename?: 'ProjectPermissions', canModify: boolean } | null, members: Array<{ __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, cupoUsers: Array<{ __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null, status: UserStatus, type: UserType, hslColor?: string | null, initials?: string | null, profilePicture?: { __typename?: 'UserPicture', mini: string, medium: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, priceList?: { __typename?: 'PriceList', id: string, currency: string } | null, retainer?: { __typename?: 'Retainer', id: string, periodDuration?: number | null, periodSum?: number | null, periods: Array<{ __typename?: 'RetainerPeriod', id: string, name: string, startDate: SAPIDate, endDate: SAPIDate, duration?: number | null, actualDuration?: number | null, sum?: number | null, actualSum?: number | null, defaultName?: string | null }> } | null, projectPhases?: Array<{ __typename?: 'ProjectPhase', id: string, title: string, ordering: number, startDate?: SAPIDate | null, endDate?: SAPIDate | null, type: ProjectPhaseTypeEnum }> | null } | null };

export type WelcomePageActiveTrialThreadQueryVariables = Exact<{
  threadId?: InputMaybe<Scalars['String']['input']>;
}>;


export type WelcomePageActiveTrialThreadQuery = { __typename?: 'Query', ActiveTrialThread?: { __typename?: 'EliChatThread', threadId: string, messages?: Array<{ __typename?: 'EliChatMessageResponse', messageId: string, threadId: string, response: string, messageType: string }> | null } | null };

export const ActivityTypeInlineSelectFragmentDoc = gql`
    fragment ActivityTypeInlineSelect on ActivityType {
  id
  name
}
    `;
export const EmailServiceSettingsEmailDomainFragmentDoc = gql`
    fragment EmailServiceSettingsEmailDomain on EmailDomain {
  domain
  isVerified
  region
  dnsRecords {
    host
    type
    value
  }
}
    `;
export const ContactUnpaidInvoicesFieldsFragmentDoc = gql`
    fragment contactUnpaidInvoicesFields on ContactUnpaidInvoices {
  currencySymbol
  hasAccessToInvoices
  hasUnpaidInvoices
  prepaymentBalance
  unpaidInvoices
}
    `;
export const ProjectPhasesProjectPhaseFragmentDoc = gql`
    fragment projectPhasesProjectPhase on ProjectPhase {
  id
  title
  startDate
  startDays
  endDate
  endDays
  type
  ordering
  isChangingDatesDisabled
  hasDependencies
  quoteLine {
    id
  }
  taskSets {
    name
    id
    ordering
    maxDays
    minDays
    taskTemplatesCount
  }
  __typename
}
    `;
export const ProjectPhasesTaskSetFragmentDoc = gql`
    fragment projectPhasesTaskSet on TaskSet {
  name
  id
  ordering
  maxDays
  minDays
  taskTemplatesCount
  __typename
}
    `;
export const QuoteMatrixRoleFragmentDoc = gql`
    fragment quoteMatrixRole on Role {
  id
  name
  laborCost(input: $laborCostInput)
}
    `;
export const QuoteMatrixUserFragmentDoc = gql`
    fragment quoteMatrixUser on User {
  id
  name
  laborCost(input: $laborCostInput)
  role {
    id
    name
  }
}
    `;
export const ResourcePlanningRoleProjectFragmentDoc = gql`
    fragment ResourcePlanningRoleProject on RoleProject {
  id
  role {
    id
    name
  }
}
    `;
export const SelfServiceSeatReductionRequestFragmentDoc = gql`
    fragment SelfServiceSeatReductionRequest on SelfServiceSeatReductionRequest {
  id
  reductionAmount
  effectiveDate
  createdDate
  modifiedDate
  createdUser {
    id
    name
    initials
  }
  modifiedUser {
    id
    name
    initials
  }
}
    `;
export const UserAssignSelectUserFragmentDoc = gql`
    fragment userAssignSelectUser on User {
  id
  name
  firstName
  lastName
  status
  type
  profilePicture {
    mini
    medium
  }
  hslColor
  initials
  role {
    id
    name
  }
}
    `;
export const StatusPickerStatusFragmentDoc = gql`
    fragment StatusPickerStatus on Status {
  id
  statusId
  name
  color
}
    `;
export const TaskListTaskFieldsFragmentDoc = gql`
    fragment TaskListTaskFields on Task {
  id
  parentId
  activityType {
    id
    name
  }
  commentsCount
  startDate
  dueDate
  dueDateTime
  durationDone
  durationPlanned
  durationRemaining
  durationScheduled
  progressPercentage
  durationBillablePlanned
  durationBillableDone
  durationBillableRemaining
  totalDurationDone
  totalDurationPlanned
  totalDurationRemaining
  totalDurationScheduled
  totalProgressPercentage
  totalDurationBillablePlanned
  totalDurationBillableDone
  totalDurationBillableRemaining
  isDone
  name
  description
  budgetedDuration
  remainingBudgetedDuration
  priority
  project {
    id
    name
  }
  projectPhase {
    id
    title
  }
  responsibleUser {
    ...userAssignSelectUser
  }
  company {
    id
    name
  }
  person {
    id
    name
  }
  status {
    ...StatusPickerStatus
  }
  isRequiredFieldsMissing
  isQuoteLineShared
  permissions {
    canView
    canModify
  }
  createdBy {
    id
    name
  }
  modifiedBy {
    id
    name
  }
  createdDateTime
  modifiedDateTime
}
    ${UserAssignSelectUserFragmentDoc}
${StatusPickerStatusFragmentDoc}`;
export const LimitedTaskFieldsFragmentDoc = gql`
    fragment LimitedTaskFields on LimitedTask {
  id
  name
  permissions {
    canView
    canModify
  }
  isDone
}
    `;
export const TaskListTaskFragmentDoc = gql`
    fragment TaskListTask on Task {
  ...TaskListTaskFields
  subtasks {
    ...TaskListTaskFields
    ...LimitedTaskFields
  }
}
    ${TaskListTaskFieldsFragmentDoc}
${LimitedTaskFieldsFragmentDoc}`;
export const TaskListLimitedTaskFragmentDoc = gql`
    fragment TaskListLimitedTask on LimitedTask {
  ...LimitedTaskFields
  subtasks {
    ...TaskListTaskFields
    ...LimitedTaskFields
  }
}
    ${LimitedTaskFieldsFragmentDoc}
${TaskListTaskFieldsFragmentDoc}`;
export const TaskListPhaseFragmentDoc = gql`
    fragment TaskListPhase on ProjectPhase {
  id
  title
  ordering
  startDate
  endDate
  type
  hasTasks
}
    `;
export const TaskListProjectFragmentDoc = gql`
    fragment TaskListProject on Project {
  id
  company {
    id
  }
  projectPhases {
    ...TaskListPhase
  }
  createTasksFromQuoteId
  permissions {
    canView
    canModify
  }
}
    ${TaskListPhaseFragmentDoc}`;
export const TaskListEnrichmentFieldsFragmentDoc = gql`
    fragment TaskListEnrichmentFields on Task {
  id
  project {
    id
  }
  assignees {
    user {
      ...userAssignSelectUser
    }
    role {
      id
      name
      initials
      hslColor
    }
    allocatedDuration
  }
  responsibleUser {
    ...userAssignSelectUser
  }
  permissions {
    canView
    canModify
  }
  hasCustomAllocation
  durationPlanned
  parentId
}
    ${UserAssignSelectUserFragmentDoc}`;
export const TaskTemplateAssigneeFieldsFragmentDoc = gql`
    fragment TaskTemplateAssigneeFields on TaskTemplateAssignee {
  id
  user {
    id
  }
  role {
    id
    name
    initials
    hslColor
  }
  allocatedDuration
}
    `;
export const TaskTemplateAssigneesTaskTemplateFragmentDoc = gql`
    fragment TaskTemplateAssigneesTaskTemplate on TaskTemplate {
  id
  owner {
    ...userAssignSelectUser
  }
  dynamicOwner
  assignees {
    ...TaskTemplateAssigneeFields
  }
}
    ${UserAssignSelectUserFragmentDoc}
${TaskTemplateAssigneeFieldsFragmentDoc}`;
export const TaskUsersTaskFragmentDoc = gql`
    fragment TaskUsersTask on Task {
  id
  project {
    id
  }
  assignees {
    user {
      ...userAssignSelectUser
    }
    role {
      id
      name
      initials
      hslColor
    }
    allocatedDuration
  }
  responsibleUser {
    ...userAssignSelectUser
  }
  permissions {
    canView
    canModify
  }
  hasCustomAllocation
  durationPlanned
  parentId
}
    ${UserAssignSelectUserFragmentDoc}`;
export const TriggersActionsModifyActionFragmentDoc = gql`
    fragment TriggersActionsModifyAction on TriggerAction {
  id
  triggerId
  type
  actionData {
    ... on User {
      id
      name
    }
    ... on WebhookData {
      urlToPost
    }
    ... on UserGroup {
      id
      name
    }
    ... on DynamicUserGroup {
      id
      name
    }
  }
  actionName
}
    `;
export const TaskUserAvailabilityFragmentFragmentDoc = gql`
    fragment taskUserAvailabilityFragment on TaskUsersAvailability {
  user {
    id
  }
  totalAvailability
  usedAvailability
}
    `;
export const UserAssignSelectInlineTaskUserAvailabilityFragmentFragmentDoc = gql`
    fragment userAssignSelectInlineTaskUserAvailabilityFragment on TaskUsersAvailability {
  user {
    id
  }
  totalAvailability
  usedAvailability
}
    `;
export const TaskTemplateEventAssignTaskTemplateFragmentDoc = gql`
    fragment TaskTemplateEventAssignTaskTemplate on TaskTemplate {
  id
  assignees {
    ...TaskTemplateAssigneeFields
  }
}
    ${TaskTemplateAssigneeFieldsFragmentDoc}`;
export const EventUsersTaskFragmentDoc = gql`
    fragment EventUsersTask on Task {
  id
  parentId
  project {
    id
  }
  assignees {
    user {
      id
    }
    role {
      id
      name
      initials
      hslColor
    }
    allocatedDuration
  }
  permissions {
    canView
    canModify
  }
  hasCustomAllocation
  durationPlanned
}
    `;
export const AuthorizeIntegrationDocument = gql`
    mutation authorizeIntegration($input: IntegrationAuthorizeInputType!) {
  IntegrationAuthorize(input: $input)
}
    `;

/**
 * __useAuthorizeIntegrationMutation__
 *
 * To run a mutation, you first call `useAuthorizeIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizeIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAuthorizeIntegrationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAuthorizeIntegrationMutation(options: VueApolloComposable.UseMutationOptions<AuthorizeIntegrationMutation, AuthorizeIntegrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AuthorizeIntegrationMutation, AuthorizeIntegrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AuthorizeIntegrationMutation, AuthorizeIntegrationMutationVariables>(AuthorizeIntegrationDocument, options);
}
export type AuthorizeIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AuthorizeIntegrationMutation, AuthorizeIntegrationMutationVariables>;
export const GetIntegrationAdapterStatusDocument = gql`
    query getIntegrationAdapterStatus($input: IntegrationGetAdapterInputType!) {
  IntegrationGetAdapter(input: $input) {
    id
    isActive
  }
}
    `;

/**
 * __useGetIntegrationAdapterStatusQuery__
 *
 * To run a query within a Vue component, call `useGetIntegrationAdapterStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationAdapterStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetIntegrationAdapterStatusQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetIntegrationAdapterStatusQuery(variables: GetIntegrationAdapterStatusQueryVariables | VueCompositionApi.Ref<GetIntegrationAdapterStatusQueryVariables> | ReactiveFunction<GetIntegrationAdapterStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIntegrationAdapterStatusQuery, GetIntegrationAdapterStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIntegrationAdapterStatusQuery, GetIntegrationAdapterStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIntegrationAdapterStatusQuery, GetIntegrationAdapterStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetIntegrationAdapterStatusQuery, GetIntegrationAdapterStatusQueryVariables>(GetIntegrationAdapterStatusDocument, variables, options);
}
export function useGetIntegrationAdapterStatusLazyQuery(variables?: GetIntegrationAdapterStatusQueryVariables | VueCompositionApi.Ref<GetIntegrationAdapterStatusQueryVariables> | ReactiveFunction<GetIntegrationAdapterStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIntegrationAdapterStatusQuery, GetIntegrationAdapterStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIntegrationAdapterStatusQuery, GetIntegrationAdapterStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIntegrationAdapterStatusQuery, GetIntegrationAdapterStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetIntegrationAdapterStatusQuery, GetIntegrationAdapterStatusQueryVariables>(GetIntegrationAdapterStatusDocument, variables, options);
}
export type GetIntegrationAdapterStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetIntegrationAdapterStatusQuery, GetIntegrationAdapterStatusQueryVariables>;
export const SetIntegrationAdapterStatusDocument = gql`
    mutation setIntegrationAdapterStatus($input: IntegrationSetAdapterStatusInputType!) {
  IntegrationSetAdapterStatus(input: $input)
}
    `;

/**
 * __useSetIntegrationAdapterStatusMutation__
 *
 * To run a mutation, you first call `useSetIntegrationAdapterStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetIntegrationAdapterStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetIntegrationAdapterStatusMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetIntegrationAdapterStatusMutation(options: VueApolloComposable.UseMutationOptions<SetIntegrationAdapterStatusMutation, SetIntegrationAdapterStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetIntegrationAdapterStatusMutation, SetIntegrationAdapterStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetIntegrationAdapterStatusMutation, SetIntegrationAdapterStatusMutationVariables>(SetIntegrationAdapterStatusDocument, options);
}
export type SetIntegrationAdapterStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetIntegrationAdapterStatusMutation, SetIntegrationAdapterStatusMutationVariables>;
export const ValidateTokenDocument = gql`
    query validateToken($input: IntegrationValidateJwtInputType!) {
  IntegrationValidateAppJwt(input: $input)
}
    `;

/**
 * __useValidateTokenQuery__
 *
 * To run a query within a Vue component, call `useValidateTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateTokenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useValidateTokenQuery({
 *   input: // value for 'input'
 * });
 */
export function useValidateTokenQuery(variables: ValidateTokenQueryVariables | VueCompositionApi.Ref<ValidateTokenQueryVariables> | ReactiveFunction<ValidateTokenQueryVariables>, options: VueApolloComposable.UseQueryOptions<ValidateTokenQuery, ValidateTokenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ValidateTokenQuery, ValidateTokenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ValidateTokenQuery, ValidateTokenQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ValidateTokenQuery, ValidateTokenQueryVariables>(ValidateTokenDocument, variables, options);
}
export function useValidateTokenLazyQuery(variables?: ValidateTokenQueryVariables | VueCompositionApi.Ref<ValidateTokenQueryVariables> | ReactiveFunction<ValidateTokenQueryVariables>, options: VueApolloComposable.UseQueryOptions<ValidateTokenQuery, ValidateTokenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ValidateTokenQuery, ValidateTokenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ValidateTokenQuery, ValidateTokenQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ValidateTokenQuery, ValidateTokenQueryVariables>(ValidateTokenDocument, variables, options);
}
export type ValidateTokenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ValidateTokenQuery, ValidateTokenQueryVariables>;
export const SetUpPermissionsDocument = gql`
    query setUpPermissions {
  EnabledFeatures @persist {
    name
  }
  EnabledModules @persist {
    name
  }
  EnabledPermissions @persist {
    name
  }
  CurrentUser @persist {
    id
    type
  }
  FeatureFlags @persist {
    name
    value
  }
}
    `;

/**
 * __useSetUpPermissionsQuery__
 *
 * To run a query within a Vue component, call `useSetUpPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetUpPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSetUpPermissionsQuery();
 */
export function useSetUpPermissionsQuery(options: VueApolloComposable.UseQueryOptions<SetUpPermissionsQuery, SetUpPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SetUpPermissionsQuery, SetUpPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SetUpPermissionsQuery, SetUpPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SetUpPermissionsQuery, SetUpPermissionsQueryVariables>(SetUpPermissionsDocument, {}, options);
}
export function useSetUpPermissionsLazyQuery(options: VueApolloComposable.UseQueryOptions<SetUpPermissionsQuery, SetUpPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SetUpPermissionsQuery, SetUpPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SetUpPermissionsQuery, SetUpPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SetUpPermissionsQuery, SetUpPermissionsQueryVariables>(SetUpPermissionsDocument, {}, options);
}
export type SetUpPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SetUpPermissionsQuery, SetUpPermissionsQueryVariables>;
export const SettingSaveDocument = gql`
    mutation SettingSave($input: SettingSaveInput!) {
  SettingSave(input: $input) {
    __typename
    name
    value
  }
}
    `;

/**
 * __useSettingSaveMutation__
 *
 * To run a mutation, you first call `useSettingSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSettingSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSettingSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSettingSaveMutation(options: VueApolloComposable.UseMutationOptions<SettingSaveMutation, SettingSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SettingSaveMutation, SettingSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SettingSaveMutation, SettingSaveMutationVariables>(SettingSaveDocument, options);
}
export type SettingSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SettingSaveMutation, SettingSaveMutationVariables>;
export const SettingsDocument = gql`
    query Settings {
  CurrentUserSettings {
    name
    value
  }
}
    `;

/**
 * __useSettingsQuery__
 *
 * To run a query within a Vue component, call `useSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsQuery();
 */
export function useSettingsQuery(options: VueApolloComposable.UseQueryOptions<SettingsQuery, SettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsQuery, SettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsQuery, SettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, {}, options);
}
export function useSettingsLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsQuery, SettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsQuery, SettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsQuery, SettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, {}, options);
}
export type SettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsQuery, SettingsQueryVariables>;
export const SocketDocument = gql`
    query socket($moduleName: String) {
  SocketConnection(moduleName: $moduleName) @persist {
    serverUrl
    userToken
  }
}
    `;

/**
 * __useSocketQuery__
 *
 * To run a query within a Vue component, call `useSocketQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocketQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSocketQuery({
 *   moduleName: // value for 'moduleName'
 * });
 */
export function useSocketQuery(variables: SocketQueryVariables | VueCompositionApi.Ref<SocketQueryVariables> | ReactiveFunction<SocketQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SocketQuery, SocketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SocketQuery, SocketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SocketQuery, SocketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SocketQuery, SocketQueryVariables>(SocketDocument, variables, options);
}
export function useSocketLazyQuery(variables: SocketQueryVariables | VueCompositionApi.Ref<SocketQueryVariables> | ReactiveFunction<SocketQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SocketQuery, SocketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SocketQuery, SocketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SocketQuery, SocketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SocketQuery, SocketQueryVariables>(SocketDocument, variables, options);
}
export type SocketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SocketQuery, SocketQueryVariables>;
export const RequiredFieldsDocument = gql`
    query requiredFields($input: RequiredUniqueFieldsInput!) {
  RequiredUniqueFields(input: $input) {
    requiredFields
  }
}
    `;

/**
 * __useRequiredFieldsQuery__
 *
 * To run a query within a Vue component, call `useRequiredFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequiredFieldsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRequiredFieldsQuery({
 *   input: // value for 'input'
 * });
 */
export function useRequiredFieldsQuery(variables: RequiredFieldsQueryVariables | VueCompositionApi.Ref<RequiredFieldsQueryVariables> | ReactiveFunction<RequiredFieldsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RequiredFieldsQuery, RequiredFieldsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RequiredFieldsQuery, RequiredFieldsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RequiredFieldsQuery, RequiredFieldsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RequiredFieldsQuery, RequiredFieldsQueryVariables>(RequiredFieldsDocument, variables, options);
}
export function useRequiredFieldsLazyQuery(variables?: RequiredFieldsQueryVariables | VueCompositionApi.Ref<RequiredFieldsQueryVariables> | ReactiveFunction<RequiredFieldsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RequiredFieldsQuery, RequiredFieldsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RequiredFieldsQuery, RequiredFieldsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RequiredFieldsQuery, RequiredFieldsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RequiredFieldsQuery, RequiredFieldsQueryVariables>(RequiredFieldsDocument, variables, options);
}
export type RequiredFieldsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RequiredFieldsQuery, RequiredFieldsQueryVariables>;
export const UseSiteDocument = gql`
    query useSite {
  CurrentSite @persist {
    id
    siteName
    siteUrl
    isTrialActive
    isTrialExpired
    isSiteExpired
    trialExpireDateTime
    canScheduleDemo
    marketingCompanySize
    hasPaymentMethod
    abTag
    version {
      name
      state
    }
    server
  }
}
    `;

/**
 * __useUseSiteQuery__
 *
 * To run a query within a Vue component, call `useUseSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseSiteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUseSiteQuery();
 */
export function useUseSiteQuery(options: VueApolloComposable.UseQueryOptions<UseSiteQuery, UseSiteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UseSiteQuery, UseSiteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UseSiteQuery, UseSiteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UseSiteQuery, UseSiteQueryVariables>(UseSiteDocument, {}, options);
}
export function useUseSiteLazyQuery(options: VueApolloComposable.UseQueryOptions<UseSiteQuery, UseSiteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UseSiteQuery, UseSiteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UseSiteQuery, UseSiteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UseSiteQuery, UseSiteQueryVariables>(UseSiteDocument, {}, options);
}
export type UseSiteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UseSiteQuery, UseSiteQueryVariables>;
export const ActivityTypeAutoSuggestDocument = gql`
    query activityTypeAutoSuggest($searchKeyword: String) {
  ActivityTypesList(searchKeyword: $searchKeyword) {
    id
    name
  }
}
    `;

/**
 * __useActivityTypeAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useActivityTypeAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTypeAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActivityTypeAutoSuggestQuery({
 *   searchKeyword: // value for 'searchKeyword'
 * });
 */
export function useActivityTypeAutoSuggestQuery(variables: ActivityTypeAutoSuggestQueryVariables | VueCompositionApi.Ref<ActivityTypeAutoSuggestQueryVariables> | ReactiveFunction<ActivityTypeAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ActivityTypeAutoSuggestQuery, ActivityTypeAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActivityTypeAutoSuggestQuery, ActivityTypeAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActivityTypeAutoSuggestQuery, ActivityTypeAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActivityTypeAutoSuggestQuery, ActivityTypeAutoSuggestQueryVariables>(ActivityTypeAutoSuggestDocument, variables, options);
}
export function useActivityTypeAutoSuggestLazyQuery(variables: ActivityTypeAutoSuggestQueryVariables | VueCompositionApi.Ref<ActivityTypeAutoSuggestQueryVariables> | ReactiveFunction<ActivityTypeAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ActivityTypeAutoSuggestQuery, ActivityTypeAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActivityTypeAutoSuggestQuery, ActivityTypeAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActivityTypeAutoSuggestQuery, ActivityTypeAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActivityTypeAutoSuggestQuery, ActivityTypeAutoSuggestQueryVariables>(ActivityTypeAutoSuggestDocument, variables, options);
}
export type ActivityTypeAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActivityTypeAutoSuggestQuery, ActivityTypeAutoSuggestQueryVariables>;
export const ActivityTypeInlineSelectDocument = gql`
    query activityTypeInlineSelect($searchKeyword: String, $status: ActivityTypeStatus) {
  ActivityTypesList(searchKeyword: $searchKeyword, status: $status) {
    ...ActivityTypeInlineSelect
  }
}
    ${ActivityTypeInlineSelectFragmentDoc}`;

/**
 * __useActivityTypeInlineSelectQuery__
 *
 * To run a query within a Vue component, call `useActivityTypeInlineSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTypeInlineSelectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActivityTypeInlineSelectQuery({
 *   searchKeyword: // value for 'searchKeyword'
 *   status: // value for 'status'
 * });
 */
export function useActivityTypeInlineSelectQuery(variables: ActivityTypeInlineSelectQueryVariables | VueCompositionApi.Ref<ActivityTypeInlineSelectQueryVariables> | ReactiveFunction<ActivityTypeInlineSelectQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ActivityTypeInlineSelectQuery, ActivityTypeInlineSelectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActivityTypeInlineSelectQuery, ActivityTypeInlineSelectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActivityTypeInlineSelectQuery, ActivityTypeInlineSelectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActivityTypeInlineSelectQuery, ActivityTypeInlineSelectQueryVariables>(ActivityTypeInlineSelectDocument, variables, options);
}
export function useActivityTypeInlineSelectLazyQuery(variables: ActivityTypeInlineSelectQueryVariables | VueCompositionApi.Ref<ActivityTypeInlineSelectQueryVariables> | ReactiveFunction<ActivityTypeInlineSelectQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ActivityTypeInlineSelectQuery, ActivityTypeInlineSelectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActivityTypeInlineSelectQuery, ActivityTypeInlineSelectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActivityTypeInlineSelectQuery, ActivityTypeInlineSelectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActivityTypeInlineSelectQuery, ActivityTypeInlineSelectQueryVariables>(ActivityTypeInlineSelectDocument, variables, options);
}
export type ActivityTypeInlineSelectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActivityTypeInlineSelectQuery, ActivityTypeInlineSelectQueryVariables>;
export const CurrencyAutoSuggestDocument = gql`
    query currencyAutoSuggest($currenciesListInput: CurrenciesListInput) {
  CurrenciesList(input: $currenciesListInput) {
    id
    name
  }
}
    `;

/**
 * __useCurrencyAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useCurrencyAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrencyAutoSuggestQuery({
 *   currenciesListInput: // value for 'currenciesListInput'
 * });
 */
export function useCurrencyAutoSuggestQuery(variables: CurrencyAutoSuggestQueryVariables | VueCompositionApi.Ref<CurrencyAutoSuggestQueryVariables> | ReactiveFunction<CurrencyAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CurrencyAutoSuggestQuery, CurrencyAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrencyAutoSuggestQuery, CurrencyAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrencyAutoSuggestQuery, CurrencyAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CurrencyAutoSuggestQuery, CurrencyAutoSuggestQueryVariables>(CurrencyAutoSuggestDocument, variables, options);
}
export function useCurrencyAutoSuggestLazyQuery(variables: CurrencyAutoSuggestQueryVariables | VueCompositionApi.Ref<CurrencyAutoSuggestQueryVariables> | ReactiveFunction<CurrencyAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CurrencyAutoSuggestQuery, CurrencyAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrencyAutoSuggestQuery, CurrencyAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrencyAutoSuggestQuery, CurrencyAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CurrencyAutoSuggestQuery, CurrencyAutoSuggestQueryVariables>(CurrencyAutoSuggestDocument, variables, options);
}
export type CurrencyAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CurrencyAutoSuggestQuery, CurrencyAutoSuggestQueryVariables>;
export const AppHeaderDocument = gql`
    query appHeader {
  Menu @persist {
    moduleName
    link
    module
  }
}
    `;

/**
 * __useAppHeaderQuery__
 *
 * To run a query within a Vue component, call `useAppHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppHeaderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppHeaderQuery();
 */
export function useAppHeaderQuery(options: VueApolloComposable.UseQueryOptions<AppHeaderQuery, AppHeaderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppHeaderQuery, AppHeaderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppHeaderQuery, AppHeaderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AppHeaderQuery, AppHeaderQueryVariables>(AppHeaderDocument, {}, options);
}
export function useAppHeaderLazyQuery(options: VueApolloComposable.UseQueryOptions<AppHeaderQuery, AppHeaderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppHeaderQuery, AppHeaderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppHeaderQuery, AppHeaderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AppHeaderQuery, AppHeaderQueryVariables>(AppHeaderDocument, {}, options);
}
export type AppHeaderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AppHeaderQuery, AppHeaderQueryVariables>;
export const AppMetricsListDocument = gql`
    query appMetricsList($input: SummaryBlockInput) {
  SummaryBlock(input: $input) {
    id
    title
    value
    unit
    valueState
    type
    secondaryValue
    secondaryUnit
    secondaryDescription
    secondaryValueState
  }
}
    `;

/**
 * __useAppMetricsListQuery__
 *
 * To run a query within a Vue component, call `useAppMetricsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppMetricsListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppMetricsListQuery({
 *   input: // value for 'input'
 * });
 */
export function useAppMetricsListQuery(variables: AppMetricsListQueryVariables | VueCompositionApi.Ref<AppMetricsListQueryVariables> | ReactiveFunction<AppMetricsListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AppMetricsListQuery, AppMetricsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppMetricsListQuery, AppMetricsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppMetricsListQuery, AppMetricsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AppMetricsListQuery, AppMetricsListQueryVariables>(AppMetricsListDocument, variables, options);
}
export function useAppMetricsListLazyQuery(variables: AppMetricsListQueryVariables | VueCompositionApi.Ref<AppMetricsListQueryVariables> | ReactiveFunction<AppMetricsListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AppMetricsListQuery, AppMetricsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppMetricsListQuery, AppMetricsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppMetricsListQuery, AppMetricsListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AppMetricsListQuery, AppMetricsListQueryVariables>(AppMetricsListDocument, variables, options);
}
export type AppMetricsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AppMetricsListQuery, AppMetricsListQueryVariables>;
export const MentionListDocument = gql`
    query mentionList($usersListInput: UsersListInput) {
  UsersList(input: $usersListInput) {
    id
    name
    initials
    hslColor
    profilePicture {
      mini
    }
  }
}
    `;

/**
 * __useMentionListQuery__
 *
 * To run a query within a Vue component, call `useMentionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentionListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMentionListQuery({
 *   usersListInput: // value for 'usersListInput'
 * });
 */
export function useMentionListQuery(variables: MentionListQueryVariables | VueCompositionApi.Ref<MentionListQueryVariables> | ReactiveFunction<MentionListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MentionListQuery, MentionListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MentionListQuery, MentionListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MentionListQuery, MentionListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MentionListQuery, MentionListQueryVariables>(MentionListDocument, variables, options);
}
export function useMentionListLazyQuery(variables: MentionListQueryVariables | VueCompositionApi.Ref<MentionListQueryVariables> | ReactiveFunction<MentionListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MentionListQuery, MentionListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MentionListQuery, MentionListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MentionListQuery, MentionListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MentionListQuery, MentionListQueryVariables>(MentionListDocument, variables, options);
}
export type MentionListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MentionListQuery, MentionListQueryVariables>;
export const CurrentUserDocument = gql`
    query currentUser {
  CurrentUser @persist {
    id
    uuid
    type
    firstName
    lastName
    name
    initials
    profilePicture {
      mini
      medium
    }
    companyAccounts {
      id
      logo
      name
      isInUse
    }
    gsm
    email
    lastNoticeVersion
    hslColor
    permissionSet {
      name
    }
    status
    languageId
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a Vue component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentUserQuery();
 */
export function useCurrentUserQuery(options: VueApolloComposable.UseQueryOptions<CurrentUserQuery, CurrentUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserQuery, CurrentUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserQuery, CurrentUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, {}, options);
}
export function useCurrentUserLazyQuery(options: VueApolloComposable.UseQueryOptions<CurrentUserQuery, CurrentUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserQuery, CurrentUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserQuery, CurrentUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, {}, options);
}
export type CurrentUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CurrentUserQuery, CurrentUserQueryVariables>;
export const AvailabilityListDocument = gql`
    query AvailabilityList($input: AvailabilityListInput!) {
  AvailabilityList(input: $input) {
    userId
    date
    availability
  }
}
    `;

/**
 * __useAvailabilityListQuery__
 *
 * To run a query within a Vue component, call `useAvailabilityListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvailabilityListQuery({
 *   input: // value for 'input'
 * });
 */
export function useAvailabilityListQuery(variables: AvailabilityListQueryVariables | VueCompositionApi.Ref<AvailabilityListQueryVariables> | ReactiveFunction<AvailabilityListQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvailabilityListQuery, AvailabilityListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailabilityListQuery, AvailabilityListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailabilityListQuery, AvailabilityListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvailabilityListQuery, AvailabilityListQueryVariables>(AvailabilityListDocument, variables, options);
}
export function useAvailabilityListLazyQuery(variables?: AvailabilityListQueryVariables | VueCompositionApi.Ref<AvailabilityListQueryVariables> | ReactiveFunction<AvailabilityListQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvailabilityListQuery, AvailabilityListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailabilityListQuery, AvailabilityListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailabilityListQuery, AvailabilityListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvailabilityListQuery, AvailabilityListQueryVariables>(AvailabilityListDocument, variables, options);
}
export type AvailabilityListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvailabilityListQuery, AvailabilityListQueryVariables>;
export const BillAutoSuggestDocument = gql`
    query billAutoSuggest($billsListInput: FinanceDocumentsListInput) {
  BillsList(input: $billsListInput) {
    id
    number
    mainContact {
      name
    }
  }
}
    `;

/**
 * __useBillAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useBillAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBillAutoSuggestQuery({
 *   billsListInput: // value for 'billsListInput'
 * });
 */
export function useBillAutoSuggestQuery(variables: BillAutoSuggestQueryVariables | VueCompositionApi.Ref<BillAutoSuggestQueryVariables> | ReactiveFunction<BillAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<BillAutoSuggestQuery, BillAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BillAutoSuggestQuery, BillAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BillAutoSuggestQuery, BillAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BillAutoSuggestQuery, BillAutoSuggestQueryVariables>(BillAutoSuggestDocument, variables, options);
}
export function useBillAutoSuggestLazyQuery(variables: BillAutoSuggestQueryVariables | VueCompositionApi.Ref<BillAutoSuggestQueryVariables> | ReactiveFunction<BillAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<BillAutoSuggestQuery, BillAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BillAutoSuggestQuery, BillAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BillAutoSuggestQuery, BillAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BillAutoSuggestQuery, BillAutoSuggestQueryVariables>(BillAutoSuggestDocument, variables, options);
}
export type BillAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BillAutoSuggestQuery, BillAutoSuggestQueryVariables>;
export const BookmarksDropdownDocument = gql`
    query bookmarksDropdown($filters: BookmarkFilterInput) {
  BookmarksList(input: $filters) {
    id
    name
    module
    owner {
      id
      name
      initials
    }
  }
}
    `;

/**
 * __useBookmarksDropdownQuery__
 *
 * To run a query within a Vue component, call `useBookmarksDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookmarksDropdownQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBookmarksDropdownQuery({
 *   filters: // value for 'filters'
 * });
 */
export function useBookmarksDropdownQuery(variables: BookmarksDropdownQueryVariables | VueCompositionApi.Ref<BookmarksDropdownQueryVariables> | ReactiveFunction<BookmarksDropdownQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<BookmarksDropdownQuery, BookmarksDropdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BookmarksDropdownQuery, BookmarksDropdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BookmarksDropdownQuery, BookmarksDropdownQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BookmarksDropdownQuery, BookmarksDropdownQueryVariables>(BookmarksDropdownDocument, variables, options);
}
export function useBookmarksDropdownLazyQuery(variables: BookmarksDropdownQueryVariables | VueCompositionApi.Ref<BookmarksDropdownQueryVariables> | ReactiveFunction<BookmarksDropdownQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<BookmarksDropdownQuery, BookmarksDropdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BookmarksDropdownQuery, BookmarksDropdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BookmarksDropdownQuery, BookmarksDropdownQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BookmarksDropdownQuery, BookmarksDropdownQueryVariables>(BookmarksDropdownDocument, variables, options);
}
export type BookmarksDropdownQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BookmarksDropdownQuery, BookmarksDropdownQueryVariables>;
export const BookmarksShortcutDocument = gql`
    query bookmarksShortcut {
  FavoriteBookmarks @persist {
    id
    name
    module
  }
}
    `;

/**
 * __useBookmarksShortcutQuery__
 *
 * To run a query within a Vue component, call `useBookmarksShortcutQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookmarksShortcutQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBookmarksShortcutQuery();
 */
export function useBookmarksShortcutQuery(options: VueApolloComposable.UseQueryOptions<BookmarksShortcutQuery, BookmarksShortcutQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BookmarksShortcutQuery, BookmarksShortcutQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BookmarksShortcutQuery, BookmarksShortcutQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BookmarksShortcutQuery, BookmarksShortcutQueryVariables>(BookmarksShortcutDocument, {}, options);
}
export function useBookmarksShortcutLazyQuery(options: VueApolloComposable.UseQueryOptions<BookmarksShortcutQuery, BookmarksShortcutQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BookmarksShortcutQuery, BookmarksShortcutQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BookmarksShortcutQuery, BookmarksShortcutQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BookmarksShortcutQuery, BookmarksShortcutQueryVariables>(BookmarksShortcutDocument, {}, options);
}
export type BookmarksShortcutQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BookmarksShortcutQuery, BookmarksShortcutQueryVariables>;
export const TimeOffDeleteDocument = gql`
    mutation timeOffDelete($input: TimeOffDeleteInput!) {
  TimeOffDelete(input: $input)
}
    `;

/**
 * __useTimeOffDeleteMutation__
 *
 * To run a mutation, you first call `useTimeOffDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTimeOffDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTimeOffDeleteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTimeOffDeleteMutation(options: VueApolloComposable.UseMutationOptions<TimeOffDeleteMutation, TimeOffDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TimeOffDeleteMutation, TimeOffDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TimeOffDeleteMutation, TimeOffDeleteMutationVariables>(TimeOffDeleteDocument, options);
}
export type TimeOffDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TimeOffDeleteMutation, TimeOffDeleteMutationVariables>;
export const TimeOffListPopoverDocument = gql`
    query timeOffListPopover($input: UserTimeOffListInput!) {
  UserTimeOffList(input: $input) {
    timeOff {
      endDate
      id
      reason
      startDate
      type {
        id
        displayName
        systemName
      }
      value
      externalSystem
    }
    user {
      id
      name
      initials
      hslColor
      profilePicture {
        mini
      }
    }
    value
    availability
    hasMultipleUsers
  }
}
    `;

/**
 * __useTimeOffListPopoverQuery__
 *
 * To run a query within a Vue component, call `useTimeOffListPopoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeOffListPopoverQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeOffListPopoverQuery({
 *   input: // value for 'input'
 * });
 */
export function useTimeOffListPopoverQuery(variables: TimeOffListPopoverQueryVariables | VueCompositionApi.Ref<TimeOffListPopoverQueryVariables> | ReactiveFunction<TimeOffListPopoverQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeOffListPopoverQuery, TimeOffListPopoverQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffListPopoverQuery, TimeOffListPopoverQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffListPopoverQuery, TimeOffListPopoverQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeOffListPopoverQuery, TimeOffListPopoverQueryVariables>(TimeOffListPopoverDocument, variables, options);
}
export function useTimeOffListPopoverLazyQuery(variables?: TimeOffListPopoverQueryVariables | VueCompositionApi.Ref<TimeOffListPopoverQueryVariables> | ReactiveFunction<TimeOffListPopoverQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeOffListPopoverQuery, TimeOffListPopoverQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffListPopoverQuery, TimeOffListPopoverQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffListPopoverQuery, TimeOffListPopoverQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeOffListPopoverQuery, TimeOffListPopoverQueryVariables>(TimeOffListPopoverDocument, variables, options);
}
export type TimeOffListPopoverQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeOffListPopoverQuery, TimeOffListPopoverQueryVariables>;
export const TimeOffModifyFormDocument = gql`
    query timeOffModifyForm($id: ID!) {
  TimeOffItem(id: $id) {
    timeOff {
      id
      type {
        id
        systemName
      }
      reason
      value
      startDate
      endDate
    }
    users {
      id
      name
    }
  }
}
    `;

/**
 * __useTimeOffModifyFormQuery__
 *
 * To run a query within a Vue component, call `useTimeOffModifyFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeOffModifyFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeOffModifyFormQuery({
 *   id: // value for 'id'
 * });
 */
export function useTimeOffModifyFormQuery(variables: TimeOffModifyFormQueryVariables | VueCompositionApi.Ref<TimeOffModifyFormQueryVariables> | ReactiveFunction<TimeOffModifyFormQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeOffModifyFormQuery, TimeOffModifyFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffModifyFormQuery, TimeOffModifyFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffModifyFormQuery, TimeOffModifyFormQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeOffModifyFormQuery, TimeOffModifyFormQueryVariables>(TimeOffModifyFormDocument, variables, options);
}
export function useTimeOffModifyFormLazyQuery(variables?: TimeOffModifyFormQueryVariables | VueCompositionApi.Ref<TimeOffModifyFormQueryVariables> | ReactiveFunction<TimeOffModifyFormQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeOffModifyFormQuery, TimeOffModifyFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffModifyFormQuery, TimeOffModifyFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffModifyFormQuery, TimeOffModifyFormQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeOffModifyFormQuery, TimeOffModifyFormQueryVariables>(TimeOffModifyFormDocument, variables, options);
}
export type TimeOffModifyFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeOffModifyFormQuery, TimeOffModifyFormQueryVariables>;
export const TimeOffModifyFormSaveDocument = gql`
    mutation timeOffModifyFormSave($input: TimeOffSaveInput!) {
  TimeOffSave(input: $input) {
    timeOff {
      endDate
      id
      reason
      startDate
      type {
        id
        systemName
      }
      value
    }
    users {
      id
      name
    }
  }
}
    `;

/**
 * __useTimeOffModifyFormSaveMutation__
 *
 * To run a mutation, you first call `useTimeOffModifyFormSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTimeOffModifyFormSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTimeOffModifyFormSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTimeOffModifyFormSaveMutation(options: VueApolloComposable.UseMutationOptions<TimeOffModifyFormSaveMutation, TimeOffModifyFormSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TimeOffModifyFormSaveMutation, TimeOffModifyFormSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TimeOffModifyFormSaveMutation, TimeOffModifyFormSaveMutationVariables>(TimeOffModifyFormSaveDocument, options);
}
export type TimeOffModifyFormSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TimeOffModifyFormSaveMutation, TimeOffModifyFormSaveMutationVariables>;
export const TimeOffTypeDocument = gql`
    query timeOffType($timeOffTypeInput: TimeOffTypesListFiltersInput!) {
  TimeOffTypesList(input: $timeOffTypeInput) {
    id
    displayName
    systemName
  }
}
    `;

/**
 * __useTimeOffTypeQuery__
 *
 * To run a query within a Vue component, call `useTimeOffTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeOffTypeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeOffTypeQuery({
 *   timeOffTypeInput: // value for 'timeOffTypeInput'
 * });
 */
export function useTimeOffTypeQuery(variables: TimeOffTypeQueryVariables | VueCompositionApi.Ref<TimeOffTypeQueryVariables> | ReactiveFunction<TimeOffTypeQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeOffTypeQuery, TimeOffTypeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffTypeQuery, TimeOffTypeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffTypeQuery, TimeOffTypeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeOffTypeQuery, TimeOffTypeQueryVariables>(TimeOffTypeDocument, variables, options);
}
export function useTimeOffTypeLazyQuery(variables?: TimeOffTypeQueryVariables | VueCompositionApi.Ref<TimeOffTypeQueryVariables> | ReactiveFunction<TimeOffTypeQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeOffTypeQuery, TimeOffTypeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffTypeQuery, TimeOffTypeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffTypeQuery, TimeOffTypeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeOffTypeQuery, TimeOffTypeQueryVariables>(TimeOffTypeDocument, variables, options);
}
export type TimeOffTypeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeOffTypeQuery, TimeOffTypeQueryVariables>;
export const TimeSpotterDocument = gql`
    query timeSpotter($input: FreeTimeSlotInput!) {
  FreeTimeSlotList(input: $input) {
    startDateTime
    endDateTime
    busyUserIds
  }
}
    `;

/**
 * __useTimeSpotterQuery__
 *
 * To run a query within a Vue component, call `useTimeSpotterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSpotterQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeSpotterQuery({
 *   input: // value for 'input'
 * });
 */
export function useTimeSpotterQuery(variables: TimeSpotterQueryVariables | VueCompositionApi.Ref<TimeSpotterQueryVariables> | ReactiveFunction<TimeSpotterQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeSpotterQuery, TimeSpotterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeSpotterQuery, TimeSpotterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeSpotterQuery, TimeSpotterQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeSpotterQuery, TimeSpotterQueryVariables>(TimeSpotterDocument, variables, options);
}
export function useTimeSpotterLazyQuery(variables?: TimeSpotterQueryVariables | VueCompositionApi.Ref<TimeSpotterQueryVariables> | ReactiveFunction<TimeSpotterQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeSpotterQuery, TimeSpotterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeSpotterQuery, TimeSpotterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeSpotterQuery, TimeSpotterQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeSpotterQuery, TimeSpotterQueryVariables>(TimeSpotterDocument, variables, options);
}
export type TimeSpotterQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeSpotterQuery, TimeSpotterQueryVariables>;
export const TimeSpotterUsersDocument = gql`
    query timeSpotterUsers($input: UsersListInput!) {
  UsersList(input: $input) {
    id
    name
    initials
    profilePicture {
      mini
    }
  }
}
    `;

/**
 * __useTimeSpotterUsersQuery__
 *
 * To run a query within a Vue component, call `useTimeSpotterUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSpotterUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeSpotterUsersQuery({
 *   input: // value for 'input'
 * });
 */
export function useTimeSpotterUsersQuery(variables: TimeSpotterUsersQueryVariables | VueCompositionApi.Ref<TimeSpotterUsersQueryVariables> | ReactiveFunction<TimeSpotterUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeSpotterUsersQuery, TimeSpotterUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeSpotterUsersQuery, TimeSpotterUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeSpotterUsersQuery, TimeSpotterUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeSpotterUsersQuery, TimeSpotterUsersQueryVariables>(TimeSpotterUsersDocument, variables, options);
}
export function useTimeSpotterUsersLazyQuery(variables?: TimeSpotterUsersQueryVariables | VueCompositionApi.Ref<TimeSpotterUsersQueryVariables> | ReactiveFunction<TimeSpotterUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeSpotterUsersQuery, TimeSpotterUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeSpotterUsersQuery, TimeSpotterUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeSpotterUsersQuery, TimeSpotterUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeSpotterUsersQuery, TimeSpotterUsersQueryVariables>(TimeSpotterUsersDocument, variables, options);
}
export type TimeSpotterUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeSpotterUsersQuery, TimeSpotterUsersQueryVariables>;
export const ClientProfileAutoSuggestDocument = gql`
    query clientProfileAutoSuggest($name: String) {
  ClientProfilesList(name: $name) {
    id
    name
  }
}
    `;

/**
 * __useClientProfileAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useClientProfileAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientProfileAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientProfileAutoSuggestQuery({
 *   name: // value for 'name'
 * });
 */
export function useClientProfileAutoSuggestQuery(variables: ClientProfileAutoSuggestQueryVariables | VueCompositionApi.Ref<ClientProfileAutoSuggestQueryVariables> | ReactiveFunction<ClientProfileAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ClientProfileAutoSuggestQuery, ClientProfileAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ClientProfileAutoSuggestQuery, ClientProfileAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ClientProfileAutoSuggestQuery, ClientProfileAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ClientProfileAutoSuggestQuery, ClientProfileAutoSuggestQueryVariables>(ClientProfileAutoSuggestDocument, variables, options);
}
export function useClientProfileAutoSuggestLazyQuery(variables: ClientProfileAutoSuggestQueryVariables | VueCompositionApi.Ref<ClientProfileAutoSuggestQueryVariables> | ReactiveFunction<ClientProfileAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ClientProfileAutoSuggestQuery, ClientProfileAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ClientProfileAutoSuggestQuery, ClientProfileAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ClientProfileAutoSuggestQuery, ClientProfileAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ClientProfileAutoSuggestQuery, ClientProfileAutoSuggestQueryVariables>(ClientProfileAutoSuggestDocument, variables, options);
}
export type ClientProfileAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ClientProfileAutoSuggestQuery, ClientProfileAutoSuggestQueryVariables>;
export const CommentReactionChangeDocument = gql`
    mutation commentReactionChange($input: CommentReactionMutationInput!) {
  CommentReactionMutation(input: $input) {
    id
    reactionCode
    isActive
    userIds
  }
}
    `;

/**
 * __useCommentReactionChangeMutation__
 *
 * To run a mutation, you first call `useCommentReactionChangeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCommentReactionChangeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCommentReactionChangeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCommentReactionChangeMutation(options: VueApolloComposable.UseMutationOptions<CommentReactionChangeMutation, CommentReactionChangeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CommentReactionChangeMutation, CommentReactionChangeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CommentReactionChangeMutation, CommentReactionChangeMutationVariables>(CommentReactionChangeDocument, options);
}
export type CommentReactionChangeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CommentReactionChangeMutation, CommentReactionChangeMutationVariables>;
export const CommentReactionUsersDocument = gql`
    query commentReactionUsers($usersListInput: UsersListInput) {
  UsersList(input: $usersListInput) {
    id
    name
  }
}
    `;

/**
 * __useCommentReactionUsersQuery__
 *
 * To run a query within a Vue component, call `useCommentReactionUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentReactionUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCommentReactionUsersQuery({
 *   usersListInput: // value for 'usersListInput'
 * });
 */
export function useCommentReactionUsersQuery(variables: CommentReactionUsersQueryVariables | VueCompositionApi.Ref<CommentReactionUsersQueryVariables> | ReactiveFunction<CommentReactionUsersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CommentReactionUsersQuery, CommentReactionUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommentReactionUsersQuery, CommentReactionUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommentReactionUsersQuery, CommentReactionUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CommentReactionUsersQuery, CommentReactionUsersQueryVariables>(CommentReactionUsersDocument, variables, options);
}
export function useCommentReactionUsersLazyQuery(variables: CommentReactionUsersQueryVariables | VueCompositionApi.Ref<CommentReactionUsersQueryVariables> | ReactiveFunction<CommentReactionUsersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CommentReactionUsersQuery, CommentReactionUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommentReactionUsersQuery, CommentReactionUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommentReactionUsersQuery, CommentReactionUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CommentReactionUsersQuery, CommentReactionUsersQueryVariables>(CommentReactionUsersDocument, variables, options);
}
export type CommentReactionUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CommentReactionUsersQuery, CommentReactionUsersQueryVariables>;
export const CommentReactionsDocument = gql`
    query commentReactions($commentId: Int!) {
  CommentReactions(commentId: $commentId) {
    id
    reactionCode
    isActive
    userIds
  }
}
    `;

/**
 * __useCommentReactionsQuery__
 *
 * To run a query within a Vue component, call `useCommentReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentReactionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCommentReactionsQuery({
 *   commentId: // value for 'commentId'
 * });
 */
export function useCommentReactionsQuery(variables: CommentReactionsQueryVariables | VueCompositionApi.Ref<CommentReactionsQueryVariables> | ReactiveFunction<CommentReactionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommentReactionsQuery, CommentReactionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommentReactionsQuery, CommentReactionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommentReactionsQuery, CommentReactionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CommentReactionsQuery, CommentReactionsQueryVariables>(CommentReactionsDocument, variables, options);
}
export function useCommentReactionsLazyQuery(variables?: CommentReactionsQueryVariables | VueCompositionApi.Ref<CommentReactionsQueryVariables> | ReactiveFunction<CommentReactionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommentReactionsQuery, CommentReactionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommentReactionsQuery, CommentReactionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommentReactionsQuery, CommentReactionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CommentReactionsQuery, CommentReactionsQueryVariables>(CommentReactionsDocument, variables, options);
}
export type CommentReactionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CommentReactionsQuery, CommentReactionsQueryVariables>;
export const ContactAutoSuggestDocument = gql`
    query contactAutoSuggest($contactsListInput: ContactsListInput, $includeType: Boolean!) {
  ContactsList(input: $contactsListInput) {
    id
    name
    type @include(if: $includeType)
  }
}
    `;

/**
 * __useContactAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useContactAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContactAutoSuggestQuery({
 *   contactsListInput: // value for 'contactsListInput'
 *   includeType: // value for 'includeType'
 * });
 */
export function useContactAutoSuggestQuery(variables: ContactAutoSuggestQueryVariables | VueCompositionApi.Ref<ContactAutoSuggestQueryVariables> | ReactiveFunction<ContactAutoSuggestQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContactAutoSuggestQuery, ContactAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContactAutoSuggestQuery, ContactAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContactAutoSuggestQuery, ContactAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContactAutoSuggestQuery, ContactAutoSuggestQueryVariables>(ContactAutoSuggestDocument, variables, options);
}
export function useContactAutoSuggestLazyQuery(variables?: ContactAutoSuggestQueryVariables | VueCompositionApi.Ref<ContactAutoSuggestQueryVariables> | ReactiveFunction<ContactAutoSuggestQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContactAutoSuggestQuery, ContactAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContactAutoSuggestQuery, ContactAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContactAutoSuggestQuery, ContactAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContactAutoSuggestQuery, ContactAutoSuggestQueryVariables>(ContactAutoSuggestDocument, variables, options);
}
export type ContactAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContactAutoSuggestQuery, ContactAutoSuggestQueryVariables>;
export const ContactCategoryAutoSuggestDocument = gql`
    query contactCategoryAutoSuggest($name: String) {
  ContactCategoriesList(name: $name) {
    id
    name
    description
  }
}
    `;

/**
 * __useContactCategoryAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useContactCategoryAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCategoryAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContactCategoryAutoSuggestQuery({
 *   name: // value for 'name'
 * });
 */
export function useContactCategoryAutoSuggestQuery(variables: ContactCategoryAutoSuggestQueryVariables | VueCompositionApi.Ref<ContactCategoryAutoSuggestQueryVariables> | ReactiveFunction<ContactCategoryAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ContactCategoryAutoSuggestQuery, ContactCategoryAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContactCategoryAutoSuggestQuery, ContactCategoryAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContactCategoryAutoSuggestQuery, ContactCategoryAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContactCategoryAutoSuggestQuery, ContactCategoryAutoSuggestQueryVariables>(ContactCategoryAutoSuggestDocument, variables, options);
}
export function useContactCategoryAutoSuggestLazyQuery(variables: ContactCategoryAutoSuggestQueryVariables | VueCompositionApi.Ref<ContactCategoryAutoSuggestQueryVariables> | ReactiveFunction<ContactCategoryAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ContactCategoryAutoSuggestQuery, ContactCategoryAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContactCategoryAutoSuggestQuery, ContactCategoryAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContactCategoryAutoSuggestQuery, ContactCategoryAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContactCategoryAutoSuggestQuery, ContactCategoryAutoSuggestQueryVariables>(ContactCategoryAutoSuggestDocument, variables, options);
}
export type ContactCategoryAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContactCategoryAutoSuggestQuery, ContactCategoryAutoSuggestQueryVariables>;
export const EliChatHistoryDocument = gql`
    query eliChatHistory($input: EliChatHistoryInput!) {
  EliChatHistory(input: $input) {
    messageId
    threadId
    response
    messageType
  }
}
    `;

/**
 * __useEliChatHistoryQuery__
 *
 * To run a query within a Vue component, call `useEliChatHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEliChatHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEliChatHistoryQuery({
 *   input: // value for 'input'
 * });
 */
export function useEliChatHistoryQuery(variables: EliChatHistoryQueryVariables | VueCompositionApi.Ref<EliChatHistoryQueryVariables> | ReactiveFunction<EliChatHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliChatHistoryQuery, EliChatHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliChatHistoryQuery, EliChatHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliChatHistoryQuery, EliChatHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EliChatHistoryQuery, EliChatHistoryQueryVariables>(EliChatHistoryDocument, variables, options);
}
export function useEliChatHistoryLazyQuery(variables?: EliChatHistoryQueryVariables | VueCompositionApi.Ref<EliChatHistoryQueryVariables> | ReactiveFunction<EliChatHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliChatHistoryQuery, EliChatHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliChatHistoryQuery, EliChatHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliChatHistoryQuery, EliChatHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EliChatHistoryQuery, EliChatHistoryQueryVariables>(EliChatHistoryDocument, variables, options);
}
export type EliChatHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EliChatHistoryQuery, EliChatHistoryQueryVariables>;
export const EliMessageRateDocument = gql`
    mutation eliMessageRate($input: EliMessageRateInput!) {
  EliMessageRate(input: $input)
}
    `;

/**
 * __useEliMessageRateMutation__
 *
 * To run a mutation, you first call `useEliMessageRateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEliMessageRateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEliMessageRateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEliMessageRateMutation(options: VueApolloComposable.UseMutationOptions<EliMessageRateMutation, EliMessageRateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EliMessageRateMutation, EliMessageRateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EliMessageRateMutation, EliMessageRateMutationVariables>(EliMessageRateDocument, options);
}
export type EliMessageRateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EliMessageRateMutation, EliMessageRateMutationVariables>;
export const EliWelcomeMessageDocument = gql`
    query eliWelcomeMessage($input: EliWelcomeMessageInput!) {
  EliWelcomeMessage(input: $input)
}
    `;

/**
 * __useEliWelcomeMessageQuery__
 *
 * To run a query within a Vue component, call `useEliWelcomeMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEliWelcomeMessageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEliWelcomeMessageQuery({
 *   input: // value for 'input'
 * });
 */
export function useEliWelcomeMessageQuery(variables: EliWelcomeMessageQueryVariables | VueCompositionApi.Ref<EliWelcomeMessageQueryVariables> | ReactiveFunction<EliWelcomeMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliWelcomeMessageQuery, EliWelcomeMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliWelcomeMessageQuery, EliWelcomeMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliWelcomeMessageQuery, EliWelcomeMessageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EliWelcomeMessageQuery, EliWelcomeMessageQueryVariables>(EliWelcomeMessageDocument, variables, options);
}
export function useEliWelcomeMessageLazyQuery(variables?: EliWelcomeMessageQueryVariables | VueCompositionApi.Ref<EliWelcomeMessageQueryVariables> | ReactiveFunction<EliWelcomeMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliWelcomeMessageQuery, EliWelcomeMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliWelcomeMessageQuery, EliWelcomeMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliWelcomeMessageQuery, EliWelcomeMessageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EliWelcomeMessageQuery, EliWelcomeMessageQueryVariables>(EliWelcomeMessageDocument, variables, options);
}
export type EliWelcomeMessageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EliWelcomeMessageQuery, EliWelcomeMessageQueryVariables>;
export const EliChatThreadHistoryDocument = gql`
    query eliChatThreadHistory {
  EliChatThreadHistory {
    threadId
    title
  }
}
    `;

/**
 * __useEliChatThreadHistoryQuery__
 *
 * To run a query within a Vue component, call `useEliChatThreadHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEliChatThreadHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEliChatThreadHistoryQuery();
 */
export function useEliChatThreadHistoryQuery(options: VueApolloComposable.UseQueryOptions<EliChatThreadHistoryQuery, EliChatThreadHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliChatThreadHistoryQuery, EliChatThreadHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliChatThreadHistoryQuery, EliChatThreadHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EliChatThreadHistoryQuery, EliChatThreadHistoryQueryVariables>(EliChatThreadHistoryDocument, {}, options);
}
export function useEliChatThreadHistoryLazyQuery(options: VueApolloComposable.UseQueryOptions<EliChatThreadHistoryQuery, EliChatThreadHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliChatThreadHistoryQuery, EliChatThreadHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliChatThreadHistoryQuery, EliChatThreadHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EliChatThreadHistoryQuery, EliChatThreadHistoryQueryVariables>(EliChatThreadHistoryDocument, {}, options);
}
export type EliChatThreadHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EliChatThreadHistoryQuery, EliChatThreadHistoryQueryVariables>;
export const EliChatMessageDocument = gql`
    query eliChatMessage($input: EliChatMessageInput!) {
  EliChatMessage(input: $input) {
    response
    messageId
    threadId
    nextActions
    feedback
  }
}
    `;

/**
 * __useEliChatMessageQuery__
 *
 * To run a query within a Vue component, call `useEliChatMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEliChatMessageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEliChatMessageQuery({
 *   input: // value for 'input'
 * });
 */
export function useEliChatMessageQuery(variables: EliChatMessageQueryVariables | VueCompositionApi.Ref<EliChatMessageQueryVariables> | ReactiveFunction<EliChatMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliChatMessageQuery, EliChatMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliChatMessageQuery, EliChatMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliChatMessageQuery, EliChatMessageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EliChatMessageQuery, EliChatMessageQueryVariables>(EliChatMessageDocument, variables, options);
}
export function useEliChatMessageLazyQuery(variables?: EliChatMessageQueryVariables | VueCompositionApi.Ref<EliChatMessageQueryVariables> | ReactiveFunction<EliChatMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliChatMessageQuery, EliChatMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliChatMessageQuery, EliChatMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliChatMessageQuery, EliChatMessageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EliChatMessageQuery, EliChatMessageQueryVariables>(EliChatMessageDocument, variables, options);
}
export type EliChatMessageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EliChatMessageQuery, EliChatMessageQueryVariables>;
export const EliInsightsBookmarkDocument = gql`
    query eliInsightsBookmark($input: EliInsightsBookmarkInput!) {
  EliInsightsBookmark(input: $input) {
    module
    moduleTranslatedName
    name
    url
  }
}
    `;

/**
 * __useEliInsightsBookmarkQuery__
 *
 * To run a query within a Vue component, call `useEliInsightsBookmarkQuery` and pass it any options that fit your needs.
 * When your component renders, `useEliInsightsBookmarkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEliInsightsBookmarkQuery({
 *   input: // value for 'input'
 * });
 */
export function useEliInsightsBookmarkQuery(variables: EliInsightsBookmarkQueryVariables | VueCompositionApi.Ref<EliInsightsBookmarkQueryVariables> | ReactiveFunction<EliInsightsBookmarkQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliInsightsBookmarkQuery, EliInsightsBookmarkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliInsightsBookmarkQuery, EliInsightsBookmarkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliInsightsBookmarkQuery, EliInsightsBookmarkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EliInsightsBookmarkQuery, EliInsightsBookmarkQueryVariables>(EliInsightsBookmarkDocument, variables, options);
}
export function useEliInsightsBookmarkLazyQuery(variables?: EliInsightsBookmarkQueryVariables | VueCompositionApi.Ref<EliInsightsBookmarkQueryVariables> | ReactiveFunction<EliInsightsBookmarkQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliInsightsBookmarkQuery, EliInsightsBookmarkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliInsightsBookmarkQuery, EliInsightsBookmarkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliInsightsBookmarkQuery, EliInsightsBookmarkQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EliInsightsBookmarkQuery, EliInsightsBookmarkQueryVariables>(EliInsightsBookmarkDocument, variables, options);
}
export type EliInsightsBookmarkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EliInsightsBookmarkQuery, EliInsightsBookmarkQueryVariables>;
export const EliInsightsDropdownDocument = gql`
    query eliInsightsDropdown($limit: Int!) {
  EliInsightsHistory(limit: $limit) {
    question
    bookmark {
      module
      moduleTranslatedName
      name
      url
    }
  }
}
    `;

/**
 * __useEliInsightsDropdownQuery__
 *
 * To run a query within a Vue component, call `useEliInsightsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useEliInsightsDropdownQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEliInsightsDropdownQuery({
 *   limit: // value for 'limit'
 * });
 */
export function useEliInsightsDropdownQuery(variables: EliInsightsDropdownQueryVariables | VueCompositionApi.Ref<EliInsightsDropdownQueryVariables> | ReactiveFunction<EliInsightsDropdownQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliInsightsDropdownQuery, EliInsightsDropdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliInsightsDropdownQuery, EliInsightsDropdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliInsightsDropdownQuery, EliInsightsDropdownQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EliInsightsDropdownQuery, EliInsightsDropdownQueryVariables>(EliInsightsDropdownDocument, variables, options);
}
export function useEliInsightsDropdownLazyQuery(variables?: EliInsightsDropdownQueryVariables | VueCompositionApi.Ref<EliInsightsDropdownQueryVariables> | ReactiveFunction<EliInsightsDropdownQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliInsightsDropdownQuery, EliInsightsDropdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliInsightsDropdownQuery, EliInsightsDropdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliInsightsDropdownQuery, EliInsightsDropdownQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EliInsightsDropdownQuery, EliInsightsDropdownQueryVariables>(EliInsightsDropdownDocument, variables, options);
}
export type EliInsightsDropdownQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EliInsightsDropdownQuery, EliInsightsDropdownQueryVariables>;
export const EliInsightsModulesDocument = gql`
    query eliInsightsModules($input: EliInsightsModulesInput!) {
  EliInsightsModules(input: $input) {
    ... on EliInsightsModulesResponse {
      module
      moduleTranslatedName
    }
    ... on EliInsightsMessageResponse {
      message
    }
  }
}
    `;

/**
 * __useEliInsightsModulesQuery__
 *
 * To run a query within a Vue component, call `useEliInsightsModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEliInsightsModulesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEliInsightsModulesQuery({
 *   input: // value for 'input'
 * });
 */
export function useEliInsightsModulesQuery(variables: EliInsightsModulesQueryVariables | VueCompositionApi.Ref<EliInsightsModulesQueryVariables> | ReactiveFunction<EliInsightsModulesQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliInsightsModulesQuery, EliInsightsModulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliInsightsModulesQuery, EliInsightsModulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliInsightsModulesQuery, EliInsightsModulesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EliInsightsModulesQuery, EliInsightsModulesQueryVariables>(EliInsightsModulesDocument, variables, options);
}
export function useEliInsightsModulesLazyQuery(variables?: EliInsightsModulesQueryVariables | VueCompositionApi.Ref<EliInsightsModulesQueryVariables> | ReactiveFunction<EliInsightsModulesQueryVariables>, options: VueApolloComposable.UseQueryOptions<EliInsightsModulesQuery, EliInsightsModulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliInsightsModulesQuery, EliInsightsModulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliInsightsModulesQuery, EliInsightsModulesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EliInsightsModulesQuery, EliInsightsModulesQueryVariables>(EliInsightsModulesDocument, variables, options);
}
export type EliInsightsModulesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EliInsightsModulesQuery, EliInsightsModulesQueryVariables>;
export const EliInsightsRateDocument = gql`
    mutation eliInsightsRate($input: EliInsightsRateInput!) {
  EliInsightsRate(input: $input)
}
    `;

/**
 * __useEliInsightsRateMutation__
 *
 * To run a mutation, you first call `useEliInsightsRateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEliInsightsRateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEliInsightsRateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEliInsightsRateMutation(options: VueApolloComposable.UseMutationOptions<EliInsightsRateMutation, EliInsightsRateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EliInsightsRateMutation, EliInsightsRateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EliInsightsRateMutation, EliInsightsRateMutationVariables>(EliInsightsRateDocument, options);
}
export type EliInsightsRateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EliInsightsRateMutation, EliInsightsRateMutationVariables>;
export const EliInsightsMetricsDocument = gql`
    query eliInsightsMetrics {
  EliInsightsMetrics {
    id
    value
    title
    secondaryValue
    secondaryDescription
    type
  }
}
    `;

/**
 * __useEliInsightsMetricsQuery__
 *
 * To run a query within a Vue component, call `useEliInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEliInsightsMetricsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEliInsightsMetricsQuery();
 */
export function useEliInsightsMetricsQuery(options: VueApolloComposable.UseQueryOptions<EliInsightsMetricsQuery, EliInsightsMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliInsightsMetricsQuery, EliInsightsMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliInsightsMetricsQuery, EliInsightsMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EliInsightsMetricsQuery, EliInsightsMetricsQueryVariables>(EliInsightsMetricsDocument, {}, options);
}
export function useEliInsightsMetricsLazyQuery(options: VueApolloComposable.UseQueryOptions<EliInsightsMetricsQuery, EliInsightsMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliInsightsMetricsQuery, EliInsightsMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliInsightsMetricsQuery, EliInsightsMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EliInsightsMetricsQuery, EliInsightsMetricsQueryVariables>(EliInsightsMetricsDocument, {}, options);
}
export type EliInsightsMetricsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EliInsightsMetricsQuery, EliInsightsMetricsQueryVariables>;
export const EliUsageMetricsDocument = gql`
    query eliUsageMetrics {
  EliUsageMetrics {
    id
    value
    title
    secondaryValue
    secondaryDescription
    type
  }
}
    `;

/**
 * __useEliUsageMetricsQuery__
 *
 * To run a query within a Vue component, call `useEliUsageMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEliUsageMetricsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEliUsageMetricsQuery();
 */
export function useEliUsageMetricsQuery(options: VueApolloComposable.UseQueryOptions<EliUsageMetricsQuery, EliUsageMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliUsageMetricsQuery, EliUsageMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliUsageMetricsQuery, EliUsageMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EliUsageMetricsQuery, EliUsageMetricsQueryVariables>(EliUsageMetricsDocument, {}, options);
}
export function useEliUsageMetricsLazyQuery(options: VueApolloComposable.UseQueryOptions<EliUsageMetricsQuery, EliUsageMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EliUsageMetricsQuery, EliUsageMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EliUsageMetricsQuery, EliUsageMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EliUsageMetricsQuery, EliUsageMetricsQueryVariables>(EliUsageMetricsDocument, {}, options);
}
export type EliUsageMetricsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EliUsageMetricsQuery, EliUsageMetricsQueryVariables>;
export const DomainAddOnPriceDocument = gql`
    query domainAddOnPrice($featureId: Int!) {
  SelfServiceAddOnPrice(featureId: $featureId) {
    sum
    currency
  }
}
    `;

/**
 * __useDomainAddOnPriceQuery__
 *
 * To run a query within a Vue component, call `useDomainAddOnPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainAddOnPriceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDomainAddOnPriceQuery({
 *   featureId: // value for 'featureId'
 * });
 */
export function useDomainAddOnPriceQuery(variables: DomainAddOnPriceQueryVariables | VueCompositionApi.Ref<DomainAddOnPriceQueryVariables> | ReactiveFunction<DomainAddOnPriceQueryVariables>, options: VueApolloComposable.UseQueryOptions<DomainAddOnPriceQuery, DomainAddOnPriceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DomainAddOnPriceQuery, DomainAddOnPriceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DomainAddOnPriceQuery, DomainAddOnPriceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DomainAddOnPriceQuery, DomainAddOnPriceQueryVariables>(DomainAddOnPriceDocument, variables, options);
}
export function useDomainAddOnPriceLazyQuery(variables?: DomainAddOnPriceQueryVariables | VueCompositionApi.Ref<DomainAddOnPriceQueryVariables> | ReactiveFunction<DomainAddOnPriceQueryVariables>, options: VueApolloComposable.UseQueryOptions<DomainAddOnPriceQuery, DomainAddOnPriceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DomainAddOnPriceQuery, DomainAddOnPriceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DomainAddOnPriceQuery, DomainAddOnPriceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DomainAddOnPriceQuery, DomainAddOnPriceQueryVariables>(DomainAddOnPriceDocument, variables, options);
}
export type DomainAddOnPriceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DomainAddOnPriceQuery, DomainAddOnPriceQueryVariables>;
export const EmailServiceSettingsEmailDomainAddDocument = gql`
    mutation emailServiceSettingsEmailDomainAdd($input: EmailDomainAddInput!) {
  EmailDomainAdd(input: $input) {
    ...EmailServiceSettingsEmailDomain
  }
}
    ${EmailServiceSettingsEmailDomainFragmentDoc}`;

/**
 * __useEmailServiceSettingsEmailDomainAddMutation__
 *
 * To run a mutation, you first call `useEmailServiceSettingsEmailDomainAddMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEmailServiceSettingsEmailDomainAddMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEmailServiceSettingsEmailDomainAddMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEmailServiceSettingsEmailDomainAddMutation(options: VueApolloComposable.UseMutationOptions<EmailServiceSettingsEmailDomainAddMutation, EmailServiceSettingsEmailDomainAddMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EmailServiceSettingsEmailDomainAddMutation, EmailServiceSettingsEmailDomainAddMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EmailServiceSettingsEmailDomainAddMutation, EmailServiceSettingsEmailDomainAddMutationVariables>(EmailServiceSettingsEmailDomainAddDocument, options);
}
export type EmailServiceSettingsEmailDomainAddMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EmailServiceSettingsEmailDomainAddMutation, EmailServiceSettingsEmailDomainAddMutationVariables>;
export const EmailServiceSettingsEmailDomainDeleteDocument = gql`
    mutation emailServiceSettingsEmailDomainDelete($input: EmailDomainDeleteInput!) {
  EmailDomainDelete(input: $input)
}
    `;

/**
 * __useEmailServiceSettingsEmailDomainDeleteMutation__
 *
 * To run a mutation, you first call `useEmailServiceSettingsEmailDomainDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEmailServiceSettingsEmailDomainDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEmailServiceSettingsEmailDomainDeleteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEmailServiceSettingsEmailDomainDeleteMutation(options: VueApolloComposable.UseMutationOptions<EmailServiceSettingsEmailDomainDeleteMutation, EmailServiceSettingsEmailDomainDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EmailServiceSettingsEmailDomainDeleteMutation, EmailServiceSettingsEmailDomainDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EmailServiceSettingsEmailDomainDeleteMutation, EmailServiceSettingsEmailDomainDeleteMutationVariables>(EmailServiceSettingsEmailDomainDeleteDocument, options);
}
export type EmailServiceSettingsEmailDomainDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EmailServiceSettingsEmailDomainDeleteMutation, EmailServiceSettingsEmailDomainDeleteMutationVariables>;
export const EmailServiceSettingsEmailDomainVerifyDocument = gql`
    mutation emailServiceSettingsEmailDomainVerify($input: EmailDomainVerifyInput!) {
  EmailDomainVerify(input: $input)
}
    `;

/**
 * __useEmailServiceSettingsEmailDomainVerifyMutation__
 *
 * To run a mutation, you first call `useEmailServiceSettingsEmailDomainVerifyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEmailServiceSettingsEmailDomainVerifyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEmailServiceSettingsEmailDomainVerifyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEmailServiceSettingsEmailDomainVerifyMutation(options: VueApolloComposable.UseMutationOptions<EmailServiceSettingsEmailDomainVerifyMutation, EmailServiceSettingsEmailDomainVerifyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EmailServiceSettingsEmailDomainVerifyMutation, EmailServiceSettingsEmailDomainVerifyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EmailServiceSettingsEmailDomainVerifyMutation, EmailServiceSettingsEmailDomainVerifyMutationVariables>(EmailServiceSettingsEmailDomainVerifyDocument, options);
}
export type EmailServiceSettingsEmailDomainVerifyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EmailServiceSettingsEmailDomainVerifyMutation, EmailServiceSettingsEmailDomainVerifyMutationVariables>;
export const EmailServiceSettingsEmailDomainsDocument = gql`
    query emailServiceSettingsEmailDomains {
  EmailDomains {
    ...EmailServiceSettingsEmailDomain
  }
}
    ${EmailServiceSettingsEmailDomainFragmentDoc}`;

/**
 * __useEmailServiceSettingsEmailDomainsQuery__
 *
 * To run a query within a Vue component, call `useEmailServiceSettingsEmailDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailServiceSettingsEmailDomainsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEmailServiceSettingsEmailDomainsQuery();
 */
export function useEmailServiceSettingsEmailDomainsQuery(options: VueApolloComposable.UseQueryOptions<EmailServiceSettingsEmailDomainsQuery, EmailServiceSettingsEmailDomainsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EmailServiceSettingsEmailDomainsQuery, EmailServiceSettingsEmailDomainsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EmailServiceSettingsEmailDomainsQuery, EmailServiceSettingsEmailDomainsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EmailServiceSettingsEmailDomainsQuery, EmailServiceSettingsEmailDomainsQueryVariables>(EmailServiceSettingsEmailDomainsDocument, {}, options);
}
export function useEmailServiceSettingsEmailDomainsLazyQuery(options: VueApolloComposable.UseQueryOptions<EmailServiceSettingsEmailDomainsQuery, EmailServiceSettingsEmailDomainsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EmailServiceSettingsEmailDomainsQuery, EmailServiceSettingsEmailDomainsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EmailServiceSettingsEmailDomainsQuery, EmailServiceSettingsEmailDomainsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EmailServiceSettingsEmailDomainsQuery, EmailServiceSettingsEmailDomainsQueryVariables>(EmailServiceSettingsEmailDomainsDocument, {}, options);
}
export type EmailServiceSettingsEmailDomainsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EmailServiceSettingsEmailDomainsQuery, EmailServiceSettingsEmailDomainsQueryVariables>;
export const AutoSuggestCalendarEventsDocument = gql`
    query autoSuggestCalendarEvents($calendarEventsListInput: CalendarEventsListInput) {
  CalendarEventsList(input: $calendarEventsListInput) {
    id
    name
  }
}
    `;

/**
 * __useAutoSuggestCalendarEventsQuery__
 *
 * To run a query within a Vue component, call `useAutoSuggestCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoSuggestCalendarEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutoSuggestCalendarEventsQuery({
 *   calendarEventsListInput: // value for 'calendarEventsListInput'
 * });
 */
export function useAutoSuggestCalendarEventsQuery(variables: AutoSuggestCalendarEventsQueryVariables | VueCompositionApi.Ref<AutoSuggestCalendarEventsQueryVariables> | ReactiveFunction<AutoSuggestCalendarEventsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AutoSuggestCalendarEventsQuery, AutoSuggestCalendarEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AutoSuggestCalendarEventsQuery, AutoSuggestCalendarEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AutoSuggestCalendarEventsQuery, AutoSuggestCalendarEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AutoSuggestCalendarEventsQuery, AutoSuggestCalendarEventsQueryVariables>(AutoSuggestCalendarEventsDocument, variables, options);
}
export function useAutoSuggestCalendarEventsLazyQuery(variables: AutoSuggestCalendarEventsQueryVariables | VueCompositionApi.Ref<AutoSuggestCalendarEventsQueryVariables> | ReactiveFunction<AutoSuggestCalendarEventsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AutoSuggestCalendarEventsQuery, AutoSuggestCalendarEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AutoSuggestCalendarEventsQuery, AutoSuggestCalendarEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AutoSuggestCalendarEventsQuery, AutoSuggestCalendarEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AutoSuggestCalendarEventsQuery, AutoSuggestCalendarEventsQueryVariables>(AutoSuggestCalendarEventsDocument, variables, options);
}
export type AutoSuggestCalendarEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AutoSuggestCalendarEventsQuery, AutoSuggestCalendarEventsQueryVariables>;
export const ExpenseAutoSuggestDocument = gql`
    query expenseAutoSuggest($expensesListInput: FinanceDocumentsListInput) {
  ExpensesList(input: $expensesListInput) {
    id
    number
    mainContact {
      name
    }
  }
}
    `;

/**
 * __useExpenseAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useExpenseAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExpenseAutoSuggestQuery({
 *   expensesListInput: // value for 'expensesListInput'
 * });
 */
export function useExpenseAutoSuggestQuery(variables: ExpenseAutoSuggestQueryVariables | VueCompositionApi.Ref<ExpenseAutoSuggestQueryVariables> | ReactiveFunction<ExpenseAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ExpenseAutoSuggestQuery, ExpenseAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpenseAutoSuggestQuery, ExpenseAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpenseAutoSuggestQuery, ExpenseAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExpenseAutoSuggestQuery, ExpenseAutoSuggestQueryVariables>(ExpenseAutoSuggestDocument, variables, options);
}
export function useExpenseAutoSuggestLazyQuery(variables: ExpenseAutoSuggestQueryVariables | VueCompositionApi.Ref<ExpenseAutoSuggestQueryVariables> | ReactiveFunction<ExpenseAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ExpenseAutoSuggestQuery, ExpenseAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpenseAutoSuggestQuery, ExpenseAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpenseAutoSuggestQuery, ExpenseAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExpenseAutoSuggestQuery, ExpenseAutoSuggestQueryVariables>(ExpenseAutoSuggestDocument, variables, options);
}
export type ExpenseAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExpenseAutoSuggestQuery, ExpenseAutoSuggestQueryVariables>;
export const ChecklistItemSetAsDoneDocument = gql`
    mutation checklistItemSetAsDone($input: ChecklistSaveInput!) {
  ChecklistItemSetAsDone(input: $input) {
    id
    type
    item
    isDone
  }
}
    `;

/**
 * __useChecklistItemSetAsDoneMutation__
 *
 * To run a mutation, you first call `useChecklistItemSetAsDoneMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChecklistItemSetAsDoneMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChecklistItemSetAsDoneMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useChecklistItemSetAsDoneMutation(options: VueApolloComposable.UseMutationOptions<ChecklistItemSetAsDoneMutation, ChecklistItemSetAsDoneMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChecklistItemSetAsDoneMutation, ChecklistItemSetAsDoneMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChecklistItemSetAsDoneMutation, ChecklistItemSetAsDoneMutationVariables>(ChecklistItemSetAsDoneDocument, options);
}
export type ChecklistItemSetAsDoneMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChecklistItemSetAsDoneMutation, ChecklistItemSetAsDoneMutationVariables>;
export const ChecklistItemsDocument = gql`
    query ChecklistItems($type: String!) {
  ChecklistItems(input: {type: $type}) {
    id
    type
    item
    isDone
  }
}
    `;

/**
 * __useChecklistItemsQuery__
 *
 * To run a query within a Vue component, call `useChecklistItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChecklistItemsQuery({
 *   type: // value for 'type'
 * });
 */
export function useChecklistItemsQuery(variables: ChecklistItemsQueryVariables | VueCompositionApi.Ref<ChecklistItemsQueryVariables> | ReactiveFunction<ChecklistItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChecklistItemsQuery, ChecklistItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChecklistItemsQuery, ChecklistItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChecklistItemsQuery, ChecklistItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChecklistItemsQuery, ChecklistItemsQueryVariables>(ChecklistItemsDocument, variables, options);
}
export function useChecklistItemsLazyQuery(variables?: ChecklistItemsQueryVariables | VueCompositionApi.Ref<ChecklistItemsQueryVariables> | ReactiveFunction<ChecklistItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChecklistItemsQuery, ChecklistItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChecklistItemsQuery, ChecklistItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChecklistItemsQuery, ChecklistItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChecklistItemsQuery, ChecklistItemsQueryVariables>(ChecklistItemsDocument, variables, options);
}
export type ChecklistItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChecklistItemsQuery, ChecklistItemsQueryVariables>;
export const GetStartedMilestonesDocument = gql`
    query getStartedMilestones {
  GetStartedMilestones {
    milestone
    isReached
  }
}
    `;

/**
 * __useGetStartedMilestonesQuery__
 *
 * To run a query within a Vue component, call `useGetStartedMilestonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStartedMilestonesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStartedMilestonesQuery();
 */
export function useGetStartedMilestonesQuery(options: VueApolloComposable.UseQueryOptions<GetStartedMilestonesQuery, GetStartedMilestonesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStartedMilestonesQuery, GetStartedMilestonesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStartedMilestonesQuery, GetStartedMilestonesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStartedMilestonesQuery, GetStartedMilestonesQueryVariables>(GetStartedMilestonesDocument, {}, options);
}
export function useGetStartedMilestonesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetStartedMilestonesQuery, GetStartedMilestonesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStartedMilestonesQuery, GetStartedMilestonesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStartedMilestonesQuery, GetStartedMilestonesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetStartedMilestonesQuery, GetStartedMilestonesQueryVariables>(GetStartedMilestonesDocument, {}, options);
}
export type GetStartedMilestonesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStartedMilestonesQuery, GetStartedMilestonesQueryVariables>;
export const HelpStationArticlesDocument = gql`
    query HelpStationArticles($tag: String!) {
  HelpStationArticles(tag: $tag) {
    id
    url
    title
  }
}
    `;

/**
 * __useHelpStationArticlesQuery__
 *
 * To run a query within a Vue component, call `useHelpStationArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpStationArticlesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHelpStationArticlesQuery({
 *   tag: // value for 'tag'
 * });
 */
export function useHelpStationArticlesQuery(variables: HelpStationArticlesQueryVariables | VueCompositionApi.Ref<HelpStationArticlesQueryVariables> | ReactiveFunction<HelpStationArticlesQueryVariables>, options: VueApolloComposable.UseQueryOptions<HelpStationArticlesQuery, HelpStationArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HelpStationArticlesQuery, HelpStationArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HelpStationArticlesQuery, HelpStationArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HelpStationArticlesQuery, HelpStationArticlesQueryVariables>(HelpStationArticlesDocument, variables, options);
}
export function useHelpStationArticlesLazyQuery(variables?: HelpStationArticlesQueryVariables | VueCompositionApi.Ref<HelpStationArticlesQueryVariables> | ReactiveFunction<HelpStationArticlesQueryVariables>, options: VueApolloComposable.UseQueryOptions<HelpStationArticlesQuery, HelpStationArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HelpStationArticlesQuery, HelpStationArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HelpStationArticlesQuery, HelpStationArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<HelpStationArticlesQuery, HelpStationArticlesQueryVariables>(HelpStationArticlesDocument, variables, options);
}
export type HelpStationArticlesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HelpStationArticlesQuery, HelpStationArticlesQueryVariables>;
export const HelpStationSearchDocument = gql`
    query HelpStationSearch($keyword: String!) {
  HelpStationArticlesSearch(keyword: $keyword) {
    id
    url
    title
  }
}
    `;

/**
 * __useHelpStationSearchQuery__
 *
 * To run a query within a Vue component, call `useHelpStationSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpStationSearchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHelpStationSearchQuery({
 *   keyword: // value for 'keyword'
 * });
 */
export function useHelpStationSearchQuery(variables: HelpStationSearchQueryVariables | VueCompositionApi.Ref<HelpStationSearchQueryVariables> | ReactiveFunction<HelpStationSearchQueryVariables>, options: VueApolloComposable.UseQueryOptions<HelpStationSearchQuery, HelpStationSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HelpStationSearchQuery, HelpStationSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HelpStationSearchQuery, HelpStationSearchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HelpStationSearchQuery, HelpStationSearchQueryVariables>(HelpStationSearchDocument, variables, options);
}
export function useHelpStationSearchLazyQuery(variables?: HelpStationSearchQueryVariables | VueCompositionApi.Ref<HelpStationSearchQueryVariables> | ReactiveFunction<HelpStationSearchQueryVariables>, options: VueApolloComposable.UseQueryOptions<HelpStationSearchQuery, HelpStationSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HelpStationSearchQuery, HelpStationSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HelpStationSearchQuery, HelpStationSearchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<HelpStationSearchQuery, HelpStationSearchQueryVariables>(HelpStationSearchDocument, variables, options);
}
export type HelpStationSearchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HelpStationSearchQuery, HelpStationSearchQueryVariables>;
export const HelpStationVideosDocument = gql`
    query HelpStationVideos($tag: String!) {
  HelpStationVideos(tag: $tag) {
    duration
    name
    link
    player_embed_url
  }
}
    `;

/**
 * __useHelpStationVideosQuery__
 *
 * To run a query within a Vue component, call `useHelpStationVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpStationVideosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHelpStationVideosQuery({
 *   tag: // value for 'tag'
 * });
 */
export function useHelpStationVideosQuery(variables: HelpStationVideosQueryVariables | VueCompositionApi.Ref<HelpStationVideosQueryVariables> | ReactiveFunction<HelpStationVideosQueryVariables>, options: VueApolloComposable.UseQueryOptions<HelpStationVideosQuery, HelpStationVideosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HelpStationVideosQuery, HelpStationVideosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HelpStationVideosQuery, HelpStationVideosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HelpStationVideosQuery, HelpStationVideosQueryVariables>(HelpStationVideosDocument, variables, options);
}
export function useHelpStationVideosLazyQuery(variables?: HelpStationVideosQueryVariables | VueCompositionApi.Ref<HelpStationVideosQueryVariables> | ReactiveFunction<HelpStationVideosQueryVariables>, options: VueApolloComposable.UseQueryOptions<HelpStationVideosQuery, HelpStationVideosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HelpStationVideosQuery, HelpStationVideosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HelpStationVideosQuery, HelpStationVideosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<HelpStationVideosQuery, HelpStationVideosQueryVariables>(HelpStationVideosDocument, variables, options);
}
export type HelpStationVideosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HelpStationVideosQuery, HelpStationVideosQueryVariables>;
export const RateVirtualAssistantChatMessageDocument = gql`
    mutation rateVirtualAssistantChatMessage($input: VirtualAssistantRatingInput!) {
  RateVirtualAssistantChatMessage(input: $input)
}
    `;

/**
 * __useRateVirtualAssistantChatMessageMutation__
 *
 * To run a mutation, you first call `useRateVirtualAssistantChatMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRateVirtualAssistantChatMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRateVirtualAssistantChatMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRateVirtualAssistantChatMessageMutation(options: VueApolloComposable.UseMutationOptions<RateVirtualAssistantChatMessageMutation, RateVirtualAssistantChatMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RateVirtualAssistantChatMessageMutation, RateVirtualAssistantChatMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RateVirtualAssistantChatMessageMutation, RateVirtualAssistantChatMessageMutationVariables>(RateVirtualAssistantChatMessageDocument, options);
}
export type RateVirtualAssistantChatMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RateVirtualAssistantChatMessageMutation, RateVirtualAssistantChatMessageMutationVariables>;
export const RateVirtualAssistantChatDocument = gql`
    mutation rateVirtualAssistantChat($input: VirtualAssistantRatingInput!) {
  RateVirtualAssistantChat(input: $input)
}
    `;

/**
 * __useRateVirtualAssistantChatMutation__
 *
 * To run a mutation, you first call `useRateVirtualAssistantChatMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRateVirtualAssistantChatMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRateVirtualAssistantChatMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRateVirtualAssistantChatMutation(options: VueApolloComposable.UseMutationOptions<RateVirtualAssistantChatMutation, RateVirtualAssistantChatMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RateVirtualAssistantChatMutation, RateVirtualAssistantChatMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RateVirtualAssistantChatMutation, RateVirtualAssistantChatMutationVariables>(RateVirtualAssistantChatDocument, options);
}
export type RateVirtualAssistantChatMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RateVirtualAssistantChatMutation, RateVirtualAssistantChatMutationVariables>;
export const TrialAutoExtensionDocument = gql`
    mutation trialAutoExtension($input: TrialExtensionInput!) {
  TrialAutoExtension(input: $input)
}
    `;

/**
 * __useTrialAutoExtensionMutation__
 *
 * To run a mutation, you first call `useTrialAutoExtensionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTrialAutoExtensionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTrialAutoExtensionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTrialAutoExtensionMutation(options: VueApolloComposable.UseMutationOptions<TrialAutoExtensionMutation, TrialAutoExtensionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrialAutoExtensionMutation, TrialAutoExtensionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrialAutoExtensionMutation, TrialAutoExtensionMutationVariables>(TrialAutoExtensionDocument, options);
}
export type TrialAutoExtensionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrialAutoExtensionMutation, TrialAutoExtensionMutationVariables>;
export const VirtualAssistantDocument = gql`
    query VirtualAssistant($messages: [VirtualAssistantMessageInput]!) {
  VirtualAssistantChat(input: $messages) {
    text
    kind
    messageId
  }
}
    `;

/**
 * __useVirtualAssistantQuery__
 *
 * To run a query within a Vue component, call `useVirtualAssistantQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualAssistantQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVirtualAssistantQuery({
 *   messages: // value for 'messages'
 * });
 */
export function useVirtualAssistantQuery(variables: VirtualAssistantQueryVariables | VueCompositionApi.Ref<VirtualAssistantQueryVariables> | ReactiveFunction<VirtualAssistantQueryVariables>, options: VueApolloComposable.UseQueryOptions<VirtualAssistantQuery, VirtualAssistantQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VirtualAssistantQuery, VirtualAssistantQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VirtualAssistantQuery, VirtualAssistantQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VirtualAssistantQuery, VirtualAssistantQueryVariables>(VirtualAssistantDocument, variables, options);
}
export function useVirtualAssistantLazyQuery(variables?: VirtualAssistantQueryVariables | VueCompositionApi.Ref<VirtualAssistantQueryVariables> | ReactiveFunction<VirtualAssistantQueryVariables>, options: VueApolloComposable.UseQueryOptions<VirtualAssistantQuery, VirtualAssistantQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VirtualAssistantQuery, VirtualAssistantQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VirtualAssistantQuery, VirtualAssistantQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VirtualAssistantQuery, VirtualAssistantQueryVariables>(VirtualAssistantDocument, variables, options);
}
export type VirtualAssistantQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VirtualAssistantQuery, VirtualAssistantQueryVariables>;
export const IntegrationContainerDocument = gql`
    query IntegrationContainer($appInput: IntegrationGetJwtInputType!, $itemInput: IntegrationItemInputType!) {
  IntegrationGetAppJwt(input: $appInput)
  IntegrationItem(input: $itemInput) {
    iframeUrl
  }
}
    `;

/**
 * __useIntegrationContainerQuery__
 *
 * To run a query within a Vue component, call `useIntegrationContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationContainerQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIntegrationContainerQuery({
 *   appInput: // value for 'appInput'
 *   itemInput: // value for 'itemInput'
 * });
 */
export function useIntegrationContainerQuery(variables: IntegrationContainerQueryVariables | VueCompositionApi.Ref<IntegrationContainerQueryVariables> | ReactiveFunction<IntegrationContainerQueryVariables>, options: VueApolloComposable.UseQueryOptions<IntegrationContainerQuery, IntegrationContainerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationContainerQuery, IntegrationContainerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationContainerQuery, IntegrationContainerQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IntegrationContainerQuery, IntegrationContainerQueryVariables>(IntegrationContainerDocument, variables, options);
}
export function useIntegrationContainerLazyQuery(variables?: IntegrationContainerQueryVariables | VueCompositionApi.Ref<IntegrationContainerQueryVariables> | ReactiveFunction<IntegrationContainerQueryVariables>, options: VueApolloComposable.UseQueryOptions<IntegrationContainerQuery, IntegrationContainerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationContainerQuery, IntegrationContainerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationContainerQuery, IntegrationContainerQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IntegrationContainerQuery, IntegrationContainerQueryVariables>(IntegrationContainerDocument, variables, options);
}
export type IntegrationContainerQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IntegrationContainerQuery, IntegrationContainerQueryVariables>;
export const IntegrationsListDocument = gql`
    query integrationsList {
  IntegrationList {
    id
    name
    description
    iconUrl
    isEnabled
    isLocked
    isConnected
    integrationPage
    iframeUrl
    groupName
  }
}
    `;

/**
 * __useIntegrationsListQuery__
 *
 * To run a query within a Vue component, call `useIntegrationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIntegrationsListQuery();
 */
export function useIntegrationsListQuery(options: VueApolloComposable.UseQueryOptions<IntegrationsListQuery, IntegrationsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationsListQuery, IntegrationsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationsListQuery, IntegrationsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IntegrationsListQuery, IntegrationsListQueryVariables>(IntegrationsListDocument, {}, options);
}
export function useIntegrationsListLazyQuery(options: VueApolloComposable.UseQueryOptions<IntegrationsListQuery, IntegrationsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationsListQuery, IntegrationsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationsListQuery, IntegrationsListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IntegrationsListQuery, IntegrationsListQueryVariables>(IntegrationsListDocument, {}, options);
}
export type IntegrationsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IntegrationsListQuery, IntegrationsListQueryVariables>;
export const IntegrationActionRunDocument = gql`
    mutation integrationActionRun($input: IntegrationActionRunInput!) {
  IntegrationActionRun(input: $input) {
    type
    message
  }
}
    `;

/**
 * __useIntegrationActionRunMutation__
 *
 * To run a mutation, you first call `useIntegrationActionRunMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationActionRunMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIntegrationActionRunMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIntegrationActionRunMutation(options: VueApolloComposable.UseMutationOptions<IntegrationActionRunMutation, IntegrationActionRunMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IntegrationActionRunMutation, IntegrationActionRunMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IntegrationActionRunMutation, IntegrationActionRunMutationVariables>(IntegrationActionRunDocument, options);
}
export type IntegrationActionRunMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IntegrationActionRunMutation, IntegrationActionRunMutationVariables>;
export const AvalaraMandatesDocument = gql`
    query avalaraMandates($countryCode: String) {
  AvalaraMandatesList(countryCode: $countryCode) {
    id
    title
    mandateId
    inputDataFormats {
      documentType
      documentVersion
    }
    isActive
    statusCode
    statusText
  }
}
    `;

/**
 * __useAvalaraMandatesQuery__
 *
 * To run a query within a Vue component, call `useAvalaraMandatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvalaraMandatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvalaraMandatesQuery({
 *   countryCode: // value for 'countryCode'
 * });
 */
export function useAvalaraMandatesQuery(variables: AvalaraMandatesQueryVariables | VueCompositionApi.Ref<AvalaraMandatesQueryVariables> | ReactiveFunction<AvalaraMandatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AvalaraMandatesQuery, AvalaraMandatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvalaraMandatesQuery, AvalaraMandatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvalaraMandatesQuery, AvalaraMandatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvalaraMandatesQuery, AvalaraMandatesQueryVariables>(AvalaraMandatesDocument, variables, options);
}
export function useAvalaraMandatesLazyQuery(variables: AvalaraMandatesQueryVariables | VueCompositionApi.Ref<AvalaraMandatesQueryVariables> | ReactiveFunction<AvalaraMandatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AvalaraMandatesQuery, AvalaraMandatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvalaraMandatesQuery, AvalaraMandatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvalaraMandatesQuery, AvalaraMandatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvalaraMandatesQuery, AvalaraMandatesQueryVariables>(AvalaraMandatesDocument, variables, options);
}
export type AvalaraMandatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvalaraMandatesQuery, AvalaraMandatesQueryVariables>;
export const AvalaraDefaultFieldMappingsDocument = gql`
    query avalaraDefaultFieldMappings($module: String!) {
  AvalaraDefaultFieldMappingsList(module: $module) {
    avalaraFieldId
    scoroFieldId
  }
}
    `;

/**
 * __useAvalaraDefaultFieldMappingsQuery__
 *
 * To run a query within a Vue component, call `useAvalaraDefaultFieldMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvalaraDefaultFieldMappingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvalaraDefaultFieldMappingsQuery({
 *   module: // value for 'module'
 * });
 */
export function useAvalaraDefaultFieldMappingsQuery(variables: AvalaraDefaultFieldMappingsQueryVariables | VueCompositionApi.Ref<AvalaraDefaultFieldMappingsQueryVariables> | ReactiveFunction<AvalaraDefaultFieldMappingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvalaraDefaultFieldMappingsQuery, AvalaraDefaultFieldMappingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvalaraDefaultFieldMappingsQuery, AvalaraDefaultFieldMappingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvalaraDefaultFieldMappingsQuery, AvalaraDefaultFieldMappingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvalaraDefaultFieldMappingsQuery, AvalaraDefaultFieldMappingsQueryVariables>(AvalaraDefaultFieldMappingsDocument, variables, options);
}
export function useAvalaraDefaultFieldMappingsLazyQuery(variables?: AvalaraDefaultFieldMappingsQueryVariables | VueCompositionApi.Ref<AvalaraDefaultFieldMappingsQueryVariables> | ReactiveFunction<AvalaraDefaultFieldMappingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvalaraDefaultFieldMappingsQuery, AvalaraDefaultFieldMappingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvalaraDefaultFieldMappingsQuery, AvalaraDefaultFieldMappingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvalaraDefaultFieldMappingsQuery, AvalaraDefaultFieldMappingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvalaraDefaultFieldMappingsQuery, AvalaraDefaultFieldMappingsQueryVariables>(AvalaraDefaultFieldMappingsDocument, variables, options);
}
export type AvalaraDefaultFieldMappingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvalaraDefaultFieldMappingsQuery, AvalaraDefaultFieldMappingsQueryVariables>;
export const AvalaraMappingFieldsDocument = gql`
    query avalaraMappingFields($mandateId: String!, $documentType: String, $documentVersion: String) {
  AvalaraMappingFieldsList(
    mandateId: $mandateId
    documentType: $documentType
    documentVersion: $documentVersion
  ) {
    id
    name
    description
    path
    dataType
    optionality
    fieldType
    minLength
    maxLength
    example
  }
}
    `;

/**
 * __useAvalaraMappingFieldsQuery__
 *
 * To run a query within a Vue component, call `useAvalaraMappingFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvalaraMappingFieldsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvalaraMappingFieldsQuery({
 *   mandateId: // value for 'mandateId'
 *   documentType: // value for 'documentType'
 *   documentVersion: // value for 'documentVersion'
 * });
 */
export function useAvalaraMappingFieldsQuery(variables: AvalaraMappingFieldsQueryVariables | VueCompositionApi.Ref<AvalaraMappingFieldsQueryVariables> | ReactiveFunction<AvalaraMappingFieldsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvalaraMappingFieldsQuery, AvalaraMappingFieldsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvalaraMappingFieldsQuery, AvalaraMappingFieldsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvalaraMappingFieldsQuery, AvalaraMappingFieldsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvalaraMappingFieldsQuery, AvalaraMappingFieldsQueryVariables>(AvalaraMappingFieldsDocument, variables, options);
}
export function useAvalaraMappingFieldsLazyQuery(variables?: AvalaraMappingFieldsQueryVariables | VueCompositionApi.Ref<AvalaraMappingFieldsQueryVariables> | ReactiveFunction<AvalaraMappingFieldsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvalaraMappingFieldsQuery, AvalaraMappingFieldsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvalaraMappingFieldsQuery, AvalaraMappingFieldsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvalaraMappingFieldsQuery, AvalaraMappingFieldsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvalaraMappingFieldsQuery, AvalaraMappingFieldsQueryVariables>(AvalaraMappingFieldsDocument, variables, options);
}
export type AvalaraMappingFieldsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvalaraMappingFieldsQuery, AvalaraMappingFieldsQueryVariables>;
export const AvalaraScoroFieldsDocument = gql`
    query avalaraScoroFields($module: String!) {
  AvalaraScoroFieldsList(module: $module) {
    id
    title
    group
  }
}
    `;

/**
 * __useAvalaraScoroFieldsQuery__
 *
 * To run a query within a Vue component, call `useAvalaraScoroFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvalaraScoroFieldsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvalaraScoroFieldsQuery({
 *   module: // value for 'module'
 * });
 */
export function useAvalaraScoroFieldsQuery(variables: AvalaraScoroFieldsQueryVariables | VueCompositionApi.Ref<AvalaraScoroFieldsQueryVariables> | ReactiveFunction<AvalaraScoroFieldsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvalaraScoroFieldsQuery, AvalaraScoroFieldsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvalaraScoroFieldsQuery, AvalaraScoroFieldsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvalaraScoroFieldsQuery, AvalaraScoroFieldsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvalaraScoroFieldsQuery, AvalaraScoroFieldsQueryVariables>(AvalaraScoroFieldsDocument, variables, options);
}
export function useAvalaraScoroFieldsLazyQuery(variables?: AvalaraScoroFieldsQueryVariables | VueCompositionApi.Ref<AvalaraScoroFieldsQueryVariables> | ReactiveFunction<AvalaraScoroFieldsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvalaraScoroFieldsQuery, AvalaraScoroFieldsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvalaraScoroFieldsQuery, AvalaraScoroFieldsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvalaraScoroFieldsQuery, AvalaraScoroFieldsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvalaraScoroFieldsQuery, AvalaraScoroFieldsQueryVariables>(AvalaraScoroFieldsDocument, variables, options);
}
export type AvalaraScoroFieldsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvalaraScoroFieldsQuery, AvalaraScoroFieldsQueryVariables>;
export const IntegrationsCustomScriptsExecutionDocument = gql`
    mutation integrationsCustomScriptsExecution($input: CustomScriptsExecutionInput!) {
  CustomScriptExecution(input: $input)
}
    `;

/**
 * __useIntegrationsCustomScriptsExecutionMutation__
 *
 * To run a mutation, you first call `useIntegrationsCustomScriptsExecutionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsCustomScriptsExecutionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIntegrationsCustomScriptsExecutionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIntegrationsCustomScriptsExecutionMutation(options: VueApolloComposable.UseMutationOptions<IntegrationsCustomScriptsExecutionMutation, IntegrationsCustomScriptsExecutionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IntegrationsCustomScriptsExecutionMutation, IntegrationsCustomScriptsExecutionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IntegrationsCustomScriptsExecutionMutation, IntegrationsCustomScriptsExecutionMutationVariables>(IntegrationsCustomScriptsExecutionDocument, options);
}
export type IntegrationsCustomScriptsExecutionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IntegrationsCustomScriptsExecutionMutation, IntegrationsCustomScriptsExecutionMutationVariables>;
export const SageDimensionsSaveDocument = gql`
    mutation sageDimensionsSave($input: SageDimensionsSaveInput!) {
  SageDimensionsSave(input: $input) {
    __typename
    id
    isActive
    value
    label
    options {
      value
    }
  }
}
    `;

/**
 * __useSageDimensionsSaveMutation__
 *
 * To run a mutation, you first call `useSageDimensionsSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSageDimensionsSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSageDimensionsSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSageDimensionsSaveMutation(options: VueApolloComposable.UseMutationOptions<SageDimensionsSaveMutation, SageDimensionsSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SageDimensionsSaveMutation, SageDimensionsSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SageDimensionsSaveMutation, SageDimensionsSaveMutationVariables>(SageDimensionsSaveDocument, options);
}
export type SageDimensionsSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SageDimensionsSaveMutation, SageDimensionsSaveMutationVariables>;
export const IntegrationsDimensionBlockDocument = gql`
    query integrationsDimensionBlock($module: String!) {
  SageDimensionsList(input: $module) {
    id
    isActive
    options {
      value
    }
    value
    label
  }
}
    `;

/**
 * __useIntegrationsDimensionBlockQuery__
 *
 * To run a query within a Vue component, call `useIntegrationsDimensionBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsDimensionBlockQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIntegrationsDimensionBlockQuery({
 *   module: // value for 'module'
 * });
 */
export function useIntegrationsDimensionBlockQuery(variables: IntegrationsDimensionBlockQueryVariables | VueCompositionApi.Ref<IntegrationsDimensionBlockQueryVariables> | ReactiveFunction<IntegrationsDimensionBlockQueryVariables>, options: VueApolloComposable.UseQueryOptions<IntegrationsDimensionBlockQuery, IntegrationsDimensionBlockQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationsDimensionBlockQuery, IntegrationsDimensionBlockQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationsDimensionBlockQuery, IntegrationsDimensionBlockQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IntegrationsDimensionBlockQuery, IntegrationsDimensionBlockQueryVariables>(IntegrationsDimensionBlockDocument, variables, options);
}
export function useIntegrationsDimensionBlockLazyQuery(variables?: IntegrationsDimensionBlockQueryVariables | VueCompositionApi.Ref<IntegrationsDimensionBlockQueryVariables> | ReactiveFunction<IntegrationsDimensionBlockQueryVariables>, options: VueApolloComposable.UseQueryOptions<IntegrationsDimensionBlockQuery, IntegrationsDimensionBlockQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationsDimensionBlockQuery, IntegrationsDimensionBlockQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationsDimensionBlockQuery, IntegrationsDimensionBlockQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IntegrationsDimensionBlockQuery, IntegrationsDimensionBlockQueryVariables>(IntegrationsDimensionBlockDocument, variables, options);
}
export type IntegrationsDimensionBlockQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IntegrationsDimensionBlockQuery, IntegrationsDimensionBlockQueryVariables>;
export const IntegrationsSettingsCalendarUserListDocument = gql`
    query integrationsSettingsCalendarUserList($input: UsersListInput!) {
  UsersList(input: $input) {
    id
    name
    status
    adapters {
      adapterCode
      externalSystemId
      calendarId
      calendarName
      syncSettings
      isActive
      setupStep
      errorCount
    }
  }
}
    `;

/**
 * __useIntegrationsSettingsCalendarUserListQuery__
 *
 * To run a query within a Vue component, call `useIntegrationsSettingsCalendarUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsSettingsCalendarUserListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIntegrationsSettingsCalendarUserListQuery({
 *   input: // value for 'input'
 * });
 */
export function useIntegrationsSettingsCalendarUserListQuery(variables: IntegrationsSettingsCalendarUserListQueryVariables | VueCompositionApi.Ref<IntegrationsSettingsCalendarUserListQueryVariables> | ReactiveFunction<IntegrationsSettingsCalendarUserListQueryVariables>, options: VueApolloComposable.UseQueryOptions<IntegrationsSettingsCalendarUserListQuery, IntegrationsSettingsCalendarUserListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationsSettingsCalendarUserListQuery, IntegrationsSettingsCalendarUserListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationsSettingsCalendarUserListQuery, IntegrationsSettingsCalendarUserListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IntegrationsSettingsCalendarUserListQuery, IntegrationsSettingsCalendarUserListQueryVariables>(IntegrationsSettingsCalendarUserListDocument, variables, options);
}
export function useIntegrationsSettingsCalendarUserListLazyQuery(variables?: IntegrationsSettingsCalendarUserListQueryVariables | VueCompositionApi.Ref<IntegrationsSettingsCalendarUserListQueryVariables> | ReactiveFunction<IntegrationsSettingsCalendarUserListQueryVariables>, options: VueApolloComposable.UseQueryOptions<IntegrationsSettingsCalendarUserListQuery, IntegrationsSettingsCalendarUserListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationsSettingsCalendarUserListQuery, IntegrationsSettingsCalendarUserListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationsSettingsCalendarUserListQuery, IntegrationsSettingsCalendarUserListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IntegrationsSettingsCalendarUserListQuery, IntegrationsSettingsCalendarUserListQueryVariables>(IntegrationsSettingsCalendarUserListDocument, variables, options);
}
export type IntegrationsSettingsCalendarUserListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IntegrationsSettingsCalendarUserListQuery, IntegrationsSettingsCalendarUserListQueryVariables>;
export const IntegrationsStripeSettingsDocument = gql`
    query integrationsStripeSettings {
  StripeTemplatesList {
    id
    isPaymentLinkActive
    relatedObject {
      __typename
      ... on PdfTemplate {
        id
        name
      }
      ... on EmailTemplate {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useIntegrationsStripeSettingsQuery__
 *
 * To run a query within a Vue component, call `useIntegrationsStripeSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsStripeSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIntegrationsStripeSettingsQuery();
 */
export function useIntegrationsStripeSettingsQuery(options: VueApolloComposable.UseQueryOptions<IntegrationsStripeSettingsQuery, IntegrationsStripeSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationsStripeSettingsQuery, IntegrationsStripeSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationsStripeSettingsQuery, IntegrationsStripeSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IntegrationsStripeSettingsQuery, IntegrationsStripeSettingsQueryVariables>(IntegrationsStripeSettingsDocument, {}, options);
}
export function useIntegrationsStripeSettingsLazyQuery(options: VueApolloComposable.UseQueryOptions<IntegrationsStripeSettingsQuery, IntegrationsStripeSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationsStripeSettingsQuery, IntegrationsStripeSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationsStripeSettingsQuery, IntegrationsStripeSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IntegrationsStripeSettingsQuery, IntegrationsStripeSettingsQueryVariables>(IntegrationsStripeSettingsDocument, {}, options);
}
export type IntegrationsStripeSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IntegrationsStripeSettingsQuery, IntegrationsStripeSettingsQueryVariables>;
export const StripeTemplateSaveDocument = gql`
    mutation stripeTemplateSave($pdfTemplateId: ID!) {
  StripeTemplateSave(pdfTemplateId: $pdfTemplateId) {
    id
    isPaymentLinkActive
    relatedObject {
      ... on PdfTemplate {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useStripeTemplateSaveMutation__
 *
 * To run a mutation, you first call `useStripeTemplateSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStripeTemplateSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStripeTemplateSaveMutation({
 *   variables: {
 *     pdfTemplateId: // value for 'pdfTemplateId'
 *   },
 * });
 */
export function useStripeTemplateSaveMutation(options: VueApolloComposable.UseMutationOptions<StripeTemplateSaveMutation, StripeTemplateSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StripeTemplateSaveMutation, StripeTemplateSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StripeTemplateSaveMutation, StripeTemplateSaveMutationVariables>(StripeTemplateSaveDocument, options);
}
export type StripeTemplateSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StripeTemplateSaveMutation, StripeTemplateSaveMutationVariables>;
export const InvoiceAutoSuggestDocument = gql`
    query invoiceAutoSuggest($invoicesListInput: FinanceDocumentsListInput) {
  InvoicesList(input: $invoicesListInput) {
    id
    number
    mainContact {
      name
    }
  }
}
    `;

/**
 * __useInvoiceAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useInvoiceAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInvoiceAutoSuggestQuery({
 *   invoicesListInput: // value for 'invoicesListInput'
 * });
 */
export function useInvoiceAutoSuggestQuery(variables: InvoiceAutoSuggestQueryVariables | VueCompositionApi.Ref<InvoiceAutoSuggestQueryVariables> | ReactiveFunction<InvoiceAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<InvoiceAutoSuggestQuery, InvoiceAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InvoiceAutoSuggestQuery, InvoiceAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InvoiceAutoSuggestQuery, InvoiceAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<InvoiceAutoSuggestQuery, InvoiceAutoSuggestQueryVariables>(InvoiceAutoSuggestDocument, variables, options);
}
export function useInvoiceAutoSuggestLazyQuery(variables: InvoiceAutoSuggestQueryVariables | VueCompositionApi.Ref<InvoiceAutoSuggestQueryVariables> | ReactiveFunction<InvoiceAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<InvoiceAutoSuggestQuery, InvoiceAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InvoiceAutoSuggestQuery, InvoiceAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InvoiceAutoSuggestQuery, InvoiceAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<InvoiceAutoSuggestQuery, InvoiceAutoSuggestQueryVariables>(InvoiceAutoSuggestDocument, variables, options);
}
export type InvoiceAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<InvoiceAutoSuggestQuery, InvoiceAutoSuggestQueryVariables>;
export const ActivityLogsDocument = gql`
    query ActivityLogs($input: ActivityLogsInput!) {
  ActivityLogs(input: $input) {
    id
    datetime
    userId
    userName
    action
    itemType
    itemId
    itemName
    changeLog
    ip
    activityType
  }
}
    `;

/**
 * __useActivityLogsQuery__
 *
 * To run a query within a Vue component, call `useActivityLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActivityLogsQuery({
 *   input: // value for 'input'
 * });
 */
export function useActivityLogsQuery(variables: ActivityLogsQueryVariables | VueCompositionApi.Ref<ActivityLogsQueryVariables> | ReactiveFunction<ActivityLogsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActivityLogsQuery, ActivityLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActivityLogsQuery, ActivityLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActivityLogsQuery, ActivityLogsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, variables, options);
}
export function useActivityLogsLazyQuery(variables?: ActivityLogsQueryVariables | VueCompositionApi.Ref<ActivityLogsQueryVariables> | ReactiveFunction<ActivityLogsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActivityLogsQuery, ActivityLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActivityLogsQuery, ActivityLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActivityLogsQuery, ActivityLogsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, variables, options);
}
export type ActivityLogsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActivityLogsQuery, ActivityLogsQueryVariables>;
export const McpPermissionSetsDocument = gql`
    query McpPermissionSets($input: PermissionSetsPermissionsInput) {
  PermissionSetsPermissions(input: $input) {
    permissionSets {
      id
      name
      permissionValues {
        permissionKey
        value
      }
    }
  }
}
    `;

/**
 * __useMcpPermissionSetsQuery__
 *
 * To run a query within a Vue component, call `useMcpPermissionSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcpPermissionSetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMcpPermissionSetsQuery({
 *   input: // value for 'input'
 * });
 */
export function useMcpPermissionSetsQuery(variables: McpPermissionSetsQueryVariables | VueCompositionApi.Ref<McpPermissionSetsQueryVariables> | ReactiveFunction<McpPermissionSetsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<McpPermissionSetsQuery, McpPermissionSetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<McpPermissionSetsQuery, McpPermissionSetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<McpPermissionSetsQuery, McpPermissionSetsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<McpPermissionSetsQuery, McpPermissionSetsQueryVariables>(McpPermissionSetsDocument, variables, options);
}
export function useMcpPermissionSetsLazyQuery(variables: McpPermissionSetsQueryVariables | VueCompositionApi.Ref<McpPermissionSetsQueryVariables> | ReactiveFunction<McpPermissionSetsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<McpPermissionSetsQuery, McpPermissionSetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<McpPermissionSetsQuery, McpPermissionSetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<McpPermissionSetsQuery, McpPermissionSetsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<McpPermissionSetsQuery, McpPermissionSetsQueryVariables>(McpPermissionSetsDocument, variables, options);
}
export type McpPermissionSetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<McpPermissionSetsQuery, McpPermissionSetsQueryVariables>;
export const UpdateMcpPermissionsDocument = gql`
    mutation UpdateMcpPermissions($input: UpdateMcpPermissionsInput!) {
  UpdateMcpPermissions(input: $input)
}
    `;

/**
 * __useUpdateMcpPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateMcpPermissionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMcpPermissionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMcpPermissionsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMcpPermissionsMutation(options: VueApolloComposable.UseMutationOptions<UpdateMcpPermissionsMutation, UpdateMcpPermissionsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMcpPermissionsMutation, UpdateMcpPermissionsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMcpPermissionsMutation, UpdateMcpPermissionsMutationVariables>(UpdateMcpPermissionsDocument, options);
}
export type UpdateMcpPermissionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMcpPermissionsMutation, UpdateMcpPermissionsMutationVariables>;
export const NotificationsDropdownContentDocument = gql`
    query notificationsDropdownContent($limit: Int, $startFrom: Int) {
  UnreadNotificationsCount @persist
  NotificationsList(bookmarkHash: null, limit: $limit, startFrom: $startFrom) {
    __typename
    id
    action
    isRead
    customText
    customLink
    customTitle
    customBody
    createdDateTime
    module
    relatedObjectId
    changes {
      ... on UnionManagerChange {
        fieldName
        previousUser {
          id
          name
          initials
          hslColor
          profilePicture {
            mini
          }
        }
        currentUser {
          id
          name
          initials
          hslColor
          profilePicture {
            mini
          }
        }
      }
      ... on UnionUsersChange {
        fieldName
        deletedUsers {
          id
          name
          initials
          hslColor
          profilePicture {
            mini
          }
        }
        addedUsers {
          id
          name
          initials
          hslColor
          profilePicture {
            mini
          }
        }
      }
      ... on UnionStatusChange {
        fieldName
        previousStatus {
          ... on UnionStatus {
            status {
              id
              name
              color
            }
          }
          ... on UnionStaticStatus {
            staticStatus {
              name
              color
            }
          }
        }
        currentStatus {
          ... on UnionStatus {
            status {
              id
              name
              color
            }
          }
          ... on UnionStaticStatus {
            staticStatus {
              name
              color
            }
          }
        }
      }
      ... on UnionProjectChange {
        fieldName
        previousProject {
          name
        }
        currentProject {
          name
        }
      }
      ... on UnionFieldChange {
        fieldName
        previousValue
        currentValue
      }
    }
    comment {
      id
      text
      strippedText
      createdDate
      reactions {
        id
        reactionCode
        isActive
        userIds
      }
    }
    task {
      id
      name
      project {
        name
      }
    }
    trigger {
      id
      name
    }
    relatedUser {
      id
      initials
      name
      profilePicture {
        medium
      }
    }
    relatedObject {
      __typename
      ... on UnionProject {
        project {
          id
          name
          defaultContact {
            name
          }
          company {
            name
          }
          strippedDescription
        }
      }
      ... on UnionTask {
        task {
          id
          name
          project {
            name
          }
          strippedDescription
        }
      }
      ... on UnionEvent {
        event {
          id
          name
          startDatetime
          project {
            name
          }
          strippedDescription
        }
      }
      ... on UnionTimeEntry {
        timeEntry {
          id
          description
          task {
            id
            name
            description
            project {
              id
              name
            }
            activityType {
              id
              name
              status
            }
          }
        }
      }
      ... on UnionContact {
        contact {
          id
          name
        }
      }
      ... on UnionBackgroundJob {
        backgroundJob {
          id
          jobTitle
          status
        }
      }
      ... on UnionQuote {
        quote {
          quoteName
          id
          number
          mainContact {
            name
          }
          project {
            name
          }
          sum
          currency
          margin
          status {
            name
            color
          }
        }
      }
      ... on UnionBill {
        bill {
          id
          number
          mainContact {
            name
          }
          project {
            name
          }
          deadline
          sum
          currency
          status
        }
      }
      ... on UnionOrder {
        order {
          id
          number
          mainContact {
            name
          }
          project {
            name
          }
        }
      }
      ... on UnionInvoice {
        invoice {
          id
          number
          deadline
          margin
          mainContact {
            name
          }
          project {
            name
          }
          sum
          currency
        }
      }
      ... on UnionExpense {
        expense {
          id
          number
          mainContact {
            name
          }
          project {
            name
          }
        }
      }
      ... on UnionPurchaseOrder {
        purchaseOrder {
          id
          number
          mainContact {
            name
          }
          project {
            name
          }
        }
      }
      ... on UnionPrepayment {
        prepayment {
          id
          number
          mainContact {
            name
          }
          project {
            name
          }
        }
      }
      ... on UnionCustomModuleEntry {
        customEntry {
          id
          module {
            nameCode
            nameTranslated
          }
          primaryFieldName
        }
      }
      ... on UnionImport {
        import {
          id
          fileName
          type
          hadErrors
          isPartiallyDeleted
          importedDateTime
        }
      }
      ... on UnionNewsFeedItem {
        newsFeedItem {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationsDropdownContentQuery__
 *
 * To run a query within a Vue component, call `useNotificationsDropdownContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsDropdownContentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationsDropdownContentQuery({
 *   limit: // value for 'limit'
 *   startFrom: // value for 'startFrom'
 * });
 */
export function useNotificationsDropdownContentQuery(variables: NotificationsDropdownContentQueryVariables | VueCompositionApi.Ref<NotificationsDropdownContentQueryVariables> | ReactiveFunction<NotificationsDropdownContentQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<NotificationsDropdownContentQuery, NotificationsDropdownContentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsDropdownContentQuery, NotificationsDropdownContentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsDropdownContentQuery, NotificationsDropdownContentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotificationsDropdownContentQuery, NotificationsDropdownContentQueryVariables>(NotificationsDropdownContentDocument, variables, options);
}
export function useNotificationsDropdownContentLazyQuery(variables: NotificationsDropdownContentQueryVariables | VueCompositionApi.Ref<NotificationsDropdownContentQueryVariables> | ReactiveFunction<NotificationsDropdownContentQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<NotificationsDropdownContentQuery, NotificationsDropdownContentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsDropdownContentQuery, NotificationsDropdownContentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsDropdownContentQuery, NotificationsDropdownContentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NotificationsDropdownContentQuery, NotificationsDropdownContentQueryVariables>(NotificationsDropdownContentDocument, variables, options);
}
export type NotificationsDropdownContentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotificationsDropdownContentQuery, NotificationsDropdownContentQueryVariables>;
export const NotificationsDropdownDocument = gql`
    query notificationsDropdown {
  UnreadNotificationsCount @persist
}
    `;

/**
 * __useNotificationsDropdownQuery__
 *
 * To run a query within a Vue component, call `useNotificationsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsDropdownQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationsDropdownQuery();
 */
export function useNotificationsDropdownQuery(options: VueApolloComposable.UseQueryOptions<NotificationsDropdownQuery, NotificationsDropdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsDropdownQuery, NotificationsDropdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsDropdownQuery, NotificationsDropdownQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotificationsDropdownQuery, NotificationsDropdownQueryVariables>(NotificationsDropdownDocument, {}, options);
}
export function useNotificationsDropdownLazyQuery(options: VueApolloComposable.UseQueryOptions<NotificationsDropdownQuery, NotificationsDropdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsDropdownQuery, NotificationsDropdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsDropdownQuery, NotificationsDropdownQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NotificationsDropdownQuery, NotificationsDropdownQueryVariables>(NotificationsDropdownDocument, {}, options);
}
export type NotificationsDropdownQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotificationsDropdownQuery, NotificationsDropdownQueryVariables>;
export const NotificationsMarkAllAsReadDocument = gql`
    mutation notificationsMarkAllAsRead {
  MarkAllNotificationsRead
}
    `;

/**
 * __useNotificationsMarkAllAsReadMutation__
 *
 * To run a mutation, you first call `useNotificationsMarkAllAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMarkAllAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNotificationsMarkAllAsReadMutation();
 */
export function useNotificationsMarkAllAsReadMutation(options: VueApolloComposable.UseMutationOptions<NotificationsMarkAllAsReadMutation, NotificationsMarkAllAsReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<NotificationsMarkAllAsReadMutation, NotificationsMarkAllAsReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<NotificationsMarkAllAsReadMutation, NotificationsMarkAllAsReadMutationVariables>(NotificationsMarkAllAsReadDocument, options);
}
export type NotificationsMarkAllAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<NotificationsMarkAllAsReadMutation, NotificationsMarkAllAsReadMutationVariables>;
export const NotificationsMarkAsReadDocument = gql`
    mutation notificationsMarkAsRead($id: ID!) {
  NotificationsMarkAsRead(id: $id) {
    ... on Notification {
      id
      isRead
    }
  }
}
    `;

/**
 * __useNotificationsMarkAsReadMutation__
 *
 * To run a mutation, you first call `useNotificationsMarkAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMarkAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNotificationsMarkAsReadMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useNotificationsMarkAsReadMutation(options: VueApolloComposable.UseMutationOptions<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables>(NotificationsMarkAsReadDocument, options);
}
export type NotificationsMarkAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables>;
export const NotificationsMarkAsUnreadDocument = gql`
    mutation notificationsMarkAsUnread($id: ID!) {
  NotificationsMarkAsUnread(id: $id) {
    ... on Notification {
      id
      isRead
    }
  }
}
    `;

/**
 * __useNotificationsMarkAsUnreadMutation__
 *
 * To run a mutation, you first call `useNotificationsMarkAsUnreadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMarkAsUnreadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNotificationsMarkAsUnreadMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useNotificationsMarkAsUnreadMutation(options: VueApolloComposable.UseMutationOptions<NotificationsMarkAsUnreadMutation, NotificationsMarkAsUnreadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<NotificationsMarkAsUnreadMutation, NotificationsMarkAsUnreadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<NotificationsMarkAsUnreadMutation, NotificationsMarkAsUnreadMutationVariables>(NotificationsMarkAsUnreadDocument, options);
}
export type NotificationsMarkAsUnreadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<NotificationsMarkAsUnreadMutation, NotificationsMarkAsUnreadMutationVariables>;
export const OrderAutoSuggestDocument = gql`
    query orderAutoSuggest($ordersListInput: FinanceDocumentsListInput) {
  OrdersList(input: $ordersListInput) {
    id
    number
    mainContact {
      name
    }
  }
}
    `;

/**
 * __useOrderAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useOrderAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOrderAutoSuggestQuery({
 *   ordersListInput: // value for 'ordersListInput'
 * });
 */
export function useOrderAutoSuggestQuery(variables: OrderAutoSuggestQueryVariables | VueCompositionApi.Ref<OrderAutoSuggestQueryVariables> | ReactiveFunction<OrderAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<OrderAutoSuggestQuery, OrderAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OrderAutoSuggestQuery, OrderAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OrderAutoSuggestQuery, OrderAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OrderAutoSuggestQuery, OrderAutoSuggestQueryVariables>(OrderAutoSuggestDocument, variables, options);
}
export function useOrderAutoSuggestLazyQuery(variables: OrderAutoSuggestQueryVariables | VueCompositionApi.Ref<OrderAutoSuggestQueryVariables> | ReactiveFunction<OrderAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<OrderAutoSuggestQuery, OrderAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OrderAutoSuggestQuery, OrderAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OrderAutoSuggestQuery, OrderAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OrderAutoSuggestQuery, OrderAutoSuggestQueryVariables>(OrderAutoSuggestDocument, variables, options);
}
export type OrderAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OrderAutoSuggestQuery, OrderAutoSuggestQueryVariables>;
export const PrepaymentAutoSuggestDocument = gql`
    query prepaymentAutoSuggest($prepaymentsListInput: FinanceDocumentsListInput) {
  PrepaymentsList(input: $prepaymentsListInput) {
    id
    number
    mainContact {
      name
    }
  }
}
    `;

/**
 * __usePrepaymentAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `usePrepaymentAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrepaymentAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePrepaymentAutoSuggestQuery({
 *   prepaymentsListInput: // value for 'prepaymentsListInput'
 * });
 */
export function usePrepaymentAutoSuggestQuery(variables: PrepaymentAutoSuggestQueryVariables | VueCompositionApi.Ref<PrepaymentAutoSuggestQueryVariables> | ReactiveFunction<PrepaymentAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PrepaymentAutoSuggestQuery, PrepaymentAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PrepaymentAutoSuggestQuery, PrepaymentAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PrepaymentAutoSuggestQuery, PrepaymentAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PrepaymentAutoSuggestQuery, PrepaymentAutoSuggestQueryVariables>(PrepaymentAutoSuggestDocument, variables, options);
}
export function usePrepaymentAutoSuggestLazyQuery(variables: PrepaymentAutoSuggestQueryVariables | VueCompositionApi.Ref<PrepaymentAutoSuggestQueryVariables> | ReactiveFunction<PrepaymentAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PrepaymentAutoSuggestQuery, PrepaymentAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PrepaymentAutoSuggestQuery, PrepaymentAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PrepaymentAutoSuggestQuery, PrepaymentAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PrepaymentAutoSuggestQuery, PrepaymentAutoSuggestQueryVariables>(PrepaymentAutoSuggestDocument, variables, options);
}
export type PrepaymentAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PrepaymentAutoSuggestQuery, PrepaymentAutoSuggestQueryVariables>;
export const PriceListExistingPriceListDocument = gql`
    query priceListExistingPriceList($rolesListInput: RolesListInput!, $localPriceListId: ID!) {
  LocalPriceList(id: $localPriceListId) {
    id
    currency
    name
    createdDate
    localRolePrices {
      roleId
      sellingPrice
    }
  }
  RolesList(input: $rolesListInput) {
    id
    name
  }
}
    `;

/**
 * __usePriceListExistingPriceListQuery__
 *
 * To run a query within a Vue component, call `usePriceListExistingPriceListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceListExistingPriceListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePriceListExistingPriceListQuery({
 *   rolesListInput: // value for 'rolesListInput'
 *   localPriceListId: // value for 'localPriceListId'
 * });
 */
export function usePriceListExistingPriceListQuery(variables: PriceListExistingPriceListQueryVariables | VueCompositionApi.Ref<PriceListExistingPriceListQueryVariables> | ReactiveFunction<PriceListExistingPriceListQueryVariables>, options: VueApolloComposable.UseQueryOptions<PriceListExistingPriceListQuery, PriceListExistingPriceListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PriceListExistingPriceListQuery, PriceListExistingPriceListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PriceListExistingPriceListQuery, PriceListExistingPriceListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PriceListExistingPriceListQuery, PriceListExistingPriceListQueryVariables>(PriceListExistingPriceListDocument, variables, options);
}
export function usePriceListExistingPriceListLazyQuery(variables?: PriceListExistingPriceListQueryVariables | VueCompositionApi.Ref<PriceListExistingPriceListQueryVariables> | ReactiveFunction<PriceListExistingPriceListQueryVariables>, options: VueApolloComposable.UseQueryOptions<PriceListExistingPriceListQuery, PriceListExistingPriceListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PriceListExistingPriceListQuery, PriceListExistingPriceListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PriceListExistingPriceListQuery, PriceListExistingPriceListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PriceListExistingPriceListQuery, PriceListExistingPriceListQueryVariables>(PriceListExistingPriceListDocument, variables, options);
}
export type PriceListExistingPriceListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PriceListExistingPriceListQuery, PriceListExistingPriceListQueryVariables>;
export const PriceListModalDocument = gql`
    query priceListModal($rolesListInput: RolesListInput!, $globalPriceListId: ID!) {
  LocalPriceListFromPriceList(id: $globalPriceListId) {
    id
    name
    currency
    localRolePrices {
      roleId
      sellingPrice
    }
  }
  RolesList(input: $rolesListInput) {
    id
    name
  }
}
    `;

/**
 * __usePriceListModalQuery__
 *
 * To run a query within a Vue component, call `usePriceListModalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceListModalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePriceListModalQuery({
 *   rolesListInput: // value for 'rolesListInput'
 *   globalPriceListId: // value for 'globalPriceListId'
 * });
 */
export function usePriceListModalQuery(variables: PriceListModalQueryVariables | VueCompositionApi.Ref<PriceListModalQueryVariables> | ReactiveFunction<PriceListModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<PriceListModalQuery, PriceListModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PriceListModalQuery, PriceListModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PriceListModalQuery, PriceListModalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PriceListModalQuery, PriceListModalQueryVariables>(PriceListModalDocument, variables, options);
}
export function usePriceListModalLazyQuery(variables?: PriceListModalQueryVariables | VueCompositionApi.Ref<PriceListModalQueryVariables> | ReactiveFunction<PriceListModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<PriceListModalQuery, PriceListModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PriceListModalQuery, PriceListModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PriceListModalQuery, PriceListModalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PriceListModalQuery, PriceListModalQueryVariables>(PriceListModalDocument, variables, options);
}
export type PriceListModalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PriceListModalQuery, PriceListModalQueryVariables>;
export const PriceListSaveDocument = gql`
    mutation priceListSave($input: LocalPriceListSaveInput!) {
  LocalPriceListSave(input: $input) {
    __typename
    id
    name
    localRolePrices {
      roleId
      sellingPrice
    }
  }
}
    `;

/**
 * __usePriceListSaveMutation__
 *
 * To run a mutation, you first call `usePriceListSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePriceListSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePriceListSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePriceListSaveMutation(options: VueApolloComposable.UseMutationOptions<PriceListSaveMutation, PriceListSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PriceListSaveMutation, PriceListSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PriceListSaveMutation, PriceListSaveMutationVariables>(PriceListSaveDocument, options);
}
export type PriceListSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PriceListSaveMutation, PriceListSaveMutationVariables>;
export const ProjectAutoSuggestDocument = gql`
    query projectAutoSuggest($projectsListInput: ProjectsListInput) {
  ProjectsList(input: $projectsListInput) {
    id
    name
  }
}
    `;

/**
 * __useProjectAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useProjectAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectAutoSuggestQuery({
 *   projectsListInput: // value for 'projectsListInput'
 * });
 */
export function useProjectAutoSuggestQuery(variables: ProjectAutoSuggestQueryVariables | VueCompositionApi.Ref<ProjectAutoSuggestQueryVariables> | ReactiveFunction<ProjectAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectAutoSuggestQuery, ProjectAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectAutoSuggestQuery, ProjectAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectAutoSuggestQuery, ProjectAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectAutoSuggestQuery, ProjectAutoSuggestQueryVariables>(ProjectAutoSuggestDocument, variables, options);
}
export function useProjectAutoSuggestLazyQuery(variables: ProjectAutoSuggestQueryVariables | VueCompositionApi.Ref<ProjectAutoSuggestQueryVariables> | ReactiveFunction<ProjectAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectAutoSuggestQuery, ProjectAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectAutoSuggestQuery, ProjectAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectAutoSuggestQuery, ProjectAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectAutoSuggestQuery, ProjectAutoSuggestQueryVariables>(ProjectAutoSuggestDocument, variables, options);
}
export type ProjectAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectAutoSuggestQuery, ProjectAutoSuggestQueryVariables>;
export const ProjectBudgetAndPricingExistingProjectDocument = gql`
    query ProjectBudgetAndPricingExistingProject($projectParams: ProjectParamsInput!) {
  Project(projectParams: $projectParams) {
    projectType
    budgetType
    duration
    useBillsExpensesInCalculations
    useRoles
    shouldDisableCalculationType
    revenueBudget {
      id
    }
    costBudget {
      id
    }
    budgetSums {
      bills
      expenses
      laborCost
      invoices
      currency
    }
    quotedBudgetSums {
      duration
      bills
      expenses
      laborCost
      invoices
      currency
    }
    priceList {
      id
      currency
    }
    localPriceList {
      id
    }
    retainer {
      id
      frequency
      frequencyType
      noOfPeriods
      budgetType
      periodBillsSum
      periodDuration
      periodExpensesSum
      periodLaborCostSum
      periodSum
      totalSum
      totalDuration
      startDate
      isPeriodDurationEnabled
    }
  }
}
    `;

/**
 * __useProjectBudgetAndPricingExistingProjectQuery__
 *
 * To run a query within a Vue component, call `useProjectBudgetAndPricingExistingProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBudgetAndPricingExistingProjectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectBudgetAndPricingExistingProjectQuery({
 *   projectParams: // value for 'projectParams'
 * });
 */
export function useProjectBudgetAndPricingExistingProjectQuery(variables: ProjectBudgetAndPricingExistingProjectQueryVariables | VueCompositionApi.Ref<ProjectBudgetAndPricingExistingProjectQueryVariables> | ReactiveFunction<ProjectBudgetAndPricingExistingProjectQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingExistingProjectQuery, ProjectBudgetAndPricingExistingProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingExistingProjectQuery, ProjectBudgetAndPricingExistingProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingExistingProjectQuery, ProjectBudgetAndPricingExistingProjectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectBudgetAndPricingExistingProjectQuery, ProjectBudgetAndPricingExistingProjectQueryVariables>(ProjectBudgetAndPricingExistingProjectDocument, variables, options);
}
export function useProjectBudgetAndPricingExistingProjectLazyQuery(variables?: ProjectBudgetAndPricingExistingProjectQueryVariables | VueCompositionApi.Ref<ProjectBudgetAndPricingExistingProjectQueryVariables> | ReactiveFunction<ProjectBudgetAndPricingExistingProjectQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingExistingProjectQuery, ProjectBudgetAndPricingExistingProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingExistingProjectQuery, ProjectBudgetAndPricingExistingProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingExistingProjectQuery, ProjectBudgetAndPricingExistingProjectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectBudgetAndPricingExistingProjectQuery, ProjectBudgetAndPricingExistingProjectQueryVariables>(ProjectBudgetAndPricingExistingProjectDocument, variables, options);
}
export type ProjectBudgetAndPricingExistingProjectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectBudgetAndPricingExistingProjectQuery, ProjectBudgetAndPricingExistingProjectQueryVariables>;
export const ProjectBudgetAndPricingPriceListsListDocument = gql`
    query ProjectBudgetAndPricingPriceListsList {
  PriceListsList {
    id
    name
    currency
    isDefault
  }
}
    `;

/**
 * __useProjectBudgetAndPricingPriceListsListQuery__
 *
 * To run a query within a Vue component, call `useProjectBudgetAndPricingPriceListsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBudgetAndPricingPriceListsListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectBudgetAndPricingPriceListsListQuery();
 */
export function useProjectBudgetAndPricingPriceListsListQuery(options: VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingPriceListsListQuery, ProjectBudgetAndPricingPriceListsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingPriceListsListQuery, ProjectBudgetAndPricingPriceListsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingPriceListsListQuery, ProjectBudgetAndPricingPriceListsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectBudgetAndPricingPriceListsListQuery, ProjectBudgetAndPricingPriceListsListQueryVariables>(ProjectBudgetAndPricingPriceListsListDocument, {}, options);
}
export function useProjectBudgetAndPricingPriceListsListLazyQuery(options: VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingPriceListsListQuery, ProjectBudgetAndPricingPriceListsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingPriceListsListQuery, ProjectBudgetAndPricingPriceListsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectBudgetAndPricingPriceListsListQuery, ProjectBudgetAndPricingPriceListsListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectBudgetAndPricingPriceListsListQuery, ProjectBudgetAndPricingPriceListsListQueryVariables>(ProjectBudgetAndPricingPriceListsListDocument, {}, options);
}
export type ProjectBudgetAndPricingPriceListsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectBudgetAndPricingPriceListsListQuery, ProjectBudgetAndPricingPriceListsListQueryVariables>;
export const ProjectSecondaryDataQueryDocument = gql`
    query ProjectSecondaryDataQuery($budgetParams: BudgetsListInput!) {
  BudgetsList(input: $budgetParams) {
    id
    name
  }
}
    `;

/**
 * __useProjectSecondaryDataQueryQuery__
 *
 * To run a query within a Vue component, call `useProjectSecondaryDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSecondaryDataQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectSecondaryDataQueryQuery({
 *   budgetParams: // value for 'budgetParams'
 * });
 */
export function useProjectSecondaryDataQueryQuery(variables: ProjectSecondaryDataQueryQueryVariables | VueCompositionApi.Ref<ProjectSecondaryDataQueryQueryVariables> | ReactiveFunction<ProjectSecondaryDataQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectSecondaryDataQueryQuery, ProjectSecondaryDataQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectSecondaryDataQueryQuery, ProjectSecondaryDataQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectSecondaryDataQueryQuery, ProjectSecondaryDataQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectSecondaryDataQueryQuery, ProjectSecondaryDataQueryQueryVariables>(ProjectSecondaryDataQueryDocument, variables, options);
}
export function useProjectSecondaryDataQueryLazyQuery(variables?: ProjectSecondaryDataQueryQueryVariables | VueCompositionApi.Ref<ProjectSecondaryDataQueryQueryVariables> | ReactiveFunction<ProjectSecondaryDataQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectSecondaryDataQueryQuery, ProjectSecondaryDataQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectSecondaryDataQueryQuery, ProjectSecondaryDataQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectSecondaryDataQueryQuery, ProjectSecondaryDataQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectSecondaryDataQueryQuery, ProjectSecondaryDataQueryQueryVariables>(ProjectSecondaryDataQueryDocument, variables, options);
}
export type ProjectSecondaryDataQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectSecondaryDataQueryQuery, ProjectSecondaryDataQueryQueryVariables>;
export const ProjectDetailsHeaderMembersSaveMutationDocument = gql`
    mutation projectDetailsHeaderMembersSaveMutation($input: ProjectMembersSaveInput!) {
  ProjectMembersSave(input: $input) {
    __typename
    id
    manager {
      id
      name
      profilePicture {
        mini
      }
    }
    members {
      id
      name
      initials
      hslColor
      profilePicture {
        mini
      }
    }
    cupoUsers {
      name
      id
      profilePicture {
        mini
      }
    }
  }
}
    `;

/**
 * __useProjectDetailsHeaderMembersSaveMutationMutation__
 *
 * To run a mutation, you first call `useProjectDetailsHeaderMembersSaveMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailsHeaderMembersSaveMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProjectDetailsHeaderMembersSaveMutationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useProjectDetailsHeaderMembersSaveMutationMutation(options: VueApolloComposable.UseMutationOptions<ProjectDetailsHeaderMembersSaveMutationMutation, ProjectDetailsHeaderMembersSaveMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProjectDetailsHeaderMembersSaveMutationMutation, ProjectDetailsHeaderMembersSaveMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProjectDetailsHeaderMembersSaveMutationMutation, ProjectDetailsHeaderMembersSaveMutationMutationVariables>(ProjectDetailsHeaderMembersSaveMutationDocument, options);
}
export type ProjectDetailsHeaderMembersSaveMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProjectDetailsHeaderMembersSaveMutationMutation, ProjectDetailsHeaderMembersSaveMutationMutationVariables>;
export const ProjectDetailsHeaderDocument = gql`
    query projectDetailsHeader($projectInput: ProjectParamsInput!) {
  Project(projectParams: $projectInput) @persist {
    id
    number
    name
    manager {
      ...userAssignSelectUser
    }
    status {
      id
      statusId
      name
      color
    }
    date
    deadline
    completedDateTime
    color
    company {
      id
      name
    }
    permissions {
      canModify
    }
    duration
    doneDuration
    toDoDuration
    isDeleted
    isPersonal
    isPrivate
    members {
      ...userAssignSelectUser
    }
    cupoUsers {
      ...userAssignSelectUser
    }
    projectType
    priceList {
      id
      currency
    }
    projectPhases {
      id
      title
      ordering
      startDate
      endDate
      type
    }
  }
}
    ${UserAssignSelectUserFragmentDoc}`;

/**
 * __useProjectDetailsHeaderQuery__
 *
 * To run a query within a Vue component, call `useProjectDetailsHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailsHeaderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectDetailsHeaderQuery({
 *   projectInput: // value for 'projectInput'
 * });
 */
export function useProjectDetailsHeaderQuery(variables: ProjectDetailsHeaderQueryVariables | VueCompositionApi.Ref<ProjectDetailsHeaderQueryVariables> | ReactiveFunction<ProjectDetailsHeaderQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderQuery, ProjectDetailsHeaderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderQuery, ProjectDetailsHeaderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderQuery, ProjectDetailsHeaderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectDetailsHeaderQuery, ProjectDetailsHeaderQueryVariables>(ProjectDetailsHeaderDocument, variables, options);
}
export function useProjectDetailsHeaderLazyQuery(variables?: ProjectDetailsHeaderQueryVariables | VueCompositionApi.Ref<ProjectDetailsHeaderQueryVariables> | ReactiveFunction<ProjectDetailsHeaderQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderQuery, ProjectDetailsHeaderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderQuery, ProjectDetailsHeaderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderQuery, ProjectDetailsHeaderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectDetailsHeaderQuery, ProjectDetailsHeaderQueryVariables>(ProjectDetailsHeaderDocument, variables, options);
}
export type ProjectDetailsHeaderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectDetailsHeaderQuery, ProjectDetailsHeaderQueryVariables>;
export const ProjectDetailsHeaderIntegrationActionListDocument = gql`
    query projectDetailsHeaderIntegrationActionList($input: IntegrationActionListInput!) {
  IntegrationActionList(input: $input) {
    type
    href
    title
    icon
    syncStatus
    errorCount
  }
}
    `;

/**
 * __useProjectDetailsHeaderIntegrationActionListQuery__
 *
 * To run a query within a Vue component, call `useProjectDetailsHeaderIntegrationActionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailsHeaderIntegrationActionListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectDetailsHeaderIntegrationActionListQuery({
 *   input: // value for 'input'
 * });
 */
export function useProjectDetailsHeaderIntegrationActionListQuery(variables: ProjectDetailsHeaderIntegrationActionListQueryVariables | VueCompositionApi.Ref<ProjectDetailsHeaderIntegrationActionListQueryVariables> | ReactiveFunction<ProjectDetailsHeaderIntegrationActionListQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderIntegrationActionListQuery, ProjectDetailsHeaderIntegrationActionListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderIntegrationActionListQuery, ProjectDetailsHeaderIntegrationActionListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderIntegrationActionListQuery, ProjectDetailsHeaderIntegrationActionListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectDetailsHeaderIntegrationActionListQuery, ProjectDetailsHeaderIntegrationActionListQueryVariables>(ProjectDetailsHeaderIntegrationActionListDocument, variables, options);
}
export function useProjectDetailsHeaderIntegrationActionListLazyQuery(variables?: ProjectDetailsHeaderIntegrationActionListQueryVariables | VueCompositionApi.Ref<ProjectDetailsHeaderIntegrationActionListQueryVariables> | ReactiveFunction<ProjectDetailsHeaderIntegrationActionListQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderIntegrationActionListQuery, ProjectDetailsHeaderIntegrationActionListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderIntegrationActionListQuery, ProjectDetailsHeaderIntegrationActionListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectDetailsHeaderIntegrationActionListQuery, ProjectDetailsHeaderIntegrationActionListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectDetailsHeaderIntegrationActionListQuery, ProjectDetailsHeaderIntegrationActionListQueryVariables>(ProjectDetailsHeaderIntegrationActionListDocument, variables, options);
}
export type ProjectDetailsHeaderIntegrationActionListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectDetailsHeaderIntegrationActionListQuery, ProjectDetailsHeaderIntegrationActionListQueryVariables>;
export const ProjectDetailsHeaderProjectRestoreDocument = gql`
    mutation projectDetailsHeaderProjectRestore($id: ID!) {
  ProjectRestore(id: $id) {
    __typename
    id
    isDeleted
  }
}
    `;

/**
 * __useProjectDetailsHeaderProjectRestoreMutation__
 *
 * To run a mutation, you first call `useProjectDetailsHeaderProjectRestoreMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailsHeaderProjectRestoreMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProjectDetailsHeaderProjectRestoreMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useProjectDetailsHeaderProjectRestoreMutation(options: VueApolloComposable.UseMutationOptions<ProjectDetailsHeaderProjectRestoreMutation, ProjectDetailsHeaderProjectRestoreMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProjectDetailsHeaderProjectRestoreMutation, ProjectDetailsHeaderProjectRestoreMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProjectDetailsHeaderProjectRestoreMutation, ProjectDetailsHeaderProjectRestoreMutationVariables>(ProjectDetailsHeaderProjectRestoreDocument, options);
}
export type ProjectDetailsHeaderProjectRestoreMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProjectDetailsHeaderProjectRestoreMutation, ProjectDetailsHeaderProjectRestoreMutationVariables>;
export const ProjectHealthDocument = gql`
    query projectHealth($input: ProjectHealthInput) {
  ProjectHealth(input: $input) {
    project {
      id
      name
    }
    projectHealthScore
    createdDatetime
  }
}
    `;

/**
 * __useProjectHealthQuery__
 *
 * To run a query within a Vue component, call `useProjectHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectHealthQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectHealthQuery({
 *   input: // value for 'input'
 * });
 */
export function useProjectHealthQuery(variables: ProjectHealthQueryVariables | VueCompositionApi.Ref<ProjectHealthQueryVariables> | ReactiveFunction<ProjectHealthQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectHealthQuery, ProjectHealthQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectHealthQuery, ProjectHealthQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectHealthQuery, ProjectHealthQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectHealthQuery, ProjectHealthQueryVariables>(ProjectHealthDocument, variables, options);
}
export function useProjectHealthLazyQuery(variables: ProjectHealthQueryVariables | VueCompositionApi.Ref<ProjectHealthQueryVariables> | ReactiveFunction<ProjectHealthQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectHealthQuery, ProjectHealthQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectHealthQuery, ProjectHealthQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectHealthQuery, ProjectHealthQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectHealthQuery, ProjectHealthQueryVariables>(ProjectHealthDocument, variables, options);
}
export type ProjectHealthQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectHealthQuery, ProjectHealthQueryVariables>;
export const ProjectsListMetricsProjectIdsDocument = gql`
    query projectsListMetricsProjectIds($input: SummaryBlockInput) {
  ProjectsListMetricsProjectIds(input: $input)
}
    `;

/**
 * __useProjectsListMetricsProjectIdsQuery__
 *
 * To run a query within a Vue component, call `useProjectsListMetricsProjectIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsListMetricsProjectIdsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectsListMetricsProjectIdsQuery({
 *   input: // value for 'input'
 * });
 */
export function useProjectsListMetricsProjectIdsQuery(variables: ProjectsListMetricsProjectIdsQueryVariables | VueCompositionApi.Ref<ProjectsListMetricsProjectIdsQueryVariables> | ReactiveFunction<ProjectsListMetricsProjectIdsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectsListMetricsProjectIdsQuery, ProjectsListMetricsProjectIdsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectsListMetricsProjectIdsQuery, ProjectsListMetricsProjectIdsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectsListMetricsProjectIdsQuery, ProjectsListMetricsProjectIdsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectsListMetricsProjectIdsQuery, ProjectsListMetricsProjectIdsQueryVariables>(ProjectsListMetricsProjectIdsDocument, variables, options);
}
export function useProjectsListMetricsProjectIdsLazyQuery(variables: ProjectsListMetricsProjectIdsQueryVariables | VueCompositionApi.Ref<ProjectsListMetricsProjectIdsQueryVariables> | ReactiveFunction<ProjectsListMetricsProjectIdsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectsListMetricsProjectIdsQuery, ProjectsListMetricsProjectIdsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectsListMetricsProjectIdsQuery, ProjectsListMetricsProjectIdsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectsListMetricsProjectIdsQuery, ProjectsListMetricsProjectIdsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectsListMetricsProjectIdsQuery, ProjectsListMetricsProjectIdsQueryVariables>(ProjectsListMetricsProjectIdsDocument, variables, options);
}
export type ProjectsListMetricsProjectIdsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectsListMetricsProjectIdsQuery, ProjectsListMetricsProjectIdsQueryVariables>;
export const ProjectMetricsConfigSaveDocument = gql`
    mutation projectMetricsConfigSave($input: ProjectMetricsConfigSaveInput!) {
  ProjectMetricsConfigSave(input: $input) {
    id
    hasHistogram
    isHistogramSupported
    metricId
    alertCondition
    alertThreshold
    alertType
    notificationTypes
  }
}
    `;

/**
 * __useProjectMetricsConfigSaveMutation__
 *
 * To run a mutation, you first call `useProjectMetricsConfigSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProjectMetricsConfigSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProjectMetricsConfigSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useProjectMetricsConfigSaveMutation(options: VueApolloComposable.UseMutationOptions<ProjectMetricsConfigSaveMutation, ProjectMetricsConfigSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProjectMetricsConfigSaveMutation, ProjectMetricsConfigSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProjectMetricsConfigSaveMutation, ProjectMetricsConfigSaveMutationVariables>(ProjectMetricsConfigSaveDocument, options);
}
export type ProjectMetricsConfigSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProjectMetricsConfigSaveMutation, ProjectMetricsConfigSaveMutationVariables>;
export const ProjectMetricsConfigDocument = gql`
    query projectMetricsConfig($input: ProjectMetricConfigInput) {
  ProjectMetricConfig(input: $input) {
    id
    hasHistogram
    isHistogramSupported
    metricId
    alertCondition
    alertThreshold
    alertType
    notificationTypes
    supportedAlertTypes
    isWatchdogLimitReached
    isPastPeriod
    retainerPeriod {
      id
      name
      startDate
      endDate
    }
  }
}
    `;

/**
 * __useProjectMetricsConfigQuery__
 *
 * To run a query within a Vue component, call `useProjectMetricsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMetricsConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectMetricsConfigQuery({
 *   input: // value for 'input'
 * });
 */
export function useProjectMetricsConfigQuery(variables: ProjectMetricsConfigQueryVariables | VueCompositionApi.Ref<ProjectMetricsConfigQueryVariables> | ReactiveFunction<ProjectMetricsConfigQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectMetricsConfigQuery, ProjectMetricsConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectMetricsConfigQuery, ProjectMetricsConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectMetricsConfigQuery, ProjectMetricsConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectMetricsConfigQuery, ProjectMetricsConfigQueryVariables>(ProjectMetricsConfigDocument, variables, options);
}
export function useProjectMetricsConfigLazyQuery(variables: ProjectMetricsConfigQueryVariables | VueCompositionApi.Ref<ProjectMetricsConfigQueryVariables> | ReactiveFunction<ProjectMetricsConfigQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectMetricsConfigQuery, ProjectMetricsConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectMetricsConfigQuery, ProjectMetricsConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectMetricsConfigQuery, ProjectMetricsConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectMetricsConfigQuery, ProjectMetricsConfigQueryVariables>(ProjectMetricsConfigDocument, variables, options);
}
export type ProjectMetricsConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectMetricsConfigQuery, ProjectMetricsConfigQueryVariables>;
export const ProjectMetricsDocument = gql`
    query projectMetrics($input: ProjectMetricsInput) {
  ProjectMetrics(input: $input) {
    id
    title
    value
    unit
    valueState
    type
    secondaryValue
    secondaryUnit
    secondaryDescription
    secondaryValueState
    isSecondaryValueFirst
    config {
      id
      hasHistogram
      isHistogramSupported
      notificationTypes
      metricId
      isAlertTriggered
      isPastPeriod
      histogramLogs {
        id
        loggedDateTime
        value
      }
    }
  }
}
    `;

/**
 * __useProjectMetricsQuery__
 *
 * To run a query within a Vue component, call `useProjectMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMetricsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectMetricsQuery({
 *   input: // value for 'input'
 * });
 */
export function useProjectMetricsQuery(variables: ProjectMetricsQueryVariables | VueCompositionApi.Ref<ProjectMetricsQueryVariables> | ReactiveFunction<ProjectMetricsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectMetricsQuery, ProjectMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectMetricsQuery, ProjectMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectMetricsQuery, ProjectMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectMetricsQuery, ProjectMetricsQueryVariables>(ProjectMetricsDocument, variables, options);
}
export function useProjectMetricsLazyQuery(variables: ProjectMetricsQueryVariables | VueCompositionApi.Ref<ProjectMetricsQueryVariables> | ReactiveFunction<ProjectMetricsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectMetricsQuery, ProjectMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectMetricsQuery, ProjectMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectMetricsQuery, ProjectMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectMetricsQuery, ProjectMetricsQueryVariables>(ProjectMetricsDocument, variables, options);
}
export type ProjectMetricsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectMetricsQuery, ProjectMetricsQueryVariables>;
export const ProjectMetricsSettingsSaveDocument = gql`
    mutation projectMetricsSettingsSave($input: ProjectMetricsSettingsSaveInput!) {
  ProjectMetricsSettingsSave(input: $input)
}
    `;

/**
 * __useProjectMetricsSettingsSaveMutation__
 *
 * To run a mutation, you first call `useProjectMetricsSettingsSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProjectMetricsSettingsSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProjectMetricsSettingsSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useProjectMetricsSettingsSaveMutation(options: VueApolloComposable.UseMutationOptions<ProjectMetricsSettingsSaveMutation, ProjectMetricsSettingsSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProjectMetricsSettingsSaveMutation, ProjectMetricsSettingsSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProjectMetricsSettingsSaveMutation, ProjectMetricsSettingsSaveMutationVariables>(ProjectMetricsSettingsSaveDocument, options);
}
export type ProjectMetricsSettingsSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProjectMetricsSettingsSaveMutation, ProjectMetricsSettingsSaveMutationVariables>;
export const ProjectMetricsSettingListDocument = gql`
    query projectMetricsSettingList($input: ProjectMetricsInput) {
  ProjectMetricsSettings(input: $input) {
    id
    isActive
    title
  }
}
    `;

/**
 * __useProjectMetricsSettingListQuery__
 *
 * To run a query within a Vue component, call `useProjectMetricsSettingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMetricsSettingListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectMetricsSettingListQuery({
 *   input: // value for 'input'
 * });
 */
export function useProjectMetricsSettingListQuery(variables: ProjectMetricsSettingListQueryVariables | VueCompositionApi.Ref<ProjectMetricsSettingListQueryVariables> | ReactiveFunction<ProjectMetricsSettingListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectMetricsSettingListQuery, ProjectMetricsSettingListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectMetricsSettingListQuery, ProjectMetricsSettingListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectMetricsSettingListQuery, ProjectMetricsSettingListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectMetricsSettingListQuery, ProjectMetricsSettingListQueryVariables>(ProjectMetricsSettingListDocument, variables, options);
}
export function useProjectMetricsSettingListLazyQuery(variables: ProjectMetricsSettingListQueryVariables | VueCompositionApi.Ref<ProjectMetricsSettingListQueryVariables> | ReactiveFunction<ProjectMetricsSettingListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectMetricsSettingListQuery, ProjectMetricsSettingListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectMetricsSettingListQuery, ProjectMetricsSettingListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectMetricsSettingListQuery, ProjectMetricsSettingListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectMetricsSettingListQuery, ProjectMetricsSettingListQueryVariables>(ProjectMetricsSettingListDocument, variables, options);
}
export type ProjectMetricsSettingListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectMetricsSettingListQuery, ProjectMetricsSettingListQueryVariables>;
export const ProjectModifyModalDocument = gql`
    query ProjectModifyModal($projectParams: ProjectParamsInput!) {
  PhasesTaskSets(projectParams: $projectParams) {
    ... on ProjectPhase {
      ...projectPhasesProjectPhase
    }
    ... on TaskSet {
      ...projectPhasesTaskSet
    }
  }
  Project(projectParams: $projectParams) {
    id
    accountId
    projectType
    name
    company {
      id
      name
      unpaidInvoices {
        ...contactUnpaidInvoicesFields
      }
    }
    number
    isPersonal
    date
    deadline
    color
    manager {
      ...userAssignSelectUser
    }
    cupoUsers {
      id
    }
    members {
      id
    }
    isPrivate
    retainer {
      frequency
      frequencyType
      noOfPeriods
      isPeriodDurationEnabled
      budgetType
      periodDuration
      periodSum
      periodBillsSum
      periodExpensesSum
      periodLaborCostSum
    }
    budgetType
    quotedBudgetSums {
      duration
      invoices
      bills
      expenses
      laborCost
      currency
    }
    useBillsExpensesInCalculations
    budgetSums {
      duration
      bills
      invoices
      expenses
      laborCost
      currency
    }
    duration
    priceList {
      id
      name
      currency
      isDefault
    }
    useRoles
    projectTags {
      id
      title
      isGroup
      parent {
        id
        title
      }
    }
    accounts {
      id
      name
      isInUse
    }
    projectPhases {
      id
      type
      title
      startDate
      endDate
    }
    hasBackToBackPhases
    revenueBudget {
      id
      name
    }
    localPriceList {
      id
      name
    }
    shouldDisableCalculationType
    permissions {
      canModify
      canDelete
    }
    costBudget {
      id
      name
    }
    numberOfTasks
  }
}
    ${ProjectPhasesProjectPhaseFragmentDoc}
${ProjectPhasesTaskSetFragmentDoc}
${ContactUnpaidInvoicesFieldsFragmentDoc}
${UserAssignSelectUserFragmentDoc}`;

/**
 * __useProjectModifyModalQuery__
 *
 * To run a query within a Vue component, call `useProjectModifyModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectModifyModalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectModifyModalQuery({
 *   projectParams: // value for 'projectParams'
 * });
 */
export function useProjectModifyModalQuery(variables: ProjectModifyModalQueryVariables | VueCompositionApi.Ref<ProjectModifyModalQueryVariables> | ReactiveFunction<ProjectModifyModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectModifyModalQuery, ProjectModifyModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectModifyModalQuery, ProjectModifyModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectModifyModalQuery, ProjectModifyModalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectModifyModalQuery, ProjectModifyModalQueryVariables>(ProjectModifyModalDocument, variables, options);
}
export function useProjectModifyModalLazyQuery(variables?: ProjectModifyModalQueryVariables | VueCompositionApi.Ref<ProjectModifyModalQueryVariables> | ReactiveFunction<ProjectModifyModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectModifyModalQuery, ProjectModifyModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectModifyModalQuery, ProjectModifyModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectModifyModalQuery, ProjectModifyModalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectModifyModalQuery, ProjectModifyModalQueryVariables>(ProjectModifyModalDocument, variables, options);
}
export type ProjectModifyModalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectModifyModalQuery, ProjectModifyModalQueryVariables>;
export const ProjectPhasesAndTaskSetsSaveDocument = gql`
    mutation projectPhasesAndTaskSetsSave($input: ProjectPhasesAndTaskSetsSaveInput!) {
  ProjectPhasesAndTaskSetsSave(input: $input) {
    id
  }
}
    `;

/**
 * __useProjectPhasesAndTaskSetsSaveMutation__
 *
 * To run a mutation, you first call `useProjectPhasesAndTaskSetsSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProjectPhasesAndTaskSetsSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProjectPhasesAndTaskSetsSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useProjectPhasesAndTaskSetsSaveMutation(options: VueApolloComposable.UseMutationOptions<ProjectPhasesAndTaskSetsSaveMutation, ProjectPhasesAndTaskSetsSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProjectPhasesAndTaskSetsSaveMutation, ProjectPhasesAndTaskSetsSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProjectPhasesAndTaskSetsSaveMutation, ProjectPhasesAndTaskSetsSaveMutationVariables>(ProjectPhasesAndTaskSetsSaveDocument, options);
}
export type ProjectPhasesAndTaskSetsSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProjectPhasesAndTaskSetsSaveMutation, ProjectPhasesAndTaskSetsSaveMutationVariables>;
export const ContactDetailsDocument = gql`
    query ContactDetails($id: ID!) {
  Contact(id: $id) {
    id
    unpaidInvoices {
      ...contactUnpaidInvoicesFields
    }
    clientProfile {
      id
      priceList {
        id
      }
    }
    customFields {
      id
      type
      value {
        ... on StringCustomFieldValue {
          stringValue
        }
        ... on DateCustomFieldValue {
          dateValue
        }
        ... on DateTimeCustomFieldValue {
          dateTimeValue
        }
        ... on BoolCustomFieldValue {
          boolValue
        }
        ... on FloatCustomFieldValue {
          floatValue
        }
        ... on FloatRangeCustomFieldValue {
          floatValueFrom
          floatValueTo
        }
        ... on IntCustomFieldValue {
          intValue
        }
        ... on ImageCustomFieldValue {
          file {
            id
          }
        }
        ... on RelationCustomFieldValue {
          relation {
            ... on Project {
              id
              name
            }
            ... on User {
              id
              name
            }
            ... on Contact {
              id
              name
            }
            ... on CalendarEvent {
              id
              name
            }
            ... on Task {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${ContactUnpaidInvoicesFieldsFragmentDoc}`;

/**
 * __useContactDetailsQuery__
 *
 * To run a query within a Vue component, call `useContactDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContactDetailsQuery({
 *   id: // value for 'id'
 * });
 */
export function useContactDetailsQuery(variables: ContactDetailsQueryVariables | VueCompositionApi.Ref<ContactDetailsQueryVariables> | ReactiveFunction<ContactDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContactDetailsQuery, ContactDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContactDetailsQuery, ContactDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContactDetailsQuery, ContactDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContactDetailsQuery, ContactDetailsQueryVariables>(ContactDetailsDocument, variables, options);
}
export function useContactDetailsLazyQuery(variables?: ContactDetailsQueryVariables | VueCompositionApi.Ref<ContactDetailsQueryVariables> | ReactiveFunction<ContactDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContactDetailsQuery, ContactDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContactDetailsQuery, ContactDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContactDetailsQuery, ContactDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContactDetailsQuery, ContactDetailsQueryVariables>(ContactDetailsDocument, variables, options);
}
export type ContactDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContactDetailsQuery, ContactDetailsQueryVariables>;
export const ProjectDeleteDocument = gql`
    mutation projectDelete($id: ID!) {
  ProjectDelete(id: $id)
}
    `;

/**
 * __useProjectDeleteMutation__
 *
 * To run a mutation, you first call `useProjectDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProjectDeleteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useProjectDeleteMutation(options: VueApolloComposable.UseMutationOptions<ProjectDeleteMutation, ProjectDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProjectDeleteMutation, ProjectDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProjectDeleteMutation, ProjectDeleteMutationVariables>(ProjectDeleteDocument, options);
}
export type ProjectDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProjectDeleteMutation, ProjectDeleteMutationVariables>;
export const ProjectNextHighestNumberDocument = gql`
    query projectNextHighestNumber {
  ProjectNextNumber
}
    `;

/**
 * __useProjectNextHighestNumberQuery__
 *
 * To run a query within a Vue component, call `useProjectNextHighestNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectNextHighestNumberQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectNextHighestNumberQuery();
 */
export function useProjectNextHighestNumberQuery(options: VueApolloComposable.UseQueryOptions<ProjectNextHighestNumberQuery, ProjectNextHighestNumberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectNextHighestNumberQuery, ProjectNextHighestNumberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectNextHighestNumberQuery, ProjectNextHighestNumberQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectNextHighestNumberQuery, ProjectNextHighestNumberQueryVariables>(ProjectNextHighestNumberDocument, {}, options);
}
export function useProjectNextHighestNumberLazyQuery(options: VueApolloComposable.UseQueryOptions<ProjectNextHighestNumberQuery, ProjectNextHighestNumberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectNextHighestNumberQuery, ProjectNextHighestNumberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectNextHighestNumberQuery, ProjectNextHighestNumberQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectNextHighestNumberQuery, ProjectNextHighestNumberQueryVariables>(ProjectNextHighestNumberDocument, {}, options);
}
export type ProjectNextHighestNumberQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectNextHighestNumberQuery, ProjectNextHighestNumberQueryVariables>;
export const ProjectRelationsDocument = gql`
    query ProjectRelations($id: ID!) {
  ProjectRelations(id: $id)
}
    `;

/**
 * __useProjectRelationsQuery__
 *
 * To run a query within a Vue component, call `useProjectRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRelationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectRelationsQuery({
 *   id: // value for 'id'
 * });
 */
export function useProjectRelationsQuery(variables: ProjectRelationsQueryVariables | VueCompositionApi.Ref<ProjectRelationsQueryVariables> | ReactiveFunction<ProjectRelationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectRelationsQuery, ProjectRelationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectRelationsQuery, ProjectRelationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectRelationsQuery, ProjectRelationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectRelationsQuery, ProjectRelationsQueryVariables>(ProjectRelationsDocument, variables, options);
}
export function useProjectRelationsLazyQuery(variables?: ProjectRelationsQueryVariables | VueCompositionApi.Ref<ProjectRelationsQueryVariables> | ReactiveFunction<ProjectRelationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectRelationsQuery, ProjectRelationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectRelationsQuery, ProjectRelationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectRelationsQuery, ProjectRelationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectRelationsQuery, ProjectRelationsQueryVariables>(ProjectRelationsDocument, variables, options);
}
export type ProjectRelationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectRelationsQuery, ProjectRelationsQueryVariables>;
export const ProjectSaveDocument = gql`
    mutation projectSave($input: ProjectSaveInput!) {
  ProjectSave(input: $input) {
    __typename
    id
    name
    manager {
      id
    }
    members {
      id
    }
    cupoUsers {
      id
    }
    projectPhases {
      id
      title
      ordering
      startDate
      endDate
      type
    }
  }
}
    `;

/**
 * __useProjectSaveMutation__
 *
 * To run a mutation, you first call `useProjectSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProjectSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProjectSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useProjectSaveMutation(options: VueApolloComposable.UseMutationOptions<ProjectSaveMutation, ProjectSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProjectSaveMutation, ProjectSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProjectSaveMutation, ProjectSaveMutationVariables>(ProjectSaveDocument, options);
}
export type ProjectSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProjectSaveMutation, ProjectSaveMutationVariables>;
export const ProjectTabsSettingsDocument = gql`
    query projectTabsSettings($tabsListInput: ProjectTabsListInput!) {
  ProjectTabsList(input: $tabsListInput) {
    key
    isActive
    shortcuts {
      id
      icon
      label
      link
    }
    subTabs {
      key
      isActive
    }
  }
}
    `;

/**
 * __useProjectTabsSettingsQuery__
 *
 * To run a query within a Vue component, call `useProjectTabsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTabsSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectTabsSettingsQuery({
 *   tabsListInput: // value for 'tabsListInput'
 * });
 */
export function useProjectTabsSettingsQuery(variables: ProjectTabsSettingsQueryVariables | VueCompositionApi.Ref<ProjectTabsSettingsQueryVariables> | ReactiveFunction<ProjectTabsSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectTabsSettingsQuery, ProjectTabsSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectTabsSettingsQuery, ProjectTabsSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectTabsSettingsQuery, ProjectTabsSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectTabsSettingsQuery, ProjectTabsSettingsQueryVariables>(ProjectTabsSettingsDocument, variables, options);
}
export function useProjectTabsSettingsLazyQuery(variables?: ProjectTabsSettingsQueryVariables | VueCompositionApi.Ref<ProjectTabsSettingsQueryVariables> | ReactiveFunction<ProjectTabsSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectTabsSettingsQuery, ProjectTabsSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectTabsSettingsQuery, ProjectTabsSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectTabsSettingsQuery, ProjectTabsSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectTabsSettingsQuery, ProjectTabsSettingsQueryVariables>(ProjectTabsSettingsDocument, variables, options);
}
export type ProjectTabsSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectTabsSettingsQuery, ProjectTabsSettingsQueryVariables>;
export const QuoteDetailsDocument = gql`
    query QuoteDetails($id: ID!) {
  Quote(id: $id) {
    id
    status {
      id
      statusId
    }
    lines {
      id
    }
  }
}
    `;

/**
 * __useQuoteDetailsQuery__
 *
 * To run a query within a Vue component, call `useQuoteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuoteDetailsQuery({
 *   id: // value for 'id'
 * });
 */
export function useQuoteDetailsQuery(variables: QuoteDetailsQueryVariables | VueCompositionApi.Ref<QuoteDetailsQueryVariables> | ReactiveFunction<QuoteDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteDetailsQuery, QuoteDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteDetailsQuery, QuoteDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteDetailsQuery, QuoteDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QuoteDetailsQuery, QuoteDetailsQueryVariables>(QuoteDetailsDocument, variables, options);
}
export function useQuoteDetailsLazyQuery(variables?: QuoteDetailsQueryVariables | VueCompositionApi.Ref<QuoteDetailsQueryVariables> | ReactiveFunction<QuoteDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteDetailsQuery, QuoteDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteDetailsQuery, QuoteDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteDetailsQuery, QuoteDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QuoteDetailsQuery, QuoteDetailsQueryVariables>(QuoteDetailsDocument, variables, options);
}
export type QuoteDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QuoteDetailsQuery, QuoteDetailsQueryVariables>;
export const QuoteStatusesListDocument = gql`
    query QuoteStatusesList {
  StatusesList(input: {filters: {module: quotes}}) {
    id
    statusId
    name
  }
}
    `;

/**
 * __useQuoteStatusesListQuery__
 *
 * To run a query within a Vue component, call `useQuoteStatusesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteStatusesListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuoteStatusesListQuery();
 */
export function useQuoteStatusesListQuery(options: VueApolloComposable.UseQueryOptions<QuoteStatusesListQuery, QuoteStatusesListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteStatusesListQuery, QuoteStatusesListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteStatusesListQuery, QuoteStatusesListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QuoteStatusesListQuery, QuoteStatusesListQueryVariables>(QuoteStatusesListDocument, {}, options);
}
export function useQuoteStatusesListLazyQuery(options: VueApolloComposable.UseQueryOptions<QuoteStatusesListQuery, QuoteStatusesListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteStatusesListQuery, QuoteStatusesListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteStatusesListQuery, QuoteStatusesListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QuoteStatusesListQuery, QuoteStatusesListQueryVariables>(QuoteStatusesListDocument, {}, options);
}
export type QuoteStatusesListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QuoteStatusesListQuery, QuoteStatusesListQueryVariables>;
export const ProjectProfitTableDocument = gql`
    query ProjectProfitTable($projectInput: ProjectParamsInput!, $projectProfitDataInput: ProjectProfitDataInput!) {
  Project(projectParams: $projectInput) {
    id
    profitData(input: $projectProfitDataInput) {
      revenueBudget
      revenueRecognized
      revenueInvoiced
      revenueForecasted
      costBudget
      costRecognized
      costInvoiced
      costForecasted
      internalCostBudget
      internalCostRecognized
      internalCostInvoiced
      internalCostForecasted
      externalCostBudget
      externalCostRecognized
      externalCostInvoiced
      externalCostForecasted
    }
  }
}
    `;

/**
 * __useProjectProfitTableQuery__
 *
 * To run a query within a Vue component, call `useProjectProfitTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectProfitTableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectProfitTableQuery({
 *   projectInput: // value for 'projectInput'
 *   projectProfitDataInput: // value for 'projectProfitDataInput'
 * });
 */
export function useProjectProfitTableQuery(variables: ProjectProfitTableQueryVariables | VueCompositionApi.Ref<ProjectProfitTableQueryVariables> | ReactiveFunction<ProjectProfitTableQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectProfitTableQuery, ProjectProfitTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectProfitTableQuery, ProjectProfitTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectProfitTableQuery, ProjectProfitTableQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectProfitTableQuery, ProjectProfitTableQueryVariables>(ProjectProfitTableDocument, variables, options);
}
export function useProjectProfitTableLazyQuery(variables?: ProjectProfitTableQueryVariables | VueCompositionApi.Ref<ProjectProfitTableQueryVariables> | ReactiveFunction<ProjectProfitTableQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectProfitTableQuery, ProjectProfitTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectProfitTableQuery, ProjectProfitTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectProfitTableQuery, ProjectProfitTableQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectProfitTableQuery, ProjectProfitTableQueryVariables>(ProjectProfitTableDocument, variables, options);
}
export type ProjectProfitTableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectProfitTableQuery, ProjectProfitTableQueryVariables>;
export const ProjectProgressDocument = gql`
    query projectProgress($projectInput: ProjectParamsInput!) {
  Project(projectParams: $projectInput) @persist {
    id
    duration
    doneDuration
    toDoDuration
    projectPhases {
      id
      title
      ordering
      startDate
      endDate
      type
    }
  }
}
    `;

/**
 * __useProjectProgressQuery__
 *
 * To run a query within a Vue component, call `useProjectProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectProgressQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectProgressQuery({
 *   projectInput: // value for 'projectInput'
 * });
 */
export function useProjectProgressQuery(variables: ProjectProgressQueryVariables | VueCompositionApi.Ref<ProjectProgressQueryVariables> | ReactiveFunction<ProjectProgressQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectProgressQuery, ProjectProgressQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectProgressQuery, ProjectProgressQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectProgressQuery, ProjectProgressQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectProgressQuery, ProjectProgressQueryVariables>(ProjectProgressDocument, variables, options);
}
export function useProjectProgressLazyQuery(variables?: ProjectProgressQueryVariables | VueCompositionApi.Ref<ProjectProgressQueryVariables> | ReactiveFunction<ProjectProgressQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectProgressQuery, ProjectProgressQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectProgressQuery, ProjectProgressQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectProgressQuery, ProjectProgressQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectProgressQuery, ProjectProgressQueryVariables>(ProjectProgressDocument, variables, options);
}
export type ProjectProgressQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectProgressQuery, ProjectProgressQueryVariables>;
export const BudgetChartDocument = gql`
    query budgetChart($projectInput: ProjectParamsInput!, $projectProgressInput: ProjectProgressInput!) {
  Project(projectParams: $projectInput) {
    id
    company {
      id
      type
    }
    progressData(input: $projectProgressInput) {
      timeBudget
      groupName
      plannedTime
      actualTime
      forecastedTime
      monetaryBudget
      actualRevenue
      forecastedRevenue
      actualCost
      bookingsCost
      costBudget
      forecastedCost
      tasksCost
    }
  }
}
    `;

/**
 * __useBudgetChartQuery__
 *
 * To run a query within a Vue component, call `useBudgetChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetChartQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBudgetChartQuery({
 *   projectInput: // value for 'projectInput'
 *   projectProgressInput: // value for 'projectProgressInput'
 * });
 */
export function useBudgetChartQuery(variables: BudgetChartQueryVariables | VueCompositionApi.Ref<BudgetChartQueryVariables> | ReactiveFunction<BudgetChartQueryVariables>, options: VueApolloComposable.UseQueryOptions<BudgetChartQuery, BudgetChartQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BudgetChartQuery, BudgetChartQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BudgetChartQuery, BudgetChartQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BudgetChartQuery, BudgetChartQueryVariables>(BudgetChartDocument, variables, options);
}
export function useBudgetChartLazyQuery(variables?: BudgetChartQueryVariables | VueCompositionApi.Ref<BudgetChartQueryVariables> | ReactiveFunction<BudgetChartQueryVariables>, options: VueApolloComposable.UseQueryOptions<BudgetChartQuery, BudgetChartQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BudgetChartQuery, BudgetChartQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BudgetChartQuery, BudgetChartQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BudgetChartQuery, BudgetChartQueryVariables>(BudgetChartDocument, variables, options);
}
export type BudgetChartQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BudgetChartQuery, BudgetChartQueryVariables>;
export const BurnUpChartDocument = gql`
    query burnUpChart($projectInput: ProjectParamsInput!, $projectProgressInput: ProjectProgressInput!) {
  Project(projectParams: $projectInput) {
    id
    date
    deadline
    company {
      id
      type
    }
    progressData(input: $projectProgressInput) {
      timeBudget
      groupName
      actualTime
      plannedTime
      forecastedTime
      monetaryBudget
      actualRevenue
      forecastedRevenue
      actualCost
      bookingsCost
      costBudget
      forecastedCost
      tasksCost
    }
  }
}
    `;

/**
 * __useBurnUpChartQuery__
 *
 * To run a query within a Vue component, call `useBurnUpChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useBurnUpChartQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBurnUpChartQuery({
 *   projectInput: // value for 'projectInput'
 *   projectProgressInput: // value for 'projectProgressInput'
 * });
 */
export function useBurnUpChartQuery(variables: BurnUpChartQueryVariables | VueCompositionApi.Ref<BurnUpChartQueryVariables> | ReactiveFunction<BurnUpChartQueryVariables>, options: VueApolloComposable.UseQueryOptions<BurnUpChartQuery, BurnUpChartQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BurnUpChartQuery, BurnUpChartQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BurnUpChartQuery, BurnUpChartQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BurnUpChartQuery, BurnUpChartQueryVariables>(BurnUpChartDocument, variables, options);
}
export function useBurnUpChartLazyQuery(variables?: BurnUpChartQueryVariables | VueCompositionApi.Ref<BurnUpChartQueryVariables> | ReactiveFunction<BurnUpChartQueryVariables>, options: VueApolloComposable.UseQueryOptions<BurnUpChartQuery, BurnUpChartQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BurnUpChartQuery, BurnUpChartQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BurnUpChartQuery, BurnUpChartQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BurnUpChartQuery, BurnUpChartQueryVariables>(BurnUpChartDocument, variables, options);
}
export type BurnUpChartQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BurnUpChartQuery, BurnUpChartQueryVariables>;
export const ProjectRevenueForecastPeriodSaveDocument = gql`
    mutation projectRevenueForecastPeriodSave($input: RevenueForecastPeriodSaveInput!) {
  RevenueForecastPeriodSave(input: $input) {
    id
    period
    earnedRevenue
    forecastedRevenue
    revenue
    isRevenueSetByUser
  }
}
    `;

/**
 * __useProjectRevenueForecastPeriodSaveMutation__
 *
 * To run a mutation, you first call `useProjectRevenueForecastPeriodSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProjectRevenueForecastPeriodSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProjectRevenueForecastPeriodSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useProjectRevenueForecastPeriodSaveMutation(options: VueApolloComposable.UseMutationOptions<ProjectRevenueForecastPeriodSaveMutation, ProjectRevenueForecastPeriodSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProjectRevenueForecastPeriodSaveMutation, ProjectRevenueForecastPeriodSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProjectRevenueForecastPeriodSaveMutation, ProjectRevenueForecastPeriodSaveMutationVariables>(ProjectRevenueForecastPeriodSaveDocument, options);
}
export type ProjectRevenueForecastPeriodSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProjectRevenueForecastPeriodSaveMutation, ProjectRevenueForecastPeriodSaveMutationVariables>;
export const ProjectRevenueForecastDocument = gql`
    query projectRevenueForecast($revenueForecastInput: ProjectRevenueForecastInput!) {
  ProjectRevenueForecast(input: $revenueForecastInput) {
    project {
      id
      priceList {
        id
        currency
      }
      budgetType
      useBillsExpensesInCalculations
      retainer {
        id
        budgetType
      }
    }
    quotedTotal
    periods {
      id
      period
      earnedRevenue
      forecastedRevenue
      revenue
      isRevenueSetByUser
    }
  }
  CurrenciesList {
    id
    name
  }
}
    `;

/**
 * __useProjectRevenueForecastQuery__
 *
 * To run a query within a Vue component, call `useProjectRevenueForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRevenueForecastQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectRevenueForecastQuery({
 *   revenueForecastInput: // value for 'revenueForecastInput'
 * });
 */
export function useProjectRevenueForecastQuery(variables: ProjectRevenueForecastQueryVariables | VueCompositionApi.Ref<ProjectRevenueForecastQueryVariables> | ReactiveFunction<ProjectRevenueForecastQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectRevenueForecastQuery, ProjectRevenueForecastQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectRevenueForecastQuery, ProjectRevenueForecastQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectRevenueForecastQuery, ProjectRevenueForecastQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectRevenueForecastQuery, ProjectRevenueForecastQueryVariables>(ProjectRevenueForecastDocument, variables, options);
}
export function useProjectRevenueForecastLazyQuery(variables?: ProjectRevenueForecastQueryVariables | VueCompositionApi.Ref<ProjectRevenueForecastQueryVariables> | ReactiveFunction<ProjectRevenueForecastQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectRevenueForecastQuery, ProjectRevenueForecastQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectRevenueForecastQuery, ProjectRevenueForecastQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectRevenueForecastQuery, ProjectRevenueForecastQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectRevenueForecastQuery, ProjectRevenueForecastQueryVariables>(ProjectRevenueForecastDocument, variables, options);
}
export type ProjectRevenueForecastQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectRevenueForecastQuery, ProjectRevenueForecastQueryVariables>;
export const TabsSaveDocument = gql`
    mutation tabsSave($input: TabsSaveInput!) {
  TabsSave(input: $input)
}
    `;

/**
 * __useTabsSaveMutation__
 *
 * To run a mutation, you first call `useTabsSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTabsSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTabsSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTabsSaveMutation(options: VueApolloComposable.UseMutationOptions<TabsSaveMutation, TabsSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TabsSaveMutation, TabsSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TabsSaveMutation, TabsSaveMutationVariables>(TabsSaveDocument, options);
}
export type TabsSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TabsSaveMutation, TabsSaveMutationVariables>;
export const ProjectTabsPageDocument = gql`
    query projectTabsPage($tabsListInput: ProjectTabsListInput!, $projectInput: ProjectParamsInput!) {
  Project(projectParams: $projectInput) {
    id
    createdDateTime
    createdBy {
      id
      initials
    }
    modifiedDateTime
    modifiedBy {
      id
      initials
    }
  }
  ProjectTabsList(input: $tabsListInput) {
    key
    isActive
    shortcuts {
      id
      icon
      label
      link
    }
    subTabs {
      key
      isActive
    }
  }
}
    `;

/**
 * __useProjectTabsPageQuery__
 *
 * To run a query within a Vue component, call `useProjectTabsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTabsPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectTabsPageQuery({
 *   tabsListInput: // value for 'tabsListInput'
 *   projectInput: // value for 'projectInput'
 * });
 */
export function useProjectTabsPageQuery(variables: ProjectTabsPageQueryVariables | VueCompositionApi.Ref<ProjectTabsPageQueryVariables> | ReactiveFunction<ProjectTabsPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectTabsPageQuery, ProjectTabsPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectTabsPageQuery, ProjectTabsPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectTabsPageQuery, ProjectTabsPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectTabsPageQuery, ProjectTabsPageQueryVariables>(ProjectTabsPageDocument, variables, options);
}
export function useProjectTabsPageLazyQuery(variables?: ProjectTabsPageQueryVariables | VueCompositionApi.Ref<ProjectTabsPageQueryVariables> | ReactiveFunction<ProjectTabsPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectTabsPageQuery, ProjectTabsPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectTabsPageQuery, ProjectTabsPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectTabsPageQuery, ProjectTabsPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectTabsPageQuery, ProjectTabsPageQueryVariables>(ProjectTabsPageDocument, variables, options);
}
export type ProjectTabsPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectTabsPageQuery, ProjectTabsPageQueryVariables>;
export const ProjectTaskListEnrichmentsDocument = gql`
    query projectTaskListEnrichments($taskListParams: TasksListInput!) {
  TasksList(input: $taskListParams) {
    ... on Task {
      ...TaskListEnrichmentFields
      subtasks {
        ... on Task {
          ...TaskListEnrichmentFields
        }
        ... on LimitedTask {
          id
          permissions {
            canView
            canModify
          }
        }
      }
    }
    ... on LimitedTask {
      id
      permissions {
        canView
        canModify
      }
    }
  }
}
    ${TaskListEnrichmentFieldsFragmentDoc}`;

/**
 * __useProjectTaskListEnrichmentsQuery__
 *
 * To run a query within a Vue component, call `useProjectTaskListEnrichmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTaskListEnrichmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectTaskListEnrichmentsQuery({
 *   taskListParams: // value for 'taskListParams'
 * });
 */
export function useProjectTaskListEnrichmentsQuery(variables: ProjectTaskListEnrichmentsQueryVariables | VueCompositionApi.Ref<ProjectTaskListEnrichmentsQueryVariables> | ReactiveFunction<ProjectTaskListEnrichmentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectTaskListEnrichmentsQuery, ProjectTaskListEnrichmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectTaskListEnrichmentsQuery, ProjectTaskListEnrichmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectTaskListEnrichmentsQuery, ProjectTaskListEnrichmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectTaskListEnrichmentsQuery, ProjectTaskListEnrichmentsQueryVariables>(ProjectTaskListEnrichmentsDocument, variables, options);
}
export function useProjectTaskListEnrichmentsLazyQuery(variables?: ProjectTaskListEnrichmentsQueryVariables | VueCompositionApi.Ref<ProjectTaskListEnrichmentsQueryVariables> | ReactiveFunction<ProjectTaskListEnrichmentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectTaskListEnrichmentsQuery, ProjectTaskListEnrichmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectTaskListEnrichmentsQuery, ProjectTaskListEnrichmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectTaskListEnrichmentsQuery, ProjectTaskListEnrichmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectTaskListEnrichmentsQuery, ProjectTaskListEnrichmentsQueryVariables>(ProjectTaskListEnrichmentsDocument, variables, options);
}
export type ProjectTaskListEnrichmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectTaskListEnrichmentsQuery, ProjectTaskListEnrichmentsQueryVariables>;
export const ProjectTaskListDocument = gql`
    query projectTaskList($taskListParams: TasksListInput!, $projectParams: ProjectParamsInput!) {
  TasksList(input: $taskListParams) {
    ...TaskListTask
    ...TaskListLimitedTask
  }
  Project(projectParams: $projectParams) {
    ...TaskListProject
  }
}
    ${TaskListTaskFragmentDoc}
${TaskListLimitedTaskFragmentDoc}
${TaskListProjectFragmentDoc}`;

/**
 * __useProjectTaskListQuery__
 *
 * To run a query within a Vue component, call `useProjectTaskListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTaskListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectTaskListQuery({
 *   taskListParams: // value for 'taskListParams'
 *   projectParams: // value for 'projectParams'
 * });
 */
export function useProjectTaskListQuery(variables: ProjectTaskListQueryVariables | VueCompositionApi.Ref<ProjectTaskListQueryVariables> | ReactiveFunction<ProjectTaskListQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectTaskListQuery, ProjectTaskListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectTaskListQuery, ProjectTaskListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectTaskListQuery, ProjectTaskListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectTaskListQuery, ProjectTaskListQueryVariables>(ProjectTaskListDocument, variables, options);
}
export function useProjectTaskListLazyQuery(variables?: ProjectTaskListQueryVariables | VueCompositionApi.Ref<ProjectTaskListQueryVariables> | ReactiveFunction<ProjectTaskListQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectTaskListQuery, ProjectTaskListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectTaskListQuery, ProjectTaskListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectTaskListQuery, ProjectTaskListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectTaskListQuery, ProjectTaskListQueryVariables>(ProjectTaskListDocument, variables, options);
}
export type ProjectTaskListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectTaskListQuery, ProjectTaskListQueryVariables>;
export const ProjectTaskListTaskSaveDocument = gql`
    mutation projectTaskListTaskSave($input: TaskSaveInput!) {
  TaskSave(input: $input) {
    ...TaskListTask
  }
}
    ${TaskListTaskFragmentDoc}`;

/**
 * __useProjectTaskListTaskSaveMutation__
 *
 * To run a mutation, you first call `useProjectTaskListTaskSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProjectTaskListTaskSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProjectTaskListTaskSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useProjectTaskListTaskSaveMutation(options: VueApolloComposable.UseMutationOptions<ProjectTaskListTaskSaveMutation, ProjectTaskListTaskSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProjectTaskListTaskSaveMutation, ProjectTaskListTaskSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProjectTaskListTaskSaveMutation, ProjectTaskListTaskSaveMutationVariables>(ProjectTaskListTaskSaveDocument, options);
}
export type ProjectTaskListTaskSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProjectTaskListTaskSaveMutation, ProjectTaskListTaskSaveMutationVariables>;
export const ProjectTemplatesDocument = gql`
    query projectTemplates {
  ProjectTemplates {
    id
    templateName
    projectType
  }
}
    `;

/**
 * __useProjectTemplatesQuery__
 *
 * To run a query within a Vue component, call `useProjectTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectTemplatesQuery();
 */
export function useProjectTemplatesQuery(options: VueApolloComposable.UseQueryOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>(ProjectTemplatesDocument, {}, options);
}
export function useProjectTemplatesLazyQuery(options: VueApolloComposable.UseQueryOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>(ProjectTemplatesDocument, {}, options);
}
export type ProjectTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>;
export const ProjectTimeFrameSaveDocument = gql`
    mutation projectTimeFrameSave($input: ProjectDatesSaveInput!) {
  ProjectDatesSave(input: $input) {
    id
    date
    deadline
  }
}
    `;

/**
 * __useProjectTimeFrameSaveMutation__
 *
 * To run a mutation, you first call `useProjectTimeFrameSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProjectTimeFrameSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProjectTimeFrameSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useProjectTimeFrameSaveMutation(options: VueApolloComposable.UseMutationOptions<ProjectTimeFrameSaveMutation, ProjectTimeFrameSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProjectTimeFrameSaveMutation, ProjectTimeFrameSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProjectTimeFrameSaveMutation, ProjectTimeFrameSaveMutationVariables>(ProjectTimeFrameSaveDocument, options);
}
export type ProjectTimeFrameSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProjectTimeFrameSaveMutation, ProjectTimeFrameSaveMutationVariables>;
export const PhasesTaskSetsDocument = gql`
    query phasesTaskSets($projectParams: ProjectParamsInput!) {
  PhasesTaskSets(projectParams: $projectParams) {
    ... on ProjectPhase {
      ...projectPhasesProjectPhase
    }
    ... on TaskSet {
      ...projectPhasesTaskSet
    }
  }
  Project(projectParams: $projectParams) {
    id
    hasBackToBackPhases
    numberOfTasks
  }
}
    ${ProjectPhasesProjectPhaseFragmentDoc}
${ProjectPhasesTaskSetFragmentDoc}`;

/**
 * __usePhasesTaskSetsQuery__
 *
 * To run a query within a Vue component, call `usePhasesTaskSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhasesTaskSetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePhasesTaskSetsQuery({
 *   projectParams: // value for 'projectParams'
 * });
 */
export function usePhasesTaskSetsQuery(variables: PhasesTaskSetsQueryVariables | VueCompositionApi.Ref<PhasesTaskSetsQueryVariables> | ReactiveFunction<PhasesTaskSetsQueryVariables>, options: VueApolloComposable.UseQueryOptions<PhasesTaskSetsQuery, PhasesTaskSetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PhasesTaskSetsQuery, PhasesTaskSetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PhasesTaskSetsQuery, PhasesTaskSetsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PhasesTaskSetsQuery, PhasesTaskSetsQueryVariables>(PhasesTaskSetsDocument, variables, options);
}
export function usePhasesTaskSetsLazyQuery(variables?: PhasesTaskSetsQueryVariables | VueCompositionApi.Ref<PhasesTaskSetsQueryVariables> | ReactiveFunction<PhasesTaskSetsQueryVariables>, options: VueApolloComposable.UseQueryOptions<PhasesTaskSetsQuery, PhasesTaskSetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PhasesTaskSetsQuery, PhasesTaskSetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PhasesTaskSetsQuery, PhasesTaskSetsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PhasesTaskSetsQuery, PhasesTaskSetsQueryVariables>(PhasesTaskSetsDocument, variables, options);
}
export type PhasesTaskSetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PhasesTaskSetsQuery, PhasesTaskSetsQueryVariables>;
export const AvailableDateDocument = gql`
    query availableDate($availableDateParams: AvailableDateParamsInput!) {
  AvailableDate(availableDateParams: $availableDateParams)
}
    `;

/**
 * __useAvailableDateQuery__
 *
 * To run a query within a Vue component, call `useAvailableDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableDateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvailableDateQuery({
 *   availableDateParams: // value for 'availableDateParams'
 * });
 */
export function useAvailableDateQuery(variables: AvailableDateQueryVariables | VueCompositionApi.Ref<AvailableDateQueryVariables> | ReactiveFunction<AvailableDateQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvailableDateQuery, AvailableDateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailableDateQuery, AvailableDateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailableDateQuery, AvailableDateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvailableDateQuery, AvailableDateQueryVariables>(AvailableDateDocument, variables, options);
}
export function useAvailableDateLazyQuery(variables?: AvailableDateQueryVariables | VueCompositionApi.Ref<AvailableDateQueryVariables> | ReactiveFunction<AvailableDateQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvailableDateQuery, AvailableDateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailableDateQuery, AvailableDateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailableDateQuery, AvailableDateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvailableDateQuery, AvailableDateQueryVariables>(AvailableDateDocument, variables, options);
}
export type AvailableDateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvailableDateQuery, AvailableDateQueryVariables>;
export const PurchaseOrderAutoSuggestDocument = gql`
    query purchaseOrderAutoSuggest($purchaseOrdersListInput: FinanceDocumentsListInput) {
  PurchaseOrdersList(input: $purchaseOrdersListInput) {
    id
    number
    mainContact {
      name
    }
  }
}
    `;

/**
 * __usePurchaseOrderAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `usePurchaseOrderAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePurchaseOrderAutoSuggestQuery({
 *   purchaseOrdersListInput: // value for 'purchaseOrdersListInput'
 * });
 */
export function usePurchaseOrderAutoSuggestQuery(variables: PurchaseOrderAutoSuggestQueryVariables | VueCompositionApi.Ref<PurchaseOrderAutoSuggestQueryVariables> | ReactiveFunction<PurchaseOrderAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PurchaseOrderAutoSuggestQuery, PurchaseOrderAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PurchaseOrderAutoSuggestQuery, PurchaseOrderAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PurchaseOrderAutoSuggestQuery, PurchaseOrderAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PurchaseOrderAutoSuggestQuery, PurchaseOrderAutoSuggestQueryVariables>(PurchaseOrderAutoSuggestDocument, variables, options);
}
export function usePurchaseOrderAutoSuggestLazyQuery(variables: PurchaseOrderAutoSuggestQueryVariables | VueCompositionApi.Ref<PurchaseOrderAutoSuggestQueryVariables> | ReactiveFunction<PurchaseOrderAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PurchaseOrderAutoSuggestQuery, PurchaseOrderAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PurchaseOrderAutoSuggestQuery, PurchaseOrderAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PurchaseOrderAutoSuggestQuery, PurchaseOrderAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PurchaseOrderAutoSuggestQuery, PurchaseOrderAutoSuggestQueryVariables>(PurchaseOrderAutoSuggestDocument, variables, options);
}
export type PurchaseOrderAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PurchaseOrderAutoSuggestQuery, PurchaseOrderAutoSuggestQueryVariables>;
export const QuoteAutoSuggestDocument = gql`
    query quoteAutoSuggest($quoteFiltersInput: QuoteFiltersInput, $startFrom: Int, $limit: Int, $ordering: [QuoteOrderingInput!]) {
  QuotesList(
    filters: $quoteFiltersInput
    startFrom: $startFrom
    limit: $limit
    ordering: $ordering
  ) {
    id
    number
    quoteName
    mainContact {
      name
    }
  }
}
    `;

/**
 * __useQuoteAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useQuoteAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuoteAutoSuggestQuery({
 *   quoteFiltersInput: // value for 'quoteFiltersInput'
 *   startFrom: // value for 'startFrom'
 *   limit: // value for 'limit'
 *   ordering: // value for 'ordering'
 * });
 */
export function useQuoteAutoSuggestQuery(variables: QuoteAutoSuggestQueryVariables | VueCompositionApi.Ref<QuoteAutoSuggestQueryVariables> | ReactiveFunction<QuoteAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<QuoteAutoSuggestQuery, QuoteAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteAutoSuggestQuery, QuoteAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteAutoSuggestQuery, QuoteAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QuoteAutoSuggestQuery, QuoteAutoSuggestQueryVariables>(QuoteAutoSuggestDocument, variables, options);
}
export function useQuoteAutoSuggestLazyQuery(variables: QuoteAutoSuggestQueryVariables | VueCompositionApi.Ref<QuoteAutoSuggestQueryVariables> | ReactiveFunction<QuoteAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<QuoteAutoSuggestQuery, QuoteAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteAutoSuggestQuery, QuoteAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteAutoSuggestQuery, QuoteAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QuoteAutoSuggestQuery, QuoteAutoSuggestQueryVariables>(QuoteAutoSuggestDocument, variables, options);
}
export type QuoteAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QuoteAutoSuggestQuery, QuoteAutoSuggestQueryVariables>;
export const QuoteMatrixModalDocument = gql`
    query quoteMatrixModal($id: ID!, $laborCostInput: LaborCostInput, $sellingPriceInput: LocalRoleSellingPriceInput) {
  QuoteMatrix(id: $id) {
    quote {
      id
      isRoleBased
      discount
      discount2
      discount3
      localPriceList {
        id
        localRolePrices {
          currencyConvertedSellingPrice(input: $sellingPriceInput)
          roleId
        }
      }
      lines {
        id
        isSubHeading
        isInternal
        isEmptyRow
        comment
        price
        amount
        secondaryAmount
        cost
        ordering
        discount
        unit {
          id
          name
        }
        product {
          id
          name
          noDiscountsApplied
        }
        providers {
          id
          price
          quantity
          unitCost
          role {
            ...quoteMatrixRole
          }
          user {
            ...quoteMatrixUser
          }
        }
      }
    }
    settings {
      hoursPerDay
      isSecondaryQuantityEnabled
      secondaryQuantityLabel
      canSeeLaborCost
    }
    extraProviders {
      role {
        ...quoteMatrixRole
      }
      user {
        ...quoteMatrixUser
      }
    }
  }
}
    ${QuoteMatrixRoleFragmentDoc}
${QuoteMatrixUserFragmentDoc}`;

/**
 * __useQuoteMatrixModalQuery__
 *
 * To run a query within a Vue component, call `useQuoteMatrixModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteMatrixModalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuoteMatrixModalQuery({
 *   id: // value for 'id'
 *   laborCostInput: // value for 'laborCostInput'
 *   sellingPriceInput: // value for 'sellingPriceInput'
 * });
 */
export function useQuoteMatrixModalQuery(variables: QuoteMatrixModalQueryVariables | VueCompositionApi.Ref<QuoteMatrixModalQueryVariables> | ReactiveFunction<QuoteMatrixModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteMatrixModalQuery, QuoteMatrixModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteMatrixModalQuery, QuoteMatrixModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteMatrixModalQuery, QuoteMatrixModalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QuoteMatrixModalQuery, QuoteMatrixModalQueryVariables>(QuoteMatrixModalDocument, variables, options);
}
export function useQuoteMatrixModalLazyQuery(variables?: QuoteMatrixModalQueryVariables | VueCompositionApi.Ref<QuoteMatrixModalQueryVariables> | ReactiveFunction<QuoteMatrixModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteMatrixModalQuery, QuoteMatrixModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteMatrixModalQuery, QuoteMatrixModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteMatrixModalQuery, QuoteMatrixModalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QuoteMatrixModalQuery, QuoteMatrixModalQueryVariables>(QuoteMatrixModalDocument, variables, options);
}
export type QuoteMatrixModalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QuoteMatrixModalQuery, QuoteMatrixModalQueryVariables>;
export const QuoteRevenueModalDocument = gql`
    query quoteRevenueModal($id: ID!) {
  QuoteRevenueForecast(id: $id) {
    quote {
      id
      revenueStartDate
      revenueIncludeCosts
    }
    periods {
      id
      revenue
      isRevenueSetByUser
    }
  }
}
    `;

/**
 * __useQuoteRevenueModalQuery__
 *
 * To run a query within a Vue component, call `useQuoteRevenueModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteRevenueModalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuoteRevenueModalQuery({
 *   id: // value for 'id'
 * });
 */
export function useQuoteRevenueModalQuery(variables: QuoteRevenueModalQueryVariables | VueCompositionApi.Ref<QuoteRevenueModalQueryVariables> | ReactiveFunction<QuoteRevenueModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteRevenueModalQuery, QuoteRevenueModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteRevenueModalQuery, QuoteRevenueModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteRevenueModalQuery, QuoteRevenueModalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QuoteRevenueModalQuery, QuoteRevenueModalQueryVariables>(QuoteRevenueModalDocument, variables, options);
}
export function useQuoteRevenueModalLazyQuery(variables?: QuoteRevenueModalQueryVariables | VueCompositionApi.Ref<QuoteRevenueModalQueryVariables> | ReactiveFunction<QuoteRevenueModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteRevenueModalQuery, QuoteRevenueModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteRevenueModalQuery, QuoteRevenueModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteRevenueModalQuery, QuoteRevenueModalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QuoteRevenueModalQuery, QuoteRevenueModalQueryVariables>(QuoteRevenueModalDocument, variables, options);
}
export type QuoteRevenueModalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QuoteRevenueModalQuery, QuoteRevenueModalQueryVariables>;
export const QuoteToTaskAssigneesOwnerDocument = gql`
    query QuoteToTaskAssigneesOwner($input: UsersListInput!) {
  UsersList(input: $input) {
    id
    name
    firstName
    lastName
    status
    type
    profilePicture {
      mini
      medium
    }
    hslColor
    initials
  }
}
    `;

/**
 * __useQuoteToTaskAssigneesOwnerQuery__
 *
 * To run a query within a Vue component, call `useQuoteToTaskAssigneesOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteToTaskAssigneesOwnerQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuoteToTaskAssigneesOwnerQuery({
 *   input: // value for 'input'
 * });
 */
export function useQuoteToTaskAssigneesOwnerQuery(variables: QuoteToTaskAssigneesOwnerQueryVariables | VueCompositionApi.Ref<QuoteToTaskAssigneesOwnerQueryVariables> | ReactiveFunction<QuoteToTaskAssigneesOwnerQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesOwnerQuery, QuoteToTaskAssigneesOwnerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesOwnerQuery, QuoteToTaskAssigneesOwnerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesOwnerQuery, QuoteToTaskAssigneesOwnerQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QuoteToTaskAssigneesOwnerQuery, QuoteToTaskAssigneesOwnerQueryVariables>(QuoteToTaskAssigneesOwnerDocument, variables, options);
}
export function useQuoteToTaskAssigneesOwnerLazyQuery(variables?: QuoteToTaskAssigneesOwnerQueryVariables | VueCompositionApi.Ref<QuoteToTaskAssigneesOwnerQueryVariables> | ReactiveFunction<QuoteToTaskAssigneesOwnerQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesOwnerQuery, QuoteToTaskAssigneesOwnerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesOwnerQuery, QuoteToTaskAssigneesOwnerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesOwnerQuery, QuoteToTaskAssigneesOwnerQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QuoteToTaskAssigneesOwnerQuery, QuoteToTaskAssigneesOwnerQueryVariables>(QuoteToTaskAssigneesOwnerDocument, variables, options);
}
export type QuoteToTaskAssigneesOwnerQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QuoteToTaskAssigneesOwnerQuery, QuoteToTaskAssigneesOwnerQueryVariables>;
export const QuoteToTaskAssigneesRolesDocument = gql`
    query QuoteToTaskAssigneesRoles($input: RolesListInput!) {
  RolesList(input: $input) {
    id
    name
    initials
    hslColor
  }
}
    `;

/**
 * __useQuoteToTaskAssigneesRolesQuery__
 *
 * To run a query within a Vue component, call `useQuoteToTaskAssigneesRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteToTaskAssigneesRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuoteToTaskAssigneesRolesQuery({
 *   input: // value for 'input'
 * });
 */
export function useQuoteToTaskAssigneesRolesQuery(variables: QuoteToTaskAssigneesRolesQueryVariables | VueCompositionApi.Ref<QuoteToTaskAssigneesRolesQueryVariables> | ReactiveFunction<QuoteToTaskAssigneesRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesRolesQuery, QuoteToTaskAssigneesRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesRolesQuery, QuoteToTaskAssigneesRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesRolesQuery, QuoteToTaskAssigneesRolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QuoteToTaskAssigneesRolesQuery, QuoteToTaskAssigneesRolesQueryVariables>(QuoteToTaskAssigneesRolesDocument, variables, options);
}
export function useQuoteToTaskAssigneesRolesLazyQuery(variables?: QuoteToTaskAssigneesRolesQueryVariables | VueCompositionApi.Ref<QuoteToTaskAssigneesRolesQueryVariables> | ReactiveFunction<QuoteToTaskAssigneesRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesRolesQuery, QuoteToTaskAssigneesRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesRolesQuery, QuoteToTaskAssigneesRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteToTaskAssigneesRolesQuery, QuoteToTaskAssigneesRolesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QuoteToTaskAssigneesRolesQuery, QuoteToTaskAssigneesRolesQueryVariables>(QuoteToTaskAssigneesRolesDocument, variables, options);
}
export type QuoteToTaskAssigneesRolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QuoteToTaskAssigneesRolesQuery, QuoteToTaskAssigneesRolesQueryVariables>;
export const JoinReferralDocument = gql`
    mutation JoinReferral {
  JoinReferralMutation {
    share
    linkedIn
  }
}
    `;

/**
 * __useJoinReferralMutation__
 *
 * To run a mutation, you first call `useJoinReferralMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useJoinReferralMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useJoinReferralMutation();
 */
export function useJoinReferralMutation(options: VueApolloComposable.UseMutationOptions<JoinReferralMutation, JoinReferralMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<JoinReferralMutation, JoinReferralMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<JoinReferralMutation, JoinReferralMutationVariables>(JoinReferralDocument, options);
}
export type JoinReferralMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<JoinReferralMutation, JoinReferralMutationVariables>;
export const ReferralLinksDocument = gql`
    query ReferralLinks {
  ReferralLinks {
    share
    linkedIn
    portal
  }
}
    `;

/**
 * __useReferralLinksQuery__
 *
 * To run a query within a Vue component, call `useReferralLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReferralLinksQuery();
 */
export function useReferralLinksQuery(options: VueApolloComposable.UseQueryOptions<ReferralLinksQuery, ReferralLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReferralLinksQuery, ReferralLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReferralLinksQuery, ReferralLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ReferralLinksQuery, ReferralLinksQueryVariables>(ReferralLinksDocument, {}, options);
}
export function useReferralLinksLazyQuery(options: VueApolloComposable.UseQueryOptions<ReferralLinksQuery, ReferralLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReferralLinksQuery, ReferralLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReferralLinksQuery, ReferralLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ReferralLinksQuery, ReferralLinksQueryVariables>(ReferralLinksDocument, {}, options);
}
export type ReferralLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReferralLinksQuery, ReferralLinksQueryVariables>;
export const ReferralShareLinksDocument = gql`
    query ReferralShareLinks {
  ReferralLinks {
    share
    linkedIn
  }
}
    `;

/**
 * __useReferralShareLinksQuery__
 *
 * To run a query within a Vue component, call `useReferralShareLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralShareLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReferralShareLinksQuery();
 */
export function useReferralShareLinksQuery(options: VueApolloComposable.UseQueryOptions<ReferralShareLinksQuery, ReferralShareLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReferralShareLinksQuery, ReferralShareLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReferralShareLinksQuery, ReferralShareLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ReferralShareLinksQuery, ReferralShareLinksQueryVariables>(ReferralShareLinksDocument, {}, options);
}
export function useReferralShareLinksLazyQuery(options: VueApolloComposable.UseQueryOptions<ReferralShareLinksQuery, ReferralShareLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReferralShareLinksQuery, ReferralShareLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReferralShareLinksQuery, ReferralShareLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ReferralShareLinksQuery, ReferralShareLinksQueryVariables>(ReferralShareLinksDocument, {}, options);
}
export type ReferralShareLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReferralShareLinksQuery, ReferralShareLinksQueryVariables>;
export const ReportsLibraryDocument = gql`
    query ReportsLibrary {
  ReportsLibrary @persist {
    categories
    reports {
      key
      url
      categories
    }
  }
}
    `;

/**
 * __useReportsLibraryQuery__
 *
 * To run a query within a Vue component, call `useReportsLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsLibraryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReportsLibraryQuery();
 */
export function useReportsLibraryQuery(options: VueApolloComposable.UseQueryOptions<ReportsLibraryQuery, ReportsLibraryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReportsLibraryQuery, ReportsLibraryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReportsLibraryQuery, ReportsLibraryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ReportsLibraryQuery, ReportsLibraryQueryVariables>(ReportsLibraryDocument, {}, options);
}
export function useReportsLibraryLazyQuery(options: VueApolloComposable.UseQueryOptions<ReportsLibraryQuery, ReportsLibraryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReportsLibraryQuery, ReportsLibraryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReportsLibraryQuery, ReportsLibraryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ReportsLibraryQuery, ReportsLibraryQueryVariables>(ReportsLibraryDocument, {}, options);
}
export type ReportsLibraryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReportsLibraryQuery, ReportsLibraryQueryVariables>;
export const ResourceAutoSuggestDocument = gql`
    query resourceAutoSuggest($resourcesListInput: ResourcesListInput) {
  ResourcesList(input: $resourcesListInput) {
    id
    name
  }
}
    `;

/**
 * __useResourceAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useResourceAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourceAutoSuggestQuery({
 *   resourcesListInput: // value for 'resourcesListInput'
 * });
 */
export function useResourceAutoSuggestQuery(variables: ResourceAutoSuggestQueryVariables | VueCompositionApi.Ref<ResourceAutoSuggestQueryVariables> | ReactiveFunction<ResourceAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ResourceAutoSuggestQuery, ResourceAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourceAutoSuggestQuery, ResourceAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourceAutoSuggestQuery, ResourceAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourceAutoSuggestQuery, ResourceAutoSuggestQueryVariables>(ResourceAutoSuggestDocument, variables, options);
}
export function useResourceAutoSuggestLazyQuery(variables: ResourceAutoSuggestQueryVariables | VueCompositionApi.Ref<ResourceAutoSuggestQueryVariables> | ReactiveFunction<ResourceAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ResourceAutoSuggestQuery, ResourceAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourceAutoSuggestQuery, ResourceAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourceAutoSuggestQuery, ResourceAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourceAutoSuggestQuery, ResourceAutoSuggestQueryVariables>(ResourceAutoSuggestDocument, variables, options);
}
export type ResourceAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourceAutoSuggestQuery, ResourceAutoSuggestQueryVariables>;
export const ResourceBookingsMoveDocument = gql`
    mutation resourceBookingsMove($input: BookingsMoveInput!) {
  BookingsMove(input: $input)
}
    `;

/**
 * __useResourceBookingsMoveMutation__
 *
 * To run a mutation, you first call `useResourceBookingsMoveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResourceBookingsMoveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResourceBookingsMoveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResourceBookingsMoveMutation(options: VueApolloComposable.UseMutationOptions<ResourceBookingsMoveMutation, ResourceBookingsMoveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResourceBookingsMoveMutation, ResourceBookingsMoveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResourceBookingsMoveMutation, ResourceBookingsMoveMutationVariables>(ResourceBookingsMoveDocument, options);
}
export type ResourceBookingsMoveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResourceBookingsMoveMutation, ResourceBookingsMoveMutationVariables>;
export const ResourcePlanningProjectAddMemberDocument = gql`
    mutation resourcePlanningProjectAddMember($input: ProjectMembersAddInput!) {
  ProjectMembersAdd(input: $input) {
    __typename
    id
    members {
      id
      name
      initials
      hslColor
      profilePicture {
        mini
      }
    }
    roleProjects {
      ...ResourcePlanningRoleProject
    }
  }
}
    ${ResourcePlanningRoleProjectFragmentDoc}`;

/**
 * __useResourcePlanningProjectAddMemberMutation__
 *
 * To run a mutation, you first call `useResourcePlanningProjectAddMemberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningProjectAddMemberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResourcePlanningProjectAddMemberMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResourcePlanningProjectAddMemberMutation(options: VueApolloComposable.UseMutationOptions<ResourcePlanningProjectAddMemberMutation, ResourcePlanningProjectAddMemberMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResourcePlanningProjectAddMemberMutation, ResourcePlanningProjectAddMemberMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResourcePlanningProjectAddMemberMutation, ResourcePlanningProjectAddMemberMutationVariables>(ResourcePlanningProjectAddMemberDocument, options);
}
export type ResourcePlanningProjectAddMemberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResourcePlanningProjectAddMemberMutation, ResourcePlanningProjectAddMemberMutationVariables>;
export const ResourcePlanningProjectRemoveMemberDocument = gql`
    mutation resourcePlanningProjectRemoveMember($input: ProjectMembersRemoveInput!) {
  ProjectMembersRemove(input: $input) {
    __typename
    id
    members {
      id
      name
      initials
      hslColor
      profilePicture {
        mini
      }
    }
    roleProjects {
      ...ResourcePlanningRoleProject
    }
  }
}
    ${ResourcePlanningRoleProjectFragmentDoc}`;

/**
 * __useResourcePlanningProjectRemoveMemberMutation__
 *
 * To run a mutation, you first call `useResourcePlanningProjectRemoveMemberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningProjectRemoveMemberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResourcePlanningProjectRemoveMemberMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResourcePlanningProjectRemoveMemberMutation(options: VueApolloComposable.UseMutationOptions<ResourcePlanningProjectRemoveMemberMutation, ResourcePlanningProjectRemoveMemberMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResourcePlanningProjectRemoveMemberMutation, ResourcePlanningProjectRemoveMemberMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResourcePlanningProjectRemoveMemberMutation, ResourcePlanningProjectRemoveMemberMutationVariables>(ResourcePlanningProjectRemoveMemberDocument, options);
}
export type ResourcePlanningProjectRemoveMemberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResourcePlanningProjectRemoveMemberMutation, ResourcePlanningProjectRemoveMemberMutationVariables>;
export const ResourcePlanningDocument = gql`
    query resourcePlanning($projectInput: ProjectParamsInput!, $bookingsListInput: BookingsListInput!) {
  Project(projectParams: $projectInput) {
    id
    name
    color
    date
    actualStartDate
    deadline
    actualDueDate
    manager {
      id
    }
    members {
      id
      name
      initials
      hslColor
      profilePicture {
        mini
      }
      role {
        id
        name
      }
    }
    permissions {
      canModify
    }
    roleProjects {
      ...ResourcePlanningRoleProject
    }
    retainer {
      periods {
        id
        startDate
        endDate
      }
    }
    isPrivate
    projectType
  }
  BookingsList(input: $bookingsListInput) {
    id
    user {
      id
    }
    startDate
    endDate
    amount
    amountType
    isTentative
    description
    roleProject {
      ...ResourcePlanningRoleProject
    }
  }
}
    ${ResourcePlanningRoleProjectFragmentDoc}`;

/**
 * __useResourcePlanningQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningQuery({
 *   projectInput: // value for 'projectInput'
 *   bookingsListInput: // value for 'bookingsListInput'
 * });
 */
export function useResourcePlanningQuery(variables: ResourcePlanningQueryVariables | VueCompositionApi.Ref<ResourcePlanningQueryVariables> | ReactiveFunction<ResourcePlanningQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningQuery, ResourcePlanningQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningQuery, ResourcePlanningQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningQuery, ResourcePlanningQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningQuery, ResourcePlanningQueryVariables>(ResourcePlanningDocument, variables, options);
}
export function useResourcePlanningLazyQuery(variables?: ResourcePlanningQueryVariables | VueCompositionApi.Ref<ResourcePlanningQueryVariables> | ReactiveFunction<ResourcePlanningQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningQuery, ResourcePlanningQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningQuery, ResourcePlanningQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningQuery, ResourcePlanningQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningQuery, ResourcePlanningQueryVariables>(ResourcePlanningDocument, variables, options);
}
export type ResourcePlanningQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningQuery, ResourcePlanningQueryVariables>;
export const ResourcePlanningUtilizationDocument = gql`
    query resourcePlanningUtilization($input: UserUtilizationInput!) {
  UserUtilization(input: $input) {
    userId
    roleId
    utilizations {
      date
      fixedBookedDuration
      tentativeBookedDuration
      availability
    }
  }
}
    `;

/**
 * __useResourcePlanningUtilizationQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningUtilizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningUtilizationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningUtilizationQuery({
 *   input: // value for 'input'
 * });
 */
export function useResourcePlanningUtilizationQuery(variables: ResourcePlanningUtilizationQueryVariables | VueCompositionApi.Ref<ResourcePlanningUtilizationQueryVariables> | ReactiveFunction<ResourcePlanningUtilizationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningUtilizationQuery, ResourcePlanningUtilizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningUtilizationQuery, ResourcePlanningUtilizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningUtilizationQuery, ResourcePlanningUtilizationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningUtilizationQuery, ResourcePlanningUtilizationQueryVariables>(ResourcePlanningUtilizationDocument, variables, options);
}
export function useResourcePlanningUtilizationLazyQuery(variables?: ResourcePlanningUtilizationQueryVariables | VueCompositionApi.Ref<ResourcePlanningUtilizationQueryVariables> | ReactiveFunction<ResourcePlanningUtilizationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningUtilizationQuery, ResourcePlanningUtilizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningUtilizationQuery, ResourcePlanningUtilizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningUtilizationQuery, ResourcePlanningUtilizationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningUtilizationQuery, ResourcePlanningUtilizationQueryVariables>(ResourcePlanningUtilizationDocument, variables, options);
}
export type ResourcePlanningUtilizationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningUtilizationQuery, ResourcePlanningUtilizationQueryVariables>;
export const ResourceBookingDeleteDocument = gql`
    mutation resourceBookingDelete($input: BookingDeleteInput!) {
  BookingDelete(input: $input)
}
    `;

/**
 * __useResourceBookingDeleteMutation__
 *
 * To run a mutation, you first call `useResourceBookingDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResourceBookingDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResourceBookingDeleteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResourceBookingDeleteMutation(options: VueApolloComposable.UseMutationOptions<ResourceBookingDeleteMutation, ResourceBookingDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResourceBookingDeleteMutation, ResourceBookingDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResourceBookingDeleteMutation, ResourceBookingDeleteMutationVariables>(ResourceBookingDeleteDocument, options);
}
export type ResourceBookingDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResourceBookingDeleteMutation, ResourceBookingDeleteMutationVariables>;
export const ResourceBookingSaveDocument = gql`
    mutation resourceBookingSave($input: BookingSaveInput!) {
  BookingSave(input: $input) {
    id
    user {
      id
    }
    startDate
    endDate
    amount
    amountType
    isTentative
    description
    roleProject {
      ...ResourcePlanningRoleProject
    }
  }
}
    ${ResourcePlanningRoleProjectFragmentDoc}`;

/**
 * __useResourceBookingSaveMutation__
 *
 * To run a mutation, you first call `useResourceBookingSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResourceBookingSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResourceBookingSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResourceBookingSaveMutation(options: VueApolloComposable.UseMutationOptions<ResourceBookingSaveMutation, ResourceBookingSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResourceBookingSaveMutation, ResourceBookingSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResourceBookingSaveMutation, ResourceBookingSaveMutationVariables>(ResourceBookingSaveDocument, options);
}
export type ResourceBookingSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResourceBookingSaveMutation, ResourceBookingSaveMutationVariables>;
export const ResourcePlanningPortfolioAddToProjectDocument = gql`
    mutation resourcePlanningPortfolioAddToProject($input: ProjectMembersAddInput!) {
  ProjectMembersAdd(input: $input) {
    __typename
    id
    name
    members {
      id
      name
      initials
      hslColor
      profilePicture {
        mini
      }
      role {
        id
      }
    }
    roleProjects {
      ...ResourcePlanningRoleProject
    }
  }
}
    ${ResourcePlanningRoleProjectFragmentDoc}`;

/**
 * __useResourcePlanningPortfolioAddToProjectMutation__
 *
 * To run a mutation, you first call `useResourcePlanningPortfolioAddToProjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningPortfolioAddToProjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResourcePlanningPortfolioAddToProjectMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResourcePlanningPortfolioAddToProjectMutation(options: VueApolloComposable.UseMutationOptions<ResourcePlanningPortfolioAddToProjectMutation, ResourcePlanningPortfolioAddToProjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResourcePlanningPortfolioAddToProjectMutation, ResourcePlanningPortfolioAddToProjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResourcePlanningPortfolioAddToProjectMutation, ResourcePlanningPortfolioAddToProjectMutationVariables>(ResourcePlanningPortfolioAddToProjectDocument, options);
}
export type ResourcePlanningPortfolioAddToProjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResourcePlanningPortfolioAddToProjectMutation, ResourcePlanningPortfolioAddToProjectMutationVariables>;
export const ResourcePlanningPortfolioBookingsDocument = gql`
    query resourcePlanningPortfolioBookings($input: BookingsListInput!) {
  BookingsList(input: $input) {
    id
    user {
      id
    }
    startDate
    endDate
    amount
    amountType
    isTentative
    description
    project {
      id
    }
    roleProject {
      ...ResourcePlanningRoleProject
    }
  }
}
    ${ResourcePlanningRoleProjectFragmentDoc}`;

/**
 * __useResourcePlanningPortfolioBookingsQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningPortfolioBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningPortfolioBookingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningPortfolioBookingsQuery({
 *   input: // value for 'input'
 * });
 */
export function useResourcePlanningPortfolioBookingsQuery(variables: ResourcePlanningPortfolioBookingsQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioBookingsQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioBookingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioBookingsQuery, ResourcePlanningPortfolioBookingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioBookingsQuery, ResourcePlanningPortfolioBookingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioBookingsQuery, ResourcePlanningPortfolioBookingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningPortfolioBookingsQuery, ResourcePlanningPortfolioBookingsQueryVariables>(ResourcePlanningPortfolioBookingsDocument, variables, options);
}
export function useResourcePlanningPortfolioBookingsLazyQuery(variables?: ResourcePlanningPortfolioBookingsQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioBookingsQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioBookingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioBookingsQuery, ResourcePlanningPortfolioBookingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioBookingsQuery, ResourcePlanningPortfolioBookingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioBookingsQuery, ResourcePlanningPortfolioBookingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningPortfolioBookingsQuery, ResourcePlanningPortfolioBookingsQueryVariables>(ResourcePlanningPortfolioBookingsDocument, variables, options);
}
export type ResourcePlanningPortfolioBookingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningPortfolioBookingsQuery, ResourcePlanningPortfolioBookingsQueryVariables>;
export const ResourcePlanningPortfolioProjectDocument = gql`
    query resourcePlanningPortfolioProject($input: ProjectParamsInput!) {
  Project(projectParams: $input) {
    id
    manager {
      id
    }
    members {
      id
      name
      initials
      hslColor
      profilePicture {
        mini
      }
      role {
        id
      }
    }
  }
}
    `;

/**
 * __useResourcePlanningPortfolioProjectQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningPortfolioProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningPortfolioProjectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningPortfolioProjectQuery({
 *   input: // value for 'input'
 * });
 */
export function useResourcePlanningPortfolioProjectQuery(variables: ResourcePlanningPortfolioProjectQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioProjectQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioProjectQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectQuery, ResourcePlanningPortfolioProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectQuery, ResourcePlanningPortfolioProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectQuery, ResourcePlanningPortfolioProjectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningPortfolioProjectQuery, ResourcePlanningPortfolioProjectQueryVariables>(ResourcePlanningPortfolioProjectDocument, variables, options);
}
export function useResourcePlanningPortfolioProjectLazyQuery(variables?: ResourcePlanningPortfolioProjectQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioProjectQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioProjectQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectQuery, ResourcePlanningPortfolioProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectQuery, ResourcePlanningPortfolioProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectQuery, ResourcePlanningPortfolioProjectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningPortfolioProjectQuery, ResourcePlanningPortfolioProjectQueryVariables>(ResourcePlanningPortfolioProjectDocument, variables, options);
}
export type ResourcePlanningPortfolioProjectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningPortfolioProjectQuery, ResourcePlanningPortfolioProjectQueryVariables>;
export const ResourcePlanningPortfolioProjectsDocument = gql`
    query resourcePlanningPortfolioProjects($input: ResourcePlanningPortfolioProjectsFiltersInput!) {
  ResourcePlanningPortfolioProjects(input: $input) {
    projects {
      id
      name
      color
      date
      actualStartDate
      deadline
      actualDueDate
      bookingsMinDate
      bookingsMaxDate
      permissions {
        canModify
      }
      manager {
        id
      }
      members {
        id
        name
        initials
        hslColor
        profilePicture {
          mini
        }
        role {
          id
        }
      }
      roleProjects {
        ...ResourcePlanningRoleProject
      }
      isPrivate
      projectType
    }
    user {
      id
    }
    role {
      id
    }
  }
}
    ${ResourcePlanningRoleProjectFragmentDoc}`;

/**
 * __useResourcePlanningPortfolioProjectsQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningPortfolioProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningPortfolioProjectsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningPortfolioProjectsQuery({
 *   input: // value for 'input'
 * });
 */
export function useResourcePlanningPortfolioProjectsQuery(variables: ResourcePlanningPortfolioProjectsQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioProjectsQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioProjectsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectsQuery, ResourcePlanningPortfolioProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectsQuery, ResourcePlanningPortfolioProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectsQuery, ResourcePlanningPortfolioProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningPortfolioProjectsQuery, ResourcePlanningPortfolioProjectsQueryVariables>(ResourcePlanningPortfolioProjectsDocument, variables, options);
}
export function useResourcePlanningPortfolioProjectsLazyQuery(variables?: ResourcePlanningPortfolioProjectsQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioProjectsQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioProjectsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectsQuery, ResourcePlanningPortfolioProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectsQuery, ResourcePlanningPortfolioProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioProjectsQuery, ResourcePlanningPortfolioProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningPortfolioProjectsQuery, ResourcePlanningPortfolioProjectsQueryVariables>(ResourcePlanningPortfolioProjectsDocument, variables, options);
}
export type ResourcePlanningPortfolioProjectsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningPortfolioProjectsQuery, ResourcePlanningPortfolioProjectsQueryVariables>;
export const ResourcePlanningPortfolioUsersDocument = gql`
    query resourcePlanningPortfolioUsers($input: FilterHashInput) {
  ResourcePlanningPortfolioUsersList(input: $input) {
    users {
      id
      name
      initials
      hslColor
      profilePicture {
        mini
      }
      role {
        id
        name
      }
    }
    roles {
      id
      name
    }
  }
}
    `;

/**
 * __useResourcePlanningPortfolioUsersQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningPortfolioUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningPortfolioUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningPortfolioUsersQuery({
 *   input: // value for 'input'
 * });
 */
export function useResourcePlanningPortfolioUsersQuery(variables: ResourcePlanningPortfolioUsersQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioUsersQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioUsersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioUsersQuery, ResourcePlanningPortfolioUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioUsersQuery, ResourcePlanningPortfolioUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioUsersQuery, ResourcePlanningPortfolioUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningPortfolioUsersQuery, ResourcePlanningPortfolioUsersQueryVariables>(ResourcePlanningPortfolioUsersDocument, variables, options);
}
export function useResourcePlanningPortfolioUsersLazyQuery(variables: ResourcePlanningPortfolioUsersQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioUsersQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioUsersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioUsersQuery, ResourcePlanningPortfolioUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioUsersQuery, ResourcePlanningPortfolioUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioUsersQuery, ResourcePlanningPortfolioUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningPortfolioUsersQuery, ResourcePlanningPortfolioUsersQueryVariables>(ResourcePlanningPortfolioUsersDocument, variables, options);
}
export type ResourcePlanningPortfolioUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningPortfolioUsersQuery, ResourcePlanningPortfolioUsersQueryVariables>;
export const ResourcePlanningPortfolioResourceUtilizationDocument = gql`
    query resourcePlanningPortfolioResourceUtilization($input: UserUtilizationInput!) {
  UserUtilization(input: $input) {
    userId
    roleId
    utilizations {
      date
      fixedBookedDuration
      tentativeBookedDuration
      availability
    }
  }
}
    `;

/**
 * __useResourcePlanningPortfolioResourceUtilizationQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningPortfolioResourceUtilizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningPortfolioResourceUtilizationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningPortfolioResourceUtilizationQuery({
 *   input: // value for 'input'
 * });
 */
export function useResourcePlanningPortfolioResourceUtilizationQuery(variables: ResourcePlanningPortfolioResourceUtilizationQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioResourceUtilizationQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioResourceUtilizationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioResourceUtilizationQuery, ResourcePlanningPortfolioResourceUtilizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioResourceUtilizationQuery, ResourcePlanningPortfolioResourceUtilizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioResourceUtilizationQuery, ResourcePlanningPortfolioResourceUtilizationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningPortfolioResourceUtilizationQuery, ResourcePlanningPortfolioResourceUtilizationQueryVariables>(ResourcePlanningPortfolioResourceUtilizationDocument, variables, options);
}
export function useResourcePlanningPortfolioResourceUtilizationLazyQuery(variables?: ResourcePlanningPortfolioResourceUtilizationQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioResourceUtilizationQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioResourceUtilizationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioResourceUtilizationQuery, ResourcePlanningPortfolioResourceUtilizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioResourceUtilizationQuery, ResourcePlanningPortfolioResourceUtilizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioResourceUtilizationQuery, ResourcePlanningPortfolioResourceUtilizationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningPortfolioResourceUtilizationQuery, ResourcePlanningPortfolioResourceUtilizationQueryVariables>(ResourcePlanningPortfolioResourceUtilizationDocument, variables, options);
}
export type ResourcePlanningPortfolioResourceUtilizationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningPortfolioResourceUtilizationQuery, ResourcePlanningPortfolioResourceUtilizationQueryVariables>;
export const ResourcePlanningPortfolioSingleProjectDocument = gql`
    query resourcePlanningPortfolioSingleProject($projectId: Int!) {
  Project(projectParams: {projectId: $projectId}) {
    id
    name
    color
    date
    actualStartDate
    deadline
    actualDueDate
    bookingsMinDate
    bookingsMaxDate
    permissions {
      canModify
    }
    manager {
      id
    }
    members {
      id
      name
      initials
      hslColor
      profilePicture {
        mini
      }
      role {
        id
      }
    }
    roleProjects {
      ...ResourcePlanningRoleProject
    }
    isPrivate
    projectType
  }
}
    ${ResourcePlanningRoleProjectFragmentDoc}`;

/**
 * __useResourcePlanningPortfolioSingleProjectQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningPortfolioSingleProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningPortfolioSingleProjectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningPortfolioSingleProjectQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useResourcePlanningPortfolioSingleProjectQuery(variables: ResourcePlanningPortfolioSingleProjectQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioSingleProjectQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioSingleProjectQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioSingleProjectQuery, ResourcePlanningPortfolioSingleProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioSingleProjectQuery, ResourcePlanningPortfolioSingleProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioSingleProjectQuery, ResourcePlanningPortfolioSingleProjectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningPortfolioSingleProjectQuery, ResourcePlanningPortfolioSingleProjectQueryVariables>(ResourcePlanningPortfolioSingleProjectDocument, variables, options);
}
export function useResourcePlanningPortfolioSingleProjectLazyQuery(variables?: ResourcePlanningPortfolioSingleProjectQueryVariables | VueCompositionApi.Ref<ResourcePlanningPortfolioSingleProjectQueryVariables> | ReactiveFunction<ResourcePlanningPortfolioSingleProjectQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioSingleProjectQuery, ResourcePlanningPortfolioSingleProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioSingleProjectQuery, ResourcePlanningPortfolioSingleProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningPortfolioSingleProjectQuery, ResourcePlanningPortfolioSingleProjectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningPortfolioSingleProjectQuery, ResourcePlanningPortfolioSingleProjectQueryVariables>(ResourcePlanningPortfolioSingleProjectDocument, variables, options);
}
export type ResourcePlanningPortfolioSingleProjectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningPortfolioSingleProjectQuery, ResourcePlanningPortfolioSingleProjectQueryVariables>;
export const ResourcePlanningProjectsPopoverDocument = gql`
    query resourcePlanningProjectsPopover($input: UserUtilizationInput!) {
  UserUtilization(input: $input) {
    totalAvailability
    userId
    roleId
    utilizations {
      fixedBookedDuration
      tentativeBookedDuration
      project {
        id
        name
        color
        company {
          id
          name
        }
        permissions {
          canView
        }
        isPrivate
        projectType
      }
    }
  }
}
    `;

/**
 * __useResourcePlanningProjectsPopoverQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningProjectsPopoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningProjectsPopoverQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningProjectsPopoverQuery({
 *   input: // value for 'input'
 * });
 */
export function useResourcePlanningProjectsPopoverQuery(variables: ResourcePlanningProjectsPopoverQueryVariables | VueCompositionApi.Ref<ResourcePlanningProjectsPopoverQueryVariables> | ReactiveFunction<ResourcePlanningProjectsPopoverQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningProjectsPopoverQuery, ResourcePlanningProjectsPopoverQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningProjectsPopoverQuery, ResourcePlanningProjectsPopoverQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningProjectsPopoverQuery, ResourcePlanningProjectsPopoverQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningProjectsPopoverQuery, ResourcePlanningProjectsPopoverQueryVariables>(ResourcePlanningProjectsPopoverDocument, variables, options);
}
export function useResourcePlanningProjectsPopoverLazyQuery(variables?: ResourcePlanningProjectsPopoverQueryVariables | VueCompositionApi.Ref<ResourcePlanningProjectsPopoverQueryVariables> | ReactiveFunction<ResourcePlanningProjectsPopoverQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningProjectsPopoverQuery, ResourcePlanningProjectsPopoverQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningProjectsPopoverQuery, ResourcePlanningProjectsPopoverQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningProjectsPopoverQuery, ResourcePlanningProjectsPopoverQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningProjectsPopoverQuery, ResourcePlanningProjectsPopoverQueryVariables>(ResourcePlanningProjectsPopoverDocument, variables, options);
}
export type ResourcePlanningProjectsPopoverQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningProjectsPopoverQuery, ResourcePlanningProjectsPopoverQueryVariables>;
export const ResourcePlanningUserSelectProjectRolesDocument = gql`
    query resourcePlanningUserSelectProjectRoles($projectInput: ProjectParamsInput!) {
  Project(projectParams: $projectInput) {
    roleProjects {
      id
      role {
        id
      }
    }
  }
}
    `;

/**
 * __useResourcePlanningUserSelectProjectRolesQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningUserSelectProjectRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningUserSelectProjectRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningUserSelectProjectRolesQuery({
 *   projectInput: // value for 'projectInput'
 * });
 */
export function useResourcePlanningUserSelectProjectRolesQuery(variables: ResourcePlanningUserSelectProjectRolesQueryVariables | VueCompositionApi.Ref<ResourcePlanningUserSelectProjectRolesQueryVariables> | ReactiveFunction<ResourcePlanningUserSelectProjectRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectProjectRolesQuery, ResourcePlanningUserSelectProjectRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectProjectRolesQuery, ResourcePlanningUserSelectProjectRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectProjectRolesQuery, ResourcePlanningUserSelectProjectRolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningUserSelectProjectRolesQuery, ResourcePlanningUserSelectProjectRolesQueryVariables>(ResourcePlanningUserSelectProjectRolesDocument, variables, options);
}
export function useResourcePlanningUserSelectProjectRolesLazyQuery(variables?: ResourcePlanningUserSelectProjectRolesQueryVariables | VueCompositionApi.Ref<ResourcePlanningUserSelectProjectRolesQueryVariables> | ReactiveFunction<ResourcePlanningUserSelectProjectRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectProjectRolesQuery, ResourcePlanningUserSelectProjectRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectProjectRolesQuery, ResourcePlanningUserSelectProjectRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectProjectRolesQuery, ResourcePlanningUserSelectProjectRolesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningUserSelectProjectRolesQuery, ResourcePlanningUserSelectProjectRolesQueryVariables>(ResourcePlanningUserSelectProjectRolesDocument, variables, options);
}
export type ResourcePlanningUserSelectProjectRolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningUserSelectProjectRolesQuery, ResourcePlanningUserSelectProjectRolesQueryVariables>;
export const ResourcePlanningUserSelectDocument = gql`
    query resourcePlanningUserSelect($usersListInput: UsersListInput!) {
  UsersList(input: $usersListInput) {
    id
    name
    hslColor
    initials
    profilePicture {
      mini
    }
    role {
      id
      name
    }
    status
  }
}
    `;

/**
 * __useResourcePlanningUserSelectQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningUserSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningUserSelectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningUserSelectQuery({
 *   usersListInput: // value for 'usersListInput'
 * });
 */
export function useResourcePlanningUserSelectQuery(variables: ResourcePlanningUserSelectQueryVariables | VueCompositionApi.Ref<ResourcePlanningUserSelectQueryVariables> | ReactiveFunction<ResourcePlanningUserSelectQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectQuery, ResourcePlanningUserSelectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectQuery, ResourcePlanningUserSelectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectQuery, ResourcePlanningUserSelectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningUserSelectQuery, ResourcePlanningUserSelectQueryVariables>(ResourcePlanningUserSelectDocument, variables, options);
}
export function useResourcePlanningUserSelectLazyQuery(variables?: ResourcePlanningUserSelectQueryVariables | VueCompositionApi.Ref<ResourcePlanningUserSelectQueryVariables> | ReactiveFunction<ResourcePlanningUserSelectQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectQuery, ResourcePlanningUserSelectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectQuery, ResourcePlanningUserSelectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectQuery, ResourcePlanningUserSelectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningUserSelectQuery, ResourcePlanningUserSelectQueryVariables>(ResourcePlanningUserSelectDocument, variables, options);
}
export type ResourcePlanningUserSelectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningUserSelectQuery, ResourcePlanningUserSelectQueryVariables>;
export const ResourcePlanningUserSelectRolesDocument = gql`
    query resourcePlanningUserSelectRoles($rolesListInput: RolesListInput!) {
  RolesList(input: $rolesListInput) {
    id
    name
    users {
      id
    }
    usersCount
    sellingPrice
  }
}
    `;

/**
 * __useResourcePlanningUserSelectRolesQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningUserSelectRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningUserSelectRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningUserSelectRolesQuery({
 *   rolesListInput: // value for 'rolesListInput'
 * });
 */
export function useResourcePlanningUserSelectRolesQuery(variables: ResourcePlanningUserSelectRolesQueryVariables | VueCompositionApi.Ref<ResourcePlanningUserSelectRolesQueryVariables> | ReactiveFunction<ResourcePlanningUserSelectRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectRolesQuery, ResourcePlanningUserSelectRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectRolesQuery, ResourcePlanningUserSelectRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectRolesQuery, ResourcePlanningUserSelectRolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningUserSelectRolesQuery, ResourcePlanningUserSelectRolesQueryVariables>(ResourcePlanningUserSelectRolesDocument, variables, options);
}
export function useResourcePlanningUserSelectRolesLazyQuery(variables?: ResourcePlanningUserSelectRolesQueryVariables | VueCompositionApi.Ref<ResourcePlanningUserSelectRolesQueryVariables> | ReactiveFunction<ResourcePlanningUserSelectRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectRolesQuery, ResourcePlanningUserSelectRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectRolesQuery, ResourcePlanningUserSelectRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningUserSelectRolesQuery, ResourcePlanningUserSelectRolesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningUserSelectRolesQuery, ResourcePlanningUserSelectRolesQueryVariables>(ResourcePlanningUserSelectRolesDocument, variables, options);
}
export type ResourcePlanningUserSelectRolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningUserSelectRolesQuery, ResourcePlanningUserSelectRolesQueryVariables>;
export const ResourcePlanningTimeOffDocument = gql`
    query resourcePlanningTimeOff($input: UserTimeOffListInput!) {
  UserTimeOffList(input: $input) {
    date
    timeOff {
      endDate
      id
      startDate
      type {
        id
        systemName
        displayName
      }
      value
    }
    user {
      id
    }
  }
}
    `;

/**
 * __useResourcePlanningTimeOffQuery__
 *
 * To run a query within a Vue component, call `useResourcePlanningTimeOffQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanningTimeOffQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResourcePlanningTimeOffQuery({
 *   input: // value for 'input'
 * });
 */
export function useResourcePlanningTimeOffQuery(variables: ResourcePlanningTimeOffQueryVariables | VueCompositionApi.Ref<ResourcePlanningTimeOffQueryVariables> | ReactiveFunction<ResourcePlanningTimeOffQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningTimeOffQuery, ResourcePlanningTimeOffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningTimeOffQuery, ResourcePlanningTimeOffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningTimeOffQuery, ResourcePlanningTimeOffQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResourcePlanningTimeOffQuery, ResourcePlanningTimeOffQueryVariables>(ResourcePlanningTimeOffDocument, variables, options);
}
export function useResourcePlanningTimeOffLazyQuery(variables?: ResourcePlanningTimeOffQueryVariables | VueCompositionApi.Ref<ResourcePlanningTimeOffQueryVariables> | ReactiveFunction<ResourcePlanningTimeOffQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResourcePlanningTimeOffQuery, ResourcePlanningTimeOffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResourcePlanningTimeOffQuery, ResourcePlanningTimeOffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResourcePlanningTimeOffQuery, ResourcePlanningTimeOffQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ResourcePlanningTimeOffQuery, ResourcePlanningTimeOffQueryVariables>(ResourcePlanningTimeOffDocument, variables, options);
}
export type ResourcePlanningTimeOffQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResourcePlanningTimeOffQuery, ResourcePlanningTimeOffQueryVariables>;
export const RetainerPeriodModalDocument = gql`
    query retainerPeriodModal($projectId: Int!, $currency: String!) {
  Project(projectParams: {projectId: $projectId}) {
    id
    color
    confirmedBillableDoneDuration
    actualUsedBudgetSum
    useBillsExpensesInCalculations
    permissions {
      canModify
    }
    priceList {
      id
      currency
    }
    retainer {
      id
      periodDuration
      periodSum
      periods {
        id
        name
        startDate
        endDate
        duration
        actualDuration(input: {projectId: $projectId})
        sum(input: {projectId: $projectId, currency: $currency})
        actualSum(input: {projectId: $projectId, currency: $currency})
        defaultName
      }
    }
  }
}
    `;

/**
 * __useRetainerPeriodModalQuery__
 *
 * To run a query within a Vue component, call `useRetainerPeriodModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetainerPeriodModalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetainerPeriodModalQuery({
 *   projectId: // value for 'projectId'
 *   currency: // value for 'currency'
 * });
 */
export function useRetainerPeriodModalQuery(variables: RetainerPeriodModalQueryVariables | VueCompositionApi.Ref<RetainerPeriodModalQueryVariables> | ReactiveFunction<RetainerPeriodModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<RetainerPeriodModalQuery, RetainerPeriodModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RetainerPeriodModalQuery, RetainerPeriodModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RetainerPeriodModalQuery, RetainerPeriodModalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RetainerPeriodModalQuery, RetainerPeriodModalQueryVariables>(RetainerPeriodModalDocument, variables, options);
}
export function useRetainerPeriodModalLazyQuery(variables?: RetainerPeriodModalQueryVariables | VueCompositionApi.Ref<RetainerPeriodModalQueryVariables> | ReactiveFunction<RetainerPeriodModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<RetainerPeriodModalQuery, RetainerPeriodModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RetainerPeriodModalQuery, RetainerPeriodModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RetainerPeriodModalQuery, RetainerPeriodModalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RetainerPeriodModalQuery, RetainerPeriodModalQueryVariables>(RetainerPeriodModalDocument, variables, options);
}
export type RetainerPeriodModalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RetainerPeriodModalQuery, RetainerPeriodModalQueryVariables>;
export const RetainerPeriodModalSaveDocument = gql`
    mutation retainerPeriodModalSave($input: RetainerSaveInput!, $projectId: Int!, $currency: String!) {
  RetainerSave(input: $input) {
    id
    periodDuration
    periodSum
    periods {
      id
      name
      startDate
      endDate
      duration
      actualDuration(input: {projectId: $projectId})
      sum(input: {projectId: $projectId, currency: $currency})
      actualSum(input: {projectId: $projectId, currency: $currency})
      defaultName
    }
  }
}
    `;

/**
 * __useRetainerPeriodModalSaveMutation__
 *
 * To run a mutation, you first call `useRetainerPeriodModalSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetainerPeriodModalSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetainerPeriodModalSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *     projectId: // value for 'projectId'
 *     currency: // value for 'currency'
 *   },
 * });
 */
export function useRetainerPeriodModalSaveMutation(options: VueApolloComposable.UseMutationOptions<RetainerPeriodModalSaveMutation, RetainerPeriodModalSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RetainerPeriodModalSaveMutation, RetainerPeriodModalSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RetainerPeriodModalSaveMutation, RetainerPeriodModalSaveMutationVariables>(RetainerPeriodModalSaveDocument, options);
}
export type RetainerPeriodModalSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RetainerPeriodModalSaveMutation, RetainerPeriodModalSaveMutationVariables>;
export const QuoteDetailsViewDocument = gql`
    query quoteDetailsView($id: ID!) {
  Quote(id: $id) {
    id
    number
    quoteName
    hasProjectOnEachLine
    author {
      id
      name
    }
    mainContact {
      id
      name
    }
    status {
      id
      color
      name
    }
    project {
      id
    }
    issueDate
    confirmedDate
    displayCurrencyRate
    lines {
      id
      isSubHeading
      isEmptyRow
      comment
      amount
      secondaryAmount
      ordering
      unit {
        id
        symbol
        name
      }
      sumAfterAllDiscounts
      unlinkedSum
      product {
        id
        name
      }
      project {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useQuoteDetailsViewQuery__
 *
 * To run a query within a Vue component, call `useQuoteDetailsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteDetailsViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuoteDetailsViewQuery({
 *   id: // value for 'id'
 * });
 */
export function useQuoteDetailsViewQuery(variables: QuoteDetailsViewQueryVariables | VueCompositionApi.Ref<QuoteDetailsViewQueryVariables> | ReactiveFunction<QuoteDetailsViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteDetailsViewQuery, QuoteDetailsViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteDetailsViewQuery, QuoteDetailsViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteDetailsViewQuery, QuoteDetailsViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QuoteDetailsViewQuery, QuoteDetailsViewQueryVariables>(QuoteDetailsViewDocument, variables, options);
}
export function useQuoteDetailsViewLazyQuery(variables?: QuoteDetailsViewQueryVariables | VueCompositionApi.Ref<QuoteDetailsViewQueryVariables> | ReactiveFunction<QuoteDetailsViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuoteDetailsViewQuery, QuoteDetailsViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuoteDetailsViewQuery, QuoteDetailsViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuoteDetailsViewQuery, QuoteDetailsViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QuoteDetailsViewQuery, QuoteDetailsViewQueryVariables>(QuoteDetailsViewDocument, variables, options);
}
export type QuoteDetailsViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QuoteDetailsViewQuery, QuoteDetailsViewQueryVariables>;
export const PurchaseOrderDetailsViewDocument = gql`
    query purchaseOrderDetailsView($id: ID!) {
  PurchaseOrder(id: $id) {
    id
    number
    hasProjectOnEachLine
    author {
      id
      name
    }
    mainContact {
      id
      name
    }
    status {
      id
      statusId
      color
      name
    }
    project {
      id
    }
    issueDate
    displayCurrencyRate
    lines {
      id
      isSubHeading
      isEmptyRow
      comment
      amount
      secondaryAmount
      ordering
      unit {
        id
        symbol
        name
      }
      sumAfterAllDiscounts
      settledSum
      isSettled
      product {
        id
        name
      }
      project {
        id
        name
      }
    }
  }
}
    `;

/**
 * __usePurchaseOrderDetailsViewQuery__
 *
 * To run a query within a Vue component, call `usePurchaseOrderDetailsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderDetailsViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePurchaseOrderDetailsViewQuery({
 *   id: // value for 'id'
 * });
 */
export function usePurchaseOrderDetailsViewQuery(variables: PurchaseOrderDetailsViewQueryVariables | VueCompositionApi.Ref<PurchaseOrderDetailsViewQueryVariables> | ReactiveFunction<PurchaseOrderDetailsViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<PurchaseOrderDetailsViewQuery, PurchaseOrderDetailsViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PurchaseOrderDetailsViewQuery, PurchaseOrderDetailsViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PurchaseOrderDetailsViewQuery, PurchaseOrderDetailsViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PurchaseOrderDetailsViewQuery, PurchaseOrderDetailsViewQueryVariables>(PurchaseOrderDetailsViewDocument, variables, options);
}
export function usePurchaseOrderDetailsViewLazyQuery(variables?: PurchaseOrderDetailsViewQueryVariables | VueCompositionApi.Ref<PurchaseOrderDetailsViewQueryVariables> | ReactiveFunction<PurchaseOrderDetailsViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<PurchaseOrderDetailsViewQuery, PurchaseOrderDetailsViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PurchaseOrderDetailsViewQuery, PurchaseOrderDetailsViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PurchaseOrderDetailsViewQuery, PurchaseOrderDetailsViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PurchaseOrderDetailsViewQuery, PurchaseOrderDetailsViewQueryVariables>(PurchaseOrderDetailsViewDocument, variables, options);
}
export type PurchaseOrderDetailsViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PurchaseOrderDetailsViewQuery, PurchaseOrderDetailsViewQueryVariables>;
export const QuotesListViewDocument = gql`
    query quotesListView($filters: QuoteFiltersInput, $startFrom: Int, $limit: Int, $ordering: [QuoteOrderingInput!]) {
  QuotesList(
    filters: $filters
    startFrom: $startFrom
    limit: $limit
    ordering: $ordering
  ) {
    id
    number
    issueDate
    sum
    hasProjectOnEachLine
    displayCurrencyRate
    author {
      id
      initials
      name
    }
    mainContact {
      id
      name
    }
    status {
      id
      name
      color
    }
    project {
      id
      name
    }
    quoteName
    confirmedDate
    lines {
      id
      project {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useQuotesListViewQuery__
 *
 * To run a query within a Vue component, call `useQuotesListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotesListViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuotesListViewQuery({
 *   filters: // value for 'filters'
 *   startFrom: // value for 'startFrom'
 *   limit: // value for 'limit'
 *   ordering: // value for 'ordering'
 * });
 */
export function useQuotesListViewQuery(variables: QuotesListViewQueryVariables | VueCompositionApi.Ref<QuotesListViewQueryVariables> | ReactiveFunction<QuotesListViewQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<QuotesListViewQuery, QuotesListViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuotesListViewQuery, QuotesListViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuotesListViewQuery, QuotesListViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QuotesListViewQuery, QuotesListViewQueryVariables>(QuotesListViewDocument, variables, options);
}
export function useQuotesListViewLazyQuery(variables: QuotesListViewQueryVariables | VueCompositionApi.Ref<QuotesListViewQueryVariables> | ReactiveFunction<QuotesListViewQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<QuotesListViewQuery, QuotesListViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuotesListViewQuery, QuotesListViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuotesListViewQuery, QuotesListViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QuotesListViewQuery, QuotesListViewQueryVariables>(QuotesListViewDocument, variables, options);
}
export type QuotesListViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QuotesListViewQuery, QuotesListViewQueryVariables>;
export const PurchaseOrdersListViewDocument = gql`
    query purchaseOrdersListView($input: FinanceDocumentsListInput!) {
  PurchaseOrdersList(input: $input) {
    id
    number
    issueDate
    sum
    hasProjectOnEachLine
    displayCurrencyRate
    author {
      id
      initials
      name
    }
    mainContact {
      id
      name
    }
    status {
      id
      name
      color
    }
    project {
      id
      name
    }
    lines {
      id
      project {
        id
        name
      }
    }
  }
}
    `;

/**
 * __usePurchaseOrdersListViewQuery__
 *
 * To run a query within a Vue component, call `usePurchaseOrdersListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrdersListViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePurchaseOrdersListViewQuery({
 *   input: // value for 'input'
 * });
 */
export function usePurchaseOrdersListViewQuery(variables: PurchaseOrdersListViewQueryVariables | VueCompositionApi.Ref<PurchaseOrdersListViewQueryVariables> | ReactiveFunction<PurchaseOrdersListViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<PurchaseOrdersListViewQuery, PurchaseOrdersListViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PurchaseOrdersListViewQuery, PurchaseOrdersListViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PurchaseOrdersListViewQuery, PurchaseOrdersListViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PurchaseOrdersListViewQuery, PurchaseOrdersListViewQueryVariables>(PurchaseOrdersListViewDocument, variables, options);
}
export function usePurchaseOrdersListViewLazyQuery(variables?: PurchaseOrdersListViewQueryVariables | VueCompositionApi.Ref<PurchaseOrdersListViewQueryVariables> | ReactiveFunction<PurchaseOrdersListViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<PurchaseOrdersListViewQuery, PurchaseOrdersListViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PurchaseOrdersListViewQuery, PurchaseOrdersListViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PurchaseOrdersListViewQuery, PurchaseOrdersListViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PurchaseOrdersListViewQuery, PurchaseOrdersListViewQueryVariables>(PurchaseOrdersListViewDocument, variables, options);
}
export type PurchaseOrdersListViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PurchaseOrdersListViewQuery, PurchaseOrdersListViewQueryVariables>;
export const RetrospectiveLinkingModalExpenseDocument = gql`
    query retrospectiveLinkingModalExpense($id: ID!) {
  Expense(id: $id) {
    __typename
    id
    number
    mainContact {
      id
      name
    }
    author {
      id
      name
    }
    issueDate
    project {
      id
      name
    }
    hasProjectOnEachLine
    displayCurrencyRate
    lines {
      id
      ordering
      quoteLine {
        __typename
        ... on QuoteLine {
          id
          product {
            id
            name
          }
          quote {
            id
            number
          }
        }
        ... on HiddenByPermissions {
          id
        }
      }
      project {
        id
        name
      }
      product {
        id
        name
      }
      comment
      isSubHeading
      isEmptyRow
      amount
      unit {
        id
        symbol
        name
      }
      secondaryAmount
      sumAfterAllDiscounts
    }
  }
}
    `;

/**
 * __useRetrospectiveLinkingModalExpenseQuery__
 *
 * To run a query within a Vue component, call `useRetrospectiveLinkingModalExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrospectiveLinkingModalExpenseQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrospectiveLinkingModalExpenseQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrospectiveLinkingModalExpenseQuery(variables: RetrospectiveLinkingModalExpenseQueryVariables | VueCompositionApi.Ref<RetrospectiveLinkingModalExpenseQueryVariables> | ReactiveFunction<RetrospectiveLinkingModalExpenseQueryVariables>, options: VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalExpenseQuery, RetrospectiveLinkingModalExpenseQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalExpenseQuery, RetrospectiveLinkingModalExpenseQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalExpenseQuery, RetrospectiveLinkingModalExpenseQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RetrospectiveLinkingModalExpenseQuery, RetrospectiveLinkingModalExpenseQueryVariables>(RetrospectiveLinkingModalExpenseDocument, variables, options);
}
export function useRetrospectiveLinkingModalExpenseLazyQuery(variables?: RetrospectiveLinkingModalExpenseQueryVariables | VueCompositionApi.Ref<RetrospectiveLinkingModalExpenseQueryVariables> | ReactiveFunction<RetrospectiveLinkingModalExpenseQueryVariables>, options: VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalExpenseQuery, RetrospectiveLinkingModalExpenseQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalExpenseQuery, RetrospectiveLinkingModalExpenseQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalExpenseQuery, RetrospectiveLinkingModalExpenseQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RetrospectiveLinkingModalExpenseQuery, RetrospectiveLinkingModalExpenseQueryVariables>(RetrospectiveLinkingModalExpenseDocument, variables, options);
}
export type RetrospectiveLinkingModalExpenseQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RetrospectiveLinkingModalExpenseQuery, RetrospectiveLinkingModalExpenseQueryVariables>;
export const RetrospectiveLinkingModalBillDocument = gql`
    query retrospectiveLinkingModalBill($id: ID!) {
  Bill(id: $id) {
    __typename
    id
    number
    mainContact {
      id
      name
    }
    author {
      id
      name
    }
    issueDate
    project {
      id
      name
    }
    hasProjectOnEachLine
    displayCurrencyRate
    lines {
      id
      ordering
      quoteLine {
        __typename
        ... on QuoteLine {
          id
          comment
          product {
            id
            name
          }
          quote {
            id
            number
          }
        }
        ... on HiddenByPermissions {
          id
        }
      }
      purchaseOrderLine {
        __typename
        ... on PurchaseOrderLine {
          id
          comment
          product {
            id
            name
          }
          purchaseOrder {
            id
            number
          }
        }
        ... on HiddenByPermissions {
          id
        }
      }
      project {
        id
        name
      }
      product {
        id
        name
      }
      comment
      isSubHeading
      isEmptyRow
      amount
      unit {
        id
        symbol
        name
      }
      secondaryAmount
      sumAfterAllDiscounts
    }
  }
}
    `;

/**
 * __useRetrospectiveLinkingModalBillQuery__
 *
 * To run a query within a Vue component, call `useRetrospectiveLinkingModalBillQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrospectiveLinkingModalBillQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrospectiveLinkingModalBillQuery({
 *   id: // value for 'id'
 * });
 */
export function useRetrospectiveLinkingModalBillQuery(variables: RetrospectiveLinkingModalBillQueryVariables | VueCompositionApi.Ref<RetrospectiveLinkingModalBillQueryVariables> | ReactiveFunction<RetrospectiveLinkingModalBillQueryVariables>, options: VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalBillQuery, RetrospectiveLinkingModalBillQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalBillQuery, RetrospectiveLinkingModalBillQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalBillQuery, RetrospectiveLinkingModalBillQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RetrospectiveLinkingModalBillQuery, RetrospectiveLinkingModalBillQueryVariables>(RetrospectiveLinkingModalBillDocument, variables, options);
}
export function useRetrospectiveLinkingModalBillLazyQuery(variables?: RetrospectiveLinkingModalBillQueryVariables | VueCompositionApi.Ref<RetrospectiveLinkingModalBillQueryVariables> | ReactiveFunction<RetrospectiveLinkingModalBillQueryVariables>, options: VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalBillQuery, RetrospectiveLinkingModalBillQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalBillQuery, RetrospectiveLinkingModalBillQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RetrospectiveLinkingModalBillQuery, RetrospectiveLinkingModalBillQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RetrospectiveLinkingModalBillQuery, RetrospectiveLinkingModalBillQueryVariables>(RetrospectiveLinkingModalBillDocument, variables, options);
}
export type RetrospectiveLinkingModalBillQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RetrospectiveLinkingModalBillQuery, RetrospectiveLinkingModalBillQueryVariables>;
export const SaveExpenseLineQuoteLineRelationsDocument = gql`
    mutation saveExpenseLineQuoteLineRelations($input: DocumentLineRelationsSaveInput!) {
  SaveExpenseLineQuoteLineRelations(input: $input)
}
    `;

/**
 * __useSaveExpenseLineQuoteLineRelationsMutation__
 *
 * To run a mutation, you first call `useSaveExpenseLineQuoteLineRelationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveExpenseLineQuoteLineRelationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveExpenseLineQuoteLineRelationsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveExpenseLineQuoteLineRelationsMutation(options: VueApolloComposable.UseMutationOptions<SaveExpenseLineQuoteLineRelationsMutation, SaveExpenseLineQuoteLineRelationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveExpenseLineQuoteLineRelationsMutation, SaveExpenseLineQuoteLineRelationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveExpenseLineQuoteLineRelationsMutation, SaveExpenseLineQuoteLineRelationsMutationVariables>(SaveExpenseLineQuoteLineRelationsDocument, options);
}
export type SaveExpenseLineQuoteLineRelationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveExpenseLineQuoteLineRelationsMutation, SaveExpenseLineQuoteLineRelationsMutationVariables>;
export const SaveBillLineQuoteLineRelationsDocument = gql`
    mutation saveBillLineQuoteLineRelations($input: DocumentLineRelationsSaveInput!) {
  SaveBillLineQuoteLineRelations(input: $input)
}
    `;

/**
 * __useSaveBillLineQuoteLineRelationsMutation__
 *
 * To run a mutation, you first call `useSaveBillLineQuoteLineRelationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveBillLineQuoteLineRelationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveBillLineQuoteLineRelationsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveBillLineQuoteLineRelationsMutation(options: VueApolloComposable.UseMutationOptions<SaveBillLineQuoteLineRelationsMutation, SaveBillLineQuoteLineRelationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveBillLineQuoteLineRelationsMutation, SaveBillLineQuoteLineRelationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveBillLineQuoteLineRelationsMutation, SaveBillLineQuoteLineRelationsMutationVariables>(SaveBillLineQuoteLineRelationsDocument, options);
}
export type SaveBillLineQuoteLineRelationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveBillLineQuoteLineRelationsMutation, SaveBillLineQuoteLineRelationsMutationVariables>;
export const SaveBillLinePurchaseOrderLineRelationsDocument = gql`
    mutation saveBillLinePurchaseOrderLineRelations($input: DocumentLineRelationsSaveInput!) {
  SaveBillLinePurchaseOrderLineRelations(input: $input)
}
    `;

/**
 * __useSaveBillLinePurchaseOrderLineRelationsMutation__
 *
 * To run a mutation, you first call `useSaveBillLinePurchaseOrderLineRelationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveBillLinePurchaseOrderLineRelationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveBillLinePurchaseOrderLineRelationsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveBillLinePurchaseOrderLineRelationsMutation(options: VueApolloComposable.UseMutationOptions<SaveBillLinePurchaseOrderLineRelationsMutation, SaveBillLinePurchaseOrderLineRelationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveBillLinePurchaseOrderLineRelationsMutation, SaveBillLinePurchaseOrderLineRelationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveBillLinePurchaseOrderLineRelationsMutation, SaveBillLinePurchaseOrderLineRelationsMutationVariables>(SaveBillLinePurchaseOrderLineRelationsDocument, options);
}
export type SaveBillLinePurchaseOrderLineRelationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveBillLinePurchaseOrderLineRelationsMutation, SaveBillLinePurchaseOrderLineRelationsMutationVariables>;
export const RevenueReportForecastDocument = gql`
    query RevenueReportForecast($input: FilterHashInput!) {
  RevenueReportForecast(input: $input) {
    revenueReportForecastList {
      project {
        id
        name
        projectType
        permissions {
          hasProjectTabs
        }
      }
      quote {
        id
        number
        quoteName
      }
      client {
        id
        name
      }
      periods {
        period
        displayRevenue
      }
    }
    revenueReportForecastSummary {
      numberOfPeriods
      fromDate
      isQuotesSelected
      isProjectsSelected
      groupBy
      periods {
        period
        recognizedRevenue
        pipelineRevenue
      }
    }
  }
}
    `;

/**
 * __useRevenueReportForecastQuery__
 *
 * To run a query within a Vue component, call `useRevenueReportForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevenueReportForecastQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRevenueReportForecastQuery({
 *   input: // value for 'input'
 * });
 */
export function useRevenueReportForecastQuery(variables: RevenueReportForecastQueryVariables | VueCompositionApi.Ref<RevenueReportForecastQueryVariables> | ReactiveFunction<RevenueReportForecastQueryVariables>, options: VueApolloComposable.UseQueryOptions<RevenueReportForecastQuery, RevenueReportForecastQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RevenueReportForecastQuery, RevenueReportForecastQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RevenueReportForecastQuery, RevenueReportForecastQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RevenueReportForecastQuery, RevenueReportForecastQueryVariables>(RevenueReportForecastDocument, variables, options);
}
export function useRevenueReportForecastLazyQuery(variables?: RevenueReportForecastQueryVariables | VueCompositionApi.Ref<RevenueReportForecastQueryVariables> | ReactiveFunction<RevenueReportForecastQueryVariables>, options: VueApolloComposable.UseQueryOptions<RevenueReportForecastQuery, RevenueReportForecastQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RevenueReportForecastQuery, RevenueReportForecastQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RevenueReportForecastQuery, RevenueReportForecastQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RevenueReportForecastQuery, RevenueReportForecastQueryVariables>(RevenueReportForecastDocument, variables, options);
}
export type RevenueReportForecastQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RevenueReportForecastQuery, RevenueReportForecastQueryVariables>;
export const RevenueReportForecastExportDocument = gql`
    query RevenueReportForecastExport($input: RevenueReportForecastExportInput!) {
  RevenueReportForecastExport(input: $input) {
    fileUrl
  }
}
    `;

/**
 * __useRevenueReportForecastExportQuery__
 *
 * To run a query within a Vue component, call `useRevenueReportForecastExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevenueReportForecastExportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRevenueReportForecastExportQuery({
 *   input: // value for 'input'
 * });
 */
export function useRevenueReportForecastExportQuery(variables: RevenueReportForecastExportQueryVariables | VueCompositionApi.Ref<RevenueReportForecastExportQueryVariables> | ReactiveFunction<RevenueReportForecastExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<RevenueReportForecastExportQuery, RevenueReportForecastExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RevenueReportForecastExportQuery, RevenueReportForecastExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RevenueReportForecastExportQuery, RevenueReportForecastExportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RevenueReportForecastExportQuery, RevenueReportForecastExportQueryVariables>(RevenueReportForecastExportDocument, variables, options);
}
export function useRevenueReportForecastExportLazyQuery(variables?: RevenueReportForecastExportQueryVariables | VueCompositionApi.Ref<RevenueReportForecastExportQueryVariables> | ReactiveFunction<RevenueReportForecastExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<RevenueReportForecastExportQuery, RevenueReportForecastExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RevenueReportForecastExportQuery, RevenueReportForecastExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RevenueReportForecastExportQuery, RevenueReportForecastExportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RevenueReportForecastExportQuery, RevenueReportForecastExportQueryVariables>(RevenueReportForecastExportDocument, variables, options);
}
export type RevenueReportForecastExportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RevenueReportForecastExportQuery, RevenueReportForecastExportQueryVariables>;
export const RoleModifyDeleteDocument = gql`
    mutation roleModifyDelete($id: ID!) {
  RoleDelete(id: $id)
}
    `;

/**
 * __useRoleModifyDeleteMutation__
 *
 * To run a mutation, you first call `useRoleModifyDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRoleModifyDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRoleModifyDeleteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRoleModifyDeleteMutation(options: VueApolloComposable.UseMutationOptions<RoleModifyDeleteMutation, RoleModifyDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RoleModifyDeleteMutation, RoleModifyDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RoleModifyDeleteMutation, RoleModifyDeleteMutationVariables>(RoleModifyDeleteDocument, options);
}
export type RoleModifyDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RoleModifyDeleteMutation, RoleModifyDeleteMutationVariables>;
export const RoleModifyPageExistingRoleDocument = gql`
    query roleModifyPageExistingRole($id: ID!) {
  Role(id: $id) {
    id
    name
    initials
    isActive
    laborCost
    priceLists {
      sellingPrice
      priceList {
        id
        name
        currency
        isDefault
      }
    }
    users {
      id
      firstName
      lastName
      profilePicture {
        medium
      }
    }
  }
}
    `;

/**
 * __useRoleModifyPageExistingRoleQuery__
 *
 * To run a query within a Vue component, call `useRoleModifyPageExistingRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleModifyPageExistingRoleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoleModifyPageExistingRoleQuery({
 *   id: // value for 'id'
 * });
 */
export function useRoleModifyPageExistingRoleQuery(variables: RoleModifyPageExistingRoleQueryVariables | VueCompositionApi.Ref<RoleModifyPageExistingRoleQueryVariables> | ReactiveFunction<RoleModifyPageExistingRoleQueryVariables>, options: VueApolloComposable.UseQueryOptions<RoleModifyPageExistingRoleQuery, RoleModifyPageExistingRoleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleModifyPageExistingRoleQuery, RoleModifyPageExistingRoleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleModifyPageExistingRoleQuery, RoleModifyPageExistingRoleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RoleModifyPageExistingRoleQuery, RoleModifyPageExistingRoleQueryVariables>(RoleModifyPageExistingRoleDocument, variables, options);
}
export function useRoleModifyPageExistingRoleLazyQuery(variables?: RoleModifyPageExistingRoleQueryVariables | VueCompositionApi.Ref<RoleModifyPageExistingRoleQueryVariables> | ReactiveFunction<RoleModifyPageExistingRoleQueryVariables>, options: VueApolloComposable.UseQueryOptions<RoleModifyPageExistingRoleQuery, RoleModifyPageExistingRoleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleModifyPageExistingRoleQuery, RoleModifyPageExistingRoleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleModifyPageExistingRoleQuery, RoleModifyPageExistingRoleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RoleModifyPageExistingRoleQuery, RoleModifyPageExistingRoleQueryVariables>(RoleModifyPageExistingRoleDocument, variables, options);
}
export type RoleModifyPageExistingRoleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RoleModifyPageExistingRoleQuery, RoleModifyPageExistingRoleQueryVariables>;
export const RoleModifyPageDocument = gql`
    query roleModifyPage($usersListInput: UsersListInput!) {
  PriceListsList {
    id
    name
    currency
    isDefault
  }
  UsersList(input: $usersListInput) {
    id
    name
    role {
      id
    }
    profilePicture {
      medium
    }
  }
}
    `;

/**
 * __useRoleModifyPageQuery__
 *
 * To run a query within a Vue component, call `useRoleModifyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleModifyPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoleModifyPageQuery({
 *   usersListInput: // value for 'usersListInput'
 * });
 */
export function useRoleModifyPageQuery(variables: RoleModifyPageQueryVariables | VueCompositionApi.Ref<RoleModifyPageQueryVariables> | ReactiveFunction<RoleModifyPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<RoleModifyPageQuery, RoleModifyPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleModifyPageQuery, RoleModifyPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleModifyPageQuery, RoleModifyPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RoleModifyPageQuery, RoleModifyPageQueryVariables>(RoleModifyPageDocument, variables, options);
}
export function useRoleModifyPageLazyQuery(variables?: RoleModifyPageQueryVariables | VueCompositionApi.Ref<RoleModifyPageQueryVariables> | ReactiveFunction<RoleModifyPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<RoleModifyPageQuery, RoleModifyPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleModifyPageQuery, RoleModifyPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleModifyPageQuery, RoleModifyPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RoleModifyPageQuery, RoleModifyPageQueryVariables>(RoleModifyPageDocument, variables, options);
}
export type RoleModifyPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RoleModifyPageQuery, RoleModifyPageQueryVariables>;
export const RoleSaveDocument = gql`
    mutation roleSave($input: RoleSaveInput!) {
  RoleSave(input: $input) {
    __typename
    id
    name
    isActive
    initials
    usersCount
    sellingPrice
    priceLists {
      sellingPrice
      priceList {
        id
        name
        currency
        isDefault
      }
    }
    users {
      id
      firstName
      lastName
      profilePicture {
        medium
      }
    }
  }
}
    `;

/**
 * __useRoleSaveMutation__
 *
 * To run a mutation, you first call `useRoleSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRoleSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRoleSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRoleSaveMutation(options: VueApolloComposable.UseMutationOptions<RoleSaveMutation, RoleSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RoleSaveMutation, RoleSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RoleSaveMutation, RoleSaveMutationVariables>(RoleSaveDocument, options);
}
export type RoleSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RoleSaveMutation, RoleSaveMutationVariables>;
export const RoleListDocument = gql`
    query RoleList($rolesListInput: RolesListInput!, $usersFilterInput: UsersListInput!) {
  RolesList(input: $rolesListInput) {
    id
    name
    initials
    users(input: $usersFilterInput) {
      id
      firstName
      lastName
    }
    usersCount
    sellingPrice
  }
}
    `;

/**
 * __useRoleListQuery__
 *
 * To run a query within a Vue component, call `useRoleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoleListQuery({
 *   rolesListInput: // value for 'rolesListInput'
 *   usersFilterInput: // value for 'usersFilterInput'
 * });
 */
export function useRoleListQuery(variables: RoleListQueryVariables | VueCompositionApi.Ref<RoleListQueryVariables> | ReactiveFunction<RoleListQueryVariables>, options: VueApolloComposable.UseQueryOptions<RoleListQuery, RoleListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleListQuery, RoleListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleListQuery, RoleListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RoleListQuery, RoleListQueryVariables>(RoleListDocument, variables, options);
}
export function useRoleListLazyQuery(variables?: RoleListQueryVariables | VueCompositionApi.Ref<RoleListQueryVariables> | ReactiveFunction<RoleListQueryVariables>, options: VueApolloComposable.UseQueryOptions<RoleListQuery, RoleListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleListQuery, RoleListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleListQuery, RoleListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RoleListQuery, RoleListQueryVariables>(RoleListDocument, variables, options);
}
export type RoleListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RoleListQuery, RoleListQueryVariables>;
export const RolePermissionsDocument = gql`
    query RolePermissions {
  Permissions {
    roles {
      canToggleRolesOff
    }
  }
}
    `;

/**
 * __useRolePermissionsQuery__
 *
 * To run a query within a Vue component, call `useRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolePermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRolePermissionsQuery();
 */
export function useRolePermissionsQuery(options: VueApolloComposable.UseQueryOptions<RolePermissionsQuery, RolePermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RolePermissionsQuery, RolePermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RolePermissionsQuery, RolePermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RolePermissionsQuery, RolePermissionsQueryVariables>(RolePermissionsDocument, {}, options);
}
export function useRolePermissionsLazyQuery(options: VueApolloComposable.UseQueryOptions<RolePermissionsQuery, RolePermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RolePermissionsQuery, RolePermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RolePermissionsQuery, RolePermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RolePermissionsQuery, RolePermissionsQueryVariables>(RolePermissionsDocument, {}, options);
}
export type RolePermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RolePermissionsQuery, RolePermissionsQueryVariables>;
export const RolesExportDocument = gql`
    query rolesExport($input: ExportInput!) {
  RolesExport(input: $input) {
    fileUrl
  }
}
    `;

/**
 * __useRolesExportQuery__
 *
 * To run a query within a Vue component, call `useRolesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesExportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRolesExportQuery({
 *   input: // value for 'input'
 * });
 */
export function useRolesExportQuery(variables: RolesExportQueryVariables | VueCompositionApi.Ref<RolesExportQueryVariables> | ReactiveFunction<RolesExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<RolesExportQuery, RolesExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RolesExportQuery, RolesExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RolesExportQuery, RolesExportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RolesExportQuery, RolesExportQueryVariables>(RolesExportDocument, variables, options);
}
export function useRolesExportLazyQuery(variables?: RolesExportQueryVariables | VueCompositionApi.Ref<RolesExportQueryVariables> | ReactiveFunction<RolesExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<RolesExportQuery, RolesExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RolesExportQuery, RolesExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RolesExportQuery, RolesExportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RolesExportQuery, RolesExportQueryVariables>(RolesExportDocument, variables, options);
}
export type RolesExportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RolesExportQuery, RolesExportQueryVariables>;
export const SalesforceIsQuoteLinkedDocument = gql`
    query salesforceIsQuoteLinked($input: SalesforceIsQuoteLinkedInputType!) {
  SalesforceIsQuoteLinked(input: $input)
}
    `;

/**
 * __useSalesforceIsQuoteLinkedQuery__
 *
 * To run a query within a Vue component, call `useSalesforceIsQuoteLinkedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceIsQuoteLinkedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSalesforceIsQuoteLinkedQuery({
 *   input: // value for 'input'
 * });
 */
export function useSalesforceIsQuoteLinkedQuery(variables: SalesforceIsQuoteLinkedQueryVariables | VueCompositionApi.Ref<SalesforceIsQuoteLinkedQueryVariables> | ReactiveFunction<SalesforceIsQuoteLinkedQueryVariables>, options: VueApolloComposable.UseQueryOptions<SalesforceIsQuoteLinkedQuery, SalesforceIsQuoteLinkedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SalesforceIsQuoteLinkedQuery, SalesforceIsQuoteLinkedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SalesforceIsQuoteLinkedQuery, SalesforceIsQuoteLinkedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SalesforceIsQuoteLinkedQuery, SalesforceIsQuoteLinkedQueryVariables>(SalesforceIsQuoteLinkedDocument, variables, options);
}
export function useSalesforceIsQuoteLinkedLazyQuery(variables?: SalesforceIsQuoteLinkedQueryVariables | VueCompositionApi.Ref<SalesforceIsQuoteLinkedQueryVariables> | ReactiveFunction<SalesforceIsQuoteLinkedQueryVariables>, options: VueApolloComposable.UseQueryOptions<SalesforceIsQuoteLinkedQuery, SalesforceIsQuoteLinkedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SalesforceIsQuoteLinkedQuery, SalesforceIsQuoteLinkedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SalesforceIsQuoteLinkedQuery, SalesforceIsQuoteLinkedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SalesforceIsQuoteLinkedQuery, SalesforceIsQuoteLinkedQueryVariables>(SalesforceIsQuoteLinkedDocument, variables, options);
}
export type SalesforceIsQuoteLinkedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SalesforceIsQuoteLinkedQuery, SalesforceIsQuoteLinkedQueryVariables>;
export const SalesforceSyncQuoteSumAndPdfDocument = gql`
    mutation salesforceSyncQuoteSumAndPdf($input: SalesforceSyncQuoteSumAndPdfInputType!) {
  SalesforceSyncQuoteSumAndPdf(input: $input)
}
    `;

/**
 * __useSalesforceSyncQuoteSumAndPdfMutation__
 *
 * To run a mutation, you first call `useSalesforceSyncQuoteSumAndPdfMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSalesforceSyncQuoteSumAndPdfMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSalesforceSyncQuoteSumAndPdfMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSalesforceSyncQuoteSumAndPdfMutation(options: VueApolloComposable.UseMutationOptions<SalesforceSyncQuoteSumAndPdfMutation, SalesforceSyncQuoteSumAndPdfMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SalesforceSyncQuoteSumAndPdfMutation, SalesforceSyncQuoteSumAndPdfMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SalesforceSyncQuoteSumAndPdfMutation, SalesforceSyncQuoteSumAndPdfMutationVariables>(SalesforceSyncQuoteSumAndPdfDocument, options);
}
export type SalesforceSyncQuoteSumAndPdfMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SalesforceSyncQuoteSumAndPdfMutation, SalesforceSyncQuoteSumAndPdfMutationVariables>;
export const SearchSettingsDocument = gql`
    query searchSettings {
  SearchSettings {
    feature {
      name
    }
    isEnabled
  }
}
    `;

/**
 * __useSearchSettingsQuery__
 *
 * To run a query within a Vue component, call `useSearchSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchSettingsQuery();
 */
export function useSearchSettingsQuery(options: VueApolloComposable.UseQueryOptions<SearchSettingsQuery, SearchSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchSettingsQuery, SearchSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchSettingsQuery, SearchSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchSettingsQuery, SearchSettingsQueryVariables>(SearchSettingsDocument, {}, options);
}
export function useSearchSettingsLazyQuery(options: VueApolloComposable.UseQueryOptions<SearchSettingsQuery, SearchSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchSettingsQuery, SearchSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchSettingsQuery, SearchSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchSettingsQuery, SearchSettingsQueryVariables>(SearchSettingsDocument, {}, options);
}
export type SearchSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchSettingsQuery, SearchSettingsQueryVariables>;
export const SearchDropdownSettingsUpdateDocument = gql`
    mutation searchDropdownSettingsUpdate($featureNames: [String!]!) {
  SearchSettingsUpdate(modules: $featureNames) {
    feature {
      name
    }
    isEnabled
  }
}
    `;

/**
 * __useSearchDropdownSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useSearchDropdownSettingsUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSearchDropdownSettingsUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSearchDropdownSettingsUpdateMutation({
 *   variables: {
 *     featureNames: // value for 'featureNames'
 *   },
 * });
 */
export function useSearchDropdownSettingsUpdateMutation(options: VueApolloComposable.UseMutationOptions<SearchDropdownSettingsUpdateMutation, SearchDropdownSettingsUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SearchDropdownSettingsUpdateMutation, SearchDropdownSettingsUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SearchDropdownSettingsUpdateMutation, SearchDropdownSettingsUpdateMutationVariables>(SearchDropdownSettingsUpdateDocument, options);
}
export type SearchDropdownSettingsUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SearchDropdownSettingsUpdateMutation, SearchDropdownSettingsUpdateMutationVariables>;
export const SearchResultsDocument = gql`
    query searchResults($keyword: String!, $limit: Int!, $feature: String!, $startFrom: Int) {
  SearchResults(
    input: {keyword: $keyword, limit: $limit, feature: {name: $feature}, startFrom: $startFrom}
  ) {
    ... on UnionFile {
      file {
        id
        name
      }
    }
    ... on UnionNewsFeedItem {
      newsFeedItem {
        id
        name
      }
    }
    ... on UnionProject {
      project {
        id
        name
      }
    }
    ... on UnionRealEstateObject {
      realEstateObject {
        id
        name
      }
    }
    ... on UnionUser {
      user {
        id
        name
        profilePicture {
          medium
        }
      }
    }
    ... on UnionContact {
      contact {
        id
        name
        phones
        mobiles
        emails
        type
      }
    }
    ... on UnionMarketingList {
      marketingList {
        id
        name
      }
    }
    ... on UnionInvoice {
      invoice {
        id
        number
        mainContact {
          id
          name
          type
        }
      }
    }
    ... on UnionOrder {
      order {
        id
        number
        mainContact {
          id
          name
          type
        }
      }
    }
    ... on UnionQuote {
      quote {
        id
        number
        mainContact {
          id
          name
          type
        }
      }
    }
    ... on UnionRentalOrder {
      rentalOrder {
        id
        number
        mainContact {
          id
          name
          type
        }
      }
    }
    ... on UnionExpense {
      expense {
        id
        number
        mainContact {
          id
          name
          type
        }
      }
    }
    ... on UnionPurchaseOrder {
      purchaseOrder {
        id
        number
        mainContact {
          id
          name
          type
        }
      }
    }
    ... on UnionBill {
      bill {
        id
        number
        mainContact {
          id
          name
          type
        }
      }
    }
  }
}
    `;

/**
 * __useSearchResultsQuery__
 *
 * To run a query within a Vue component, call `useSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchResultsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchResultsQuery({
 *   keyword: // value for 'keyword'
 *   limit: // value for 'limit'
 *   feature: // value for 'feature'
 *   startFrom: // value for 'startFrom'
 * });
 */
export function useSearchResultsQuery(variables: SearchResultsQueryVariables | VueCompositionApi.Ref<SearchResultsQueryVariables> | ReactiveFunction<SearchResultsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchResultsQuery, SearchResultsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchResultsQuery, SearchResultsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchResultsQuery, SearchResultsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchResultsQuery, SearchResultsQueryVariables>(SearchResultsDocument, variables, options);
}
export function useSearchResultsLazyQuery(variables?: SearchResultsQueryVariables | VueCompositionApi.Ref<SearchResultsQueryVariables> | ReactiveFunction<SearchResultsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchResultsQuery, SearchResultsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchResultsQuery, SearchResultsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchResultsQuery, SearchResultsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchResultsQuery, SearchResultsQueryVariables>(SearchResultsDocument, variables, options);
}
export type SearchResultsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchResultsQuery, SearchResultsQueryVariables>;
export const SearchTotalsDocument = gql`
    query searchTotals($keyword: String!, $feature: String!) {
  SearchTotals(input: {keyword: $keyword, feature: {name: $feature}}) {
    feature {
      name
    }
    count
  }
}
    `;

/**
 * __useSearchTotalsQuery__
 *
 * To run a query within a Vue component, call `useSearchTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTotalsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchTotalsQuery({
 *   keyword: // value for 'keyword'
 *   feature: // value for 'feature'
 * });
 */
export function useSearchTotalsQuery(variables: SearchTotalsQueryVariables | VueCompositionApi.Ref<SearchTotalsQueryVariables> | ReactiveFunction<SearchTotalsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchTotalsQuery, SearchTotalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchTotalsQuery, SearchTotalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchTotalsQuery, SearchTotalsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchTotalsQuery, SearchTotalsQueryVariables>(SearchTotalsDocument, variables, options);
}
export function useSearchTotalsLazyQuery(variables?: SearchTotalsQueryVariables | VueCompositionApi.Ref<SearchTotalsQueryVariables> | ReactiveFunction<SearchTotalsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchTotalsQuery, SearchTotalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchTotalsQuery, SearchTotalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchTotalsQuery, SearchTotalsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchTotalsQuery, SearchTotalsQueryVariables>(SearchTotalsDocument, variables, options);
}
export type SearchTotalsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchTotalsQuery, SearchTotalsQueryVariables>;
export const SelfServiceModalCancelDocument = gql`
    mutation selfServiceModalCancel($input: SelfServiceCancelSubscriptionRequestInput!) {
  SelfServiceCancelSubscriptionRequest(input: $input)
}
    `;

/**
 * __useSelfServiceModalCancelMutation__
 *
 * To run a mutation, you first call `useSelfServiceModalCancelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceModalCancelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSelfServiceModalCancelMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSelfServiceModalCancelMutation(options: VueApolloComposable.UseMutationOptions<SelfServiceModalCancelMutation, SelfServiceModalCancelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SelfServiceModalCancelMutation, SelfServiceModalCancelMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SelfServiceModalCancelMutation, SelfServiceModalCancelMutationVariables>(SelfServiceModalCancelDocument, options);
}
export type SelfServiceModalCancelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SelfServiceModalCancelMutation, SelfServiceModalCancelMutationVariables>;
export const SelfServiceScheduleSeatReductionDeleteDocument = gql`
    mutation selfServiceScheduleSeatReductionDelete($reductionRequestId: ID!) {
  SelfServiceDeleteSeatReductionRequest(reductionRequestId: $reductionRequestId)
}
    `;

/**
 * __useSelfServiceScheduleSeatReductionDeleteMutation__
 *
 * To run a mutation, you first call `useSelfServiceScheduleSeatReductionDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceScheduleSeatReductionDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSelfServiceScheduleSeatReductionDeleteMutation({
 *   variables: {
 *     reductionRequestId: // value for 'reductionRequestId'
 *   },
 * });
 */
export function useSelfServiceScheduleSeatReductionDeleteMutation(options: VueApolloComposable.UseMutationOptions<SelfServiceScheduleSeatReductionDeleteMutation, SelfServiceScheduleSeatReductionDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SelfServiceScheduleSeatReductionDeleteMutation, SelfServiceScheduleSeatReductionDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SelfServiceScheduleSeatReductionDeleteMutation, SelfServiceScheduleSeatReductionDeleteMutationVariables>(SelfServiceScheduleSeatReductionDeleteDocument, options);
}
export type SelfServiceScheduleSeatReductionDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SelfServiceScheduleSeatReductionDeleteMutation, SelfServiceScheduleSeatReductionDeleteMutationVariables>;
export const SelfServiceScheduleSeatReductionModalDocument = gql`
    mutation selfServiceScheduleSeatReductionModal($input: SelfServiceSendSeatReductionRequestInput!) {
  SelfServiceSendSeatReductionRequest(input: $input) {
    ...SelfServiceSeatReductionRequest
  }
}
    ${SelfServiceSeatReductionRequestFragmentDoc}`;

/**
 * __useSelfServiceScheduleSeatReductionModalMutation__
 *
 * To run a mutation, you first call `useSelfServiceScheduleSeatReductionModalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceScheduleSeatReductionModalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSelfServiceScheduleSeatReductionModalMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSelfServiceScheduleSeatReductionModalMutation(options: VueApolloComposable.UseMutationOptions<SelfServiceScheduleSeatReductionModalMutation, SelfServiceScheduleSeatReductionModalMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SelfServiceScheduleSeatReductionModalMutation, SelfServiceScheduleSeatReductionModalMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SelfServiceScheduleSeatReductionModalMutation, SelfServiceScheduleSeatReductionModalMutationVariables>(SelfServiceScheduleSeatReductionModalDocument, options);
}
export type SelfServiceScheduleSeatReductionModalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SelfServiceScheduleSeatReductionModalMutation, SelfServiceScheduleSeatReductionModalMutationVariables>;
export const SelfServiceFeaturesOverLimitDocument = gql`
    query selfServiceFeaturesOverLimit($input: SelfServiceDataInput!) {
  SelfServiceFeaturesOverLimit(input: $input) {
    feature {
      id
      title
    }
    currentUsage
    limit
    isBlockingDowngrade
    willDeleteData
    actionUrl
  }
}
    `;

/**
 * __useSelfServiceFeaturesOverLimitQuery__
 *
 * To run a query within a Vue component, call `useSelfServiceFeaturesOverLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceFeaturesOverLimitQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelfServiceFeaturesOverLimitQuery({
 *   input: // value for 'input'
 * });
 */
export function useSelfServiceFeaturesOverLimitQuery(variables: SelfServiceFeaturesOverLimitQueryVariables | VueCompositionApi.Ref<SelfServiceFeaturesOverLimitQueryVariables> | ReactiveFunction<SelfServiceFeaturesOverLimitQueryVariables>, options: VueApolloComposable.UseQueryOptions<SelfServiceFeaturesOverLimitQuery, SelfServiceFeaturesOverLimitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SelfServiceFeaturesOverLimitQuery, SelfServiceFeaturesOverLimitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SelfServiceFeaturesOverLimitQuery, SelfServiceFeaturesOverLimitQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SelfServiceFeaturesOverLimitQuery, SelfServiceFeaturesOverLimitQueryVariables>(SelfServiceFeaturesOverLimitDocument, variables, options);
}
export function useSelfServiceFeaturesOverLimitLazyQuery(variables?: SelfServiceFeaturesOverLimitQueryVariables | VueCompositionApi.Ref<SelfServiceFeaturesOverLimitQueryVariables> | ReactiveFunction<SelfServiceFeaturesOverLimitQueryVariables>, options: VueApolloComposable.UseQueryOptions<SelfServiceFeaturesOverLimitQuery, SelfServiceFeaturesOverLimitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SelfServiceFeaturesOverLimitQuery, SelfServiceFeaturesOverLimitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SelfServiceFeaturesOverLimitQuery, SelfServiceFeaturesOverLimitQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SelfServiceFeaturesOverLimitQuery, SelfServiceFeaturesOverLimitQueryVariables>(SelfServiceFeaturesOverLimitDocument, variables, options);
}
export type SelfServiceFeaturesOverLimitQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SelfServiceFeaturesOverLimitQuery, SelfServiceFeaturesOverLimitQueryVariables>;
export const SelfServiceAddonsDocument = gql`
    query SelfServiceAddons($siteId: ID, $selfServiceData: SelfServiceDataInput!) {
  SelfServiceData(siteId: $siteId, userChanges: $selfServiceData) {
    addons {
      id
      name
      description
      amountInUse
      annualPrice
      monthlyPrice
      setupPrice
      cannotRemove
      code
      group
      isFree
      isGlobal
      isInUse
      isIncludedInPackage
      isPerUser
      isBundle
      availableInPackage
      isTool
    }
  }
}
    `;

/**
 * __useSelfServiceAddonsQuery__
 *
 * To run a query within a Vue component, call `useSelfServiceAddonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceAddonsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelfServiceAddonsQuery({
 *   siteId: // value for 'siteId'
 *   selfServiceData: // value for 'selfServiceData'
 * });
 */
export function useSelfServiceAddonsQuery(variables: SelfServiceAddonsQueryVariables | VueCompositionApi.Ref<SelfServiceAddonsQueryVariables> | ReactiveFunction<SelfServiceAddonsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SelfServiceAddonsQuery, SelfServiceAddonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SelfServiceAddonsQuery, SelfServiceAddonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SelfServiceAddonsQuery, SelfServiceAddonsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SelfServiceAddonsQuery, SelfServiceAddonsQueryVariables>(SelfServiceAddonsDocument, variables, options);
}
export function useSelfServiceAddonsLazyQuery(variables?: SelfServiceAddonsQueryVariables | VueCompositionApi.Ref<SelfServiceAddonsQueryVariables> | ReactiveFunction<SelfServiceAddonsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SelfServiceAddonsQuery, SelfServiceAddonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SelfServiceAddonsQuery, SelfServiceAddonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SelfServiceAddonsQuery, SelfServiceAddonsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SelfServiceAddonsQuery, SelfServiceAddonsQueryVariables>(SelfServiceAddonsDocument, variables, options);
}
export type SelfServiceAddonsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SelfServiceAddonsQuery, SelfServiceAddonsQueryVariables>;
export const SelfServiceCostDocument = gql`
    query SelfServiceCost($siteId: ID, $selfServiceData: SelfServiceDataInput!) {
  SelfServiceData(siteId: $siteId, userChanges: $selfServiceData) {
    standardPaymentSum
    standardPaymentDate
    isVoucherApplied
  }
}
    `;

/**
 * __useSelfServiceCostQuery__
 *
 * To run a query within a Vue component, call `useSelfServiceCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceCostQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelfServiceCostQuery({
 *   siteId: // value for 'siteId'
 *   selfServiceData: // value for 'selfServiceData'
 * });
 */
export function useSelfServiceCostQuery(variables: SelfServiceCostQueryVariables | VueCompositionApi.Ref<SelfServiceCostQueryVariables> | ReactiveFunction<SelfServiceCostQueryVariables>, options: VueApolloComposable.UseQueryOptions<SelfServiceCostQuery, SelfServiceCostQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SelfServiceCostQuery, SelfServiceCostQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SelfServiceCostQuery, SelfServiceCostQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SelfServiceCostQuery, SelfServiceCostQueryVariables>(SelfServiceCostDocument, variables, options);
}
export function useSelfServiceCostLazyQuery(variables?: SelfServiceCostQueryVariables | VueCompositionApi.Ref<SelfServiceCostQueryVariables> | ReactiveFunction<SelfServiceCostQueryVariables>, options: VueApolloComposable.UseQueryOptions<SelfServiceCostQuery, SelfServiceCostQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SelfServiceCostQuery, SelfServiceCostQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SelfServiceCostQuery, SelfServiceCostQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SelfServiceCostQuery, SelfServiceCostQueryVariables>(SelfServiceCostDocument, variables, options);
}
export type SelfServiceCostQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SelfServiceCostQuery, SelfServiceCostQueryVariables>;
export const SelfServiceDataDocument = gql`
    query selfServiceData($siteId: ID) {
  SelfServiceData(siteId: $siteId) {
    billingCycle
    paidSeatCount
    usedSeatCount
    minSeatCount
    currency
    site {
      isTrialActive
      trialExpireDateTime
      hasPaymentMethod
      paidUntilDate
      isFree
      isTrialExpired
      isSiteExpired
    }
    addons {
      id
      name
      description
      amountInUse
      annualPrice
      monthlyPrice
      setupPrice
      cannotRemove
      code
      group
      isFree
      isGlobal
      isInUse
      isIncludedInPackage
      isPerUser
      isBundle
      availableInPackage
      isTool
    }
    customAddons {
      id
      name
      description
      amountInUse
      annualPrice
      monthlyPrice
      setupPrice
      cannotRemove
      code
      group
      isFree
      isGlobal
      isInUse
      isIncludedInPackage
      isPerUser
      isBundle
      availableInPackage
      isTool
    }
    companyAccounts {
      id
      name
      hasRelatedUsers
      price
      isInUse
    }
    packages {
      id
      name
      monthlyPrice
      annualPrice
      isTrialPackage
      sortingOrder
    }
    currentPackage {
      id
      name
    }
    onboardingPackages {
      id
      name
      price
      maxUserCount
      description
    }
    currentOnboardingPackage {
      id
    }
    paymentInfo {
      type
      creditCardLastNumbers
      hasPaymentHistory
    }
    standardPaymentDate
    standardPaymentSum
    nextPaymentSum
    nextPaymentDate
    isVoucherApplied
    onboardingCustomPrice
    seatReductionRequests {
      ...SelfServiceSeatReductionRequest
    }
  }
}
    ${SelfServiceSeatReductionRequestFragmentDoc}`;

/**
 * __useSelfServiceDataQuery__
 *
 * To run a query within a Vue component, call `useSelfServiceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelfServiceDataQuery({
 *   siteId: // value for 'siteId'
 * });
 */
export function useSelfServiceDataQuery(variables: SelfServiceDataQueryVariables | VueCompositionApi.Ref<SelfServiceDataQueryVariables> | ReactiveFunction<SelfServiceDataQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SelfServiceDataQuery, SelfServiceDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SelfServiceDataQuery, SelfServiceDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SelfServiceDataQuery, SelfServiceDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SelfServiceDataQuery, SelfServiceDataQueryVariables>(SelfServiceDataDocument, variables, options);
}
export function useSelfServiceDataLazyQuery(variables: SelfServiceDataQueryVariables | VueCompositionApi.Ref<SelfServiceDataQueryVariables> | ReactiveFunction<SelfServiceDataQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SelfServiceDataQuery, SelfServiceDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SelfServiceDataQuery, SelfServiceDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SelfServiceDataQuery, SelfServiceDataQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SelfServiceDataQuery, SelfServiceDataQueryVariables>(SelfServiceDataDocument, variables, options);
}
export type SelfServiceDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SelfServiceDataQuery, SelfServiceDataQueryVariables>;
export const SelfServiceUpdateDocument = gql`
    mutation selfServiceUpdate($siteId: ID, $userChanges: SelfServiceDataInput!) {
  SelfServiceDataUpdate(siteId: $siteId, userChanges: $userChanges)
}
    `;

/**
 * __useSelfServiceUpdateMutation__
 *
 * To run a mutation, you first call `useSelfServiceUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSelfServiceUpdateMutation({
 *   variables: {
 *     siteId: // value for 'siteId'
 *     userChanges: // value for 'userChanges'
 *   },
 * });
 */
export function useSelfServiceUpdateMutation(options: VueApolloComposable.UseMutationOptions<SelfServiceUpdateMutation, SelfServiceUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SelfServiceUpdateMutation, SelfServiceUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SelfServiceUpdateMutation, SelfServiceUpdateMutationVariables>(SelfServiceUpdateDocument, options);
}
export type SelfServiceUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SelfServiceUpdateMutation, SelfServiceUpdateMutationVariables>;
export const SelfServiceVoucherApplyDocument = gql`
    mutation selfServiceVoucherApply($voucherCode: String!, $siteId: ID) {
  SelfServiceVoucherApply(voucher: $voucherCode, siteId: $siteId)
}
    `;

/**
 * __useSelfServiceVoucherApplyMutation__
 *
 * To run a mutation, you first call `useSelfServiceVoucherApplyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceVoucherApplyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSelfServiceVoucherApplyMutation({
 *   variables: {
 *     voucherCode: // value for 'voucherCode'
 *     siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSelfServiceVoucherApplyMutation(options: VueApolloComposable.UseMutationOptions<SelfServiceVoucherApplyMutation, SelfServiceVoucherApplyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SelfServiceVoucherApplyMutation, SelfServiceVoucherApplyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SelfServiceVoucherApplyMutation, SelfServiceVoucherApplyMutationVariables>(SelfServiceVoucherApplyDocument, options);
}
export type SelfServiceVoucherApplyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SelfServiceVoucherApplyMutation, SelfServiceVoucherApplyMutationVariables>;
export const SettingsDropdownDocument = gql`
    query settingsDropdown($input: SettingLookupRequest!) {
  SettingsLookup(input: $input) {
    path
    title
    userHasAccess
    siteHasAccess
  }
}
    `;

/**
 * __useSettingsDropdownQuery__
 *
 * To run a query within a Vue component, call `useSettingsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsDropdownQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsDropdownQuery({
 *   input: // value for 'input'
 * });
 */
export function useSettingsDropdownQuery(variables: SettingsDropdownQueryVariables | VueCompositionApi.Ref<SettingsDropdownQueryVariables> | ReactiveFunction<SettingsDropdownQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsDropdownQuery, SettingsDropdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsDropdownQuery, SettingsDropdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsDropdownQuery, SettingsDropdownQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsDropdownQuery, SettingsDropdownQueryVariables>(SettingsDropdownDocument, variables, options);
}
export function useSettingsDropdownLazyQuery(variables?: SettingsDropdownQueryVariables | VueCompositionApi.Ref<SettingsDropdownQueryVariables> | ReactiveFunction<SettingsDropdownQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsDropdownQuery, SettingsDropdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsDropdownQuery, SettingsDropdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsDropdownQuery, SettingsDropdownQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsDropdownQuery, SettingsDropdownQueryVariables>(SettingsDropdownDocument, variables, options);
}
export type SettingsDropdownQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsDropdownQuery, SettingsDropdownQueryVariables>;
export const SingleSignOnUsersDocument = gql`
    query singleSignOnUsers($input: UsersListInput!) {
  UsersList(input: $input) {
    id
    name
    initials
    profilePicture {
      mini
      medium
    }
  }
}
    `;

/**
 * __useSingleSignOnUsersQuery__
 *
 * To run a query within a Vue component, call `useSingleSignOnUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleSignOnUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSingleSignOnUsersQuery({
 *   input: // value for 'input'
 * });
 */
export function useSingleSignOnUsersQuery(variables: SingleSignOnUsersQueryVariables | VueCompositionApi.Ref<SingleSignOnUsersQueryVariables> | ReactiveFunction<SingleSignOnUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<SingleSignOnUsersQuery, SingleSignOnUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SingleSignOnUsersQuery, SingleSignOnUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SingleSignOnUsersQuery, SingleSignOnUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SingleSignOnUsersQuery, SingleSignOnUsersQueryVariables>(SingleSignOnUsersDocument, variables, options);
}
export function useSingleSignOnUsersLazyQuery(variables?: SingleSignOnUsersQueryVariables | VueCompositionApi.Ref<SingleSignOnUsersQueryVariables> | ReactiveFunction<SingleSignOnUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<SingleSignOnUsersQuery, SingleSignOnUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SingleSignOnUsersQuery, SingleSignOnUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SingleSignOnUsersQuery, SingleSignOnUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SingleSignOnUsersQuery, SingleSignOnUsersQueryVariables>(SingleSignOnUsersDocument, variables, options);
}
export type SingleSignOnUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SingleSignOnUsersQuery, SingleSignOnUsersQueryVariables>;
export const SingleSignOnRegularLoginExclusionAddDocument = gql`
    mutation singleSignOnRegularLoginExclusionAdd($ids: [ID!]!) {
  SingleSignOnRegularLoginExclusionAdd(input: $ids)
}
    `;

/**
 * __useSingleSignOnRegularLoginExclusionAddMutation__
 *
 * To run a mutation, you first call `useSingleSignOnRegularLoginExclusionAddMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSingleSignOnRegularLoginExclusionAddMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSingleSignOnRegularLoginExclusionAddMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useSingleSignOnRegularLoginExclusionAddMutation(options: VueApolloComposable.UseMutationOptions<SingleSignOnRegularLoginExclusionAddMutation, SingleSignOnRegularLoginExclusionAddMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SingleSignOnRegularLoginExclusionAddMutation, SingleSignOnRegularLoginExclusionAddMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SingleSignOnRegularLoginExclusionAddMutation, SingleSignOnRegularLoginExclusionAddMutationVariables>(SingleSignOnRegularLoginExclusionAddDocument, options);
}
export type SingleSignOnRegularLoginExclusionAddMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SingleSignOnRegularLoginExclusionAddMutation, SingleSignOnRegularLoginExclusionAddMutationVariables>;
export const SingleSignOnRegularLoginExclusionDeleteDocument = gql`
    mutation singleSignOnRegularLoginExclusionDelete($id: ID!) {
  SingleSignOnRegularLoginExclusionDelete(id: $id)
}
    `;

/**
 * __useSingleSignOnRegularLoginExclusionDeleteMutation__
 *
 * To run a mutation, you first call `useSingleSignOnRegularLoginExclusionDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSingleSignOnRegularLoginExclusionDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSingleSignOnRegularLoginExclusionDeleteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSingleSignOnRegularLoginExclusionDeleteMutation(options: VueApolloComposable.UseMutationOptions<SingleSignOnRegularLoginExclusionDeleteMutation, SingleSignOnRegularLoginExclusionDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SingleSignOnRegularLoginExclusionDeleteMutation, SingleSignOnRegularLoginExclusionDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SingleSignOnRegularLoginExclusionDeleteMutation, SingleSignOnRegularLoginExclusionDeleteMutationVariables>(SingleSignOnRegularLoginExclusionDeleteDocument, options);
}
export type SingleSignOnRegularLoginExclusionDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SingleSignOnRegularLoginExclusionDeleteMutation, SingleSignOnRegularLoginExclusionDeleteMutationVariables>;
export const ShareSnapshotGanttStartDocument = gql`
    mutation shareSnapshotGanttStart($input: GanttChartShareInput!) {
  PublicGanttShare(input: $input) {
    id
    url
    snapshotDate
    isUrlExpired
  }
}
    `;

/**
 * __useShareSnapshotGanttStartMutation__
 *
 * To run a mutation, you first call `useShareSnapshotGanttStartMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useShareSnapshotGanttStartMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useShareSnapshotGanttStartMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useShareSnapshotGanttStartMutation(options: VueApolloComposable.UseMutationOptions<ShareSnapshotGanttStartMutation, ShareSnapshotGanttStartMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ShareSnapshotGanttStartMutation, ShareSnapshotGanttStartMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ShareSnapshotGanttStartMutation, ShareSnapshotGanttStartMutationVariables>(ShareSnapshotGanttStartDocument, options);
}
export type ShareSnapshotGanttStartMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ShareSnapshotGanttStartMutation, ShareSnapshotGanttStartMutationVariables>;
export const ShareSnapshotGanttStopDocument = gql`
    mutation shareSnapshotGanttStop($input: UnShareInput!) {
  PublicGanttUnShare(input: $input)
}
    `;

/**
 * __useShareSnapshotGanttStopMutation__
 *
 * To run a mutation, you first call `useShareSnapshotGanttStopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useShareSnapshotGanttStopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useShareSnapshotGanttStopMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useShareSnapshotGanttStopMutation(options: VueApolloComposable.UseMutationOptions<ShareSnapshotGanttStopMutation, ShareSnapshotGanttStopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ShareSnapshotGanttStopMutation, ShareSnapshotGanttStopMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ShareSnapshotGanttStopMutation, ShareSnapshotGanttStopMutationVariables>(ShareSnapshotGanttStopDocument, options);
}
export type ShareSnapshotGanttStopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ShareSnapshotGanttStopMutation, ShareSnapshotGanttStopMutationVariables>;
export const ShareSnapshotModalDocument = gql`
    query shareSnapshotModal($input: ShareSnapshotInput!) {
  ShareSnapshot(input: $input) {
    id
    url
    snapshotDate
    isUrlExpired
  }
}
    `;

/**
 * __useShareSnapshotModalQuery__
 *
 * To run a query within a Vue component, call `useShareSnapshotModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareSnapshotModalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useShareSnapshotModalQuery({
 *   input: // value for 'input'
 * });
 */
export function useShareSnapshotModalQuery(variables: ShareSnapshotModalQueryVariables | VueCompositionApi.Ref<ShareSnapshotModalQueryVariables> | ReactiveFunction<ShareSnapshotModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<ShareSnapshotModalQuery, ShareSnapshotModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShareSnapshotModalQuery, ShareSnapshotModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShareSnapshotModalQuery, ShareSnapshotModalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ShareSnapshotModalQuery, ShareSnapshotModalQueryVariables>(ShareSnapshotModalDocument, variables, options);
}
export function useShareSnapshotModalLazyQuery(variables?: ShareSnapshotModalQueryVariables | VueCompositionApi.Ref<ShareSnapshotModalQueryVariables> | ReactiveFunction<ShareSnapshotModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<ShareSnapshotModalQuery, ShareSnapshotModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShareSnapshotModalQuery, ShareSnapshotModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShareSnapshotModalQuery, ShareSnapshotModalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ShareSnapshotModalQuery, ShareSnapshotModalQueryVariables>(ShareSnapshotModalDocument, variables, options);
}
export type ShareSnapshotModalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ShareSnapshotModalQuery, ShareSnapshotModalQueryVariables>;
export const ShareSnapshotQuoteStartDocument = gql`
    mutation shareSnapshotQuoteStart($input: QuoteShareInput!) {
  QuoteShare(input: $input) {
    id
    url
    snapshotDate
    isUrlExpired
  }
}
    `;

/**
 * __useShareSnapshotQuoteStartMutation__
 *
 * To run a mutation, you first call `useShareSnapshotQuoteStartMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useShareSnapshotQuoteStartMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useShareSnapshotQuoteStartMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useShareSnapshotQuoteStartMutation(options: VueApolloComposable.UseMutationOptions<ShareSnapshotQuoteStartMutation, ShareSnapshotQuoteStartMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ShareSnapshotQuoteStartMutation, ShareSnapshotQuoteStartMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ShareSnapshotQuoteStartMutation, ShareSnapshotQuoteStartMutationVariables>(ShareSnapshotQuoteStartDocument, options);
}
export type ShareSnapshotQuoteStartMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ShareSnapshotQuoteStartMutation, ShareSnapshotQuoteStartMutationVariables>;
export const ShareSnapshotQuoteStopDocument = gql`
    mutation shareSnapshotQuoteStop($input: UnShareInput!) {
  QuoteUnShare(input: $input)
}
    `;

/**
 * __useShareSnapshotQuoteStopMutation__
 *
 * To run a mutation, you first call `useShareSnapshotQuoteStopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useShareSnapshotQuoteStopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useShareSnapshotQuoteStopMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useShareSnapshotQuoteStopMutation(options: VueApolloComposable.UseMutationOptions<ShareSnapshotQuoteStopMutation, ShareSnapshotQuoteStopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ShareSnapshotQuoteStopMutation, ShareSnapshotQuoteStopMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ShareSnapshotQuoteStopMutation, ShareSnapshotQuoteStopMutationVariables>(ShareSnapshotQuoteStopDocument, options);
}
export type ShareSnapshotQuoteStopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ShareSnapshotQuoteStopMutation, ShareSnapshotQuoteStopMutationVariables>;
export const StatusAutoSuggestDocument = gql`
    query statusAutoSuggest($statusesListInput: StatusesListInput) {
  StatusesList(input: $statusesListInput) {
    statusId
    name
  }
}
    `;

/**
 * __useStatusAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useStatusAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStatusAutoSuggestQuery({
 *   statusesListInput: // value for 'statusesListInput'
 * });
 */
export function useStatusAutoSuggestQuery(variables: StatusAutoSuggestQueryVariables | VueCompositionApi.Ref<StatusAutoSuggestQueryVariables> | ReactiveFunction<StatusAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<StatusAutoSuggestQuery, StatusAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StatusAutoSuggestQuery, StatusAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StatusAutoSuggestQuery, StatusAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<StatusAutoSuggestQuery, StatusAutoSuggestQueryVariables>(StatusAutoSuggestDocument, variables, options);
}
export function useStatusAutoSuggestLazyQuery(variables: StatusAutoSuggestQueryVariables | VueCompositionApi.Ref<StatusAutoSuggestQueryVariables> | ReactiveFunction<StatusAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<StatusAutoSuggestQuery, StatusAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StatusAutoSuggestQuery, StatusAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StatusAutoSuggestQuery, StatusAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<StatusAutoSuggestQuery, StatusAutoSuggestQueryVariables>(StatusAutoSuggestDocument, variables, options);
}
export type StatusAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<StatusAutoSuggestQuery, StatusAutoSuggestQueryVariables>;
export const StatusChangeDocument = gql`
    mutation statusChange($input: StatusChangeInput!) {
  StatusChange(input: $input)
}
    `;

/**
 * __useStatusChangeMutation__
 *
 * To run a mutation, you first call `useStatusChangeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStatusChangeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStatusChangeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useStatusChangeMutation(options: VueApolloComposable.UseMutationOptions<StatusChangeMutation, StatusChangeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StatusChangeMutation, StatusChangeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StatusChangeMutation, StatusChangeMutationVariables>(StatusChangeDocument, options);
}
export type StatusChangeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StatusChangeMutation, StatusChangeMutationVariables>;
export const StatusesListDocument = gql`
    query statusesList($statusesListInput: StatusesListInput) {
  StatusesList(input: $statusesListInput) {
    ...StatusPickerStatus
  }
}
    ${StatusPickerStatusFragmentDoc}`;

/**
 * __useStatusesListQuery__
 *
 * To run a query within a Vue component, call `useStatusesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusesListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStatusesListQuery({
 *   statusesListInput: // value for 'statusesListInput'
 * });
 */
export function useStatusesListQuery(variables: StatusesListQueryVariables | VueCompositionApi.Ref<StatusesListQueryVariables> | ReactiveFunction<StatusesListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<StatusesListQuery, StatusesListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StatusesListQuery, StatusesListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StatusesListQuery, StatusesListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<StatusesListQuery, StatusesListQueryVariables>(StatusesListDocument, variables, options);
}
export function useStatusesListLazyQuery(variables: StatusesListQueryVariables | VueCompositionApi.Ref<StatusesListQueryVariables> | ReactiveFunction<StatusesListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<StatusesListQuery, StatusesListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StatusesListQuery, StatusesListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StatusesListQuery, StatusesListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<StatusesListQuery, StatusesListQueryVariables>(StatusesListDocument, variables, options);
}
export type StatusesListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<StatusesListQuery, StatusesListQueryVariables>;
export const SubtaskListDocument = gql`
    query subtaskList($taskId: ID!, $taskListParams: TasksListInput!) {
  Task(id: $taskId) {
    id
    project {
      id
    }
    company {
      id
    }
    person {
      id
    }
    activityType {
      id
    }
    projectPhase {
      id
    }
    quote {
      id
    }
    isDone
  }
  TasksList(input: $taskListParams) {
    ...TaskListTask
    ...TaskListLimitedTask
  }
}
    ${TaskListTaskFragmentDoc}
${TaskListLimitedTaskFragmentDoc}`;

/**
 * __useSubtaskListQuery__
 *
 * To run a query within a Vue component, call `useSubtaskListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubtaskListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSubtaskListQuery({
 *   taskId: // value for 'taskId'
 *   taskListParams: // value for 'taskListParams'
 * });
 */
export function useSubtaskListQuery(variables: SubtaskListQueryVariables | VueCompositionApi.Ref<SubtaskListQueryVariables> | ReactiveFunction<SubtaskListQueryVariables>, options: VueApolloComposable.UseQueryOptions<SubtaskListQuery, SubtaskListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SubtaskListQuery, SubtaskListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SubtaskListQuery, SubtaskListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SubtaskListQuery, SubtaskListQueryVariables>(SubtaskListDocument, variables, options);
}
export function useSubtaskListLazyQuery(variables?: SubtaskListQueryVariables | VueCompositionApi.Ref<SubtaskListQueryVariables> | ReactiveFunction<SubtaskListQueryVariables>, options: VueApolloComposable.UseQueryOptions<SubtaskListQuery, SubtaskListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SubtaskListQuery, SubtaskListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SubtaskListQuery, SubtaskListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SubtaskListQuery, SubtaskListQueryVariables>(SubtaskListDocument, variables, options);
}
export type SubtaskListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SubtaskListQuery, SubtaskListQueryVariables>;
export const TagAutoSuggestDocument = gql`
    query tagAutoSuggest($tagsListInput: TagsListInput) {
  TagsList(input: $tagsListInput) {
    id
    title
    isGroup
  }
}
    `;

/**
 * __useTagAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useTagAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTagAutoSuggestQuery({
 *   tagsListInput: // value for 'tagsListInput'
 * });
 */
export function useTagAutoSuggestQuery(variables: TagAutoSuggestQueryVariables | VueCompositionApi.Ref<TagAutoSuggestQueryVariables> | ReactiveFunction<TagAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TagAutoSuggestQuery, TagAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TagAutoSuggestQuery, TagAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TagAutoSuggestQuery, TagAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TagAutoSuggestQuery, TagAutoSuggestQueryVariables>(TagAutoSuggestDocument, variables, options);
}
export function useTagAutoSuggestLazyQuery(variables: TagAutoSuggestQueryVariables | VueCompositionApi.Ref<TagAutoSuggestQueryVariables> | ReactiveFunction<TagAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TagAutoSuggestQuery, TagAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TagAutoSuggestQuery, TagAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TagAutoSuggestQuery, TagAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TagAutoSuggestQuery, TagAutoSuggestQueryVariables>(TagAutoSuggestDocument, variables, options);
}
export type TagAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TagAutoSuggestQuery, TagAutoSuggestQueryVariables>;
export const TaskAutoSuggestDocument = gql`
    query taskAutoSuggest($tasksSearchInput: TasksSearchInput!) {
  TasksSearch(input: $tasksSearchInput) {
    id
    name
    priority
    project {
      name
    }
    company {
      name
    }
    person {
      name
    }
  }
}
    `;

/**
 * __useTaskAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useTaskAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskAutoSuggestQuery({
 *   tasksSearchInput: // value for 'tasksSearchInput'
 * });
 */
export function useTaskAutoSuggestQuery(variables: TaskAutoSuggestQueryVariables | VueCompositionApi.Ref<TaskAutoSuggestQueryVariables> | ReactiveFunction<TaskAutoSuggestQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskAutoSuggestQuery, TaskAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskAutoSuggestQuery, TaskAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskAutoSuggestQuery, TaskAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskAutoSuggestQuery, TaskAutoSuggestQueryVariables>(TaskAutoSuggestDocument, variables, options);
}
export function useTaskAutoSuggestLazyQuery(variables?: TaskAutoSuggestQueryVariables | VueCompositionApi.Ref<TaskAutoSuggestQueryVariables> | ReactiveFunction<TaskAutoSuggestQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskAutoSuggestQuery, TaskAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskAutoSuggestQuery, TaskAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskAutoSuggestQuery, TaskAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskAutoSuggestQuery, TaskAutoSuggestQueryVariables>(TaskAutoSuggestDocument, variables, options);
}
export type TaskAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskAutoSuggestQuery, TaskAutoSuggestQueryVariables>;
export const TaskAutoSuggestTaskDocument = gql`
    query taskAutoSuggestTask($id: ID!) {
  Task(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useTaskAutoSuggestTaskQuery__
 *
 * To run a query within a Vue component, call `useTaskAutoSuggestTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskAutoSuggestTaskQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskAutoSuggestTaskQuery({
 *   id: // value for 'id'
 * });
 */
export function useTaskAutoSuggestTaskQuery(variables: TaskAutoSuggestTaskQueryVariables | VueCompositionApi.Ref<TaskAutoSuggestTaskQueryVariables> | ReactiveFunction<TaskAutoSuggestTaskQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskAutoSuggestTaskQuery, TaskAutoSuggestTaskQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskAutoSuggestTaskQuery, TaskAutoSuggestTaskQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskAutoSuggestTaskQuery, TaskAutoSuggestTaskQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskAutoSuggestTaskQuery, TaskAutoSuggestTaskQueryVariables>(TaskAutoSuggestTaskDocument, variables, options);
}
export function useTaskAutoSuggestTaskLazyQuery(variables?: TaskAutoSuggestTaskQueryVariables | VueCompositionApi.Ref<TaskAutoSuggestTaskQueryVariables> | ReactiveFunction<TaskAutoSuggestTaskQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskAutoSuggestTaskQuery, TaskAutoSuggestTaskQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskAutoSuggestTaskQuery, TaskAutoSuggestTaskQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskAutoSuggestTaskQuery, TaskAutoSuggestTaskQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskAutoSuggestTaskQuery, TaskAutoSuggestTaskQueryVariables>(TaskAutoSuggestTaskDocument, variables, options);
}
export type TaskAutoSuggestTaskQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskAutoSuggestTaskQuery, TaskAutoSuggestTaskQueryVariables>;
export const TaskBudgetDocument = gql`
    query taskBudget($id: ID!) {
  TaskBudgetList(id: $id) {
    id
    budgetedDuration
    doneDuration {
      taskId
      duration
    }
    isBudgeted
    isRoleAssigned
    plannedDuration
    role {
      id
      name
      initials
      hslColor
    }
    users {
      id
      name
      initials
      hslColor
      profilePicture {
        mini
      }
    }
  }
}
    `;

/**
 * __useTaskBudgetQuery__
 *
 * To run a query within a Vue component, call `useTaskBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskBudgetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskBudgetQuery({
 *   id: // value for 'id'
 * });
 */
export function useTaskBudgetQuery(variables: TaskBudgetQueryVariables | VueCompositionApi.Ref<TaskBudgetQueryVariables> | ReactiveFunction<TaskBudgetQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskBudgetQuery, TaskBudgetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskBudgetQuery, TaskBudgetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskBudgetQuery, TaskBudgetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskBudgetQuery, TaskBudgetQueryVariables>(TaskBudgetDocument, variables, options);
}
export function useTaskBudgetLazyQuery(variables?: TaskBudgetQueryVariables | VueCompositionApi.Ref<TaskBudgetQueryVariables> | ReactiveFunction<TaskBudgetQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskBudgetQuery, TaskBudgetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskBudgetQuery, TaskBudgetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskBudgetQuery, TaskBudgetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskBudgetQuery, TaskBudgetQueryVariables>(TaskBudgetDocument, variables, options);
}
export type TaskBudgetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskBudgetQuery, TaskBudgetQueryVariables>;
export const TaskHeaderDocument = gql`
    query taskHeader($taskId: ID!) {
  Task(id: $taskId) {
    id
    totalDurationDone
    totalDurationPlanned
    totalDurationRemaining
    totalDurationScheduled
    totalProgressPercentage
    totalDurationBillablePlanned
    totalDurationBillableDone
    totalDurationBillableRemaining
    billableTimeType
    subtasksCount
  }
}
    `;

/**
 * __useTaskHeaderQuery__
 *
 * To run a query within a Vue component, call `useTaskHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskHeaderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskHeaderQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useTaskHeaderQuery(variables: TaskHeaderQueryVariables | VueCompositionApi.Ref<TaskHeaderQueryVariables> | ReactiveFunction<TaskHeaderQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskHeaderQuery, TaskHeaderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskHeaderQuery, TaskHeaderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskHeaderQuery, TaskHeaderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskHeaderQuery, TaskHeaderQueryVariables>(TaskHeaderDocument, variables, options);
}
export function useTaskHeaderLazyQuery(variables?: TaskHeaderQueryVariables | VueCompositionApi.Ref<TaskHeaderQueryVariables> | ReactiveFunction<TaskHeaderQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskHeaderQuery, TaskHeaderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskHeaderQuery, TaskHeaderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskHeaderQuery, TaskHeaderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskHeaderQuery, TaskHeaderQueryVariables>(TaskHeaderDocument, variables, options);
}
export type TaskHeaderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskHeaderQuery, TaskHeaderQueryVariables>;
export const TaskListRowTaskBundleSaveDocument = gql`
    mutation taskListRowTaskBundleSave($input: TaskSetAsSubtasksSaveInput!) {
  TaskSetAsSubtasksSave(input: $input) {
    ...TaskListTask
  }
}
    ${TaskListTaskFragmentDoc}`;

/**
 * __useTaskListRowTaskBundleSaveMutation__
 *
 * To run a mutation, you first call `useTaskListRowTaskBundleSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTaskListRowTaskBundleSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTaskListRowTaskBundleSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTaskListRowTaskBundleSaveMutation(options: VueApolloComposable.UseMutationOptions<TaskListRowTaskBundleSaveMutation, TaskListRowTaskBundleSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TaskListRowTaskBundleSaveMutation, TaskListRowTaskBundleSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TaskListRowTaskBundleSaveMutation, TaskListRowTaskBundleSaveMutationVariables>(TaskListRowTaskBundleSaveDocument, options);
}
export type TaskListRowTaskBundleSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TaskListRowTaskBundleSaveMutation, TaskListRowTaskBundleSaveMutationVariables>;
export const TaskListTaskMarkAsDoneDocument = gql`
    mutation taskListTaskMarkAsDone($input: TaskMarkAsDoneMutationInput!) {
  TaskMarkAsDone(input: $input) {
    ...TaskListTask
  }
}
    ${TaskListTaskFragmentDoc}`;

/**
 * __useTaskListTaskMarkAsDoneMutation__
 *
 * To run a mutation, you first call `useTaskListTaskMarkAsDoneMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTaskListTaskMarkAsDoneMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTaskListTaskMarkAsDoneMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTaskListTaskMarkAsDoneMutation(options: VueApolloComposable.UseMutationOptions<TaskListTaskMarkAsDoneMutation, TaskListTaskMarkAsDoneMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TaskListTaskMarkAsDoneMutation, TaskListTaskMarkAsDoneMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TaskListTaskMarkAsDoneMutation, TaskListTaskMarkAsDoneMutationVariables>(TaskListTaskMarkAsDoneDocument, options);
}
export type TaskListTaskMarkAsDoneMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TaskListTaskMarkAsDoneMutation, TaskListTaskMarkAsDoneMutationVariables>;
export const TaskListTaskMarkAsNotDoneDocument = gql`
    mutation taskListTaskMarkAsNotDone($input: TaskMarkAsNotDoneMutationInput!) {
  TaskMarkAsNotDone(input: $input) {
    ...TaskListTask
  }
}
    ${TaskListTaskFragmentDoc}`;

/**
 * __useTaskListTaskMarkAsNotDoneMutation__
 *
 * To run a mutation, you first call `useTaskListTaskMarkAsNotDoneMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTaskListTaskMarkAsNotDoneMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTaskListTaskMarkAsNotDoneMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTaskListTaskMarkAsNotDoneMutation(options: VueApolloComposable.UseMutationOptions<TaskListTaskMarkAsNotDoneMutation, TaskListTaskMarkAsNotDoneMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TaskListTaskMarkAsNotDoneMutation, TaskListTaskMarkAsNotDoneMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TaskListTaskMarkAsNotDoneMutation, TaskListTaskMarkAsNotDoneMutationVariables>(TaskListTaskMarkAsNotDoneDocument, options);
}
export type TaskListTaskMarkAsNotDoneMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TaskListTaskMarkAsNotDoneMutation, TaskListTaskMarkAsNotDoneMutationVariables>;
export const TaskListTaskDocument = gql`
    query taskListTask($id: ID!) {
  Task(id: $id) {
    ...TaskListTask
  }
}
    ${TaskListTaskFragmentDoc}`;

/**
 * __useTaskListTaskQuery__
 *
 * To run a query within a Vue component, call `useTaskListTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskListTaskQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskListTaskQuery({
 *   id: // value for 'id'
 * });
 */
export function useTaskListTaskQuery(variables: TaskListTaskQueryVariables | VueCompositionApi.Ref<TaskListTaskQueryVariables> | ReactiveFunction<TaskListTaskQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskListTaskQuery, TaskListTaskQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskListTaskQuery, TaskListTaskQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskListTaskQuery, TaskListTaskQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskListTaskQuery, TaskListTaskQueryVariables>(TaskListTaskDocument, variables, options);
}
export function useTaskListTaskLazyQuery(variables?: TaskListTaskQueryVariables | VueCompositionApi.Ref<TaskListTaskQueryVariables> | ReactiveFunction<TaskListTaskQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskListTaskQuery, TaskListTaskQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskListTaskQuery, TaskListTaskQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskListTaskQuery, TaskListTaskQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskListTaskQuery, TaskListTaskQueryVariables>(TaskListTaskDocument, variables, options);
}
export type TaskListTaskQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskListTaskQuery, TaskListTaskQueryVariables>;
export const TaskListTaskSaveDocument = gql`
    mutation taskListTaskSave($input: TaskSaveInput!) {
  TaskSave(input: $input) {
    ...TaskListTask
  }
}
    ${TaskListTaskFragmentDoc}`;

/**
 * __useTaskListTaskSaveMutation__
 *
 * To run a mutation, you first call `useTaskListTaskSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTaskListTaskSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTaskListTaskSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTaskListTaskSaveMutation(options: VueApolloComposable.UseMutationOptions<TaskListTaskSaveMutation, TaskListTaskSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TaskListTaskSaveMutation, TaskListTaskSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TaskListTaskSaveMutation, TaskListTaskSaveMutationVariables>(TaskListTaskSaveDocument, options);
}
export type TaskListTaskSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TaskListTaskSaveMutation, TaskListTaskSaveMutationVariables>;
export const TaskListTaskAssigneesSaveDocument = gql`
    mutation taskListTaskAssigneesSave($input: TaskAssigneesSaveInput!) {
  TaskAssigneesSave(input: $input) {
    ...TaskListTask
  }
}
    ${TaskListTaskFragmentDoc}`;

/**
 * __useTaskListTaskAssigneesSaveMutation__
 *
 * To run a mutation, you first call `useTaskListTaskAssigneesSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTaskListTaskAssigneesSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTaskListTaskAssigneesSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTaskListTaskAssigneesSaveMutation(options: VueApolloComposable.UseMutationOptions<TaskListTaskAssigneesSaveMutation, TaskListTaskAssigneesSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TaskListTaskAssigneesSaveMutation, TaskListTaskAssigneesSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TaskListTaskAssigneesSaveMutation, TaskListTaskAssigneesSaveMutationVariables>(TaskListTaskAssigneesSaveDocument, options);
}
export type TaskListTaskAssigneesSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TaskListTaskAssigneesSaveMutation, TaskListTaskAssigneesSaveMutationVariables>;
export const TaskMissingRequiredFieldsDocument = gql`
    query taskMissingRequiredFields($id: ID!) {
  Task(id: $id) {
    isTimeEntriesRequiredFieldsMissing
  }
}
    `;

/**
 * __useTaskMissingRequiredFieldsQuery__
 *
 * To run a query within a Vue component, call `useTaskMissingRequiredFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskMissingRequiredFieldsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskMissingRequiredFieldsQuery({
 *   id: // value for 'id'
 * });
 */
export function useTaskMissingRequiredFieldsQuery(variables: TaskMissingRequiredFieldsQueryVariables | VueCompositionApi.Ref<TaskMissingRequiredFieldsQueryVariables> | ReactiveFunction<TaskMissingRequiredFieldsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskMissingRequiredFieldsQuery, TaskMissingRequiredFieldsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskMissingRequiredFieldsQuery, TaskMissingRequiredFieldsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskMissingRequiredFieldsQuery, TaskMissingRequiredFieldsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskMissingRequiredFieldsQuery, TaskMissingRequiredFieldsQueryVariables>(TaskMissingRequiredFieldsDocument, variables, options);
}
export function useTaskMissingRequiredFieldsLazyQuery(variables?: TaskMissingRequiredFieldsQueryVariables | VueCompositionApi.Ref<TaskMissingRequiredFieldsQueryVariables> | ReactiveFunction<TaskMissingRequiredFieldsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskMissingRequiredFieldsQuery, TaskMissingRequiredFieldsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskMissingRequiredFieldsQuery, TaskMissingRequiredFieldsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskMissingRequiredFieldsQuery, TaskMissingRequiredFieldsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskMissingRequiredFieldsQuery, TaskMissingRequiredFieldsQueryVariables>(TaskMissingRequiredFieldsDocument, variables, options);
}
export type TaskMissingRequiredFieldsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskMissingRequiredFieldsQuery, TaskMissingRequiredFieldsQueryVariables>;
export const TaskTemplateAssigneesDocument = gql`
    query TaskTemplateAssignees($id: ID!) {
  TaskTemplate(id: $id) {
    ...TaskTemplateAssigneesTaskTemplate
  }
}
    ${TaskTemplateAssigneesTaskTemplateFragmentDoc}`;

/**
 * __useTaskTemplateAssigneesQuery__
 *
 * To run a query within a Vue component, call `useTaskTemplateAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTemplateAssigneesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskTemplateAssigneesQuery({
 *   id: // value for 'id'
 * });
 */
export function useTaskTemplateAssigneesQuery(variables: TaskTemplateAssigneesQueryVariables | VueCompositionApi.Ref<TaskTemplateAssigneesQueryVariables> | ReactiveFunction<TaskTemplateAssigneesQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskTemplateAssigneesQuery, TaskTemplateAssigneesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskTemplateAssigneesQuery, TaskTemplateAssigneesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskTemplateAssigneesQuery, TaskTemplateAssigneesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskTemplateAssigneesQuery, TaskTemplateAssigneesQueryVariables>(TaskTemplateAssigneesDocument, variables, options);
}
export function useTaskTemplateAssigneesLazyQuery(variables?: TaskTemplateAssigneesQueryVariables | VueCompositionApi.Ref<TaskTemplateAssigneesQueryVariables> | ReactiveFunction<TaskTemplateAssigneesQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskTemplateAssigneesQuery, TaskTemplateAssigneesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskTemplateAssigneesQuery, TaskTemplateAssigneesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskTemplateAssigneesQuery, TaskTemplateAssigneesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskTemplateAssigneesQuery, TaskTemplateAssigneesQueryVariables>(TaskTemplateAssigneesDocument, variables, options);
}
export type TaskTemplateAssigneesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskTemplateAssigneesQuery, TaskTemplateAssigneesQueryVariables>;
export const TaskTemplateUsersAssigneesSaveDocument = gql`
    mutation taskTemplateUsersAssigneesSave($input: TaskTemplateAssigneesSaveInput!) {
  TaskTemplateAssigneesSave(input: $input) {
    ...TaskTemplateAssigneesTaskTemplate
  }
}
    ${TaskTemplateAssigneesTaskTemplateFragmentDoc}`;

/**
 * __useTaskTemplateUsersAssigneesSaveMutation__
 *
 * To run a mutation, you first call `useTaskTemplateUsersAssigneesSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTaskTemplateUsersAssigneesSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTaskTemplateUsersAssigneesSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTaskTemplateUsersAssigneesSaveMutation(options: VueApolloComposable.UseMutationOptions<TaskTemplateUsersAssigneesSaveMutation, TaskTemplateUsersAssigneesSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TaskTemplateUsersAssigneesSaveMutation, TaskTemplateUsersAssigneesSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TaskTemplateUsersAssigneesSaveMutation, TaskTemplateUsersAssigneesSaveMutationVariables>(TaskTemplateUsersAssigneesSaveDocument, options);
}
export type TaskTemplateUsersAssigneesSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TaskTemplateUsersAssigneesSaveMutation, TaskTemplateUsersAssigneesSaveMutationVariables>;
export const TaskTooltipDocument = gql`
    query taskTooltip($taskId: ID!) {
  Task(id: $taskId) {
    id
    activityType {
      id
      name
    }
    assignees {
      user {
        id
      }
      role {
        id
        name
        initials
      }
    }
    description
    commentsCount
    startDate
    dueDate
    dueDateTime
    totalDurationDone
    totalDurationPlanned
    totalDurationRemaining
    totalDurationScheduled
    totalProgressPercentage
    totalDurationBillablePlanned
    totalDurationBillableDone
    totalDurationBillableRemaining
    isDone
    name
    priority
    project {
      id
      name
    }
    projectPhase {
      id
      title
    }
    responsibleUser {
      ...userAssignSelectUser
    }
    company {
      id
      name
    }
    person {
      id
      name
    }
    status {
      ...StatusPickerStatus
    }
    isRequiredFieldsMissing
    permissions {
      canModify
    }
    createdBy {
      id
      name
    }
    modifiedBy {
      id
      name
    }
    createdDateTime
    modifiedDateTime
  }
}
    ${UserAssignSelectUserFragmentDoc}
${StatusPickerStatusFragmentDoc}`;

/**
 * __useTaskTooltipQuery__
 *
 * To run a query within a Vue component, call `useTaskTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTooltipQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskTooltipQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useTaskTooltipQuery(variables: TaskTooltipQueryVariables | VueCompositionApi.Ref<TaskTooltipQueryVariables> | ReactiveFunction<TaskTooltipQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskTooltipQuery, TaskTooltipQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskTooltipQuery, TaskTooltipQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskTooltipQuery, TaskTooltipQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskTooltipQuery, TaskTooltipQueryVariables>(TaskTooltipDocument, variables, options);
}
export function useTaskTooltipLazyQuery(variables?: TaskTooltipQueryVariables | VueCompositionApi.Ref<TaskTooltipQueryVariables> | ReactiveFunction<TaskTooltipQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskTooltipQuery, TaskTooltipQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskTooltipQuery, TaskTooltipQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskTooltipQuery, TaskTooltipQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskTooltipQuery, TaskTooltipQueryVariables>(TaskTooltipDocument, variables, options);
}
export type TaskTooltipQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskTooltipQuery, TaskTooltipQueryVariables>;
export const TaskUsersDocument = gql`
    query taskUsers($id: ID!) {
  Task(id: $id) {
    ...TaskUsersTask
  }
}
    ${TaskUsersTaskFragmentDoc}`;

/**
 * __useTaskUsersQuery__
 *
 * To run a query within a Vue component, call `useTaskUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskUsersQuery({
 *   id: // value for 'id'
 * });
 */
export function useTaskUsersQuery(variables: TaskUsersQueryVariables | VueCompositionApi.Ref<TaskUsersQueryVariables> | ReactiveFunction<TaskUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskUsersQuery, TaskUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskUsersQuery, TaskUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskUsersQuery, TaskUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskUsersQuery, TaskUsersQueryVariables>(TaskUsersDocument, variables, options);
}
export function useTaskUsersLazyQuery(variables?: TaskUsersQueryVariables | VueCompositionApi.Ref<TaskUsersQueryVariables> | ReactiveFunction<TaskUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskUsersQuery, TaskUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskUsersQuery, TaskUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskUsersQuery, TaskUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskUsersQuery, TaskUsersQueryVariables>(TaskUsersDocument, variables, options);
}
export type TaskUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskUsersQuery, TaskUsersQueryVariables>;
export const TaskUsersResponsibleSaveDocument = gql`
    mutation taskUsersResponsibleSave($input: TaskResponsibleSaveInput!) {
  TaskResponsibleSave(input: $input) {
    ...TaskUsersTask
  }
}
    ${TaskUsersTaskFragmentDoc}`;

/**
 * __useTaskUsersResponsibleSaveMutation__
 *
 * To run a mutation, you first call `useTaskUsersResponsibleSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTaskUsersResponsibleSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTaskUsersResponsibleSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTaskUsersResponsibleSaveMutation(options: VueApolloComposable.UseMutationOptions<TaskUsersResponsibleSaveMutation, TaskUsersResponsibleSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TaskUsersResponsibleSaveMutation, TaskUsersResponsibleSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TaskUsersResponsibleSaveMutation, TaskUsersResponsibleSaveMutationVariables>(TaskUsersResponsibleSaveDocument, options);
}
export type TaskUsersResponsibleSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TaskUsersResponsibleSaveMutation, TaskUsersResponsibleSaveMutationVariables>;
export const TaskUsersAssigneesSaveDocument = gql`
    mutation taskUsersAssigneesSave($input: TaskAssigneesSaveInput!) {
  TaskAssigneesSave(input: $input) {
    ...TaskUsersTask
  }
}
    ${TaskUsersTaskFragmentDoc}`;

/**
 * __useTaskUsersAssigneesSaveMutation__
 *
 * To run a mutation, you first call `useTaskUsersAssigneesSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTaskUsersAssigneesSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTaskUsersAssigneesSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTaskUsersAssigneesSaveMutation(options: VueApolloComposable.UseMutationOptions<TaskUsersAssigneesSaveMutation, TaskUsersAssigneesSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TaskUsersAssigneesSaveMutation, TaskUsersAssigneesSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TaskUsersAssigneesSaveMutation, TaskUsersAssigneesSaveMutationVariables>(TaskUsersAssigneesSaveDocument, options);
}
export type TaskUsersAssigneesSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TaskUsersAssigneesSaveMutation, TaskUsersAssigneesSaveMutationVariables>;
export const TaskUsersGanttAssigneesSaveDocument = gql`
    mutation taskUsersGanttAssigneesSave($input: TaskAssigneesSaveInput!) {
  TaskAssigneesSave(input: $input) {
    id
    assignees {
      user {
        ...userAssignSelectUser
      }
      role {
        id
        name
        initials
        hslColor
      }
      allocatedDuration
    }
    hasCustomAllocation
  }
}
    ${UserAssignSelectUserFragmentDoc}`;

/**
 * __useTaskUsersGanttAssigneesSaveMutation__
 *
 * To run a mutation, you first call `useTaskUsersGanttAssigneesSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTaskUsersGanttAssigneesSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTaskUsersGanttAssigneesSaveMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTaskUsersGanttAssigneesSaveMutation(options: VueApolloComposable.UseMutationOptions<TaskUsersGanttAssigneesSaveMutation, TaskUsersGanttAssigneesSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TaskUsersGanttAssigneesSaveMutation, TaskUsersGanttAssigneesSaveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TaskUsersGanttAssigneesSaveMutation, TaskUsersGanttAssigneesSaveMutationVariables>(TaskUsersGanttAssigneesSaveDocument, options);
}
export type TaskUsersGanttAssigneesSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TaskUsersGanttAssigneesSaveMutation, TaskUsersGanttAssigneesSaveMutationVariables>;
export const TaskUsersGanttDocument = gql`
    query taskUsersGantt($id: ID!) {
  Task(id: $id) {
    id
    project {
      id
    }
    assignees {
      user {
        ...userAssignSelectUser
      }
      role {
        id
        name
        initials
        hslColor
      }
      allocatedDuration
    }
    responsibleUser {
      ...userAssignSelectUser
    }
    permissions {
      canView
      canModify
    }
    hasCustomAllocation
    durationPlanned
    startDate
    dueDate
    parentId
  }
}
    ${UserAssignSelectUserFragmentDoc}`;

/**
 * __useTaskUsersGanttQuery__
 *
 * To run a query within a Vue component, call `useTaskUsersGanttQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskUsersGanttQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskUsersGanttQuery({
 *   id: // value for 'id'
 * });
 */
export function useTaskUsersGanttQuery(variables: TaskUsersGanttQueryVariables | VueCompositionApi.Ref<TaskUsersGanttQueryVariables> | ReactiveFunction<TaskUsersGanttQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskUsersGanttQuery, TaskUsersGanttQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskUsersGanttQuery, TaskUsersGanttQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskUsersGanttQuery, TaskUsersGanttQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskUsersGanttQuery, TaskUsersGanttQueryVariables>(TaskUsersGanttDocument, variables, options);
}
export function useTaskUsersGanttLazyQuery(variables?: TaskUsersGanttQueryVariables | VueCompositionApi.Ref<TaskUsersGanttQueryVariables> | ReactiveFunction<TaskUsersGanttQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskUsersGanttQuery, TaskUsersGanttQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskUsersGanttQuery, TaskUsersGanttQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskUsersGanttQuery, TaskUsersGanttQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskUsersGanttQuery, TaskUsersGanttQueryVariables>(TaskUsersGanttDocument, variables, options);
}
export type TaskUsersGanttQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskUsersGanttQuery, TaskUsersGanttQueryVariables>;
export const TaskBundleAutoSuggestDocument = gql`
    query taskBundleAutoSuggest($searchKeyword: String) {
  TaskSetsList(searchKeyword: $searchKeyword) {
    id
    name
    maxDays
    minDays
    taskTemplatesCount
  }
}
    `;

/**
 * __useTaskBundleAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useTaskBundleAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskBundleAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskBundleAutoSuggestQuery({
 *   searchKeyword: // value for 'searchKeyword'
 * });
 */
export function useTaskBundleAutoSuggestQuery(variables: TaskBundleAutoSuggestQueryVariables | VueCompositionApi.Ref<TaskBundleAutoSuggestQueryVariables> | ReactiveFunction<TaskBundleAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TaskBundleAutoSuggestQuery, TaskBundleAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskBundleAutoSuggestQuery, TaskBundleAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskBundleAutoSuggestQuery, TaskBundleAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskBundleAutoSuggestQuery, TaskBundleAutoSuggestQueryVariables>(TaskBundleAutoSuggestDocument, variables, options);
}
export function useTaskBundleAutoSuggestLazyQuery(variables: TaskBundleAutoSuggestQueryVariables | VueCompositionApi.Ref<TaskBundleAutoSuggestQueryVariables> | ReactiveFunction<TaskBundleAutoSuggestQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TaskBundleAutoSuggestQuery, TaskBundleAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskBundleAutoSuggestQuery, TaskBundleAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskBundleAutoSuggestQuery, TaskBundleAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskBundleAutoSuggestQuery, TaskBundleAutoSuggestQueryVariables>(TaskBundleAutoSuggestDocument, variables, options);
}
export type TaskBundleAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskBundleAutoSuggestQuery, TaskBundleAutoSuggestQueryVariables>;
export const TeamReportExportDocument = gql`
    query teamReportExport($input: FilterHashExportInput!) {
  TeamReportExport(input: $input) {
    fileUrl
  }
}
    `;

/**
 * __useTeamReportExportQuery__
 *
 * To run a query within a Vue component, call `useTeamReportExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamReportExportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTeamReportExportQuery({
 *   input: // value for 'input'
 * });
 */
export function useTeamReportExportQuery(variables: TeamReportExportQueryVariables | VueCompositionApi.Ref<TeamReportExportQueryVariables> | ReactiveFunction<TeamReportExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TeamReportExportQuery, TeamReportExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TeamReportExportQuery, TeamReportExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TeamReportExportQuery, TeamReportExportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TeamReportExportQuery, TeamReportExportQueryVariables>(TeamReportExportDocument, variables, options);
}
export function useTeamReportExportLazyQuery(variables?: TeamReportExportQueryVariables | VueCompositionApi.Ref<TeamReportExportQueryVariables> | ReactiveFunction<TeamReportExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TeamReportExportQuery, TeamReportExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TeamReportExportQuery, TeamReportExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TeamReportExportQuery, TeamReportExportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TeamReportExportQuery, TeamReportExportQueryVariables>(TeamReportExportDocument, variables, options);
}
export type TeamReportExportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TeamReportExportQuery, TeamReportExportQueryVariables>;
export const TeamReportMetricsDocument = gql`
    query teamReportMetrics($input: FilterHashInput!) {
  TeamReportMetrics(input: $input) {
    id
    title
    value
    unit
    valueState
    type
    secondaryValue
    secondaryUnit
    secondaryDescription
    secondaryValueState
  }
}
    `;

/**
 * __useTeamReportMetricsQuery__
 *
 * To run a query within a Vue component, call `useTeamReportMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamReportMetricsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTeamReportMetricsQuery({
 *   input: // value for 'input'
 * });
 */
export function useTeamReportMetricsQuery(variables: TeamReportMetricsQueryVariables | VueCompositionApi.Ref<TeamReportMetricsQueryVariables> | ReactiveFunction<TeamReportMetricsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TeamReportMetricsQuery, TeamReportMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TeamReportMetricsQuery, TeamReportMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TeamReportMetricsQuery, TeamReportMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TeamReportMetricsQuery, TeamReportMetricsQueryVariables>(TeamReportMetricsDocument, variables, options);
}
export function useTeamReportMetricsLazyQuery(variables?: TeamReportMetricsQueryVariables | VueCompositionApi.Ref<TeamReportMetricsQueryVariables> | ReactiveFunction<TeamReportMetricsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TeamReportMetricsQuery, TeamReportMetricsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TeamReportMetricsQuery, TeamReportMetricsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TeamReportMetricsQuery, TeamReportMetricsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TeamReportMetricsQuery, TeamReportMetricsQueryVariables>(TeamReportMetricsDocument, variables, options);
}
export type TeamReportMetricsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TeamReportMetricsQuery, TeamReportMetricsQueryVariables>;
export const TeamReportDocument = gql`
    query teamReport($input: FilterHashInput!) {
  TeamReport(input: $input) {
    columns
    orderBy {
      fieldName
      direction
    }
    groupBy
    rows {
      user {
        id
        name
        initials
        hslColor
        profilePicture {
          mini
        }
        role {
          id
          name
        }
      }
      groupName
      capacity {
        value
        unit
      }
      timeOff {
        value
        unit
      }
      extraAvailability {
        value
        unit
      }
      availability {
        value
        unit
      }
      bookings {
        value
        unit
      }
      bookingsFixed {
        value
        unit
      }
      bookingsTentative {
        value
        unit
      }
      bookingsVsAvailability {
        value
        unit
      }
      tasksPlanned {
        value
        unit
      }
      timeEntries {
        value
        unit
      }
      timeEntriesScheduled {
        value
        unit
      }
      timeEntriesDone {
        value
        unit
      }
      timeEntriesVsAvailability {
        value
        unit
      }
      timeEntriesBillable {
        value
        unit
      }
      timeEntriesBillableVsAvailability {
        value
        unit
      }
      timeEntriesNonBillable {
        value
        unit
      }
      timeEntriesNonBillableVsAvailability {
        value
        unit
      }
    }
  }
}
    `;

/**
 * __useTeamReportQuery__
 *
 * To run a query within a Vue component, call `useTeamReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTeamReportQuery({
 *   input: // value for 'input'
 * });
 */
export function useTeamReportQuery(variables: TeamReportQueryVariables | VueCompositionApi.Ref<TeamReportQueryVariables> | ReactiveFunction<TeamReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TeamReportQuery, TeamReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TeamReportQuery, TeamReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TeamReportQuery, TeamReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TeamReportQuery, TeamReportQueryVariables>(TeamReportDocument, variables, options);
}
export function useTeamReportLazyQuery(variables?: TeamReportQueryVariables | VueCompositionApi.Ref<TeamReportQueryVariables> | ReactiveFunction<TeamReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TeamReportQuery, TeamReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TeamReportQuery, TeamReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TeamReportQuery, TeamReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TeamReportQuery, TeamReportQueryVariables>(TeamReportDocument, variables, options);
}
export type TeamReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TeamReportQuery, TeamReportQueryVariables>;
export const InvoiceAllocationDocument = gql`
    mutation InvoiceAllocation($input: InvoiceAllocationsSaveInput!) {
  InvoiceAllocation(input: $input)
}
    `;

/**
 * __useInvoiceAllocationMutation__
 *
 * To run a mutation, you first call `useInvoiceAllocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceAllocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInvoiceAllocationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceAllocationMutation(options: VueApolloComposable.UseMutationOptions<InvoiceAllocationMutation, InvoiceAllocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InvoiceAllocationMutation, InvoiceAllocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InvoiceAllocationMutation, InvoiceAllocationMutationVariables>(InvoiceAllocationDocument, options);
}
export type InvoiceAllocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InvoiceAllocationMutation, InvoiceAllocationMutationVariables>;
export const TimeEntryActionsDocument = gql`
    mutation timeEntryActions($input: TimeEntrySaveInput!) {
  TimeEntrySave(input: $input) {
    id
  }
}
    `;

/**
 * __useTimeEntryActionsMutation__
 *
 * To run a mutation, you first call `useTimeEntryActionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTimeEntryActionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTimeEntryActionsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTimeEntryActionsMutation(options: VueApolloComposable.UseMutationOptions<TimeEntryActionsMutation, TimeEntryActionsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TimeEntryActionsMutation, TimeEntryActionsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TimeEntryActionsMutation, TimeEntryActionsMutationVariables>(TimeEntryActionsDocument, options);
}
export type TimeEntryActionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TimeEntryActionsMutation, TimeEntryActionsMutationVariables>;
export const TimeOffReportDocument = gql`
    query TimeOffReport($input: FilterHashInput!, $includeSummary: Boolean!) {
  TimeOffReport(input: $input) {
    timeOffReportList {
      user {
        id
        name
        initials
        hslColor
        profilePicture {
          mini
        }
        role {
          id
          name
        }
      }
      timeOffs {
        timeOff {
          id
          type {
            id
            systemName
            displayName
          }
          reason
          startDate
          endDate
          externalSystem
        }
        offDays
        offSeconds
        extraSeconds
        overlappingProjects {
          project {
            id
            name
            color
            company {
              id
              name
            }
            permissions {
              canView
            }
            isPrivate
            projectType
          }
          overlapDaysCount
          startDate
          endDate
        }
        hasMultipleUsers
      }
      total {
        offDays
        offSeconds
        extraSeconds
      }
      overlappingProjects {
        project {
          id
          name
          color
          company {
            id
            name
          }
          permissions {
            canView
          }
          isPrivate
          projectType
        }
        overlapDaysCount
        startDate
        endDate
      }
    }
    timeOffReportSummary @include(if: $includeSummary) {
      usersCount
      total {
        offDays
        offSeconds
        extraSeconds
      }
    }
  }
}
    `;

/**
 * __useTimeOffReportQuery__
 *
 * To run a query within a Vue component, call `useTimeOffReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeOffReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeOffReportQuery({
 *   input: // value for 'input'
 *   includeSummary: // value for 'includeSummary'
 * });
 */
export function useTimeOffReportQuery(variables: TimeOffReportQueryVariables | VueCompositionApi.Ref<TimeOffReportQueryVariables> | ReactiveFunction<TimeOffReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeOffReportQuery, TimeOffReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffReportQuery, TimeOffReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffReportQuery, TimeOffReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeOffReportQuery, TimeOffReportQueryVariables>(TimeOffReportDocument, variables, options);
}
export function useTimeOffReportLazyQuery(variables?: TimeOffReportQueryVariables | VueCompositionApi.Ref<TimeOffReportQueryVariables> | ReactiveFunction<TimeOffReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeOffReportQuery, TimeOffReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffReportQuery, TimeOffReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffReportQuery, TimeOffReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeOffReportQuery, TimeOffReportQueryVariables>(TimeOffReportDocument, variables, options);
}
export type TimeOffReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeOffReportQuery, TimeOffReportQueryVariables>;
export const TimeOffReportExportDocument = gql`
    query timeOffReportExport($input: FilterHashExportInput!) {
  TimeOffReportExport(input: $input) {
    fileUrl
  }
}
    `;

/**
 * __useTimeOffReportExportQuery__
 *
 * To run a query within a Vue component, call `useTimeOffReportExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeOffReportExportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeOffReportExportQuery({
 *   input: // value for 'input'
 * });
 */
export function useTimeOffReportExportQuery(variables: TimeOffReportExportQueryVariables | VueCompositionApi.Ref<TimeOffReportExportQueryVariables> | ReactiveFunction<TimeOffReportExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeOffReportExportQuery, TimeOffReportExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffReportExportQuery, TimeOffReportExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffReportExportQuery, TimeOffReportExportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeOffReportExportQuery, TimeOffReportExportQueryVariables>(TimeOffReportExportDocument, variables, options);
}
export function useTimeOffReportExportLazyQuery(variables?: TimeOffReportExportQueryVariables | VueCompositionApi.Ref<TimeOffReportExportQueryVariables> | ReactiveFunction<TimeOffReportExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeOffReportExportQuery, TimeOffReportExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffReportExportQuery, TimeOffReportExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffReportExportQuery, TimeOffReportExportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeOffReportExportQuery, TimeOffReportExportQueryVariables>(TimeOffReportExportDocument, variables, options);
}
export type TimeOffReportExportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeOffReportExportQuery, TimeOffReportExportQueryVariables>;
export const TimeOffTypeDeleteDocument = gql`
    mutation timeOffTypeDelete($id: ID!) {
  TimeOffTypeDelete(id: $id)
}
    `;

/**
 * __useTimeOffTypeDeleteMutation__
 *
 * To run a mutation, you first call `useTimeOffTypeDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTimeOffTypeDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTimeOffTypeDeleteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useTimeOffTypeDeleteMutation(options: VueApolloComposable.UseMutationOptions<TimeOffTypeDeleteMutation, TimeOffTypeDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TimeOffTypeDeleteMutation, TimeOffTypeDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TimeOffTypeDeleteMutation, TimeOffTypeDeleteMutationVariables>(TimeOffTypeDeleteDocument, options);
}
export type TimeOffTypeDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TimeOffTypeDeleteMutation, TimeOffTypeDeleteMutationVariables>;
export const TimeOffTypeModifyDocument = gql`
    mutation timeOffTypeModify($input: TimeOffTypeSaveInput!) {
  TimeOffTypeSave(input: $input) {
    displayName
    id
    isInUse
    isSystem
    isDefault
    ordering
  }
}
    `;

/**
 * __useTimeOffTypeModifyMutation__
 *
 * To run a mutation, you first call `useTimeOffTypeModifyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTimeOffTypeModifyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTimeOffTypeModifyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTimeOffTypeModifyMutation(options: VueApolloComposable.UseMutationOptions<TimeOffTypeModifyMutation, TimeOffTypeModifyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TimeOffTypeModifyMutation, TimeOffTypeModifyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TimeOffTypeModifyMutation, TimeOffTypeModifyMutationVariables>(TimeOffTypeModifyDocument, options);
}
export type TimeOffTypeModifyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TimeOffTypeModifyMutation, TimeOffTypeModifyMutationVariables>;
export const TimeOffTypeModifyPageDocument = gql`
    query TimeOffTypeModifyPage($input: TimeOffTypesListFiltersInput) {
  TimeOffTypesList(input: $input) {
    displayName
    id
    isInUse
    ordering
    isSystem
    isDefault
    externalSystems
  }
}
    `;

/**
 * __useTimeOffTypeModifyPageQuery__
 *
 * To run a query within a Vue component, call `useTimeOffTypeModifyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeOffTypeModifyPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeOffTypeModifyPageQuery({
 *   input: // value for 'input'
 * });
 */
export function useTimeOffTypeModifyPageQuery(variables: TimeOffTypeModifyPageQueryVariables | VueCompositionApi.Ref<TimeOffTypeModifyPageQueryVariables> | ReactiveFunction<TimeOffTypeModifyPageQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TimeOffTypeModifyPageQuery, TimeOffTypeModifyPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffTypeModifyPageQuery, TimeOffTypeModifyPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffTypeModifyPageQuery, TimeOffTypeModifyPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeOffTypeModifyPageQuery, TimeOffTypeModifyPageQueryVariables>(TimeOffTypeModifyPageDocument, variables, options);
}
export function useTimeOffTypeModifyPageLazyQuery(variables: TimeOffTypeModifyPageQueryVariables | VueCompositionApi.Ref<TimeOffTypeModifyPageQueryVariables> | ReactiveFunction<TimeOffTypeModifyPageQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TimeOffTypeModifyPageQuery, TimeOffTypeModifyPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeOffTypeModifyPageQuery, TimeOffTypeModifyPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeOffTypeModifyPageQuery, TimeOffTypeModifyPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeOffTypeModifyPageQuery, TimeOffTypeModifyPageQueryVariables>(TimeOffTypeModifyPageDocument, variables, options);
}
export type TimeOffTypeModifyPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeOffTypeModifyPageQuery, TimeOffTypeModifyPageQueryVariables>;
export const TimeOffTypeOrderingDocument = gql`
    mutation timeOffTypeOrdering($input: TimeOffTypesOrderSaveInput!) {
  TimeOffTypesOrderSave(input: $input)
}
    `;

/**
 * __useTimeOffTypeOrderingMutation__
 *
 * To run a mutation, you first call `useTimeOffTypeOrderingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTimeOffTypeOrderingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTimeOffTypeOrderingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTimeOffTypeOrderingMutation(options: VueApolloComposable.UseMutationOptions<TimeOffTypeOrderingMutation, TimeOffTypeOrderingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TimeOffTypeOrderingMutation, TimeOffTypeOrderingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TimeOffTypeOrderingMutation, TimeOffTypeOrderingMutationVariables>(TimeOffTypeOrderingDocument, options);
}
export type TimeOffTypeOrderingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TimeOffTypeOrderingMutation, TimeOffTypeOrderingMutationVariables>;
export const TimeTrackerDropdownDocument = gql`
    query timeTrackerDropdown {
  ActiveTimer @persist {
    id
    startedDateTime
    timerDuration
  }
}
    `;

/**
 * __useTimeTrackerDropdownQuery__
 *
 * To run a query within a Vue component, call `useTimeTrackerDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeTrackerDropdownQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeTrackerDropdownQuery();
 */
export function useTimeTrackerDropdownQuery(options: VueApolloComposable.UseQueryOptions<TimeTrackerDropdownQuery, TimeTrackerDropdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeTrackerDropdownQuery, TimeTrackerDropdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeTrackerDropdownQuery, TimeTrackerDropdownQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeTrackerDropdownQuery, TimeTrackerDropdownQueryVariables>(TimeTrackerDropdownDocument, {}, options);
}
export function useTimeTrackerDropdownLazyQuery(options: VueApolloComposable.UseQueryOptions<TimeTrackerDropdownQuery, TimeTrackerDropdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeTrackerDropdownQuery, TimeTrackerDropdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeTrackerDropdownQuery, TimeTrackerDropdownQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeTrackerDropdownQuery, TimeTrackerDropdownQueryVariables>(TimeTrackerDropdownDocument, {}, options);
}
export type TimeTrackerDropdownQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeTrackerDropdownQuery, TimeTrackerDropdownQueryVariables>;
export const TimesheetScheduleRemindersDocument = gql`
    mutation TimesheetScheduleReminders($input: TimesheetScheduleRemindersInput!) {
  TimesheetScheduleReminders(input: $input)
}
    `;

/**
 * __useTimesheetScheduleRemindersMutation__
 *
 * To run a mutation, you first call `useTimesheetScheduleRemindersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTimesheetScheduleRemindersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTimesheetScheduleRemindersMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTimesheetScheduleRemindersMutation(options: VueApolloComposable.UseMutationOptions<TimesheetScheduleRemindersMutation, TimesheetScheduleRemindersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TimesheetScheduleRemindersMutation, TimesheetScheduleRemindersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TimesheetScheduleRemindersMutation, TimesheetScheduleRemindersMutationVariables>(TimesheetScheduleRemindersDocument, options);
}
export type TimesheetScheduleRemindersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TimesheetScheduleRemindersMutation, TimesheetScheduleRemindersMutationVariables>;
export const TriggersActionsListDocument = gql`
    query triggersActionsList {
  CurrentUserTriggersList {
    id
    name
    module
    customModule {
      nameCode
      nameTranslated
    }
    status
    runCount
    isTemplate
    isSystemNotification
    user {
      id
      initials
      name
    }
    isMuted
  }
  ActiveTriggersLimitReached
}
    `;

/**
 * __useTriggersActionsListQuery__
 *
 * To run a query within a Vue component, call `useTriggersActionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggersActionsListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTriggersActionsListQuery();
 */
export function useTriggersActionsListQuery(options: VueApolloComposable.UseQueryOptions<TriggersActionsListQuery, TriggersActionsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersActionsListQuery, TriggersActionsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersActionsListQuery, TriggersActionsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TriggersActionsListQuery, TriggersActionsListQueryVariables>(TriggersActionsListDocument, {}, options);
}
export function useTriggersActionsListLazyQuery(options: VueApolloComposable.UseQueryOptions<TriggersActionsListQuery, TriggersActionsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersActionsListQuery, TriggersActionsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersActionsListQuery, TriggersActionsListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TriggersActionsListQuery, TriggersActionsListQueryVariables>(TriggersActionsListDocument, {}, options);
}
export type TriggersActionsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TriggersActionsListQuery, TriggersActionsListQueryVariables>;
export const TriggersActionsModifyTabsActionDocument = gql`
    query triggersActionsModifyTabsAction($input: ModuleInput!) {
  DynamicUserGroupsList(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useTriggersActionsModifyTabsActionQuery__
 *
 * To run a query within a Vue component, call `useTriggersActionsModifyTabsActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggersActionsModifyTabsActionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTriggersActionsModifyTabsActionQuery({
 *   input: // value for 'input'
 * });
 */
export function useTriggersActionsModifyTabsActionQuery(variables: TriggersActionsModifyTabsActionQueryVariables | VueCompositionApi.Ref<TriggersActionsModifyTabsActionQueryVariables> | ReactiveFunction<TriggersActionsModifyTabsActionQueryVariables>, options: VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsActionQuery, TriggersActionsModifyTabsActionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsActionQuery, TriggersActionsModifyTabsActionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsActionQuery, TriggersActionsModifyTabsActionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TriggersActionsModifyTabsActionQuery, TriggersActionsModifyTabsActionQueryVariables>(TriggersActionsModifyTabsActionDocument, variables, options);
}
export function useTriggersActionsModifyTabsActionLazyQuery(variables?: TriggersActionsModifyTabsActionQueryVariables | VueCompositionApi.Ref<TriggersActionsModifyTabsActionQueryVariables> | ReactiveFunction<TriggersActionsModifyTabsActionQueryVariables>, options: VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsActionQuery, TriggersActionsModifyTabsActionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsActionQuery, TriggersActionsModifyTabsActionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsActionQuery, TriggersActionsModifyTabsActionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TriggersActionsModifyTabsActionQuery, TriggersActionsModifyTabsActionQueryVariables>(TriggersActionsModifyTabsActionDocument, variables, options);
}
export type TriggersActionsModifyTabsActionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TriggersActionsModifyTabsActionQuery, TriggersActionsModifyTabsActionQueryVariables>;
export const TriggersActionsModifyTabsTriggerDocument = gql`
    query triggersActionsModifyTabsTrigger {
  TriggerModulesList {
    ... on Module {
      name
    }
    ... on CustomModule {
      nameCode
      nameTranslated
    }
  }
}
    `;

/**
 * __useTriggersActionsModifyTabsTriggerQuery__
 *
 * To run a query within a Vue component, call `useTriggersActionsModifyTabsTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggersActionsModifyTabsTriggerQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTriggersActionsModifyTabsTriggerQuery();
 */
export function useTriggersActionsModifyTabsTriggerQuery(options: VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsTriggerQuery, TriggersActionsModifyTabsTriggerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsTriggerQuery, TriggersActionsModifyTabsTriggerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsTriggerQuery, TriggersActionsModifyTabsTriggerQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TriggersActionsModifyTabsTriggerQuery, TriggersActionsModifyTabsTriggerQueryVariables>(TriggersActionsModifyTabsTriggerDocument, {}, options);
}
export function useTriggersActionsModifyTabsTriggerLazyQuery(options: VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsTriggerQuery, TriggersActionsModifyTabsTriggerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsTriggerQuery, TriggersActionsModifyTabsTriggerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersActionsModifyTabsTriggerQuery, TriggersActionsModifyTabsTriggerQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TriggersActionsModifyTabsTriggerQuery, TriggersActionsModifyTabsTriggerQueryVariables>(TriggersActionsModifyTabsTriggerDocument, {}, options);
}
export type TriggersActionsModifyTabsTriggerQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TriggersActionsModifyTabsTriggerQuery, TriggersActionsModifyTabsTriggerQueryVariables>;
export const TriggersActionsFieldsListDocument = gql`
    query triggersActionsFieldsList($module: ModuleType, $customModule: String) {
  TriggerFieldsList(module: $module, customModule: $customModule) {
    label
    name
    type
    activities
    conditions
    values {
      id
      label
      name
    }
  }
}
    `;

/**
 * __useTriggersActionsFieldsListQuery__
 *
 * To run a query within a Vue component, call `useTriggersActionsFieldsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggersActionsFieldsListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTriggersActionsFieldsListQuery({
 *   module: // value for 'module'
 *   customModule: // value for 'customModule'
 * });
 */
export function useTriggersActionsFieldsListQuery(variables: TriggersActionsFieldsListQueryVariables | VueCompositionApi.Ref<TriggersActionsFieldsListQueryVariables> | ReactiveFunction<TriggersActionsFieldsListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TriggersActionsFieldsListQuery, TriggersActionsFieldsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersActionsFieldsListQuery, TriggersActionsFieldsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersActionsFieldsListQuery, TriggersActionsFieldsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TriggersActionsFieldsListQuery, TriggersActionsFieldsListQueryVariables>(TriggersActionsFieldsListDocument, variables, options);
}
export function useTriggersActionsFieldsListLazyQuery(variables: TriggersActionsFieldsListQueryVariables | VueCompositionApi.Ref<TriggersActionsFieldsListQueryVariables> | ReactiveFunction<TriggersActionsFieldsListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TriggersActionsFieldsListQuery, TriggersActionsFieldsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersActionsFieldsListQuery, TriggersActionsFieldsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersActionsFieldsListQuery, TriggersActionsFieldsListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TriggersActionsFieldsListQuery, TriggersActionsFieldsListQueryVariables>(TriggersActionsFieldsListDocument, variables, options);
}
export type TriggersActionsFieldsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TriggersActionsFieldsListQuery, TriggersActionsFieldsListQueryVariables>;
export const TriggersActionsModifyDeleteDocument = gql`
    mutation triggersActionsModifyDelete($id: ID!) {
  TriggerDelete(triggerId: $id)
}
    `;

/**
 * __useTriggersActionsModifyDeleteMutation__
 *
 * To run a mutation, you first call `useTriggersActionsModifyDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggersActionsModifyDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggersActionsModifyDeleteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useTriggersActionsModifyDeleteMutation(options: VueApolloComposable.UseMutationOptions<TriggersActionsModifyDeleteMutation, TriggersActionsModifyDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggersActionsModifyDeleteMutation, TriggersActionsModifyDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggersActionsModifyDeleteMutation, TriggersActionsModifyDeleteMutationVariables>(TriggersActionsModifyDeleteDocument, options);
}
export type TriggersActionsModifyDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggersActionsModifyDeleteMutation, TriggersActionsModifyDeleteMutationVariables>;
export const TriggersActionsModifyDocument = gql`
    query triggersActionsModify($id: ID!) {
  TriggerModulesList {
    ... on Module {
      name
    }
    ... on CustomModule {
      nameCode
      nameTranslated
    }
  }
  Trigger(id: $id) {
    id
    name
    module
    customModule {
      nameCode
      nameTranslated
    }
    status
    runCount
    isShared
    isSystem
    isTemplate
    bookmark {
      id
      name
      module
      owner {
        id
        name
        initials
      }
    }
    user {
      id
      name
      initials
    }
    filterData {
      filters {
        logicalOperator
        blocks {
          logicalOperator
          rules {
            fieldType
            fieldCondition
            fieldTypeLabel
            groupValues {
              id
            }
            values {
              ... on UnionUser {
                user {
                  id
                  name
                }
              }
              ... on UnionStringFieldValue {
                stringValue
              }
              ... on UnionTask {
                task {
                  id
                  name
                }
              }
              ... on UnionEvent {
                event {
                  id
                  name
                }
              }
              ... on UnionQuote {
                quote {
                  id
                  number
                  quoteName
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionContact {
                contact {
                  id
                  name
                }
              }
              ... on UnionContactCategory {
                contactCategory {
                  id
                  name
                }
              }
              ... on UnionTag {
                tag {
                  id
                  title
                }
              }
              ... on UnionClientProfile {
                clientProfile {
                  id
                  name
                }
              }
              ... on UnionProject {
                project {
                  id
                  name
                }
              }
              ... on UnionBill {
                bill {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionExpense {
                expense {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionInvoice {
                invoice {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionPrepayment {
                prepayment {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionPurchaseOrder {
                purchaseOrder {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionOrder {
                order {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionStatus {
                status {
                  statusId
                  name
                }
              }
              ... on UnionActivity {
                activity {
                  id
                  name
                }
              }
              ... on UnionResource {
                resource {
                  id
                  name
                }
              }
              ... on UnionCurrency {
                currency {
                  id
                  name
                }
              }
            }
          }
        }
      }
      activities {
        logicalOperator
        blocks {
          logicalOperator
          rules {
            fieldType
            fieldCondition
            fieldTypeLabel
            groupValues {
              id
            }
            values {
              ... on UnionUser {
                user {
                  id
                  name
                }
              }
              ... on UnionStringFieldValue {
                stringValue
              }
              ... on UnionTask {
                task {
                  id
                  name
                }
              }
              ... on UnionEvent {
                event {
                  id
                  name
                }
              }
              ... on UnionQuote {
                quote {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionContact {
                contact {
                  id
                  name
                }
              }
              ... on UnionContactCategory {
                contactCategory {
                  id
                  name
                }
              }
              ... on UnionTag {
                tag {
                  id
                  title
                }
              }
              ... on UnionClientProfile {
                clientProfile {
                  id
                  name
                }
              }
              ... on UnionProject {
                project {
                  id
                  name
                }
              }
              ... on UnionBill {
                bill {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionExpense {
                expense {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionInvoice {
                invoice {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionPrepayment {
                prepayment {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionPurchaseOrder {
                purchaseOrder {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionOrder {
                order {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionStatus {
                status {
                  statusId
                  name
                }
              }
              ... on UnionActivity {
                activity {
                  id
                  name
                }
              }
              ... on UnionResource {
                resource {
                  id
                  name
                }
              }
              ... on UnionCurrency {
                currency {
                  id
                  name
                }
              }
            }
          }
        }
      }
      activityDoers {
        values {
          id
          name
        }
        groupValues {
          ... on UserGroup {
            id
          }
          ... on DynamicUserGroup {
            id
          }
        }
      }
    }
    actions {
      ...TriggersActionsModifyAction
    }
    activities {
      activity
    }
  }
}
    ${TriggersActionsModifyActionFragmentDoc}`;

/**
 * __useTriggersActionsModifyQuery__
 *
 * To run a query within a Vue component, call `useTriggersActionsModifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggersActionsModifyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTriggersActionsModifyQuery({
 *   id: // value for 'id'
 * });
 */
export function useTriggersActionsModifyQuery(variables: TriggersActionsModifyQueryVariables | VueCompositionApi.Ref<TriggersActionsModifyQueryVariables> | ReactiveFunction<TriggersActionsModifyQueryVariables>, options: VueApolloComposable.UseQueryOptions<TriggersActionsModifyQuery, TriggersActionsModifyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersActionsModifyQuery, TriggersActionsModifyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersActionsModifyQuery, TriggersActionsModifyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TriggersActionsModifyQuery, TriggersActionsModifyQueryVariables>(TriggersActionsModifyDocument, variables, options);
}
export function useTriggersActionsModifyLazyQuery(variables?: TriggersActionsModifyQueryVariables | VueCompositionApi.Ref<TriggersActionsModifyQueryVariables> | ReactiveFunction<TriggersActionsModifyQueryVariables>, options: VueApolloComposable.UseQueryOptions<TriggersActionsModifyQuery, TriggersActionsModifyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersActionsModifyQuery, TriggersActionsModifyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersActionsModifyQuery, TriggersActionsModifyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TriggersActionsModifyQuery, TriggersActionsModifyQueryVariables>(TriggersActionsModifyDocument, variables, options);
}
export type TriggersActionsModifyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TriggersActionsModifyQuery, TriggersActionsModifyQueryVariables>;
export const TriggersActionsModifyUpdateDocument = gql`
    mutation triggersActionsModifyUpdate($id: ID!, $data: TriggerDataInput!) {
  TriggerDataUpdate(triggerId: $id, triggerChanges: $data) {
    id
    name
    module
    customModule {
      nameCode
      nameTranslated
    }
    status
    runCount
    isShared
    isSystem
    isTemplate
    bookmark {
      id
      name
      module
      owner {
        id
        name
        initials
      }
    }
    user {
      id
      name
      initials
    }
    filterData {
      filters {
        logicalOperator
        blocks {
          logicalOperator
          rules {
            fieldType
            fieldCondition
            fieldTypeLabel
            groupValues {
              id
            }
            values {
              ... on UnionUser {
                user {
                  id
                  name
                }
              }
              ... on UnionStringFieldValue {
                stringValue
              }
              ... on UnionTask {
                task {
                  id
                  name
                }
              }
              ... on UnionEvent {
                event {
                  id
                  name
                }
              }
              ... on UnionQuote {
                quote {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionContact {
                contact {
                  id
                  name
                }
              }
              ... on UnionContactCategory {
                contactCategory {
                  id
                  name
                }
              }
              ... on UnionTag {
                tag {
                  id
                  title
                }
              }
              ... on UnionClientProfile {
                clientProfile {
                  id
                  name
                }
              }
              ... on UnionProject {
                project {
                  id
                  name
                }
              }
              ... on UnionBill {
                bill {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionExpense {
                expense {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionInvoice {
                invoice {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionPrepayment {
                prepayment {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionPurchaseOrder {
                purchaseOrder {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionOrder {
                order {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionStatus {
                status {
                  statusId
                  name
                }
              }
              ... on UnionActivity {
                activity {
                  id
                  name
                }
              }
              ... on UnionResource {
                resource {
                  id
                  name
                }
              }
              ... on UnionCurrency {
                currency {
                  id
                  name
                }
              }
            }
          }
        }
      }
      activities {
        logicalOperator
        blocks {
          logicalOperator
          rules {
            fieldType
            fieldCondition
            fieldTypeLabel
            groupValues {
              id
            }
            values {
              ... on UnionUser {
                user {
                  id
                  name
                }
              }
              ... on UnionStringFieldValue {
                stringValue
              }
              ... on UnionTask {
                task {
                  id
                  name
                }
              }
              ... on UnionEvent {
                event {
                  id
                  name
                }
              }
              ... on UnionQuote {
                quote {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionContact {
                contact {
                  id
                  name
                }
              }
              ... on UnionContactCategory {
                contactCategory {
                  id
                  name
                }
              }
              ... on UnionTag {
                tag {
                  id
                  title
                }
              }
              ... on UnionClientProfile {
                clientProfile {
                  id
                  name
                }
              }
              ... on UnionProject {
                project {
                  id
                  name
                }
              }
              ... on UnionBill {
                bill {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionExpense {
                expense {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionInvoice {
                invoice {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionPrepayment {
                prepayment {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionPurchaseOrder {
                purchaseOrder {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionOrder {
                order {
                  id
                  number
                  mainContact {
                    name
                  }
                }
              }
              ... on UnionStatus {
                status {
                  statusId
                  name
                }
              }
              ... on UnionActivity {
                activity {
                  id
                  name
                }
              }
              ... on UnionResource {
                resource {
                  id
                  name
                }
              }
              ... on UnionCurrency {
                currency {
                  id
                  name
                }
              }
            }
          }
        }
      }
      activityDoers {
        values {
          id
          name
        }
        groupValues {
          ... on UserGroup {
            id
          }
          ... on DynamicUserGroup {
            id
          }
        }
      }
    }
    actions {
      id
      triggerId
      type
      actionData {
        ... on User {
          id
          name
        }
        ... on WebhookData {
          urlToPost
        }
        ... on UserGroup {
          id
          name
        }
        ... on DynamicUserGroup {
          id
          name
        }
      }
      actionName
    }
    activities {
      activity
    }
  }
}
    `;

/**
 * __useTriggersActionsModifyUpdateMutation__
 *
 * To run a mutation, you first call `useTriggersActionsModifyUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggersActionsModifyUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggersActionsModifyUpdateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useTriggersActionsModifyUpdateMutation(options: VueApolloComposable.UseMutationOptions<TriggersActionsModifyUpdateMutation, TriggersActionsModifyUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggersActionsModifyUpdateMutation, TriggersActionsModifyUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggersActionsModifyUpdateMutation, TriggersActionsModifyUpdateMutationVariables>(TriggersActionsModifyUpdateDocument, options);
}
export type TriggersActionsModifyUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggersActionsModifyUpdateMutation, TriggersActionsModifyUpdateMutationVariables>;
export const TriggersActionsMutedUpdateDocument = gql`
    mutation triggersActionsMutedUpdate($id: ID!) {
  TriggerMutedUpdate(triggerId: $id) {
    id
    isMuted
  }
}
    `;

/**
 * __useTriggersActionsMutedUpdateMutation__
 *
 * To run a mutation, you first call `useTriggersActionsMutedUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggersActionsMutedUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggersActionsMutedUpdateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useTriggersActionsMutedUpdateMutation(options: VueApolloComposable.UseMutationOptions<TriggersActionsMutedUpdateMutation, TriggersActionsMutedUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggersActionsMutedUpdateMutation, TriggersActionsMutedUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggersActionsMutedUpdateMutation, TriggersActionsMutedUpdateMutationVariables>(TriggersActionsMutedUpdateDocument, options);
}
export type TriggersActionsMutedUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggersActionsMutedUpdateMutation, TriggersActionsMutedUpdateMutationVariables>;
export const TriggersNotifyOptionsDocument = gql`
    query triggersNotifyOptions {
  TriggerNotifyOptions @persist
}
    `;

/**
 * __useTriggersNotifyOptionsQuery__
 *
 * To run a query within a Vue component, call `useTriggersNotifyOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggersNotifyOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTriggersNotifyOptionsQuery();
 */
export function useTriggersNotifyOptionsQuery(options: VueApolloComposable.UseQueryOptions<TriggersNotifyOptionsQuery, TriggersNotifyOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersNotifyOptionsQuery, TriggersNotifyOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersNotifyOptionsQuery, TriggersNotifyOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TriggersNotifyOptionsQuery, TriggersNotifyOptionsQueryVariables>(TriggersNotifyOptionsDocument, {}, options);
}
export function useTriggersNotifyOptionsLazyQuery(options: VueApolloComposable.UseQueryOptions<TriggersNotifyOptionsQuery, TriggersNotifyOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TriggersNotifyOptionsQuery, TriggersNotifyOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TriggersNotifyOptionsQuery, TriggersNotifyOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TriggersNotifyOptionsQuery, TriggersNotifyOptionsQueryVariables>(TriggersNotifyOptionsDocument, {}, options);
}
export type TriggersNotifyOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TriggersNotifyOptionsQuery, TriggersNotifyOptionsQueryVariables>;
export const TriggersActionsStatusUpdateDocument = gql`
    mutation triggersActionsStatusUpdate($id: ID!, $status: TriggerStatusType!) {
  TriggerStatusUpdate(triggerId: $id, status: $status) {
    id
    name
    status
  }
}
    `;

/**
 * __useTriggersActionsStatusUpdateMutation__
 *
 * To run a mutation, you first call `useTriggersActionsStatusUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggersActionsStatusUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggersActionsStatusUpdateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     status: // value for 'status'
 *   },
 * });
 */
export function useTriggersActionsStatusUpdateMutation(options: VueApolloComposable.UseMutationOptions<TriggersActionsStatusUpdateMutation, TriggersActionsStatusUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggersActionsStatusUpdateMutation, TriggersActionsStatusUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggersActionsStatusUpdateMutation, TriggersActionsStatusUpdateMutationVariables>(TriggersActionsStatusUpdateDocument, options);
}
export type TriggersActionsStatusUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggersActionsStatusUpdateMutation, TriggersActionsStatusUpdateMutationVariables>;
export const UserActionsListDocument = gql`
    query userActionsList {
  CurrentUser @persist {
    id
    type
    companyAccounts {
      id
      name
      logo
    }
  }
  CurrentUserHasDemoData @persist
  UserEmailDraftsCount @persist
}
    `;

/**
 * __useUserActionsListQuery__
 *
 * To run a query within a Vue component, call `useUserActionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserActionsListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserActionsListQuery();
 */
export function useUserActionsListQuery(options: VueApolloComposable.UseQueryOptions<UserActionsListQuery, UserActionsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserActionsListQuery, UserActionsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserActionsListQuery, UserActionsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserActionsListQuery, UserActionsListQueryVariables>(UserActionsListDocument, {}, options);
}
export function useUserActionsListLazyQuery(options: VueApolloComposable.UseQueryOptions<UserActionsListQuery, UserActionsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserActionsListQuery, UserActionsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserActionsListQuery, UserActionsListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserActionsListQuery, UserActionsListQueryVariables>(UserActionsListDocument, {}, options);
}
export type UserActionsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserActionsListQuery, UserActionsListQueryVariables>;
export const UserAssignSelectProjectMembersDocument = gql`
    query userAssignSelectProjectMembers($projectParams: ProjectParamsInput!) {
  Project(projectParams: $projectParams) {
    id
    members {
      id
    }
  }
}
    `;

/**
 * __useUserAssignSelectProjectMembersQuery__
 *
 * To run a query within a Vue component, call `useUserAssignSelectProjectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAssignSelectProjectMembersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAssignSelectProjectMembersQuery({
 *   projectParams: // value for 'projectParams'
 * });
 */
export function useUserAssignSelectProjectMembersQuery(variables: UserAssignSelectProjectMembersQueryVariables | VueCompositionApi.Ref<UserAssignSelectProjectMembersQueryVariables> | ReactiveFunction<UserAssignSelectProjectMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectProjectMembersQuery, UserAssignSelectProjectMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectProjectMembersQuery, UserAssignSelectProjectMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectProjectMembersQuery, UserAssignSelectProjectMembersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAssignSelectProjectMembersQuery, UserAssignSelectProjectMembersQueryVariables>(UserAssignSelectProjectMembersDocument, variables, options);
}
export function useUserAssignSelectProjectMembersLazyQuery(variables?: UserAssignSelectProjectMembersQueryVariables | VueCompositionApi.Ref<UserAssignSelectProjectMembersQueryVariables> | ReactiveFunction<UserAssignSelectProjectMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectProjectMembersQuery, UserAssignSelectProjectMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectProjectMembersQuery, UserAssignSelectProjectMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectProjectMembersQuery, UserAssignSelectProjectMembersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAssignSelectProjectMembersQuery, UserAssignSelectProjectMembersQueryVariables>(UserAssignSelectProjectMembersDocument, variables, options);
}
export type UserAssignSelectProjectMembersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAssignSelectProjectMembersQuery, UserAssignSelectProjectMembersQueryVariables>;
export const UserAssignSelectUsersAndGroupsDocument = gql`
    query userAssignSelectUsersAndGroups($usersListInput: UsersListInput!, $projectParams: ProjectParamsInput!, $loadProject: Boolean!, $rolesListInput: RolesListInput!, $loadRoles: Boolean!) {
  UserGroupsList {
    id
    name
    users {
      id
      status
    }
  }
  UsersList(input: $usersListInput) {
    ...userAssignSelectUser
  }
  Project(projectParams: $projectParams) @include(if: $loadProject) {
    id
    cupoUsers {
      id
    }
    members {
      id
    }
  }
  RolesList(input: $rolesListInput) @include(if: $loadRoles) {
    id
    name
    initials
    hslColor
  }
}
    ${UserAssignSelectUserFragmentDoc}`;

/**
 * __useUserAssignSelectUsersAndGroupsQuery__
 *
 * To run a query within a Vue component, call `useUserAssignSelectUsersAndGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAssignSelectUsersAndGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAssignSelectUsersAndGroupsQuery({
 *   usersListInput: // value for 'usersListInput'
 *   projectParams: // value for 'projectParams'
 *   loadProject: // value for 'loadProject'
 *   rolesListInput: // value for 'rolesListInput'
 *   loadRoles: // value for 'loadRoles'
 * });
 */
export function useUserAssignSelectUsersAndGroupsQuery(variables: UserAssignSelectUsersAndGroupsQueryVariables | VueCompositionApi.Ref<UserAssignSelectUsersAndGroupsQueryVariables> | ReactiveFunction<UserAssignSelectUsersAndGroupsQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectUsersAndGroupsQuery, UserAssignSelectUsersAndGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectUsersAndGroupsQuery, UserAssignSelectUsersAndGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectUsersAndGroupsQuery, UserAssignSelectUsersAndGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAssignSelectUsersAndGroupsQuery, UserAssignSelectUsersAndGroupsQueryVariables>(UserAssignSelectUsersAndGroupsDocument, variables, options);
}
export function useUserAssignSelectUsersAndGroupsLazyQuery(variables?: UserAssignSelectUsersAndGroupsQueryVariables | VueCompositionApi.Ref<UserAssignSelectUsersAndGroupsQueryVariables> | ReactiveFunction<UserAssignSelectUsersAndGroupsQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectUsersAndGroupsQuery, UserAssignSelectUsersAndGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectUsersAndGroupsQuery, UserAssignSelectUsersAndGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectUsersAndGroupsQuery, UserAssignSelectUsersAndGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAssignSelectUsersAndGroupsQuery, UserAssignSelectUsersAndGroupsQueryVariables>(UserAssignSelectUsersAndGroupsDocument, variables, options);
}
export type UserAssignSelectUsersAndGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAssignSelectUsersAndGroupsQuery, UserAssignSelectUsersAndGroupsQueryVariables>;
export const UserAssignSelectUsersDocument = gql`
    query userAssignSelectUsers($input: UsersListInput!, $projectParams: ProjectParamsInput!, $loadProject: Boolean!) {
  UsersList(input: $input) {
    ...userAssignSelectUser
  }
  Project(projectParams: $projectParams) @include(if: $loadProject) {
    id
    cupoUsers {
      id
    }
    members {
      id
    }
  }
}
    ${UserAssignSelectUserFragmentDoc}`;

/**
 * __useUserAssignSelectUsersQuery__
 *
 * To run a query within a Vue component, call `useUserAssignSelectUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAssignSelectUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAssignSelectUsersQuery({
 *   input: // value for 'input'
 *   projectParams: // value for 'projectParams'
 *   loadProject: // value for 'loadProject'
 * });
 */
export function useUserAssignSelectUsersQuery(variables: UserAssignSelectUsersQueryVariables | VueCompositionApi.Ref<UserAssignSelectUsersQueryVariables> | ReactiveFunction<UserAssignSelectUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectUsersQuery, UserAssignSelectUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectUsersQuery, UserAssignSelectUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectUsersQuery, UserAssignSelectUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAssignSelectUsersQuery, UserAssignSelectUsersQueryVariables>(UserAssignSelectUsersDocument, variables, options);
}
export function useUserAssignSelectUsersLazyQuery(variables?: UserAssignSelectUsersQueryVariables | VueCompositionApi.Ref<UserAssignSelectUsersQueryVariables> | ReactiveFunction<UserAssignSelectUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectUsersQuery, UserAssignSelectUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectUsersQuery, UserAssignSelectUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectUsersQuery, UserAssignSelectUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAssignSelectUsersQuery, UserAssignSelectUsersQueryVariables>(UserAssignSelectUsersDocument, variables, options);
}
export type UserAssignSelectUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAssignSelectUsersQuery, UserAssignSelectUsersQueryVariables>;
export const UserAssignSelectAvailabilityDocument = gql`
    query userAssignSelectAvailability($input: TaskUsersAvailabilityInput!) {
  TaskUsersAvailability(input: $input) {
    ...taskUserAvailabilityFragment
  }
}
    ${TaskUserAvailabilityFragmentFragmentDoc}`;

/**
 * __useUserAssignSelectAvailabilityQuery__
 *
 * To run a query within a Vue component, call `useUserAssignSelectAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAssignSelectAvailabilityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAssignSelectAvailabilityQuery({
 *   input: // value for 'input'
 * });
 */
export function useUserAssignSelectAvailabilityQuery(variables: UserAssignSelectAvailabilityQueryVariables | VueCompositionApi.Ref<UserAssignSelectAvailabilityQueryVariables> | ReactiveFunction<UserAssignSelectAvailabilityQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectAvailabilityQuery, UserAssignSelectAvailabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectAvailabilityQuery, UserAssignSelectAvailabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectAvailabilityQuery, UserAssignSelectAvailabilityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAssignSelectAvailabilityQuery, UserAssignSelectAvailabilityQueryVariables>(UserAssignSelectAvailabilityDocument, variables, options);
}
export function useUserAssignSelectAvailabilityLazyQuery(variables?: UserAssignSelectAvailabilityQueryVariables | VueCompositionApi.Ref<UserAssignSelectAvailabilityQueryVariables> | ReactiveFunction<UserAssignSelectAvailabilityQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectAvailabilityQuery, UserAssignSelectAvailabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectAvailabilityQuery, UserAssignSelectAvailabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectAvailabilityQuery, UserAssignSelectAvailabilityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAssignSelectAvailabilityQuery, UserAssignSelectAvailabilityQueryVariables>(UserAssignSelectAvailabilityDocument, variables, options);
}
export type UserAssignSelectAvailabilityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAssignSelectAvailabilityQuery, UserAssignSelectAvailabilityQueryVariables>;
export const UserAssignSelectInlineProjectMembersDocument = gql`
    query userAssignSelectInlineProjectMembers($projectParams: ProjectParamsInput!) {
  Project(projectParams: $projectParams) {
    id
    members {
      id
    }
  }
}
    `;

/**
 * __useUserAssignSelectInlineProjectMembersQuery__
 *
 * To run a query within a Vue component, call `useUserAssignSelectInlineProjectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAssignSelectInlineProjectMembersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAssignSelectInlineProjectMembersQuery({
 *   projectParams: // value for 'projectParams'
 * });
 */
export function useUserAssignSelectInlineProjectMembersQuery(variables: UserAssignSelectInlineProjectMembersQueryVariables | VueCompositionApi.Ref<UserAssignSelectInlineProjectMembersQueryVariables> | ReactiveFunction<UserAssignSelectInlineProjectMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectInlineProjectMembersQuery, UserAssignSelectInlineProjectMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineProjectMembersQuery, UserAssignSelectInlineProjectMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineProjectMembersQuery, UserAssignSelectInlineProjectMembersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAssignSelectInlineProjectMembersQuery, UserAssignSelectInlineProjectMembersQueryVariables>(UserAssignSelectInlineProjectMembersDocument, variables, options);
}
export function useUserAssignSelectInlineProjectMembersLazyQuery(variables?: UserAssignSelectInlineProjectMembersQueryVariables | VueCompositionApi.Ref<UserAssignSelectInlineProjectMembersQueryVariables> | ReactiveFunction<UserAssignSelectInlineProjectMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectInlineProjectMembersQuery, UserAssignSelectInlineProjectMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineProjectMembersQuery, UserAssignSelectInlineProjectMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineProjectMembersQuery, UserAssignSelectInlineProjectMembersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAssignSelectInlineProjectMembersQuery, UserAssignSelectInlineProjectMembersQueryVariables>(UserAssignSelectInlineProjectMembersDocument, variables, options);
}
export type UserAssignSelectInlineProjectMembersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAssignSelectInlineProjectMembersQuery, UserAssignSelectInlineProjectMembersQueryVariables>;
export const UserAssignSelectInlineUsersAndGroupsDocument = gql`
    query userAssignSelectInlineUsersAndGroups($usersListInput: UsersListInput!, $projectParams: ProjectParamsInput!, $loadProject: Boolean!, $rolesListInput: RolesListInput!, $loadRoles: Boolean!) {
  UserGroupsList {
    id
    name
    users {
      id
      status
    }
  }
  UsersList(input: $usersListInput) {
    ...userAssignSelectUser
  }
  Project(projectParams: $projectParams) @include(if: $loadProject) {
    id
    cupoUsers {
      id
    }
    members {
      id
    }
  }
  RolesList(input: $rolesListInput) @include(if: $loadRoles) {
    id
    name
    initials
    hslColor
  }
}
    ${UserAssignSelectUserFragmentDoc}`;

/**
 * __useUserAssignSelectInlineUsersAndGroupsQuery__
 *
 * To run a query within a Vue component, call `useUserAssignSelectInlineUsersAndGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAssignSelectInlineUsersAndGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAssignSelectInlineUsersAndGroupsQuery({
 *   usersListInput: // value for 'usersListInput'
 *   projectParams: // value for 'projectParams'
 *   loadProject: // value for 'loadProject'
 *   rolesListInput: // value for 'rolesListInput'
 *   loadRoles: // value for 'loadRoles'
 * });
 */
export function useUserAssignSelectInlineUsersAndGroupsQuery(variables: UserAssignSelectInlineUsersAndGroupsQueryVariables | VueCompositionApi.Ref<UserAssignSelectInlineUsersAndGroupsQueryVariables> | ReactiveFunction<UserAssignSelectInlineUsersAndGroupsQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersAndGroupsQuery, UserAssignSelectInlineUsersAndGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersAndGroupsQuery, UserAssignSelectInlineUsersAndGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersAndGroupsQuery, UserAssignSelectInlineUsersAndGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAssignSelectInlineUsersAndGroupsQuery, UserAssignSelectInlineUsersAndGroupsQueryVariables>(UserAssignSelectInlineUsersAndGroupsDocument, variables, options);
}
export function useUserAssignSelectInlineUsersAndGroupsLazyQuery(variables?: UserAssignSelectInlineUsersAndGroupsQueryVariables | VueCompositionApi.Ref<UserAssignSelectInlineUsersAndGroupsQueryVariables> | ReactiveFunction<UserAssignSelectInlineUsersAndGroupsQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersAndGroupsQuery, UserAssignSelectInlineUsersAndGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersAndGroupsQuery, UserAssignSelectInlineUsersAndGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersAndGroupsQuery, UserAssignSelectInlineUsersAndGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAssignSelectInlineUsersAndGroupsQuery, UserAssignSelectInlineUsersAndGroupsQueryVariables>(UserAssignSelectInlineUsersAndGroupsDocument, variables, options);
}
export type UserAssignSelectInlineUsersAndGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAssignSelectInlineUsersAndGroupsQuery, UserAssignSelectInlineUsersAndGroupsQueryVariables>;
export const UserAssignSelectInlineUsersDocument = gql`
    query userAssignSelectInlineUsers($input: UsersListInput!, $projectParams: ProjectParamsInput!, $loadProject: Boolean!) {
  UsersList(input: $input) {
    ...userAssignSelectUser
  }
  Project(projectParams: $projectParams) @include(if: $loadProject) {
    id
    cupoUsers {
      id
    }
    members {
      id
    }
  }
}
    ${UserAssignSelectUserFragmentDoc}`;

/**
 * __useUserAssignSelectInlineUsersQuery__
 *
 * To run a query within a Vue component, call `useUserAssignSelectInlineUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAssignSelectInlineUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAssignSelectInlineUsersQuery({
 *   input: // value for 'input'
 *   projectParams: // value for 'projectParams'
 *   loadProject: // value for 'loadProject'
 * });
 */
export function useUserAssignSelectInlineUsersQuery(variables: UserAssignSelectInlineUsersQueryVariables | VueCompositionApi.Ref<UserAssignSelectInlineUsersQueryVariables> | ReactiveFunction<UserAssignSelectInlineUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersQuery, UserAssignSelectInlineUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersQuery, UserAssignSelectInlineUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersQuery, UserAssignSelectInlineUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAssignSelectInlineUsersQuery, UserAssignSelectInlineUsersQueryVariables>(UserAssignSelectInlineUsersDocument, variables, options);
}
export function useUserAssignSelectInlineUsersLazyQuery(variables?: UserAssignSelectInlineUsersQueryVariables | VueCompositionApi.Ref<UserAssignSelectInlineUsersQueryVariables> | ReactiveFunction<UserAssignSelectInlineUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersQuery, UserAssignSelectInlineUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersQuery, UserAssignSelectInlineUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineUsersQuery, UserAssignSelectInlineUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAssignSelectInlineUsersQuery, UserAssignSelectInlineUsersQueryVariables>(UserAssignSelectInlineUsersDocument, variables, options);
}
export type UserAssignSelectInlineUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAssignSelectInlineUsersQuery, UserAssignSelectInlineUsersQueryVariables>;
export const UserAssignSelectInlineAvailabilityDocument = gql`
    query userAssignSelectInlineAvailability($input: TaskUsersAvailabilityInput!) {
  TaskUsersAvailability(input: $input) {
    ...userAssignSelectInlineTaskUserAvailabilityFragment
  }
}
    ${UserAssignSelectInlineTaskUserAvailabilityFragmentFragmentDoc}`;

/**
 * __useUserAssignSelectInlineAvailabilityQuery__
 *
 * To run a query within a Vue component, call `useUserAssignSelectInlineAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAssignSelectInlineAvailabilityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAssignSelectInlineAvailabilityQuery({
 *   input: // value for 'input'
 * });
 */
export function useUserAssignSelectInlineAvailabilityQuery(variables: UserAssignSelectInlineAvailabilityQueryVariables | VueCompositionApi.Ref<UserAssignSelectInlineAvailabilityQueryVariables> | ReactiveFunction<UserAssignSelectInlineAvailabilityQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectInlineAvailabilityQuery, UserAssignSelectInlineAvailabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineAvailabilityQuery, UserAssignSelectInlineAvailabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineAvailabilityQuery, UserAssignSelectInlineAvailabilityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAssignSelectInlineAvailabilityQuery, UserAssignSelectInlineAvailabilityQueryVariables>(UserAssignSelectInlineAvailabilityDocument, variables, options);
}
export function useUserAssignSelectInlineAvailabilityLazyQuery(variables?: UserAssignSelectInlineAvailabilityQueryVariables | VueCompositionApi.Ref<UserAssignSelectInlineAvailabilityQueryVariables> | ReactiveFunction<UserAssignSelectInlineAvailabilityQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignSelectInlineAvailabilityQuery, UserAssignSelectInlineAvailabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineAvailabilityQuery, UserAssignSelectInlineAvailabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignSelectInlineAvailabilityQuery, UserAssignSelectInlineAvailabilityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAssignSelectInlineAvailabilityQuery, UserAssignSelectInlineAvailabilityQueryVariables>(UserAssignSelectInlineAvailabilityDocument, variables, options);
}
export type UserAssignSelectInlineAvailabilityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAssignSelectInlineAvailabilityQuery, UserAssignSelectInlineAvailabilityQueryVariables>;
export const UserAutoSuggestDocument = gql`
    query userAutoSuggest($usersListInput: UsersListInput!) {
  UsersList(input: $usersListInput) {
    id
    name
  }
}
    `;

/**
 * __useUserAutoSuggestQuery__
 *
 * To run a query within a Vue component, call `useUserAutoSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAutoSuggestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAutoSuggestQuery({
 *   usersListInput: // value for 'usersListInput'
 * });
 */
export function useUserAutoSuggestQuery(variables: UserAutoSuggestQueryVariables | VueCompositionApi.Ref<UserAutoSuggestQueryVariables> | ReactiveFunction<UserAutoSuggestQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAutoSuggestQuery, UserAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAutoSuggestQuery, UserAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAutoSuggestQuery, UserAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAutoSuggestQuery, UserAutoSuggestQueryVariables>(UserAutoSuggestDocument, variables, options);
}
export function useUserAutoSuggestLazyQuery(variables?: UserAutoSuggestQueryVariables | VueCompositionApi.Ref<UserAutoSuggestQueryVariables> | ReactiveFunction<UserAutoSuggestQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAutoSuggestQuery, UserAutoSuggestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAutoSuggestQuery, UserAutoSuggestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAutoSuggestQuery, UserAutoSuggestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAutoSuggestQuery, UserAutoSuggestQueryVariables>(UserAutoSuggestDocument, variables, options);
}
export type UserAutoSuggestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAutoSuggestQuery, UserAutoSuggestQueryVariables>;
export const TaskTemplateEventAssignDocument = gql`
    query taskTemplateEventAssign($id: ID!) {
  TaskTemplate(id: $id) {
    ...TaskTemplateEventAssignTaskTemplate
  }
}
    ${TaskTemplateEventAssignTaskTemplateFragmentDoc}`;

/**
 * __useTaskTemplateEventAssignQuery__
 *
 * To run a query within a Vue component, call `useTaskTemplateEventAssignQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTemplateEventAssignQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaskTemplateEventAssignQuery({
 *   id: // value for 'id'
 * });
 */
export function useTaskTemplateEventAssignQuery(variables: TaskTemplateEventAssignQueryVariables | VueCompositionApi.Ref<TaskTemplateEventAssignQueryVariables> | ReactiveFunction<TaskTemplateEventAssignQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskTemplateEventAssignQuery, TaskTemplateEventAssignQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskTemplateEventAssignQuery, TaskTemplateEventAssignQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskTemplateEventAssignQuery, TaskTemplateEventAssignQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaskTemplateEventAssignQuery, TaskTemplateEventAssignQueryVariables>(TaskTemplateEventAssignDocument, variables, options);
}
export function useTaskTemplateEventAssignLazyQuery(variables?: TaskTemplateEventAssignQueryVariables | VueCompositionApi.Ref<TaskTemplateEventAssignQueryVariables> | ReactiveFunction<TaskTemplateEventAssignQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaskTemplateEventAssignQuery, TaskTemplateEventAssignQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaskTemplateEventAssignQuery, TaskTemplateEventAssignQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaskTemplateEventAssignQuery, TaskTemplateEventAssignQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaskTemplateEventAssignQuery, TaskTemplateEventAssignQueryVariables>(TaskTemplateEventAssignDocument, variables, options);
}
export type TaskTemplateEventAssignQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaskTemplateEventAssignQuery, TaskTemplateEventAssignQueryVariables>;
export const UserEventAssignDocument = gql`
    query userEventAssign($id: ID!) {
  Task(id: $id) {
    ...EventUsersTask
  }
}
    ${EventUsersTaskFragmentDoc}`;

/**
 * __useUserEventAssignQuery__
 *
 * To run a query within a Vue component, call `useUserEventAssignQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEventAssignQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserEventAssignQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserEventAssignQuery(variables: UserEventAssignQueryVariables | VueCompositionApi.Ref<UserEventAssignQueryVariables> | ReactiveFunction<UserEventAssignQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserEventAssignQuery, UserEventAssignQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserEventAssignQuery, UserEventAssignQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserEventAssignQuery, UserEventAssignQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserEventAssignQuery, UserEventAssignQueryVariables>(UserEventAssignDocument, variables, options);
}
export function useUserEventAssignLazyQuery(variables?: UserEventAssignQueryVariables | VueCompositionApi.Ref<UserEventAssignQueryVariables> | ReactiveFunction<UserEventAssignQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserEventAssignQuery, UserEventAssignQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserEventAssignQuery, UserEventAssignQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserEventAssignQuery, UserEventAssignQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserEventAssignQuery, UserEventAssignQueryVariables>(UserEventAssignDocument, variables, options);
}
export type UserEventAssignQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserEventAssignQuery, UserEventAssignQueryVariables>;
export const UserRoleSelectDocument = gql`
    query userRoleSelect($usersListInput: UsersListInput!, $rolesListInput: RolesListInput!, $laborCostInput: LaborCostInput, $includeRoles: Boolean!) {
  UsersList(input: $usersListInput) {
    id
    name
    hslColor
    initials
    profilePicture {
      mini
    }
    role {
      id
      name
    }
    status
    laborCost(input: $laborCostInput)
  }
  RolesList(input: $rolesListInput) @include(if: $includeRoles) {
    id
    name
    laborCost(input: $laborCostInput)
    users {
      id
    }
  }
}
    `;

/**
 * __useUserRoleSelectQuery__
 *
 * To run a query within a Vue component, call `useUserRoleSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleSelectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserRoleSelectQuery({
 *   usersListInput: // value for 'usersListInput'
 *   rolesListInput: // value for 'rolesListInput'
 *   laborCostInput: // value for 'laborCostInput'
 *   includeRoles: // value for 'includeRoles'
 * });
 */
export function useUserRoleSelectQuery(variables: UserRoleSelectQueryVariables | VueCompositionApi.Ref<UserRoleSelectQueryVariables> | ReactiveFunction<UserRoleSelectQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserRoleSelectQuery, UserRoleSelectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserRoleSelectQuery, UserRoleSelectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserRoleSelectQuery, UserRoleSelectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserRoleSelectQuery, UserRoleSelectQueryVariables>(UserRoleSelectDocument, variables, options);
}
export function useUserRoleSelectLazyQuery(variables?: UserRoleSelectQueryVariables | VueCompositionApi.Ref<UserRoleSelectQueryVariables> | ReactiveFunction<UserRoleSelectQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserRoleSelectQuery, UserRoleSelectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserRoleSelectQuery, UserRoleSelectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserRoleSelectQuery, UserRoleSelectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserRoleSelectQuery, UserRoleSelectQueryVariables>(UserRoleSelectDocument, variables, options);
}
export type UserRoleSelectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserRoleSelectQuery, UserRoleSelectQueryVariables>;
export const UserSelectListDocument = gql`
    query userSelectList($usersListInput: UsersListInput, $includeGroups: Boolean!) {
  UserGroupsList @include(if: $includeGroups) {
    id
    name
    users {
      id
      status
    }
  }
  UsersList(input: $usersListInput) {
    id
    name
  }
}
    `;

/**
 * __useUserSelectListQuery__
 *
 * To run a query within a Vue component, call `useUserSelectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserSelectListQuery({
 *   usersListInput: // value for 'usersListInput'
 *   includeGroups: // value for 'includeGroups'
 * });
 */
export function useUserSelectListQuery(variables: UserSelectListQueryVariables | VueCompositionApi.Ref<UserSelectListQueryVariables> | ReactiveFunction<UserSelectListQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserSelectListQuery, UserSelectListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserSelectListQuery, UserSelectListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserSelectListQuery, UserSelectListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserSelectListQuery, UserSelectListQueryVariables>(UserSelectListDocument, variables, options);
}
export function useUserSelectListLazyQuery(variables?: UserSelectListQueryVariables | VueCompositionApi.Ref<UserSelectListQueryVariables> | ReactiveFunction<UserSelectListQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserSelectListQuery, UserSelectListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserSelectListQuery, UserSelectListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserSelectListQuery, UserSelectListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserSelectListQuery, UserSelectListQueryVariables>(UserSelectListDocument, variables, options);
}
export type UserSelectListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserSelectListQuery, UserSelectListQueryVariables>;
export const InviteUsersDocument = gql`
    mutation InviteUsers($input: [InviteUsersSaveInput!]!) {
  InviteUsersMutation(input: $input)
}
    `;

/**
 * __useInviteUsersMutation__
 *
 * To run a mutation, you first call `useInviteUsersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInviteUsersMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useInviteUsersMutation(options: VueApolloComposable.UseMutationOptions<InviteUsersMutation, InviteUsersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InviteUsersMutation, InviteUsersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InviteUsersMutation, InviteUsersMutationVariables>(InviteUsersDocument, options);
}
export type InviteUsersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InviteUsersMutation, InviteUsersMutationVariables>;
export const PermissionSetsListDocument = gql`
    query PermissionSetsList {
  PermissionSetsList(input: {type: "regular"}) {
    id
    name
  }
}
    `;

/**
 * __usePermissionSetsListQuery__
 *
 * To run a query within a Vue component, call `usePermissionSetsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionSetsListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePermissionSetsListQuery();
 */
export function usePermissionSetsListQuery(options: VueApolloComposable.UseQueryOptions<PermissionSetsListQuery, PermissionSetsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PermissionSetsListQuery, PermissionSetsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PermissionSetsListQuery, PermissionSetsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PermissionSetsListQuery, PermissionSetsListQueryVariables>(PermissionSetsListDocument, {}, options);
}
export function usePermissionSetsListLazyQuery(options: VueApolloComposable.UseQueryOptions<PermissionSetsListQuery, PermissionSetsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PermissionSetsListQuery, PermissionSetsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PermissionSetsListQuery, PermissionSetsListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PermissionSetsListQuery, PermissionSetsListQueryVariables>(PermissionSetsListDocument, {}, options);
}
export type PermissionSetsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PermissionSetsListQuery, PermissionSetsListQueryVariables>;
export const WorkReportChartDocument = gql`
    query WorkReportChart($bookmarkHash: String!, $startFrom: Int!, $limit: Int!) {
  WorkReportList(
    bookmarkHash: $bookmarkHash
    startFrom: $startFrom
    limit: $limit
  ) {
    id
    title
    type
    value {
      actualDuration
      billableDuration
      id
      plannedDuration
      quantity
      title
      todoDuration
      type
    }
  }
}
    `;

/**
 * __useWorkReportChartQuery__
 *
 * To run a query within a Vue component, call `useWorkReportChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkReportChartQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWorkReportChartQuery({
 *   bookmarkHash: // value for 'bookmarkHash'
 *   startFrom: // value for 'startFrom'
 *   limit: // value for 'limit'
 * });
 */
export function useWorkReportChartQuery(variables: WorkReportChartQueryVariables | VueCompositionApi.Ref<WorkReportChartQueryVariables> | ReactiveFunction<WorkReportChartQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkReportChartQuery, WorkReportChartQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkReportChartQuery, WorkReportChartQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkReportChartQuery, WorkReportChartQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WorkReportChartQuery, WorkReportChartQueryVariables>(WorkReportChartDocument, variables, options);
}
export function useWorkReportChartLazyQuery(variables?: WorkReportChartQueryVariables | VueCompositionApi.Ref<WorkReportChartQueryVariables> | ReactiveFunction<WorkReportChartQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkReportChartQuery, WorkReportChartQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkReportChartQuery, WorkReportChartQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkReportChartQuery, WorkReportChartQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WorkReportChartQuery, WorkReportChartQueryVariables>(WorkReportChartDocument, variables, options);
}
export type WorkReportChartQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WorkReportChartQuery, WorkReportChartQueryVariables>;
export const ProjectsViewPageDocument = gql`
    query projectsViewPage($projectInput: ProjectParamsInput!, $projectId: Int!, $currency: String!) {
  Project(projectParams: $projectInput) @persist {
    id
    number
    name
    manager {
      ...userAssignSelectUser
    }
    status {
      id
      statusId
      name
      color
    }
    date
    deadline
    completedDateTime
    color
    company {
      id
      name
    }
    permissions {
      canModify
    }
    duration
    doneDuration
    toDoDuration
    isDeleted
    isPersonal
    isPrivate
    members {
      ...userAssignSelectUser
    }
    cupoUsers {
      ...userAssignSelectUser
    }
    projectType
    confirmedDoneDuration
    actualUsedBudgetSum
    useBillsExpensesInCalculations
    priceList {
      id
      currency
    }
    retainer {
      id
      periodDuration
      periodSum
      periods {
        id
        name
        startDate
        endDate
        duration
        actualDuration(input: {projectId: $projectId})
        sum(input: {projectId: $projectId, currency: $currency})
        actualSum(input: {projectId: $projectId, currency: $currency})
        defaultName
      }
    }
    projectPhases {
      id
      title
      ordering
      startDate
      endDate
      type
    }
  }
}
    ${UserAssignSelectUserFragmentDoc}`;

/**
 * __useProjectsViewPageQuery__
 *
 * To run a query within a Vue component, call `useProjectsViewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsViewPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectsViewPageQuery({
 *   projectInput: // value for 'projectInput'
 *   projectId: // value for 'projectId'
 *   currency: // value for 'currency'
 * });
 */
export function useProjectsViewPageQuery(variables: ProjectsViewPageQueryVariables | VueCompositionApi.Ref<ProjectsViewPageQueryVariables> | ReactiveFunction<ProjectsViewPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectsViewPageQuery, ProjectsViewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectsViewPageQuery, ProjectsViewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectsViewPageQuery, ProjectsViewPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectsViewPageQuery, ProjectsViewPageQueryVariables>(ProjectsViewPageDocument, variables, options);
}
export function useProjectsViewPageLazyQuery(variables?: ProjectsViewPageQueryVariables | VueCompositionApi.Ref<ProjectsViewPageQueryVariables> | ReactiveFunction<ProjectsViewPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectsViewPageQuery, ProjectsViewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectsViewPageQuery, ProjectsViewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectsViewPageQuery, ProjectsViewPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectsViewPageQuery, ProjectsViewPageQueryVariables>(ProjectsViewPageDocument, variables, options);
}
export type ProjectsViewPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectsViewPageQuery, ProjectsViewPageQueryVariables>;
export const WelcomePageActiveTrialThreadDocument = gql`
    query WelcomePageActiveTrialThread($threadId: String) {
  ActiveTrialThread(input: $threadId) {
    threadId
    messages {
      messageId
      threadId
      response
      messageType
    }
  }
}
    `;

/**
 * __useWelcomePageActiveTrialThreadQuery__
 *
 * To run a query within a Vue component, call `useWelcomePageActiveTrialThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useWelcomePageActiveTrialThreadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWelcomePageActiveTrialThreadQuery({
 *   threadId: // value for 'threadId'
 * });
 */
export function useWelcomePageActiveTrialThreadQuery(variables: WelcomePageActiveTrialThreadQueryVariables | VueCompositionApi.Ref<WelcomePageActiveTrialThreadQueryVariables> | ReactiveFunction<WelcomePageActiveTrialThreadQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<WelcomePageActiveTrialThreadQuery, WelcomePageActiveTrialThreadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WelcomePageActiveTrialThreadQuery, WelcomePageActiveTrialThreadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WelcomePageActiveTrialThreadQuery, WelcomePageActiveTrialThreadQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WelcomePageActiveTrialThreadQuery, WelcomePageActiveTrialThreadQueryVariables>(WelcomePageActiveTrialThreadDocument, variables, options);
}
export function useWelcomePageActiveTrialThreadLazyQuery(variables: WelcomePageActiveTrialThreadQueryVariables | VueCompositionApi.Ref<WelcomePageActiveTrialThreadQueryVariables> | ReactiveFunction<WelcomePageActiveTrialThreadQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<WelcomePageActiveTrialThreadQuery, WelcomePageActiveTrialThreadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WelcomePageActiveTrialThreadQuery, WelcomePageActiveTrialThreadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WelcomePageActiveTrialThreadQuery, WelcomePageActiveTrialThreadQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WelcomePageActiveTrialThreadQuery, WelcomePageActiveTrialThreadQueryVariables>(WelcomePageActiveTrialThreadDocument, variables, options);
}
export type WelcomePageActiveTrialThreadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WelcomePageActiveTrialThreadQuery, WelcomePageActiveTrialThreadQueryVariables>;
export const TYPES = {
  ActivityGroupType: 'ActivityGroupType',
  ActivityLogsInput: 'ActivityLogsInput',
  ActivitySourceEnum: 'ActivitySourceEnum',
  ActivityType: 'ActivityType',
  ActivityTypeStatus: 'ActivityTypeStatus',
  Adapter: 'Adapter',
  Availability: 'Availability',
  AvailabilityListInput: 'AvailabilityListInput',
  AvailableDateParamsInput: 'AvailableDateParamsInput',
  AvalaraDefaultFieldMapping: 'AvalaraDefaultFieldMapping',
  AvalaraInputDataFormat: 'AvalaraInputDataFormat',
  AvalaraMandate: 'AvalaraMandate',
  AvalaraMappingField: 'AvalaraMappingField',
  AvalaraScoroField: 'AvalaraScoroField',
  BackgroundJob: 'BackgroundJob',
  BackgroundJobStatus: 'BackgroundJobStatus',
  Bill: 'Bill',
  BillLine: 'BillLine',
  BillableTimeTypeEnum: 'BillableTimeTypeEnum',
  Booking: 'Booking',
  BookingAmountType: 'BookingAmountType',
  BookingCreationSource: 'BookingCreationSource',
  BookingDeleteInput: 'BookingDeleteInput',
  BookingSaveInput: 'BookingSaveInput',
  BookingsFiltersInput: 'BookingsFiltersInput',
  BookingsListInput: 'BookingsListInput',
  BookingsMoveInput: 'BookingsMoveInput',
  Bookmark: 'Bookmark',
  BookmarkFilterInput: 'BookmarkFilterInput',
  BoolCustomFieldValue: 'BoolCustomFieldValue',
  Boolean: 'Boolean',
  Budget: 'Budget',
  BudgetList: 'BudgetList',
  BudgetsFiltersInput: 'BudgetsFiltersInput',
  BudgetsListInput: 'BudgetsListInput',
  CalendarEvent: 'CalendarEvent',
  CalendarEventsFiltersInput: 'CalendarEventsFiltersInput',
  CalendarEventsListInput: 'CalendarEventsListInput',
  ChecklistItems: 'ChecklistItems',
  ChecklistItemsInput: 'ChecklistItemsInput',
  ChecklistSaveInput: 'ChecklistSaveInput',
  ClientProfile: 'ClientProfile',
  Comment: 'Comment',
  CommentReactionItem: 'CommentReactionItem',
  CommentReactionMutationInput: 'CommentReactionMutationInput',
  CompanyAccount: 'CompanyAccount',
  Contact: 'Contact',
  ContactCategory: 'ContactCategory',
  ContactType: 'ContactType',
  ContactUnpaidInvoices: 'ContactUnpaidInvoices',
  ContactsFiltersInput: 'ContactsFiltersInput',
  ContactsListInput: 'ContactsListInput',
  CurrenciesFiltersInput: 'CurrenciesFiltersInput',
  CurrenciesListInput: 'CurrenciesListInput',
  Currency: 'Currency',
  CustomFieldData: 'CustomFieldData',
  CustomFieldInput: 'CustomFieldInput',
  CustomFieldType: 'CustomFieldType',
  CustomFieldValue: 'CustomFieldValue',
  CustomModule: 'CustomModule',
  CustomModuleEntry: 'CustomModuleEntry',
  CustomScriptsExecutionInput: 'CustomScriptsExecutionInput',
  Date: 'Date',
  DateCustomFieldValue: 'DateCustomFieldValue',
  DateTime: 'DateTime',
  DateTimeCustomFieldValue: 'DateTimeCustomFieldValue',
  DocumentLineRelationsSaveInput: 'DocumentLineRelationsSaveInput',
  DocumentLineToDocumentLineRelationInput: 'DocumentLineToDocumentLineRelationInput',
  Duration: 'Duration',
  DynamicOwnerEnum: 'DynamicOwnerEnum',
  DynamicUserGroup: 'DynamicUserGroup',
  EliChatHistoryInput: 'EliChatHistoryInput',
  EliChatMessageInput: 'EliChatMessageInput',
  EliChatMessageResponse: 'EliChatMessageResponse',
  EliChatThread: 'EliChatThread',
  EliInsightsBookmarkInput: 'EliInsightsBookmarkInput',
  EliInsightsBookmarkResponse: 'EliInsightsBookmarkResponse',
  EliInsightsHistoryResponse: 'EliInsightsHistoryResponse',
  EliInsightsMessageResponse: 'EliInsightsMessageResponse',
  EliInsightsModulesInput: 'EliInsightsModulesInput',
  EliInsightsModulesResponse: 'EliInsightsModulesResponse',
  EliInsightsModulesResponseUnion: 'EliInsightsModulesResponseUnion',
  EliInsightsRateInput: 'EliInsightsRateInput',
  EliMessageRateInput: 'EliMessageRateInput',
  EliWelcomeMessageInput: 'EliWelcomeMessageInput',
  EmailDeliveryRegionEnum: 'EmailDeliveryRegionEnum',
  EmailDomain: 'EmailDomain',
  EmailDomainAddInput: 'EmailDomainAddInput',
  EmailDomainDeleteInput: 'EmailDomainDeleteInput',
  EmailDomainDnsRecord: 'EmailDomainDnsRecord',
  EmailDomainVerifyInput: 'EmailDomainVerifyInput',
  EmailTemplate: 'EmailTemplate',
  Expense: 'Expense',
  ExpenseLine: 'ExpenseLine',
  ExportCsvDelimiterEnum: 'ExportCsvDelimiterEnum',
  ExportCsvEncodingEnum: 'ExportCsvEncodingEnum',
  ExportFileFormatEnum: 'ExportFileFormatEnum',
  ExportInput: 'ExportInput',
  ExportResponse: 'ExportResponse',
  ExportXlsEncodingEnum: 'ExportXlsEncodingEnum',
  ExternalSystemEnum: 'ExternalSystemEnum',
  Feature: 'Feature',
  FeatureFlag: 'FeatureFlag',
  FeatureInput: 'FeatureInput',
  File: 'File',
  Filter: 'Filter',
  FilterHashExportInput: 'FilterHashExportInput',
  FilterHashInput: 'FilterHashInput',
  FinanceDocumentFilterInput: 'FinanceDocumentFilterInput',
  FinanceDocumentsListInput: 'FinanceDocumentsListInput',
  Float: 'Float',
  FloatCustomFieldValue: 'FloatCustomFieldValue',
  FloatRangeCustomFieldValue: 'FloatRangeCustomFieldValue',
  FreeTimeSlot: 'FreeTimeSlot',
  FreeTimeSlotInput: 'FreeTimeSlotInput',
  GanttChartShareInput: 'GanttChartShareInput',
  HelpStationArticle: 'HelpStationArticle',
  HelpStationVideo: 'HelpStationVideo',
  HiddenByPermissions: 'HiddenByPermissions',
  ID: 'ID',
  ImageCustomFieldValue: 'ImageCustomFieldValue',
  ImportType: 'ImportType',
  Int: 'Int',
  IntCustomFieldValue: 'IntCustomFieldValue',
  IntegrationAction: 'IntegrationAction',
  IntegrationActionListInput: 'IntegrationActionListInput',
  IntegrationActionRunInput: 'IntegrationActionRunInput',
  IntegrationActionRunResponse: 'IntegrationActionRunResponse',
  IntegrationAuthorizeInputType: 'IntegrationAuthorizeInputType',
  IntegrationGetAdapterInputType: 'IntegrationGetAdapterInputType',
  IntegrationGetJwtInputType: 'IntegrationGetJwtInputType',
  IntegrationItem: 'IntegrationItem',
  IntegrationItemEntity: 'IntegrationItemEntity',
  IntegrationItemInputType: 'IntegrationItemInputType',
  IntegrationSetAdapterStatusInputType: 'IntegrationSetAdapterStatusInputType',
  IntegrationValidateJwtInputType: 'IntegrationValidateJwtInputType',
  InviteUsersSaveInput: 'InviteUsersSaveInput',
  Invoice: 'Invoice',
  InvoiceAllocationsSaveInput: 'InvoiceAllocationsSaveInput',
  IsUniqueFieldInput: 'IsUniqueFieldInput',
  LaborCostInput: 'LaborCostInput',
  LimitedTask: 'LimitedTask',
  LocalPriceList: 'LocalPriceList',
  LocalPriceListSaveInput: 'LocalPriceListSaveInput',
  LocalPriceListSaveLocalRolePriceInput: 'LocalPriceListSaveLocalRolePriceInput',
  LocalRolePrice: 'LocalRolePrice',
  LocalRoleSellingPriceInput: 'LocalRoleSellingPriceInput',
  Long: 'Long',
  MarketingList: 'MarketingList',
  MenuItem: 'MenuItem',
  MetricConfig: 'MetricConfig',
  MetricLog: 'MetricLog',
  MetricSettingOption: 'MetricSettingOption',
  MetricsValueState: 'MetricsValueState',
  Milestone: 'Milestone',
  Module: 'Module',
  ModuleInput: 'ModuleInput',
  ModuleType: 'ModuleType',
  Mutation: 'Mutation',
  NewsFeedItem: 'NewsFeedItem',
  Notification: 'Notification',
  NotificationActionType: 'NotificationActionType',
  NotificationChange: 'NotificationChange',
  NotificationRelatedObject: 'NotificationRelatedObject',
  NotificationStatus: 'NotificationStatus',
  Order: 'Order',
  OrderBy: 'OrderBy',
  OrderByInput: 'OrderByInput',
  OrderDirectionEnum: 'OrderDirectionEnum',
  PagerInput: 'PagerInput',
  PdfTemplate: 'PdfTemplate',
  Permission: 'Permission',
  PermissionSet: 'PermissionSet',
  PermissionSetPermissionUpdateInput: 'PermissionSetPermissionUpdateInput',
  PermissionSetWithPermissions: 'PermissionSetWithPermissions',
  PermissionSetsListInput: 'PermissionSetsListInput',
  PermissionSetsPermissionsInput: 'PermissionSetsPermissionsInput',
  PermissionSetsPermissionsResult: 'PermissionSetsPermissionsResult',
  PermissionValue: 'PermissionValue',
  Permissions: 'Permissions',
  Phase: 'Phase',
  PhasesTaskSets: 'PhasesTaskSets',
  Prepayment: 'Prepayment',
  PriceList: 'PriceList',
  PriceListsFiltersInput: 'PriceListsFiltersInput',
  PriceListsListInput: 'PriceListsListInput',
  Priority: 'Priority',
  Product: 'Product',
  ProductGroup: 'ProductGroup',
  Project: 'Project',
  ProjectBudget: 'ProjectBudget',
  ProjectBudgetSums: 'ProjectBudgetSums',
  ProjectDatesSaveInput: 'ProjectDatesSaveInput',
  ProjectHealth: 'ProjectHealth',
  ProjectHealthInput: 'ProjectHealthInput',
  ProjectListOrderByEnum: 'ProjectListOrderByEnum',
  ProjectMembersAddInput: 'ProjectMembersAddInput',
  ProjectMembersRemoveInput: 'ProjectMembersRemoveInput',
  ProjectMembersSaveInput: 'ProjectMembersSaveInput',
  ProjectMetricConfigInput: 'ProjectMetricConfigInput',
  ProjectMetricsConfigSaveInput: 'ProjectMetricsConfigSaveInput',
  ProjectMetricsInput: 'ProjectMetricsInput',
  ProjectMetricsSettingsSaveInput: 'ProjectMetricsSettingsSaveInput',
  ProjectParamsInput: 'ProjectParamsInput',
  ProjectPermissions: 'ProjectPermissions',
  ProjectPhase: 'ProjectPhase',
  ProjectPhaseInput: 'ProjectPhaseInput',
  ProjectPhaseTypeEnum: 'ProjectPhaseTypeEnum',
  ProjectPhasesAndTaskSetsSaveInput: 'ProjectPhasesAndTaskSetsSaveInput',
  ProjectProfitData: 'ProjectProfitData',
  ProjectProfitDataInput: 'ProjectProfitDataInput',
  ProjectProgressGroup: 'ProjectProgressGroup',
  ProjectProgressGroupBy: 'ProjectProgressGroupBy',
  ProjectProgressInput: 'ProjectProgressInput',
  ProjectRelatedObjectEnum: 'ProjectRelatedObjectEnum',
  ProjectRetainerBudgetInput: 'ProjectRetainerBudgetInput',
  ProjectRevenueForecast: 'ProjectRevenueForecast',
  ProjectRevenueForecastInput: 'ProjectRevenueForecastInput',
  ProjectSaveInput: 'ProjectSaveInput',
  ProjectSimpleBudgetInput: 'ProjectSimpleBudgetInput',
  ProjectTabsListInput: 'ProjectTabsListInput',
  ProjectTemplate: 'ProjectTemplate',
  ProjectType: 'ProjectType',
  ProjectsFiltersInput: 'ProjectsFiltersInput',
  ProjectsListInput: 'ProjectsListInput',
  PurchaseOrder: 'PurchaseOrder',
  PurchaseOrderLine: 'PurchaseOrderLine',
  PurchaseOrderLineMaybeHiddenByPermissions: 'PurchaseOrderLineMaybeHiddenByPermissions',
  Query: 'Query',
  Quote: 'Quote',
  QuoteFiltersInput: 'QuoteFiltersInput',
  QuoteLine: 'QuoteLine',
  QuoteLineMaybeHiddenByPermissions: 'QuoteLineMaybeHiddenByPermissions',
  QuoteLineProvider: 'QuoteLineProvider',
  QuoteMatrix: 'QuoteMatrix',
  QuoteMatrixProvider: 'QuoteMatrixProvider',
  QuoteMatrixSettings: 'QuoteMatrixSettings',
  QuoteOrderingInput: 'QuoteOrderingInput',
  QuoteRevenueForecast: 'QuoteRevenueForecast',
  QuoteShareInput: 'QuoteShareInput',
  QuotesListOrderBy: 'QuotesListOrderBy',
  RealEstateObject: 'RealEstateObject',
  ReferralLinks: 'ReferralLinks',
  RelationCustomFieldValue: 'RelationCustomFieldValue',
  RelationValue: 'RelationValue',
  RentalOrder: 'RentalOrder',
  ReportDataGroupInterface: 'ReportDataGroupInterface',
  ReportsLibrary: 'ReportsLibrary',
  ReportsLibraryReport: 'ReportsLibraryReport',
  RequiredUniqueFieldsInput: 'RequiredUniqueFieldsInput',
  Resource: 'Resource',
  ResourcePlanningPortfolio: 'ResourcePlanningPortfolio',
  ResourcePlanningPortfolioProjects: 'ResourcePlanningPortfolioProjects',
  ResourcePlanningPortfolioProjectsFiltersInput: 'ResourcePlanningPortfolioProjectsFiltersInput',
  ResourcesFiltersInput: 'ResourcesFiltersInput',
  ResourcesListInput: 'ResourcesListInput',
  Retainer: 'Retainer',
  RetainerBudget: 'RetainerBudget',
  RetainerFrequency: 'RetainerFrequency',
  RetainerPeriod: 'RetainerPeriod',
  RetainerSaveInput: 'RetainerSaveInput',
  RetainerSavePeriodInput: 'RetainerSavePeriodInput',
  RetainerValuesInput: 'RetainerValuesInput',
  RevenueForecastPeriod: 'RevenueForecastPeriod',
  RevenueForecastPeriodSaveInput: 'RevenueForecastPeriodSaveInput',
  RevenueReportForecast: 'RevenueReportForecast',
  RevenueReportForecastExportInput: 'RevenueReportForecastExportInput',
  RevenueReportForecastGroupByEnum: 'RevenueReportForecastGroupByEnum',
  RevenueReportForecastListItem: 'RevenueReportForecastListItem',
  RevenueReportForecastPeriod: 'RevenueReportForecastPeriod',
  RevenueReportForecastSummary: 'RevenueReportForecastSummary',
  RevenueReportForecastSummaryPeriod: 'RevenueReportForecastSummaryPeriod',
  Role: 'Role',
  RolePermissions: 'RolePermissions',
  RolePriceList: 'RolePriceList',
  RoleProject: 'RoleProject',
  RoleSaveInput: 'RoleSaveInput',
  RoleSavePriceListInput: 'RoleSavePriceListInput',
  RoleSaveTranslationInput: 'RoleSaveTranslationInput',
  RoleSellingPriceInput: 'RoleSellingPriceInput',
  RoleTranslation: 'RoleTranslation',
  RolesFiltersInput: 'RolesFiltersInput',
  RolesListInput: 'RolesListInput',
  SageDimension: 'SageDimension',
  SageDimensionOptionType: 'SageDimensionOptionType',
  SageDimensionsSaveInput: 'SageDimensionsSaveInput',
  SageDimensionsSaveListInput: 'SageDimensionsSaveListInput',
  SalesforceIsQuoteLinkedInputType: 'SalesforceIsQuoteLinkedInputType',
  SalesforceSyncQuoteSumAndPdfInputType: 'SalesforceSyncQuoteSumAndPdfInputType',
  SearchInput: 'SearchInput',
  SearchResult: 'SearchResult',
  SearchSetting: 'SearchSetting',
  SearchTotal: 'SearchTotal',
  SelfServiceAddon: 'SelfServiceAddon',
  SelfServiceAddonInput: 'SelfServiceAddonInput',
  SelfServiceBillingCycleType: 'SelfServiceBillingCycleType',
  SelfServiceCancelSubscriptionReason: 'SelfServiceCancelSubscriptionReason',
  SelfServiceCancelSubscriptionRequestInput: 'SelfServiceCancelSubscriptionRequestInput',
  SelfServiceCompanyAccount: 'SelfServiceCompanyAccount',
  SelfServiceCompanyAccountInput: 'SelfServiceCompanyAccountInput',
  SelfServiceCurrency: 'SelfServiceCurrency',
  SelfServiceData: 'SelfServiceData',
  SelfServiceDataInput: 'SelfServiceDataInput',
  SelfServiceFeatureOverLimit: 'SelfServiceFeatureOverLimit',
  SelfServiceOnboardingPackage: 'SelfServiceOnboardingPackage',
  SelfServicePackage: 'SelfServicePackage',
  SelfServicePaymentMethodInfo: 'SelfServicePaymentMethodInfo',
  SelfServicePaymentMethodType: 'SelfServicePaymentMethodType',
  SelfServiceSeatReductionRequest: 'SelfServiceSeatReductionRequest',
  SelfServiceSendSeatReductionRequestInput: 'SelfServiceSendSeatReductionRequestInput',
  Setting: 'Setting',
  SettingLookup: 'SettingLookup',
  SettingLookupRequest: 'SettingLookupRequest',
  SettingSaveInput: 'SettingSaveInput',
  SettingValue: 'SettingValue',
  ShareSnapshot: 'ShareSnapshot',
  ShareSnapshotInput: 'ShareSnapshotInput',
  ShareTypeEnum: 'ShareTypeEnum',
  Site: 'Site',
  SocketConnection: 'SocketConnection',
  SortDirection: 'SortDirection',
  StaticStatus: 'StaticStatus',
  Status: 'Status',
  StatusChangeInput: 'StatusChangeInput',
  StatusModulesEnum: 'StatusModulesEnum',
  StatusesFiltersInput: 'StatusesFiltersInput',
  StatusesListInput: 'StatusesListInput',
  String: 'String',
  StringCustomFieldValue: 'StringCustomFieldValue',
  StripeTemplate: 'StripeTemplate',
  StripeTemplateObject: 'StripeTemplateObject',
  SumWithCurrency: 'SumWithCurrency',
  SummaryBlockInput: 'SummaryBlockInput',
  SummaryBlockItem: 'SummaryBlockItem',
  SummaryBlockItemType: 'SummaryBlockItemType',
  Tab: 'Tab',
  TabKey: 'TabKey',
  TabSaveInput: 'TabSaveInput',
  TabShortcut: 'TabShortcut',
  TabsSaveInput: 'TabsSaveInput',
  Tag: 'Tag',
  TagsFiltersInput: 'TagsFiltersInput',
  TagsListInput: 'TagsListInput',
  Task: 'Task',
  TaskAssignee: 'TaskAssignee',
  TaskAssigneesInput: 'TaskAssigneesInput',
  TaskAssigneesSaveInput: 'TaskAssigneesSaveInput',
  TaskBudgetRow: 'TaskBudgetRow',
  TaskDoneDuration: 'TaskDoneDuration',
  TaskMarkAsDoneInput: 'TaskMarkAsDoneInput',
  TaskMarkAsDoneMutationInput: 'TaskMarkAsDoneMutationInput',
  TaskMarkAsNotDoneMutationInput: 'TaskMarkAsNotDoneMutationInput',
  TaskMaybeLimitedByPermissions: 'TaskMaybeLimitedByPermissions',
  TaskOrderingInput: 'TaskOrderingInput',
  TaskPermissions: 'TaskPermissions',
  TaskResponsibleSaveInput: 'TaskResponsibleSaveInput',
  TaskSaveInput: 'TaskSaveInput',
  TaskSet: 'TaskSet',
  TaskSetAsSubtasksSaveInput: 'TaskSetAsSubtasksSaveInput',
  TaskSetsInput: 'TaskSetsInput',
  TaskTemplate: 'TaskTemplate',
  TaskTemplateAssignee: 'TaskTemplateAssignee',
  TaskTemplateAssigneesInput: 'TaskTemplateAssigneesInput',
  TaskTemplateAssigneesSaveInput: 'TaskTemplateAssigneesSaveInput',
  TaskUsersAvailability: 'TaskUsersAvailability',
  TaskUsersAvailabilityInput: 'TaskUsersAvailabilityInput',
  TasksFiltersInput: 'TasksFiltersInput',
  TasksListInput: 'TasksListInput',
  TasksListOrderByEnum: 'TasksListOrderByEnum',
  TasksSearchFilter: 'TasksSearchFilter',
  TasksSearchInput: 'TasksSearchInput',
  TeamReport: 'TeamReport',
  TeamReportColumnEnum: 'TeamReportColumnEnum',
  TeamReportGroupByEnum: 'TeamReportGroupByEnum',
  TeamReportRow: 'TeamReportRow',
  TeamReportRowItem: 'TeamReportRowItem',
  Time: 'Time',
  TimeEntry: 'TimeEntry',
  TimeEntrySaveInput: 'TimeEntrySaveInput',
  TimeOff: 'TimeOff',
  TimeOffDeleteInput: 'TimeOffDeleteInput',
  TimeOffFiltersInput: 'TimeOffFiltersInput',
  TimeOffItem: 'TimeOffItem',
  TimeOffOverlappingProjectsListItem: 'TimeOffOverlappingProjectsListItem',
  TimeOffReport: 'TimeOffReport',
  TimeOffReportItem: 'TimeOffReportItem',
  TimeOffReportListItem: 'TimeOffReportListItem',
  TimeOffReportSummary: 'TimeOffReportSummary',
  TimeOffReportTotal: 'TimeOffReportTotal',
  TimeOffSaveInput: 'TimeOffSaveInput',
  TimeOffTypeListItem: 'TimeOffTypeListItem',
  TimeOffTypeRelation: 'TimeOffTypeRelation',
  TimeOffTypeSaveInput: 'TimeOffTypeSaveInput',
  TimeOffTypesListFiltersInput: 'TimeOffTypesListFiltersInput',
  TimeOffTypesOrderSaveInput: 'TimeOffTypesOrderSaveInput',
  TimesheetScheduleRemindersInput: 'TimesheetScheduleRemindersInput',
  TranslatedValue: 'TranslatedValue',
  Translation: 'Translation',
  TrialExtensionInput: 'TrialExtensionInput',
  Trigger: 'Trigger',
  TriggerAction: 'TriggerAction',
  TriggerActionData: 'TriggerActionData',
  TriggerActionInput: 'TriggerActionInput',
  TriggerActionType: 'TriggerActionType',
  TriggerActivity: 'TriggerActivity',
  TriggerActivityInput: 'TriggerActivityInput',
  TriggerActivityType: 'TriggerActivityType',
  TriggerDataInput: 'TriggerDataInput',
  TriggerDoerGroupData: 'TriggerDoerGroupData',
  TriggerFieldList: 'TriggerFieldList',
  TriggerFieldListActivitiesType: 'TriggerFieldListActivitiesType',
  TriggerFieldListConditionsType: 'TriggerFieldListConditionsType',
  TriggerFieldType: 'TriggerFieldType',
  TriggerFieldValue: 'TriggerFieldValue',
  TriggerFilterData: 'TriggerFilterData',
  TriggerFilterDataBlock: 'TriggerFilterDataBlock',
  TriggerFilterDataBlockInput: 'TriggerFilterDataBlockInput',
  TriggerFilterDataFilter: 'TriggerFilterDataFilter',
  TriggerFilterDataFilterInput: 'TriggerFilterDataFilterInput',
  TriggerFilterDataInput: 'TriggerFilterDataInput',
  TriggerFilterDataLogicalOperator: 'TriggerFilterDataLogicalOperator',
  TriggerFilterDataRule: 'TriggerFilterDataRule',
  TriggerFilterDataRuleInput: 'TriggerFilterDataRuleInput',
  TriggerFilterDataUserInput: 'TriggerFilterDataUserInput',
  TriggerFilterDataUserList: 'TriggerFilterDataUserList',
  TriggerFilterDataValue: 'TriggerFilterDataValue',
  TriggerModuleUnion: 'TriggerModuleUnion',
  TriggerStatusType: 'TriggerStatusType',
  TriggersFiltersInput: 'TriggersFiltersInput',
  TriggersListInput: 'TriggersListInput',
  UnShareInput: 'UnShareInput',
  UnionActivity: 'UnionActivity',
  UnionBackgroundJob: 'UnionBackgroundJob',
  UnionBill: 'UnionBill',
  UnionClientProfile: 'UnionClientProfile',
  UnionContact: 'UnionContact',
  UnionContactCategory: 'UnionContactCategory',
  UnionCurrency: 'UnionCurrency',
  UnionCustomModuleEntry: 'UnionCustomModuleEntry',
  UnionEvent: 'UnionEvent',
  UnionExpense: 'UnionExpense',
  UnionFieldChange: 'UnionFieldChange',
  UnionFile: 'UnionFile',
  UnionImport: 'UnionImport',
  UnionInvoice: 'UnionInvoice',
  UnionManagerChange: 'UnionManagerChange',
  UnionMarketingList: 'UnionMarketingList',
  UnionNewsFeedItem: 'UnionNewsFeedItem',
  UnionOrder: 'UnionOrder',
  UnionPrepayment: 'UnionPrepayment',
  UnionProject: 'UnionProject',
  UnionProjectChange: 'UnionProjectChange',
  UnionPurchaseOrder: 'UnionPurchaseOrder',
  UnionQuote: 'UnionQuote',
  UnionRealEstateObject: 'UnionRealEstateObject',
  UnionRentalOrder: 'UnionRentalOrder',
  UnionResource: 'UnionResource',
  UnionStaticStatus: 'UnionStaticStatus',
  UnionStatus: 'UnionStatus',
  UnionStatusChange: 'UnionStatusChange',
  UnionStringFieldValue: 'UnionStringFieldValue',
  UnionTag: 'UnionTag',
  UnionTask: 'UnionTask',
  UnionTimeEntry: 'UnionTimeEntry',
  UnionUser: 'UnionUser',
  UnionUsersChange: 'UnionUsersChange',
  Unit: 'Unit',
  UpdateMcpPermissionsInput: 'UpdateMcpPermissionsInput',
  User: 'User',
  UserGroup: 'UserGroup',
  UserLog: 'UserLog',
  UserLogFiltersInput: 'UserLogFiltersInput',
  UserPicture: 'UserPicture',
  UserStatus: 'UserStatus',
  UserTimeOff: 'UserTimeOff',
  UserTimeOffListInput: 'UserTimeOffListInput',
  UserType: 'UserType',
  UserUtilization: 'UserUtilization',
  UserUtilizationInput: 'UserUtilizationInput',
  UserUtilizationResponse: 'UserUtilizationResponse',
  UsersFiltersInput: 'UsersFiltersInput',
  UsersListInput: 'UsersListInput',
  UtilizationGroupBy: 'UtilizationGroupBy',
  ValidationFields: 'ValidationFields',
  Version: 'Version',
  VirtualAssistantChatResponse: 'VirtualAssistantChatResponse',
  VirtualAssistantMessageInput: 'VirtualAssistantMessageInput',
  VirtualAssistantRatingInput: 'VirtualAssistantRatingInput',
  WatchdogAlertConditionEnum: 'WatchdogAlertConditionEnum',
  WatchdogAlertTypeEnum: 'WatchdogAlertTypeEnum',
  WatchdogNotificationTypeEnum: 'WatchdogNotificationTypeEnum',
  WebhookData: 'WebhookData',
  WorkReportPrimaryGroup: 'WorkReportPrimaryGroup',
  WorkReportSecondaryGroup: 'WorkReportSecondaryGroup'
} as const